// src/components/property-offers.tsx
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  fragment FilterPillsFragment on OfferDetails {\n    filterPills {\n      pillLabel\n      query\n      type\n      value\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  fragment HighlightedBenefitsFragment on OfferDetails {\n    highlightedBenefits {\n      listItems {\n        icon {\n          id\n        }\n        impressionAnalytics {\n          referrerId\n        }\n        text\n      }\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  fragment LegalDisclaimerFragment on OfferDetails {\n    legalDisclaimer {\n      content {\n        markupType\n        text\n      }\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  fragment ClientSideAnalyticsFragment on ClientSideAnalytics {\n    eventType\n    linkName\n    referrerId\n    uisPrimeMessages {\n      schemaName\n      messageContent\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  fragment IconFragment on Icon {\n    description\n    id\n    iconSize: size\n    theme\n    title\n    withBackground\n    spotLight\n  }\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  fragment IllustrationFragment on Illustration {\n    description\n    id\n    link: url\n  }\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  fragment MarkFragment on Mark {\n    description\n    id\n    markSize: size\n    url {\n      ... on HttpURI {\n        relativePath\n        value\n      }\n    }\n  }\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  fragment UIGraphicFragment on UIGraphic {\n    ... on Icon {\n      ...IconFragment\n    }\n\n    ... on Mark {\n      ...MarkFragment\n    }\n\n    ... on Illustration {\n      ...IllustrationFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingOneKeyBurnSwitchFragment on OfferDetails {\n    lodgingOneKeyBurnSwitch {\n      burnSwitchGraphic: graphic {\n        ...UIGraphicFragment\n      }\n      switch {\n        enabled\n        checked\n        checkedLabel\n        uncheckedLabel\n        checkedDescription\n        uncheckedDescription\n        checkedAnalytics {\n          linkName\n          referrerId\n        }\n        uncheckedAnalytics {\n          linkName\n          referrerId\n        }\n      }\n      impressionTracking {\n        ...ClientSideAnalyticsFragment\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n  fragment LoyaltyDiscountToggleFragment on OfferDetails {\n    loyaltyDiscount {\n      saveWithPointsMessage\n      saveWithPointsActionMessage\n    }\n  }\n"
    ]);
    _templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        "\n  fragment VipModuleFragment on PropertyHighlightSection {\n    label\n    header {\n      mark {\n        id\n        description\n      }\n      text\n    }\n    subSections {\n      title {\n        badge {\n          theme_temp\n          text\n        }\n        value\n        state\n      }\n      description\n      contents {\n        badge {\n          text\n          theme_temp\n        }\n        value\n      }\n      footerLink {\n        icon {\n          id\n          withBackground\n          description\n        }\n        link {\n          referrerId\n          uri {\n            relativePath\n            value\n          }\n          target\n        }\n        value\n        accessibilityLabel\n      }\n    }\n  }\n"
    ]);
    _templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _tagged_template_literal([
        "\n  fragment NewVipModuleFragment on OfferDetails {\n    propertyHighlightSection {\n      ...VipModuleFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingEGDSBasicPillFragment on EGDSBasicPill {\n    primary\n    accessibility\n    selected\n    name\n    value\n  }\n"
    ]);
    _templateObject12 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _tagged_template_literal([
        "\n  fragment FilterDialogPillFragment on LodgingFilterSelectionDialog {\n    dialog {\n      footer {\n        buttons {\n          primary\n        }\n      }\n    }\n    clearAll {\n      primary\n    }\n    filterSection {\n      primary\n      ... on ShoppingMultiSelectionField {\n        id\n        primary\n        options {\n          id\n          primary\n          value\n          selected\n          disabled\n        }\n      }\n    }\n    toolbar {\n      title\n    }\n  }\n"
    ]);
    _templateObject13 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingFilterDialogPillFragment on LodgingFilterDialogPill {\n    triggerPill {\n      primary\n      selected\n    }\n    filterDialog {\n      ...FilterDialogPillFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject14 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyFilterPillsFragment on OfferDetails {\n    id\n    offerFilters {\n      heading {\n        text\n      }\n      accessibilityHeader\n      liveAnnounce\n      filterPills {\n        ...LodgingEGDSBasicPillFragment\n        ...LodgingFilterDialogPillFragment\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject15 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingEGDSIconFragment on Icon {\n    description\n    id\n    size\n    theme\n  }\n"
    ]);
    _templateObject16 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingUILinkActionFragment on UILinkAction {\n    resource {\n      ... on HttpURI {\n        relativePath\n        value\n      }\n    }\n    target\n    useRelativePath\n  }\n"
    ]);
    _templateObject17 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingEGDSButtonFragment on EGDSButton {\n    accessibility\n    analytics {\n      ...ClientSideAnalyticsFragment\n    }\n    action {\n      ...LodgingUILinkActionFragment\n    }\n    icon {\n      ...LodgingEGDSIconFragment\n    }\n    ... on UIPrimaryButton {\n      egdsElementId\n    }\n    disabled\n    primary\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject18 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingEGDSFloatingActionButtonFragment on UIPrimaryButton {\n    accessibility\n    analytics {\n      ...ClientSideAnalyticsFragment\n    }\n    disabled\n    action {\n      ...LodgingUILinkActionFragment\n    }\n    icon {\n      ...LodgingEGDSIconFragment\n    }\n    egdsElementId\n  }\n"
    ]);
    _templateObject19 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingEGDSFloatingButtonFragment on UIPrimaryButton {\n    accessibility\n    analytics {\n      ...ClientSideAnalyticsFragment\n    }\n    disabled\n    primary\n    action {\n      ...LodgingUILinkActionFragment\n    }\n    icon {\n      ...LodgingEGDSIconFragment\n    }\n    egdsElementId\n  }\n"
    ]);
    _templateObject20 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSStandardLinkFragment on EGDSStandardLink {\n    action {\n      accessibility\n      analytics {\n        linkName\n        referrerId\n      }\n      resource {\n        value\n        ... on HttpURI {\n          relativePath\n        }\n      }\n      target\n      useRelativePath\n    }\n    disabled\n    standardLinkIcon: icon {\n      ...IconFragment\n    }\n    iconPosition\n    size\n    text\n  }\n\n  ",
        "\n"
    ]);
    _templateObject21 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSUILinkActionFragment on UILinkAction {\n    accessibility\n    analytics {\n      referrerId\n      linkName\n      uisPrimeMessages {\n        schemaName\n        messageContent\n      }\n    }\n    resource {\n      value\n      ... on HttpURI {\n        relativePath\n      }\n    }\n    target\n    useRelativePath\n  }\n"
    ]);
    _templateObject22 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSStandardMessagingCardFragment on EGDSStandardMessagingCard {\n    message\n    heading\n    background\n    themes\n    rightIcon {\n      ...IconFragment\n    }\n    graphic {\n      ...UIGraphicFragment\n    }\n    links {\n      ...EGDSStandardLinkFragment\n    }\n    buttons {\n      ...LodgingEGDSButtonFragment\n    }\n    impressionTracking {\n      ...ClientSideAnalyticsFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject23 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyLevelOffersCardFragment on OfferDetails {\n    propertyLevelOffersCard {\n      ...EGDSStandardMessagingCardFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject24 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = _tagged_template_literal([
        "\n  fragment MessagingResultTitleMediaFragment on MessagingResultTitle {\n    icon {\n      id\n      description\n      size\n      spotLight\n    }\n    illustration {\n      assetUri {\n        value\n      }\n      description\n    }\n    egdsMark {\n      id\n      description\n      url {\n        ... on HttpURI {\n          value\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject25 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = _tagged_template_literal([
        "\n  fragment MessageResultFragment on MessageResult {\n    title {\n      text\n      ...MessagingResultTitleMediaFragment\n    }\n    subtitle {\n      text\n      ...MessagingResultTitleMediaFragment\n    }\n    action {\n      primary {\n        ...MessageActionContent\n      }\n      secondary {\n        ...MessageActionContent\n      }\n    }\n    type\n    footerText\n  }\n  fragment MessageActionContent on MessagingAction {\n    text\n    linkUrl\n    referrerId\n    actionDetails {\n      action\n      accessibilityLabel\n    }\n    analytics {\n      linkName\n      referrerId\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject26 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = _tagged_template_literal([
        "\n  fragment SparkleBannerFragment on MessageResult {\n    __typename\n    title {\n      ...MessageTitleFields\n      ...MessagingResultTitleMediaFragment\n    }\n    subtitle {\n      ...MessageTitleFields\n    }\n    action {\n      primary {\n        ...MessagingActionFields\n      }\n      secondary {\n        ...MessagingActionFields\n      }\n    }\n    type\n  }\n  fragment MessageTitleFields on MessagingResultTitle {\n    text\n    icon {\n      description\n      id\n    }\n    illustration {\n      assetUri {\n        value\n      }\n      description\n    }\n  }\n  fragment MessagingActionFields on MessagingAction {\n    actionDetails {\n      action\n      accessibilityLabel\n    }\n    analytics {\n      linkName\n      referrerId\n    }\n    linkUrl\n    referrerId\n    text\n  }\n  ",
        "\n"
    ]);
    _templateObject27 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyLevelOffersMessageFragment on OfferDetails {\n    propertyLevelOffersMessage {\n      ...MessageResultFragment\n      ...SparkleBannerFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject28 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = _tagged_template_literal([
        "\n  fragment ListingsHeaderFragment on OfferDetails {\n    listingsHeader {\n      text\n    }\n  }\n"
    ]);
    _templateObject29 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = _tagged_template_literal([
        "\n  fragment AlternateDateOptionFragment on AlternateDateOption {\n    dates {\n      link {\n        uri {\n          relativePath\n        }\n        referrerId\n      }\n      value\n    }\n    price {\n      displayPrice {\n        formatted\n      }\n    }\n  }\n"
    ]);
    _templateObject30 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = _tagged_template_literal([
        "\n  fragment AlternateDatesFragment on OfferDetails {\n    alternateDates {\n      header {\n        text\n        subText\n      }\n      options {\n        ...AlternateDateOptionFragment\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject31 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingEnrichedMessageFragment on LodgingEnrichedMessage {\n    __typename\n    subText\n    value\n    theme\n    state\n    accessibilityLabel\n    icon {\n      id\n      size\n      theme\n    }\n    mark {\n      id\n    }\n    egdsMark {\n      url {\n        value\n      }\n    }\n  }\n"
    ]);
    _templateObject32 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingPlainFullscreenDialogFragment on LodgingPlainDialog {\n    __typename\n    content\n    trigger {\n      clientSideAnalytics {\n        linkName\n        referrerId\n      }\n      icon {\n        description\n        id\n      }\n      theme\n      value\n    }\n    toolbar {\n      title\n      icon {\n        description\n      }\n      clientSideAnalytics {\n        linkName\n        referrerId\n      }\n    }\n  }\n"
    ]);
    _templateObject33 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyOffersIncludedPerksFragment on OfferDetails {\n    includedPerks {\n      header {\n        text\n        accessibilityLabel\n      }\n      icon {\n        id\n        spotLight\n      }\n      iconAnalytics {\n        linkName\n        referrerId\n        uisPrimeMessages {\n          messageContent\n          schemaName\n        }\n      }\n      items {\n        accessibilityLabel\n        graphic {\n          ... on Icon {\n            description\n            id\n          }\n          ... on Mark {\n            description\n            id\n            url {\n              value\n            }\n          }\n        }\n        moreInfoDialog {\n          ...LodgingPlainFullscreenDialogFragment\n        }\n        text\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject34 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingAdaptExAnalyticsEventFragment on LodgingAdaptExAnalyticsEvent {\n    campaignId\n    clientSideAnalytics {\n      referrerId\n      eventType\n      linkName\n    }\n    events {\n      eventType\n      eventTarget\n      banditDisplayed\n      payloadId\n    }\n  }\n"
    ]);
    _templateObject35 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject36() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingSectionHeaderFragment on LodgingHeader {\n    text\n    accessibilityLabel\n    impressionAnalytics {\n      event\n      referrerId\n    }\n  }\n"
    ]);
    _templateObject36 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject37() {
    var data = _tagged_template_literal([
        "\n  fragment VerticalMessagingCardFragment on MessageResult {\n    title {\n      text\n    }\n    subtitle {\n      text\n    }\n    featuredImage {\n      url\n      description\n    }\n    action {\n      primary {\n        text\n        referrerId\n        actionDetails {\n          action\n          accessibilityLabel\n        }\n      }\n      secondary {\n        text\n        referrerId\n        actionDetails {\n          action\n          accessibilityLabel\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject37 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject38() {
    var data = _tagged_template_literal([
        "\n  fragment SpaceDetailsFloorPlanFragment on SpaceDetails {\n    floorPlan {\n      images {\n        alt\n        image {\n          description\n          url\n        }\n        subjectId\n      }\n      toolbar {\n        icon {\n          description\n          id\n          size\n        }\n        title\n      }\n      trigger {\n        value\n      }\n    }\n  }\n"
    ]);
    _templateObject38 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject39() {
    var data = _tagged_template_literal([
        "\n  fragment SpaceDetailsHeaderFragment on SpaceDetails {\n    header {\n      text\n    }\n    summary\n  }\n"
    ]);
    _templateObject39 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject40() {
    var data = _tagged_template_literal([
        "\n  fragment SpaceDetailsSpacesFragment on SpaceDetails {\n    spaces {\n      name\n      description\n      icons {\n        description\n        id\n        size\n      }\n    }\n  }\n"
    ]);
    _templateObject40 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject41() {
    var data = _tagged_template_literal([
        "\n  fragment VirtualTourPromptFragment on VirtualTourPrompt {\n    heading {\n      text\n    }\n    button {\n      accessibility\n      primary\n      icon {\n        description\n        id\n      }\n      action {\n        resource {\n          value\n        }\n        accessibility\n      }\n    }\n    heroImage {\n      description\n      url\n      cameraMovement\n    }\n    caption {\n      text\n    }\n  }\n"
    ]);
    _templateObject41 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject42() {
    var data = _tagged_template_literal([
        "\n  fragment SpaceDetailsFragment on SpaceDetails {\n    ...SpaceDetailsHeaderFragment\n    ...SpaceDetailsSpacesFragment\n    ...SpaceDetailsFloorPlanFragment\n    virtualTourPrompt {\n      ...VirtualTourPromptFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject42 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject43() {
    var data = _tagged_template_literal([
        "\n  fragment AvailabilityCallToActionFragment on AvailabilityCallToAction {\n    __typename\n    ... on LodgingPlainMessage {\n      value\n    }\n    ... on LodgingButton {\n      text\n    }\n  }\n"
    ]);
    _templateObject43 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject44() {
    var data = _tagged_template_literal([
        "\n  fragment AvailabilityCtaFragment on PropertyUnit {\n    availabilityCallToAction {\n      ... on LodgingPlainMessage {\n        value\n      }\n      ... on LodgingButton {\n        text\n      }\n    }\n  }\n"
    ]);
    _templateObject44 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject45() {
    var data = _tagged_template_literal([
        "\n  fragment SleepingArrangementsFragment on PropertyUnit {\n    spaceDetails {\n      ...SpaceDetailsHeaderFragment\n      ...SpaceDetailsSpacesFragment\n      ...SpaceDetailsFloorPlanFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject45 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject46() {
    var data = _tagged_template_literal([
        "\n  fragment PriceSummaryFragment on PropertyPrice {\n    displayMessages {\n      lineItems {\n        ...PriceMessageFragment\n        ...EnrichedMessageFragment\n      }\n    }\n    options {\n      leadingCaption\n      displayPrice {\n        formatted\n      }\n      disclaimer {\n        value\n      }\n      priceDisclaimer {\n        content\n        primaryButton {\n          text\n        }\n        trigger {\n          icon {\n            description\n          }\n        }\n      }\n      accessibilityLabel\n      strikeOut {\n        formatted\n      }\n      loyaltyPrice {\n        unit\n        amount {\n          formatted\n        }\n        totalStrikeOutPoints {\n          formatted\n        }\n      }\n    }\n    priceMessaging {\n      value\n      theme\n    }\n  }\n\n  fragment PriceMessageFragment on DisplayPrice {\n    __typename\n    role\n    price {\n      formatted\n      accessibilityLabel\n    }\n    disclaimer {\n      content\n      primaryUIButton {\n        accessibility\n        primary\n      }\n    }\n  }\n\n  fragment EnrichedMessageFragment on LodgingEnrichedMessage {\n    __typename\n    value\n    state\n  }\n"
    ]);
    _templateObject46 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject47() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingPriceSummaryFragment on Offer {\n    price {\n      options {\n        leadingCaption\n        displayPrice {\n          formatted\n        }\n        priceDisclaimer {\n          content\n          primaryButton {\n            text\n          }\n          trigger {\n            icon {\n              description\n            }\n          }\n        }\n        accessibilityLabel\n        strikeOut {\n          formatted\n        }\n        loyaltyPrice {\n          unit\n          amount {\n            formatted\n          }\n          totalStrikeOutPoints {\n            formatted\n          }\n        }\n      }\n      priceMessaging {\n        value\n        theme\n      }\n    }\n  }\n"
    ]);
    _templateObject47 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject48() {
    var data = _tagged_template_literal([
        "\n  fragment MarketingSectionFragment on MarketingSection {\n    title {\n      text\n    }\n    feeDialog {\n      title\n      content\n      tertiaryUIButton {\n        primary\n      }\n      trigger {\n        value\n        mark {\n          id\n        }\n        icon {\n          id\n          size\n        }\n        clientSideAnalytics {\n          linkName\n          referrerId\n        }\n      }\n    }\n    paymentDetails {\n      ...LodgingEnrichedMessageFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject48 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject49() {
    var data = _tagged_template_literal([
        "\n  fragment UIPrimaryButtonFragment on UIPrimaryButton {\n    primary\n    accessibility\n    action {\n      __typename\n      analytics {\n        referrerId\n        linkName\n      }\n      ... on UILinkAction {\n        resource {\n          value\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject49 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject50() {
    var data = _tagged_template_literal([
        "\n  fragment UISecondaryButtonFragment on UISecondaryButton {\n    primary\n    action {\n      __typename\n      analytics {\n        referrerId\n        linkName\n      }\n      ... on UILinkAction {\n        resource {\n          value\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject50 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject51() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingPlainDialogFragment on LodgingPlainDialog {\n    content\n    primaryUIButton {\n      ...UIPrimaryButtonFragment\n    }\n    secondaryUIButton {\n      ...UISecondaryButtonFragment\n    }\n    primaryButton {\n      text\n      analytics {\n        linkName\n        referrerId\n      }\n    }\n    trigger {\n      clientSideAnalytics {\n        linkName\n        referrerId\n      }\n      icon {\n        description\n        id\n      }\n      theme\n      value\n      secondaryValue\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject51 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject52() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingPlainMessageFragment on LodgingPlainMessage {\n    value\n  }\n"
    ]);
    _templateObject52 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject53() {
    var data = _tagged_template_literal([
        "\n  fragment PrimaryInfoFragment on PrimaryInfo {\n    heading {\n      text\n    }\n    subheading {\n      text\n    }\n  }\n"
    ]);
    _templateObject53 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject54() {
    var data = _tagged_template_literal([
        "\n  fragment SecondaryInfoFragment on SecondaryInfo {\n    title {\n      text\n    }\n    message\n  }\n"
    ]);
    _templateObject54 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject55() {
    var data = _tagged_template_literal([
        "\n  fragment MessageSectionsFragment on LodgingPolicy {\n    messageSections {\n      primaryInfo {\n        ...PrimaryInfoFragment\n      }\n      secondaryInfo {\n        ...SecondaryInfoFragment\n      }\n    }\n  }\n  ",
        ",\n  ",
        "\n"
    ]);
    _templateObject55 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject56() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingStepIndicatorFragment on LodgingStepIndicator {\n    accessibilityLabel\n    steppers {\n      text {\n        text\n      }\n      state\n      track {\n        text {\n          text\n          accessibility\n        }\n        position\n      }\n    }\n  }\n"
    ]);
    _templateObject56 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject57() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingPolicyFragment on LodgingPolicy {\n    title {\n      text\n    }\n    stepIndicator {\n      ...LodgingStepIndicatorFragment\n    }\n    ...MessageSectionsFragment\n    policyClientSideAnalytics {\n      linkName\n      referrerId\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject57 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject58() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingDetailedTimelineFragment on LodgingDetailedTimeline {\n    title {\n      ... on EGDSStylizedText {\n        text\n      }\n      ... on EGDSGraphicText {\n        text\n      }\n    }\n    policies {\n      ...LodgingPolicyFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject58 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject59() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingPolicyDialogFragment on LodgingPolicyDialog {\n    policyContent {\n      ...LodgingDetailedTimelineFragment\n    }\n    trigger {\n      clientSideAnalytics {\n        linkName\n        referrerId\n      }\n      icon {\n        description\n        id\n      }\n      theme\n      value\n      secondaryValue\n      accessibilityLabel\n    }\n    toolbar {\n      title\n      icon {\n        description\n        __typename\n      }\n      clientSideAnalytics {\n        linkName\n        referrerId\n        __typename\n      }\n      __typename\n    }\n    __typename\n  }\n  ",
        "\n"
    ]);
    _templateObject59 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject60() {
    var data = _tagged_template_literal([
        "\n  fragment RatePlanMessageFragment on RatePlanMessage {\n    ...LodgingPlainDialogFragment\n    ...LodgingEnrichedMessageFragment\n    ...LodgingPlainMessageFragment\n    ...LodgingPolicyDialogFragment\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject60 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject61() {
    var data = _tagged_template_literal([
        "\n  fragment HighlightedMessagesFragment on RatePlan {\n    id\n    highlightedMessages {\n      ...LodgingPlainDialogFragment\n      ...LodgingEnrichedMessageFragment\n      ...LodgingPlainMessageFragment\n      ...LodgingPolicyDialogFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject61 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject62() {
    var data = _tagged_template_literal([
        "\n  fragment PriceSummaryFooterFragment on PriceSummaryFooter {\n    footerMessages {\n      ...LodgingEnrichedMessageFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject62 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject63() {
    var data = _tagged_template_literal([
        "\n  fragment PriceSummaryLineItemFragment on PriceSummaryLineItem {\n    name {\n      primaryMessage {\n        ...LodgingEnrichedMessageFragment\n      }\n      secondaryMessages {\n        ...LodgingEnrichedMessageFragment\n      }\n    }\n    value {\n      primaryMessage {\n        ...LodgingEnrichedMessageFragment\n      }\n      secondaryMessages {\n        ...LodgingEnrichedMessageFragment\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject63 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject64() {
    var data = _tagged_template_literal([
        "\n  fragment PriceSummarySectionFragment on PriceSummarySection {\n    sectionHeading {\n      ...LodgingEnrichedMessageFragment\n    }\n    sectionFooter {\n      ...PriceSummaryFooterFragment\n    }\n    items {\n      ...PriceSummaryLineItemFragment\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject64 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject65() {
    var data = _tagged_template_literal([
        "\n  fragment PriceBreakdownSummaryFragment on Offer {\n    priceBreakDownSummary {\n      priceSummaryHeading {\n        ...LodgingEnrichedMessageFragment\n      }\n      sections {\n        ...PriceSummarySectionFragment\n      }\n      disclaimers {\n        ...LodgingEnrichedMessageFragment\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject65 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject66() {
    var data = _tagged_template_literal([
        "\n  fragment PricePresentationDialogFragment on Offer {\n    pricePresentationDialog {\n      toolbar {\n        title\n        icon {\n          ...IconFragment\n        }\n        clientSideAnalytics {\n          linkName\n          referrerId\n        }\n      }\n      trigger {\n        clientSideAnalytics {\n          linkName\n          referrerId\n        }\n        accessibilityLabel\n        value\n      }\n    }\n    pricePresentation {\n      title {\n        primary\n      }\n      sections {\n        ...PricePresentationSectionFragment\n      }\n      footer {\n        header\n        messages {\n          ...PriceLineElementFragment\n        }\n      }\n    }\n  }\n\n  fragment PricePresentationSectionFragment on PricePresentationSection {\n    header {\n      name {\n        ...PricePresentationLineItemEntryFragment\n      }\n      enrichedValue {\n        ...PricePresentationLineItemEntryFragment\n      }\n    }\n    subSections {\n      ...PricePresentationSubSectionFragment\n    }\n  }\n\n  fragment PricePresentationSubSectionFragment on PricePresentationSubSection {\n    header {\n      name {\n        primaryMessage {\n          __typename\n          ... on PriceLineText {\n            primary\n          }\n          ... on PriceLineHeading {\n            primary\n          }\n        }\n      }\n      enrichedValue {\n        ...PricePresentationLineItemEntryFragment\n      }\n    }\n    items {\n      ...PricePresentationLineItemFragment\n    }\n  }\n\n  fragment PricePresentationLineItemFragment on PricePresentationLineItem {\n    enrichedValue {\n      ...PricePresentationLineItemEntryFragment\n    }\n    name {\n      ...PricePresentationLineItemEntryFragment\n    }\n  }\n\n  fragment PricePresentationLineItemEntryFragment on PricePresentationLineItemEntry {\n    primaryMessage {\n      ...PriceLineElementFragment\n    }\n    secondaryMessages {\n      ...PriceLineElementFragment\n    }\n  }\n\n  fragment PriceLineElementFragment on PricePresentationLineItemMessage {\n    __typename\n    ...PriceLineTextFragment\n    ...PriceLineHeadingFragment\n    ...PriceLineBadgeFragment\n    ...InlinePriceLineTextFragment\n  }\n\n  fragment PriceLineTextFragment on PriceLineText {\n    __typename\n    theme\n    primary\n    weight\n    additionalInfo {\n      ...AdditionalInformationPopoverFragment\n    }\n    icon {\n      ...IconFragment\n    }\n    graphic {\n      ...UIGraphicFragment\n    }\n  }\n  ",
        "\n\n  fragment AdditionalInformationPopoverFragment on AdditionalInformationPopover {\n    icon {\n      ...IconFragment\n    }\n    enrichedSecondaries {\n      ...AdditionalInformationPopoverSectionFragment\n    }\n    analytics {\n      linkName\n      referrerId\n    }\n  }\n\n  fragment AdditionalInformationPopoverSectionFragment on AdditionalInformationPopoverSection {\n    __typename\n    ... on AdditionalInformationPopoverTextSection {\n      ...AdditionalInformationPopoverTextSectionFragment\n    }\n    ... on AdditionalInformationPopoverListSection {\n      ...AdditionalInformationPopoverListSectionFragment\n    }\n    ... on AdditionalInformationPopoverGridSection {\n      ...AdditionalInformationPopoverGridSectionFragment\n    }\n  }\n\n  fragment AdditionalInformationPopoverTextSectionFragment on AdditionalInformationPopoverTextSection {\n    __typename\n    text {\n      __typename\n      text\n      ... on EGDSStandardLink {\n        standardLinkIcon: icon {\n          ...IconFragment\n        }\n        action {\n          accessibility\n          analytics {\n            linkName\n            referrerId\n          }\n          resource {\n            value\n          }\n          target\n        }\n        iconPosition\n        size\n        text\n      }\n    }\n  }\n\n  fragment AdditionalInformationPopoverListSectionFragment on AdditionalInformationPopoverListSection {\n    __typename\n    content {\n      __typename\n      items {\n        text\n      }\n    }\n  }\n\n  fragment AdditionalInformationPopoverGridSectionFragment on AdditionalInformationPopoverGridSection {\n    __typename\n    subSections {\n      header {\n        name {\n          primaryMessage {\n            ...AdditionalInformationPopoverGridLineItemMessageFragment\n          }\n        }\n      }\n      items {\n        name {\n          ...AdditionalInformationPopoverGridLineItemEntryFragment\n        }\n        enrichedValue {\n          ...AdditionalInformationPopoverGridLineItemEntryFragment\n        }\n      }\n    }\n  }\n\n  fragment AdditionalInformationPopoverGridLineItemEntryFragment on PricePresentationLineItemEntry {\n    primaryMessage {\n      ...AdditionalInformationPopoverGridLineItemMessageFragment\n    }\n    secondaryMessages {\n      ...AdditionalInformationPopoverGridLineItemMessageFragment\n    }\n  }\n\n  fragment AdditionalInformationPopoverGridLineItemMessageFragment on PricePresentationLineItemMessage {\n    ... on PriceLineText {\n      __typename\n      primary\n    }\n    ... on PriceLineHeading {\n      __typename\n      tag\n      size\n      primary\n    }\n  }\n\n  fragment PriceLineHeadingFragment on PriceLineHeading {\n    __typename\n    primary\n    tag\n    size\n    additionalInfo {\n      ...AdditionalInformationPopoverFragment\n    }\n    icon {\n      ...IconFragment\n    }\n  }\n\n  fragment PriceLineBadgeFragment on PriceLineBadge {\n    __typename\n    badge {\n      accessibility\n      text\n      theme\n    }\n  }\n\n  fragment InlinePriceLineTextFragment on InlinePriceLineText {\n    __typename\n    inlineItems {\n      ...PriceLineTextFragment\n    }\n  }\n"
    ]);
    _templateObject66 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject67() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingPlainSheetFragment on LodgingPlainDialog {\n    __typename\n    content\n    trigger {\n      clientSideAnalytics {\n        linkName\n        referrerId\n      }\n      icon {\n        description\n        id\n      }\n      theme\n      value\n    }\n    toolbar {\n      title\n      icon {\n        description\n      }\n      clientSideAnalytics {\n        linkName\n        referrerId\n      }\n    }\n  }\n"
    ]);
    _templateObject67 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject68() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyFeaturesFragment on PropertyInfoItem {\n    text\n    graphic {\n      __typename\n      ... on Icon {\n        description\n        id\n      }\n      ... on Mark {\n        description\n        id\n        url {\n          value\n        }\n      }\n    }\n    moreInfoDialog {\n      ...LodgingPlainSheetFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject68 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject69() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyOffersPriceChangeMessageFragment on RatePlan {\n    headerMessage {\n      ...LodgingEnrichedMessageFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject69 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject70() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyOffersRateViewScarcityFragment on Offer {\n    availability {\n      scarcityMessage\n    }\n  }\n"
    ]);
    _templateObject70 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject71() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyRatePlanBadgeFragment on RatePlan {\n    badge {\n      theme_temp\n      text\n      icon_temp {\n        id\n        description\n        title\n      }\n    }\n  }\n"
    ]);
    _templateObject71 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject72() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyInfoMessageFragment on PropertyInfoItem {\n    text\n    icon {\n      id\n      token\n    }\n    state\n    graphic {\n      ... on Mark {\n        description\n        markUrl: url {\n          relativePath\n          value\n        }\n        size\n        id\n      }\n    }\n  }\n"
    ]);
    _templateObject72 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject73() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingEGDSGraphicTextFragment on EGDSGraphicText {\n    text\n    graphic {\n      ... on Icon {\n        id\n        size\n      }\n    }\n  }\n"
    ]);
    _templateObject73 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject74() {
    var data = _tagged_template_literal([
        "\n  fragment DatelessCheckAvailabilityFragment on DatelessCheckAvailability {\n    checkAvailabilityButton {\n      ...LodgingEGDSButtonFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject74 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject75() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSActionDialogFragment on EGDSActionDialog {\n    closeAnalytics {\n      referrerId\n      linkName\n    }\n    footer {\n      ... on EGDSStackedDialogFooter {\n        buttons {\n          ... on EGDSOverlayButton {\n            __typename\n          }\n        }\n      }\n      ... on EGDSInlineDialogFooter {\n        buttons {\n          ... on UIPrimaryButton {\n            accessibility\n            primary\n            disabled\n            action {\n              ... on UILinkAction {\n                resource {\n                  value\n                }\n                analytics {\n                  linkName\n                  referrerId\n                }\n              }\n            }\n          }\n          ... on UITertiaryButton {\n            accessibility\n            primary\n            action {\n              ... on UILinkAction {\n                resource {\n                  value\n                }\n              }\n            }\n            disabled\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject75 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject76() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSDialogFragment on EGDSDialog {\n    ...EGDSActionDialogFragment\n  }\n  ",
        "\n"
    ]);
    _templateObject76 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject77() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSParagraphFragment on EGDSParagraph {\n    text\n    style\n  }\n"
    ]);
    _templateObject77 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject78() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingMemberSignInDialogFragment on LodgingMemberSignInDialog {\n    dialogTrigger: trigger {\n      value\n      accessibilityLabel\n    }\n    title\n    dialogContent {\n      ...EGDSParagraphFragment\n    }\n    actionDialog {\n      ...EGDSActionDialogFragment\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject78 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject79() {
    var data = _tagged_template_literal([
        "\n  mutation SelectProducts(\n    $context: ContextInput!\n    $sessionId: String!\n    $priceToken: String\n    $properties: [PropertyNaturalKeyInput!]\n    $flights: [FlightNaturalKeyInput!]\n    $cars: [CarNaturalKeyInput!]\n    $dealMarker: String\n  ) {\n    multiItemShopping(context: $context) {\n      selectProducts(\n        sessionId: $sessionId\n        priceToken: $priceToken\n        properties: $properties\n        flights: $flights\n        cars: $cars\n        dealMarker: $dealMarker\n      ) {\n        ... on MultiItemSearchContextCreatedResponse {\n          shoppingContext {\n            multiItem {\n              id\n              packageType\n            }\n          }\n          redirectUrl\n        }\n        ... on MultiItemSearchContextErrorResponse {\n          message\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject79 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject80() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyLodgingFormButtonFragment on LodgingForm {\n    action\n    inputs {\n      ... on LodgingTextInput {\n        name\n        type\n        value\n      }\n    }\n    method\n    submit {\n      text\n      accessibilityLabel\n      analytics {\n        linkName\n        referrerId\n      }\n      adaptExSuccessEvents {\n        ...LodgingAdaptExAnalyticsEventFragment\n      }\n      lodgingRecommendationClickstreamEvent {\n        recommendationResponseId\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject80 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject81() {
    var data = _tagged_template_literal([
        "\n  mutation lodgingPropertyCheckoutPrepareCheckout(\n    $context: ContextInput!\n    $activities: [ActivityNaturalKeyInput!]\n    $properties: [PropertyNaturalKeyInput!]\n    $totalPrice: MoneyInput\n    $checkoutOptions: [CheckoutOptionInput!]\n    $offerTokens: [OfferTokenInput!]\n  ) {\n    prepareCheckout(\n      context: $context\n      activities: $activities\n      properties: $properties\n      totalPrice: $totalPrice\n      checkoutOptions: $checkoutOptions\n      offerTokens: $offerTokens\n    ) {\n      __typename\n      tripId\n      checkoutUrl\n      failureReason {\n        description\n        message\n      }\n    }\n  }\n"
    ]);
    _templateObject81 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject82() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyLodgingPrepareCheckoutFragment on LodgingPrepareCheckout {\n    checkoutButton {\n      ...UIPrimaryButtonFragment\n      __typename\n    }\n    action {\n      checkoutOptions {\n        type\n        value\n        __typename\n      }\n      offerTokens {\n        token\n        lineOfBusiness\n        __typename\n      }\n      totalPrice {\n        amount\n        currencyInfo {\n          code\n          __typename\n        }\n        __typename\n      }\n      analytics {\n        eventType\n        linkName\n        referrerId\n        __typename\n      }\n      analyticsList {\n        eventType\n        linkName\n        referrerId\n      }\n      lodgingRecommendationClickstreamEvent {\n        recommendationResponseId\n      }\n      __typename\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject82 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject83() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyPaymentPriceFragment on Offer {\n    price {\n      lead {\n        formatted\n      }\n      priceMessaging {\n        value\n        theme\n      }\n      options {\n        leadingCaption\n        displayPrice {\n          formatted\n        }\n        disclaimer {\n          value\n        }\n        priceDisclaimer {\n          content\n          primaryButton {\n            text\n          }\n          trigger {\n            icon {\n              description\n            }\n          }\n        }\n        accessibilityLabel\n        strikeOut {\n          formatted\n        }\n        loyaltyPrice {\n          unit\n          amount {\n            formatted\n          }\n          totalStrikeOutPoints {\n            formatted\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject83 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject84() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyPaymentOptionsFragment on Offer {\n    loyaltyMessage {\n      ... on LodgingEnrichedMessage {\n        value\n        state\n      }\n    }\n    lodgingPrepareCheckout {\n      ...PropertyLodgingPrepareCheckoutFragment\n    }\n    offerBookButton {\n      ...PropertyLodgingFormButtonFragment\n    }\n    ...PropertyPaymentPriceFragment\n    price {\n      ...PriceSummaryFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject84 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject85() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyReserveButtonFragment on RatePlan {\n    id\n    reserveCallToAction {\n      __typename\n      ... on EtpDialog {\n        content {\n          ... on LodgingPaymentOptionsDialogContent {\n            messages {\n              ...LodgingEGDSGraphicTextFragment\n            }\n          }\n        }\n        trigger {\n          value\n          accessibilityLabel\n        }\n        toolbar {\n          icon {\n            description\n          }\n          title\n        }\n      }\n      ... on LodgingForm {\n        ...PropertyLodgingFormButtonFragment\n      }\n      ... on LodgingMemberSignInDialog {\n        ...LodgingMemberSignInDialogFragment\n      }\n      ... on DatelessCheckAvailability {\n        ...DatelessCheckAvailabilityFragment\n      }\n    }\n    etpDialogTopMessage {\n      ...MessageResultFragment\n    }\n    priceDetails {\n      action {\n        ... on SelectPackageActionInput {\n          packageOfferId\n          __typename\n        }\n      }\n      price {\n        multiItemPriceToken\n      }\n      hotelCollect\n      propertyNaturalKeys {\n        id\n        businessModelType\n        checkIn {\n          month\n          day\n          year\n        }\n        checkOut {\n          month\n          day\n          year\n        }\n        inventoryType\n        noCreditCard\n        petsIncluded\n        ratePlanId\n        roomTypeId\n        ratePlanType\n        rooms {\n          childAges\n          numberOfAdults\n        }\n        shoppingPath\n      }\n      noCreditCard\n      paymentModel\n      ...PropertyPaymentOptionsFragment\n      dealMarker\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject85 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject86() {
    var data = _tagged_template_literal([
        "\n  fragment RatePlanAmenitiesFragment on RatePlanAmenity {\n    icon {\n      id\n      description\n      size\n    }\n    description\n    additionalInformation\n    id\n  }\n"
    ]);
    _templateObject86 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject87() {
    var data = _tagged_template_literal([
        "\n  fragment RatePlanAnalyticsFragment on RatePlan {\n    clientSideAnalytics {\n      referrerId\n      linkName\n      uisPrimeMessages {\n        messageContent\n        schemaName\n      }\n    }\n  }\n"
    ]);
    _templateObject87 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject88() {
    var data = _tagged_template_literal([
        "\n  fragment RatePlanWithAmenitiesFragment on RatePlan {\n    ...RatePlanAnalyticsFragment\n    shareUrl {\n      accessibilityLabel\n      value\n      link {\n        clientSideAnalytics {\n          linkName\n          referrerId\n        }\n        uri {\n          relativePath\n        }\n      }\n    }\n    id\n    amenities {\n      ...RatePlanAmenitiesFragment\n    }\n    ...PropertyRatePlanBadgeFragment\n    paymentPolicy {\n      paymentType\n      heading\n      price {\n        ...PriceSummaryFragment\n      }\n      descriptions {\n        heading\n        header {\n          text\n          mark {\n            id\n            url {\n              value\n            }\n          }\n        }\n        items {\n          ...PropertyInfoMessageFragment\n        }\n      }\n    }\n    priceDetails {\n      optionTitle {\n        text\n      }\n      pointsApplied\n      ...PropertyOffersRateViewScarcityFragment\n      ...LodgingPriceSummaryFragment\n      ...PriceBreakdownSummaryFragment\n      ...PricePresentationDialogFragment\n      price {\n        ...PriceSummaryFragment\n      }\n    }\n    marketingSection {\n      ...MarketingSectionFragment\n    }\n    ...HighlightedMessagesFragment\n    ...PropertyOffersPriceChangeMessageFragment\n    ...PropertyReserveButtonFragment\n    loyaltyMessage {\n      ...LodgingEnrichedMessageFragment\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject88 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject89() {
    var data = _tagged_template_literal([
        "\n  fragment ExpandoItemsCardFragment on LodgingExpandoItemsCard {\n    expando {\n      collapsedLabel\n      expandedLabel\n      expanded\n    }\n    header {\n      accessibilityLabel\n      egdsStandardBadge {\n        accessibility\n        theme\n        text\n      }\n      label\n      subText\n      text\n    }\n    items {\n      icon {\n        description\n        id\n      }\n      impressionAnalytics {\n        referrerId\n        linkName\n        event\n      }\n      subText\n      text\n    }\n  }\n"
    ]);
    _templateObject89 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject90() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyDialogFeaturesFragment on PropertyInfoItem {\n    __typename\n    text\n    icon {\n      id\n      description\n    }\n  }\n"
    ]);
    _templateObject90 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject91() {
    var data = _tagged_template_literal([
        "\n  fragment RoomAmenityContentTextFragment on PropertyContentItemMarkup {\n    content {\n      text\n    }\n  }\n"
    ]);
    _templateObject91 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject92() {
    var data = _tagged_template_literal([
        "\n  fragment RoomAmenityContentFragment on PropertyContent {\n    header {\n      text\n      icon {\n        id\n      }\n    }\n    items {\n      ... on PropertyContentItemMarkup {\n        ...RoomAmenityContentTextFragment\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject92 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject93() {
    var data = _tagged_template_literal([
        "\n  fragment RoomAmenitiesDescriptionFragment on PropertyContentSection {\n    header {\n      text\n    }\n    bodySubSections {\n      contents {\n        ...RoomAmenityContentFragment\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject93 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject94() {
    var data = _tagged_template_literal([
        "\n  fragment UnitPropertyOffersDetailsDialogFragment on PropertyUnitDetailsDialog {\n    toolbar {\n      title\n      icon {\n        description\n      }\n    }\n    content {\n      ratePlanTitle {\n        text\n      }\n      dialogFeatures {\n        listItems {\n          text\n          icon {\n            id\n            description\n          }\n        }\n      }\n      details {\n        header {\n          text\n          subText\n        }\n        contents {\n          heading\n          items {\n            text\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject94 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject95() {
    var data = _tagged_template_literal([
        "\n  fragment LinkTriggerFragment on LodgingDialogTriggerMessage {\n    value\n    accessibilityLabel\n  }\n"
    ]);
    _templateObject95 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject96() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyOffersHeaderFragment on LodgingHeader {\n    text\n    subText\n  }\n"
    ]);
    _templateObject96 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject97() {
    var data = _tagged_template_literal([
        "\n  fragment RatePlansExpandoFragment on RatePlansExpando {\n    collapseButton {\n      text\n    }\n    expandButton {\n      text\n    }\n  }\n"
    ]);
    _templateObject97 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject98() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyUnitFragment on PropertyUnit {\n    __typename\n    ... on PropertyUnit {\n      id\n      header {\n        ...PropertyOffersHeaderFragment\n      }\n      features {\n        ...PropertyFeaturesFragment\n      }\n      unitGallery {\n        accessibilityLabel\n        images {\n          image {\n            description\n            url\n          }\n        }\n      }\n      ratePlans {\n        ...RatePlanWithAmenitiesFragment\n      }\n      ratePlansExpando {\n        ...RatePlansExpandoFragment\n      }\n      ...AvailabilityCtaFragment\n      roomAmenities {\n        ...RoomAmenitiesDescriptionFragment\n      }\n      detailsDialog {\n        ...UnitPropertyOffersDetailsDialogFragment\n        toolbar {\n          clientSideAnalytics {\n            referrerId\n            linkName\n          }\n        }\n        trigger {\n          ...LinkTriggerFragment\n          clientSideAnalytics {\n            referrerId\n            linkName\n          }\n        }\n      }\n      spaceDetails {\n        ...SpaceDetailsFragment\n      }\n      ...SleepingArrangementsFragment\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject98 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject99() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingNotificationsCardFragment on LodgingNotificationsCard {\n    header {\n      text\n    }\n    messages {\n      ...LodgingEnrichedMessageFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject99 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject100() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyRatePlanStandardBadgeFragment on RatePlan {\n    standardBadge {\n      standardBadge {\n        theme\n        text\n        graphic {\n          __typename\n          ... on Icon {\n            description\n            id\n          }\n          ... on Mark {\n            description\n            id\n          }\n        }\n      }\n      impressionEventAnalytics {\n        referrerId\n        linkName\n        event\n      }\n    }\n  }\n"
    ]);
    _templateObject100 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject101() {
    var data = _tagged_template_literal([
        "\n  fragment UnitCategorizationRatePlanFragment on RatePlan {\n    ...RatePlanAnalyticsFragment\n    shareUrl {\n      accessibilityLabel\n      value\n      link {\n        clientSideAnalytics {\n          linkName\n          referrerId\n        }\n        uri {\n          relativePath\n        }\n      }\n    }\n    id\n    loyaltyMessage {\n      ...LodgingEnrichedMessageFragment\n    }\n    paymentPolicy {\n      paymentType\n      heading\n      descriptions {\n        heading\n        header {\n          text\n          mark {\n            id\n            url {\n              value\n            }\n          }\n        }\n        items {\n          text\n          icon {\n            id\n            token\n          }\n        }\n      }\n      price {\n        ...PriceSummaryFragment\n      }\n    }\n    priceDetails {\n      pointsApplied\n      ...PropertyOffersRateViewScarcityFragment\n      ...LodgingPriceSummaryFragment\n      ...PriceBreakdownSummaryFragment\n      ...PricePresentationDialogFragment\n      price {\n        ...PriceSummaryFragment\n      }\n    }\n    ...HighlightedMessagesFragment\n    ...PropertyOffersPriceChangeMessageFragment\n    ...PropertyRatePlanBadgeFragment\n    ...PropertyRatePlanStandardBadgeFragment\n    ...PropertyReserveButtonFragment\n    offerNotifications {\n      ...LodgingNotificationsCardFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject101 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject102() {
    var data = _tagged_template_literal([
        "\n  fragment UnitCategorizationComplexDialogFragment on LodgingComplexDialog {\n    content {\n      content\n      title {\n        text\n      }\n    }\n    primaryUIButton {\n      ...UIPrimaryButtonFragment\n    }\n    toolbar {\n      title\n      icon {\n        description\n      }\n      clientSideAnalytics {\n        linkName\n        referrerId\n      }\n    }\n    trigger {\n      clientSideAnalytics {\n        linkName\n        referrerId\n      }\n      icon {\n        id\n        description\n      }\n      value\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject102 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject103() {
    var data = _tagged_template_literal([
        "\n  fragment SelectionHeaderDialogFragment on LodgingOfferSelectionHeaderDialog {\n    ...UnitCategorizationComplexDialogFragment\n    ...LodgingPolicyDialogFragment\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject103 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject104() {
    var data = _tagged_template_literal([
        "\n  fragment SelectionHeaderFragment on LodgingOfferSelectionHeader {\n    title {\n      text\n      subText\n      accessibilityLabel\n    }\n    dialog {\n      ...UnitCategorizationComplexDialogFragment\n    }\n    complexDialog {\n      ...SelectionHeaderDialogFragment\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject104 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject105() {
    var data = _tagged_template_literal([
        "\n  fragment UnitCategorizationPropertyUnitFragment on PropertyUnit {\n    ...AvailabilityCtaFragment\n    detailsDialog {\n      ...UnitPropertyOffersDetailsDialogFragment\n      toolbar {\n        clientSideAnalytics {\n          referrerId\n          linkName\n        }\n      }\n      trigger {\n        ...LinkTriggerFragment\n        clientSideAnalytics {\n          referrerId\n          linkName\n        }\n      }\n    }\n    id\n    ratePlans {\n      ...RatePlanWithAmenitiesFragment\n      ...UnitCategorizationRatePlanFragment\n    }\n    roomAmenities {\n      ...RoomAmenitiesDescriptionFragment\n    }\n    unitGallery {\n      accessibilityLabel\n      images {\n        image {\n          description\n          url\n        }\n      }\n    }\n    spaceDetails {\n      ...SpaceDetailsFragment\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject105 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject106() {
    var data = _tagged_template_literal([
        "\n  fragment UnitCategorizationSelectionFragment on LodgingOfferOption {\n    clientSideAnalytics {\n      linkName\n      referrerId\n    }\n    description\n    enabled\n    optionId\n    price\n    subText\n    accessibilityLabel\n    liveAnnounceMessage\n    liveAnnouncePoliteness\n    selected\n  }\n"
    ]);
    _templateObject106 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject107() {
    var data = _tagged_template_literal([
        "\n  fragment UnitCategorizationFragment on LodgingCategorizedUnit {\n    primarySelections {\n      propertyUnit {\n        ...UnitCategorizationPropertyUnitFragment\n      }\n      primarySelection {\n        ...UnitCategorizationSelectionFragment\n      }\n      secondarySelections {\n        recommendedSelection\n        secondarySelection {\n          ...UnitCategorizationSelectionFragment\n          dialog {\n            ...LodgingPlainFullscreenDialogFragment\n          }\n        }\n        tertiarySelections {\n          ...UnitCategorizationSelectionFragment\n          dialog {\n            ...LodgingPlainFullscreenDialogFragment\n          }\n        }\n      }\n    }\n    primaryHeader {\n      ...SelectionHeaderFragment\n    }\n    secondaryHeader {\n      ...SelectionHeaderFragment\n    }\n    tertiaryHeader {\n      ...SelectionHeaderFragment\n    }\n    footerButton {\n      primary\n      accessibility\n      analytics {\n        linkName\n        referrerId\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject107 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject108() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyUnitCardFragment on LodgingCategorizedUnit {\n    header {\n      ...PropertyOffersHeaderFragment\n    }\n    features {\n      ...PropertyFeaturesFragment\n    }\n    highlightedMessages {\n      ...RatePlanMessageFragment\n    }\n    featureHeader {\n      text\n    }\n    expandoItemsCard {\n      ...ExpandoItemsCardFragment\n    }\n    ...UnitCategorizationFragment\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject108 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject109() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyUnitCategorizationFragment on LodgingCategorizedUnit {\n    __typename\n    header {\n      ...PropertyOffersHeaderFragment\n    }\n    features {\n      ...PropertyFeaturesFragment\n    }\n    highlightedMessages {\n      ...RatePlanMessageFragment\n    }\n    featureHeader {\n      text\n    }\n    expandoItemsCard {\n      ...ExpandoItemsCardFragment\n    }\n    ...UnitCategorizationFragment\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject109 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject110() {
    var data = _tagged_template_literal([
        "\n  fragment ListingsFragment on OfferDetails {\n    listings {\n      ...PropertyUnitFragment\n    }\n    categorizedListings {\n      ...PropertyUnitCategorizationFragment\n      ...VerticalMessagingCardFragment\n      ...LodgingSectionHeaderFragment\n    }\n    offerAdaptExSuccessEvents {\n      ...LodgingAdaptExAnalyticsEventFragment\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject110 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject111() {
    var data = _tagged_template_literal([
        "\n  fragment ErrorMessageFragment on MessageResult {\n    title {\n      text\n    }\n    action {\n      primary {\n        text\n        linkUrl\n      }\n    }\n  }\n"
    ]);
    _templateObject111 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject112() {
    var data = _tagged_template_literal([
        "\n  fragment ListingsErrorMessageFragment on OfferDetails {\n    errorMessage {\n      ...ErrorMessageFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject112 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject113() {
    var data = _tagged_template_literal([
        "\n  fragment ShoppingContextFragment on OfferDetails {\n    shoppingContext {\n      multiItem {\n        id\n        packageType\n      }\n    }\n  }\n"
    ]);
    _templateObject113 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject114() {
    var data = _tagged_template_literal([
        "\n  fragment StickyBarDisclaimerFragment on OfferDetails {\n    stickyBar {\n      price {\n        disclaimer {\n          value\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject114 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject115() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyOffersFragment on OfferDetails {\n    ...ListingsHeaderFragment\n    ...AlternateDatesFragment\n    ...ListingsErrorMessageFragment\n    ...ListingsFragment\n    ...StickyBarDisclaimerFragment\n    ...ShoppingContextFragment\n    offerLevelMessages {\n      ...MessageResultFragment\n    }\n    ...PropertyFilterPillsFragment\n    ...FilterPillsFragment\n    ...PropertyOffersIncludedPerksFragment\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject115 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject116() {
    var data = _tagged_template_literal([
        "\n  fragment OffersLodgingLinkMessageFragment on LodgingLinkMessage {\n    icon {\n      id\n    }\n    link {\n      clientSideAnalytics {\n        referrerId\n        linkName\n      }\n      uri {\n        relativePath\n        value\n      }\n      referrerId\n    }\n    value\n  }\n"
    ]);
    _templateObject116 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject117() {
    var data = _tagged_template_literal([
        "\n  fragment PropertySearchLinkFragment on OfferDetails {\n    propertySearchLink {\n      ...OffersLodgingLinkMessageFragment\n    }\n    partnerPropertySearchLink {\n      ...OffersLodgingLinkMessageFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject117 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject118() {
    var data = _tagged_template_literal([
        "\n  fragment AlternateAvailabilityMsgFragment on LodgingComplexLinkMessage {\n    text {\n      value\n    }\n    actionLink {\n      link {\n        uri {\n          relativePath\n          value\n        }\n      }\n      value\n    }\n  }\n"
    ]);
    _templateObject118 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject119() {
    var data = _tagged_template_literal([
        "\n  fragment SingleOfferAvailabilityCtaFragment on SingleUnitOfferDetails {\n    availabilityCallToAction {\n      ... on LodgingPlainMessage {\n        value\n      }\n      ... on LodgingButton {\n        text\n      }\n    }\n  }\n"
    ]);
    _templateObject119 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject120() {
    var data = _tagged_template_literal([
        "\n  fragment PriceMessagesFragment on SingleUnitOfferDetails {\n    displayPrice {\n      priceMessages {\n        ...LodgingEnrichedMessageFragment\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject120 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject121() {
    var data = _tagged_template_literal([
        "\n  fragment SingleUnitPriceSummaryFragment on RatePlan {\n    ...PropertyOffersPriceChangeMessageFragment\n    ...PropertyRatePlanBadgeFragment\n    priceDetails {\n      pointsApplied\n      ...LodgingPriceSummaryFragment\n      price {\n        ...PriceSummaryFragment\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject121 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject122() {
    var data = _tagged_template_literal([
        "\n  fragment PropertySingleOfferDetailsFragment on SingleUnitOfferDetails {\n    id\n    ...PriceMessagesFragment\n    ratePlans {\n      ...SingleUnitPriceSummaryFragment\n      ...HighlightedMessagesFragment\n    }\n    ...SingleOfferAvailabilityCtaFragment\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject122 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject123() {
    var data = _tagged_template_literal([
        "\n  fragment ReservePropertyFragment on RatePlan {\n    paymentPolicy {\n      paymentType\n      heading\n      descriptions {\n        heading\n        header {\n          text\n          mark {\n            id\n            token\n            url {\n              value\n            }\n          }\n        }\n        items {\n          ...PropertyInfoMessageFragment\n          icon {\n            id\n            token\n          }\n        }\n      }\n      price {\n        ...PriceSummaryFragment\n      }\n    }\n    priceDetails {\n      ...PriceBreakdownSummaryFragment\n    }\n    ...PropertyReserveButtonFragment\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject123 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject124() {
    var data = _tagged_template_literal([
        "\n  fragment PropertySingleOfferDialogLinkFragment on OfferDetails {\n    singleUnitOfferDialog {\n      content {\n        ...PropertySingleOfferDetailsFragment\n        ratePlans {\n          priceDetails {\n            ...PriceBreakdownSummaryFragment\n            ...PricePresentationDialogFragment\n          }\n          marketingSection {\n            ...MarketingSectionFragment\n          }\n          ...ReservePropertyFragment\n        }\n      }\n      trigger {\n        value\n        secondaryValue\n      }\n      toolbar {\n        icon {\n          description\n        }\n        title\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject124 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject125() {
    var data = _tagged_template_literal([
        "\n  fragment TotalPriceFragment on SingleUnitOfferDetails {\n    totalPrice {\n      label {\n        ...LodgingEnrichedMessageFragment\n      }\n      amount {\n        ...LodgingEnrichedMessageFragment\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject125 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject126() {
    var data = _tagged_template_literal([
        "\n  fragment PropertySingleRatePlanFragment on OfferDetails {\n    errorMessage {\n      ...ErrorMessageFragment\n    }\n    alternateAvailabilityMsg {\n      ...AlternateAvailabilityMsgFragment\n    }\n    ...AlternateDatesFragment\n    singleUnitOffer {\n      accessibilityLabel\n      ...TotalPriceFragment\n      ...PropertySingleOfferDetailsFragment\n      ratePlans {\n        priceDetails {\n          ...PriceBreakdownSummaryFragment\n          ...PricePresentationDialogFragment\n        }\n        marketingSection {\n          ...MarketingSectionFragment\n        }\n        shareUrl {\n          accessibilityLabel\n          value\n          link {\n            clientSideAnalytics {\n              linkName\n              referrerId\n            }\n            uri {\n              relativePath\n              value\n            }\n          }\n        }\n        ...ReservePropertyFragment\n      }\n      view\n    }\n    ...PropertySingleOfferDialogLinkFragment\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject126 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject127() {
    var data = _tagged_template_literal([
        "\n  fragment SingleOfferFragment on OfferDetails {\n    ...PropertySingleRatePlanFragment\n  }\n\n  ",
        "\n"
    ]);
    _templateObject127 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject128() {
    var data = _tagged_template_literal([
        "\n  fragment PropertySpaceDetailsFragment on OfferDetails {\n    spaceDetails {\n      ...SpaceDetailsHeaderFragment\n      ...SpaceDetailsSpacesFragment\n      ...SpaceDetailsFloorPlanFragment\n      virtualTourPrompt {\n        ...VirtualTourPromptFragment\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject128 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject129() {
    var data = _tagged_template_literal([
        "\n  fragment StickyCtaFragment on OfferDetails {\n    stickyBar {\n      stickyButton {\n        text\n        targetRef\n      }\n    }\n    shoppingContext {\n      multiItem {\n        packageType\n      }\n    }\n    ...PropertySingleOfferDialogLinkFragment\n  }\n  ",
        "\n"
    ]);
    _templateObject129 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject130() {
    var data = _tagged_template_literal([
        "\n  fragment StickyPriceSummaryFragment on PropertyDetailsStickyBar {\n    qualifier\n    subText\n    price {\n      formattedDisplayPrice\n      accessibilityLabel\n      priceDisclaimer {\n        content\n        primaryUIButton {\n          primary\n        }\n        trigger {\n          icon {\n            id\n            size\n          }\n        }\n      }\n    }\n    propertyPrice {\n      ...PriceSummaryFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject130 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject131() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyStickyBookBarPricePresentationDialogFragment on PropertyDetailsStickyBar {\n    pricePresentationDialog {\n      toolbar {\n        title\n        icon {\n          ...IconFragment\n        }\n        clientSideAnalytics {\n          linkName\n          referrerId\n        }\n      }\n      trigger {\n        clientSideAnalytics {\n          linkName\n          referrerId\n        }\n        value\n      }\n    }\n    pricePresentation {\n      title {\n        primary\n      }\n      sections {\n        ...PricePresentationSectionFragment\n      }\n      footer {\n        header\n        messages {\n          ...PriceLineElementFragment\n        }\n      }\n    }\n  }\n\n  fragment PricePresentationSectionFragment on PricePresentationSection {\n    header {\n      name {\n        ...PricePresentationLineItemEntryFragment\n      }\n      enrichedValue {\n        ...PricePresentationLineItemEntryFragment\n      }\n    }\n    subSections {\n      ...PricePresentationSubSectionFragment\n    }\n  }\n\n  fragment PricePresentationSubSectionFragment on PricePresentationSubSection {\n    header {\n      name {\n        primaryMessage {\n          __typename\n          ... on PriceLineText {\n            primary\n          }\n          ... on PriceLineHeading {\n            primary\n          }\n        }\n      }\n      enrichedValue {\n        ...PricePresentationLineItemEntryFragment\n      }\n    }\n    items {\n      ...PricePresentationLineItemFragment\n    }\n  }\n\n  fragment PricePresentationLineItemFragment on PricePresentationLineItem {\n    enrichedValue {\n      ...PricePresentationLineItemEntryFragment\n    }\n    name {\n      ...PricePresentationLineItemEntryFragment\n    }\n  }\n\n  fragment PricePresentationLineItemEntryFragment on PricePresentationLineItemEntry {\n    primaryMessage {\n      ...PriceLineElementFragment\n    }\n    secondaryMessages {\n      ...PriceLineElementFragment\n    }\n  }\n\n  fragment PriceLineElementFragment on PricePresentationLineItemMessage {\n    __typename\n    ...PriceLineTextFragment\n    ...PriceLineHeadingFragment\n    ...PriceLineBadgeFragment\n    ...InlinePriceLineTextFragment\n  }\n\n  fragment PriceLineTextFragment on PriceLineText {\n    __typename\n    theme\n    primary\n    weight\n    additionalInfo {\n      ...AdditionalInformationPopoverFragment\n    }\n    icon {\n      ...IconFragment\n    }\n    graphic {\n      ...UIGraphicFragment\n    }\n  }\n  ",
        "\n\n  fragment AdditionalInformationPopoverFragment on AdditionalInformationPopover {\n    icon {\n      ...IconFragment\n    }\n    enrichedSecondaries {\n      ...AdditionalInformationPopoverSectionFragment\n    }\n    analytics {\n      linkName\n      referrerId\n    }\n  }\n\n  fragment AdditionalInformationPopoverSectionFragment on AdditionalInformationPopoverSection {\n    __typename\n    ... on AdditionalInformationPopoverTextSection {\n      ...AdditionalInformationPopoverTextSectionFragment\n    }\n    ... on AdditionalInformationPopoverListSection {\n      ...AdditionalInformationPopoverListSectionFragment\n    }\n    ... on AdditionalInformationPopoverGridSection {\n      ...AdditionalInformationPopoverGridSectionFragment\n    }\n  }\n\n  fragment AdditionalInformationPopoverTextSectionFragment on AdditionalInformationPopoverTextSection {\n    __typename\n    text {\n      __typename\n      text\n      ... on EGDSStandardLink {\n        standardLinkIcon: icon {\n          ...IconFragment\n        }\n        action {\n          accessibility\n          analytics {\n            linkName\n            referrerId\n          }\n          resource {\n            value\n          }\n          target\n        }\n        iconPosition\n        size\n        text\n      }\n    }\n  }\n\n  fragment AdditionalInformationPopoverListSectionFragment on AdditionalInformationPopoverListSection {\n    __typename\n    content {\n      __typename\n      items {\n        text\n      }\n    }\n  }\n\n  fragment AdditionalInformationPopoverGridSectionFragment on AdditionalInformationPopoverGridSection {\n    __typename\n    subSections {\n      header {\n        name {\n          primaryMessage {\n            ...AdditionalInformationPopoverGridLineItemMessageFragment\n          }\n        }\n      }\n      items {\n        name {\n          ...AdditionalInformationPopoverGridLineItemEntryFragment\n        }\n        enrichedValue {\n          ...AdditionalInformationPopoverGridLineItemEntryFragment\n        }\n      }\n    }\n  }\n\n  fragment AdditionalInformationPopoverGridLineItemEntryFragment on PricePresentationLineItemEntry {\n    primaryMessage {\n      ...AdditionalInformationPopoverGridLineItemMessageFragment\n    }\n    secondaryMessages {\n      ...AdditionalInformationPopoverGridLineItemMessageFragment\n    }\n  }\n\n  fragment AdditionalInformationPopoverGridLineItemMessageFragment on PricePresentationLineItemMessage {\n    ... on PriceLineText {\n      __typename\n      primary\n    }\n    ... on PriceLineHeading {\n      __typename\n      tag\n      size\n      primary\n    }\n  }\n\n  fragment PriceLineHeadingFragment on PriceLineHeading {\n    __typename\n    primary\n    tag\n    size\n    additionalInfo {\n      ...AdditionalInformationPopoverFragment\n    }\n    icon {\n      ...IconFragment\n    }\n  }\n\n  fragment PriceLineBadgeFragment on PriceLineBadge {\n    __typename\n    badge {\n      accessibility\n      text\n      theme\n    }\n  }\n\n  fragment InlinePriceLineTextFragment on InlinePriceLineText {\n    __typename\n    inlineItems {\n      ...PriceLineTextFragment\n    }\n  }\n"
    ]);
    _templateObject131 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject132() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyStickyBookBarFragment on OfferDetails {\n    soldOut\n    stickyBar {\n      ...StickyPriceSummaryFragment\n      ...PropertyStickyBookBarPricePresentationDialogFragment\n      structuredData {\n        itemprop\n        itemscope\n        itemtype\n        content\n      }\n    }\n    ...StickyCtaFragment\n    ...PropertySingleOfferDialogLinkFragment\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject132 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject133() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyStickyPriceHeaderFragment on OfferDetails {\n    soldOut\n    stickyBar {\n      ...StickyPriceSummaryFragment\n    }\n    ...StickyCtaFragment\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject133 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject134() {
    var data = _tagged_template_literal([
        "\n  fragment TripSummaryFragment on TripSummaryContent {\n    header {\n      text\n    }\n    summary {\n      value\n    }\n    installmentPlanOptions {\n      totalPrice\n      textRequired\n    }\n    price {\n      options {\n        leadingCaption\n        displayPrice {\n          formatted\n        }\n        loyaltyPrice {\n          unit\n          amount {\n            formatted\n          }\n          totalStrikeOutPoints {\n            formatted\n          }\n        }\n        strikeOut {\n          formatted\n        }\n        accessibilityLabel\n        priceDisclaimer {\n          content\n          primaryButton {\n            text\n          }\n          tertiaryUIButton {\n            primary\n            action {\n              analytics {\n                referrerId\n                linkName\n              }\n            }\n          }\n          trigger {\n            icon {\n              id\n              description\n            }\n            clientSideAnalytics {\n              linkName\n              referrerId\n            }\n            value\n          }\n        }\n      }\n      priceMessaging {\n        value\n      }\n    }\n  }\n"
    ]);
    _templateObject134 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject135() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyTripSummaryFragment on OfferDetails {\n    tripSummary {\n      ...TripSummaryFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject135 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject136() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyUnitListViewElementFragment on LodgingCategorizedUnit {\n    header {\n      text\n    }\n  }\n"
    ]);
    _templateObject136 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject137() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyUnitListViewFragment on OfferDetails {\n    categorizedListings {\n      ...PropertyUnitListViewElementFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject137 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject138() {
    var data = _tagged_template_literal([
        "\n  fragment SingleOfferSearchFragment on OfferDetails {\n    errorMessage {\n      title {\n        text\n      }\n      action {\n        primary {\n          text\n          linkUrl\n        }\n      }\n    }\n    searchCriteria {\n      primary {\n        dateRange {\n          checkInDate {\n            month\n          }\n        }\n      }\n    }\n    singleUnitOffer {\n      ratePlans {\n        id\n      }\n    }\n  }\n"
    ]);
    _templateObject138 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject139() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingGuestGroupFragment on LodgingGuestGroup {\n    adults {\n      primary {\n        ... on EGDSBasicStepInput {\n          min\n          max\n          label\n          step\n          value\n        }\n      }\n    }\n    children {\n      primary {\n        ... on EGDSBasicStepInput {\n          min\n          max\n          label\n          step\n          subLabel\n          value\n        }\n      }\n      secondary {\n        title {\n          value\n          icon {\n            theme\n            description\n            token\n          }\n        }\n        inputs {\n          ... on EGDSBasicSelect {\n            egdsElementId\n            label\n            options {\n              label\n              selected\n              value\n            }\n          }\n        }\n      }\n    }\n    maxGuest\n    maxChildren\n  }\n"
    ]);
    _templateObject139 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject140() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingPetGroupFragment on LodgingPetGroup {\n    input {\n      primary {\n        ... on EGDSBasicCheckBox {\n          description\n          enabled\n          errorMessage\n          name\n          required\n          label {\n            text\n          }\n          state\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject140 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject141() {
    var data = _tagged_template_literal([
        "\n  fragment UnitGroupFragment on LodgingUnitGroup {\n    inputs {\n      ...LodgingGuestGroupFragment\n      ...LodgingPetGroupFragment\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject141 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject142() {
    var data = _tagged_template_literal([
        "\n  fragment TravelerSelectorFormFragment on TravelerSelectorForm {\n    title {\n      ...LodgingEnrichedMessageFragment\n    }\n    unitGroups {\n      ...UnitGroupFragment\n    }\n    submitButton {\n      ...LodgingEGDSButtonFragment\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject142 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject143() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingUnitCardFragment on LodgingUnitCard {\n    unitId\n    header {\n      text\n    }\n    image {\n      description\n      url\n    }\n    trigger {\n      accessibilityLabel\n      clientSideAnalytics {\n        linkName\n        referrerId\n      }\n      secondaryValue\n      theme\n      value\n    }\n  }\n"
    ]);
    _templateObject143 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject144() {
    var data = _tagged_template_literal([
        "\n  fragment UnitsCarouselFragment on OfferDetails {\n    unitsCarousel {\n      carousel {\n        nextButton {\n          __typename\n          icon {\n            description\n          }\n        }\n        previousButton {\n          __typename\n          icon {\n            description\n          }\n        }\n      }\n      heading {\n        ... on EGDSStylizedText {\n          text\n        }\n      }\n      impressionAnalytics {\n        linkName\n        referrerId\n      }\n      items {\n        ... on LodgingUnitCard {\n          ...LodgingUnitCardFragment\n        }\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject144 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject145() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyContentItemLodgingLinkMessageFragment on LodgingLinkMessage {\n    icon {\n      id\n      __typename\n    }\n    link {\n      clientSideAnalytics {\n        linkName\n        referrerId\n      }\n      uri {\n        relativePath\n        value\n        __typename\n      }\n      target\n      __typename\n    }\n    value\n    accessibilityLabel\n    __typename\n  }\n"
    ]);
    _templateObject145 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject146() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyContentItemTextFragment on PropertyContentItemText {\n    content {\n      primary {\n        value\n        badge {\n          icon_temp {\n            id\n            description\n            title\n            __typename\n          }\n          mark {\n            id\n            description\n            __typename\n          }\n          text\n          theme_temp\n          __typename\n        }\n        __typename\n      }\n      __typename\n    }\n  }\n"
    ]);
    _templateObject146 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject147() {
    var data = _tagged_template_literal([
        "\n  fragment VipAccessModuleDetailFragment on PropertyContentSectionGroup {\n    sections {\n      sectionName\n      header {\n        text\n      }\n      bodySubSections {\n        elementsV2 {\n          elements {\n            __typename\n            ... on PropertyContent {\n              items {\n                __typename\n                ...PropertyContentItemTextFragment\n                ...PropertyContentItemLodgingLinkMessageFragment\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject147 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject148() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyHighlightSectionFragment on PropertyHighlightSection {\n    label\n    header {\n      badge {\n        text\n        theme_temp\n      }\n      mark {\n        id\n        description\n      }\n      text\n    }\n    subSections {\n      description\n      contents {\n        icon {\n          id\n          withBackground\n          description\n        }\n        value\n      }\n    }\n    footerLink {\n      icon {\n        id\n      }\n      link {\n        referrerId\n        uri {\n          relativePath\n          value\n        }\n        target\n      }\n      value\n      accessibilityLabel\n    }\n  }\n"
    ]);
    _templateObject148 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject149() {
    var data = _tagged_template_literal([
        "\n  fragment VipMessagingCardFragment on OfferDetails {\n    propertyHighlightSection {\n      ...PropertyHighlightSectionFragment\n    }\n    propertyContentSectionGroup {\n      ...VipAccessModuleDetailFragment\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject149 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject150() {
    var data = _tagged_template_literal([
        "\n  query PropertyOffersQuery(\n    $context: ContextInput!\n    $propertyId: String!\n    $searchCriteria: PropertySearchCriteriaInput\n    $shoppingContext: ShoppingContextInput\n    $travelAdTrackingInfo: PropertyTravelAdTrackingInfoInput\n    $searchOffer: SearchOfferInput\n    $referrer: String\n  ) {\n    propertyOffers(\n      context: $context\n      propertyId: $propertyId\n      referrer: $referrer\n      searchCriteria: $searchCriteria\n      searchOffer: $searchOffer\n      shoppingContext: $shoppingContext\n      travelAdTrackingInfo: $travelAdTrackingInfo\n    ) {\n      id\n      loading {\n        accessibilityLabel\n      }\n      ...PropertyLevelOffersMessageFragment\n      ...PropertyLevelOffersCardFragment\n      ...ListingsHeaderFragment\n      ...VipMessagingCardFragment\n      ...NewVipModuleFragment\n      ...PropertyTripSummaryFragment\n      ...SingleOfferFragment\n      ...PropertyStickyBookBarFragment\n      ...PropertyStickyPriceHeaderFragment\n      ...PropertyOffersFragment\n      ...PropertySpaceDetailsFragment\n      ...PropertySearchLinkFragment\n      ...PropertyUnitListViewFragment\n      ...FilterPillsFragment\n      ...LoyaltyDiscountToggleFragment\n      ...LegalDisclaimerFragment\n      ...HighlightedBenefitsFragment\n      ...LodgingOneKeyBurnSwitchFragment\n      ...UnitsCarouselFragment\n    }\n    travelerSelector(context: $context, searchCriteria: $searchCriteria, propertyId: $propertyId) {\n      ...TravelerSelectorFormFragment\n    }\n  }\n\n  # fragments for the main components\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject150 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject151() {
    var data = _tagged_template_literal([
        "\n  query BasicPropertyOffersQuery(\n    $context: ContextInput!\n    $propertyId: String!\n    $searchCriteria: PropertySearchCriteriaInput\n    $shoppingContext: ShoppingContextInput\n    $searchOffer: SearchOfferInput\n  ) {\n    propertyOffers(\n      context: $context\n      propertyId: $propertyId\n      searchCriteria: $searchCriteria\n      searchOffer: $searchOffer\n      shoppingContext: $shoppingContext\n    ) {\n      ...ListingsHeaderFragment\n      ...ListingsFragment\n      ...ShoppingContextFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject151 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject152() {
    var data = _tagged_template_literal([
        "\n  query RoomDetailsQuery(\n    $context: ContextInput!\n    $propertyId: String!\n    $searchCriteria: PropertySearchCriteriaInput\n    $shoppingContext: ShoppingContextInput\n    $travelAdTrackingInfo: PropertyTravelAdTrackingInfoInput\n    $searchOffer: SearchOfferInput\n    $referrer: String\n  ) {\n    propertyOffers(\n      context: $context\n      propertyId: $propertyId\n      referrer: $referrer\n      searchCriteria: $searchCriteria\n      searchOffer: $searchOffer\n      shoppingContext: $shoppingContext\n      travelAdTrackingInfo: $travelAdTrackingInfo\n    ) {\n      units {\n        ...PropertyUnitFragment\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject152 = function _templateObject() {
        return data;
    };
    return data;
}
import React183 from "react";
import { gql as gql148, useQuery } from "@apollo/client";
import { useBexApi as useBexApi7 } from "@shared-ui/bex-api-context";
// src/components/filter-pills/filter-pills.tsx
import React2 from "react";
import { gql } from "@apollo/client";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { ViewLarge, Viewport, ViewSmall } from "@shared-ui/viewport-context";
import { UitkPillContainer, UitkRemovablePill } from "uitk-react-pill";
import { UitkSpacing } from "uitk-react-spacing";
// src/components/__private/context/link-component-context.tsx
import React from "react";
var DefaultLinkWrapper = function(_param) /* @__PURE__ */ {
    var children = _param.children, props = _object_without_properties(_param, [
        "children"
    ]);
    return React.createElement("a", _object_spread({}, props), children);
};
var LinkComponentContext = React.createContext({
    Link: DefaultLinkWrapper
});
var useLinkComponent = function() {
    return React.useContext(LinkComponentContext);
};
var LinkComponentProvider = function(param) {
    var Link = param.Link, children = param.children;
    return /* @__PURE__ */ React.createElement(LinkComponentContext.Provider, {
        value: {
            Link: Link || DefaultLinkWrapper
        }
    }, children);
};
// src/components/filter-pills/filter-pills.tsx
var __FilterPillsFragment = gql(_templateObject());
var FilterPills = function(param) {
    var data = param.data;
    var _filterPills;
    var clickTracker = useClickTracker();
    var Link = useLinkComponent().Link;
    var filterPills = data.filterPills;
    if (!((_filterPills = filterPills) === null || _filterPills === void 0 ? void 0 : _filterPills.length)) {
        return null;
    }
    var pills = filterPills.map(function(pill) {
        var type = pill.type, value = pill.value, pillLabel = pill.pillLabel, query = pill.query;
        var onClick = function() {
            return clickTracker("RoomFilter.".concat(value, ".Off"), "pill link");
        };
        var child = /* @__PURE__ */ React2.createElement(UitkRemovablePill, {
            id: "".concat(type, "-").concat(value),
            onClick: onClick
        }, pillLabel);
        return query ? /* @__PURE__ */ React2.createElement(Link, {
            key: pillLabel,
            href: query
        }, child) : /* @__PURE__ */ React2.createElement(React2.Fragment, {
            key: pillLabel
        }, child);
    });
    return /* @__PURE__ */ React2.createElement(UitkSpacing, {
        margin: {
            block: "three"
        }
    }, /* @__PURE__ */ React2.createElement("div", null, /* @__PURE__ */ React2.createElement(Viewport, null, /* @__PURE__ */ React2.createElement(ViewSmall, null, /* @__PURE__ */ React2.createElement(UitkPillContainer, null, pills)), /* @__PURE__ */ React2.createElement(ViewLarge, null, /* @__PURE__ */ React2.createElement(UitkPillContainer, {
        wrap: true
    }, pills)))));
};
FilterPills.displayName = "FilterPills";
FilterPills.fragment = __FilterPillsFragment;
// src/components/highlighted-benefits/index.tsx
import React3 from "react";
import { gql as gql2 } from "@apollo/client";
import { IntersectionTracker } from "@shared-ui/clickstream-analytics-context";
import { UitkIcon } from "uitk-react-icons";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { FitContent, UitkLayoutGrid, UitkLayoutGridItem } from "uitk-react-layout-grid";
import { UitkSpacing as UitkSpacing2 } from "uitk-react-spacing";
import { UitkText } from "uitk-react-text";
var __HighlightedBenefitsFragment = gql2(_templateObject1());
var HighlightedBenefits = function(param) {
    var data = param.data;
    var _data_highlightedBenefits, _data;
    var listItems = (_data = data) === null || _data === void 0 ? void 0 : (_data_highlightedBenefits = _data.highlightedBenefits) === null || _data_highlightedBenefits === void 0 ? void 0 : _data_highlightedBenefits.listItems;
    if (!listItems || !listItems.length) {
        return null;
    }
    return /* @__PURE__ */ React3.createElement(UitkSpacing2, {
        padding: {
            blockend: "six"
        }
    }, /* @__PURE__ */ React3.createElement(UitkLayoutGrid, {
        columns: [
            FitContent("48x"),
            FitContent("48x")
        ],
        space: "six"
    }, listItems.map(function(param, index) {
        var icon = param.icon, text = param.text, impressionAnalytics = param.impressionAnalytics;
        var _impressionAnalytics;
        return /* @__PURE__ */ React3.createElement(IntersectionTracker, {
            trackOnce: true,
            referrerId: "".concat((_impressionAnalytics = impressionAnalytics) === null || _impressionAnalytics === void 0 ? void 0 : _impressionAnalytics.referrerId),
            linkName: text,
            intersectionOptions: {
                threshold: 1
            },
            key: index
        }, /* @__PURE__ */ React3.createElement(UitkLayoutGridItem, null, /* @__PURE__ */ React3.createElement(UitkLayoutFlex, null, /* @__PURE__ */ React3.createElement(UitkLayoutFlexItem, {
            alignSelf: "center"
        }, /* @__PURE__ */ React3.createElement(UitkSpacing2, {
            margin: {
                inlineend: "two"
            }
        }, /* @__PURE__ */ React3.createElement(UitkIcon, {
            name: icon.id,
            theme: "positive"
        }))), /* @__PURE__ */ React3.createElement(UitkLayoutFlexItem, {
            alignSelf: "center"
        }, /* @__PURE__ */ React3.createElement(UitkText, {
            theme: "positive"
        }, text)))));
    })));
};
HighlightedBenefits.displayName = "HighlightedBenefits";
HighlightedBenefits.fragment = __HighlightedBenefitsFragment;
// src/components/highlighted-benefits/placeholder.tsx
import React4 from "react";
import { MinMax, UitkLayoutGrid as UitkLayoutGrid2, UitkLayoutGridItem as UitkLayoutGridItem2 } from "uitk-react-layout-grid";
import { UitkLineSkeleton } from "uitk-react-skeleton";
import { UitkSpacing as UitkSpacing3 } from "uitk-react-spacing";
var HighlightedBenefitsPlaceholder = function() {
    return /* @__PURE__ */ React4.createElement(UitkSpacing3, {
        padding: {
            blockend: "six"
        }
    }, /* @__PURE__ */ React4.createElement(UitkLayoutGrid2, {
        columns: [
            MinMax("16x", "40x"),
            MinMax("16x", "40x")
        ],
        space: "six",
        alignItems: "center"
    }, /* @__PURE__ */ React4.createElement(UitkLayoutGridItem2, null, /* @__PURE__ */ React4.createElement(UitkLineSkeleton, {
        animation: false,
        type: "primary"
    })), /* @__PURE__ */ React4.createElement(UitkLayoutGridItem2, null, /* @__PURE__ */ React4.createElement(UitkLineSkeleton, {
        animation: false,
        type: "primary"
    }))));
};
// src/components/inputs-context.tsx
import React5 from "react";
var defaultInputs = {
    propertyId: ""
};
var InputsContext = React5.createContext(defaultInputs);
var usePropertyOffersInputs = function() {
    return React5.useContext(InputsContext);
};
var InputsProvider = function(param) {
    var children = param.children, inputs = param.inputs;
    return /* @__PURE__ */ React5.createElement(InputsContext.Provider, {
        value: inputs
    }, children);
};
// src/components/legal-disclaimer/legal-disclaimer.tsx
import React6 from "react";
import { gql as gql3 } from "@apollo/client";
import { UitkCard } from "uitk-react-cards";
import { UitkSpacing as UitkSpacing4 } from "uitk-react-spacing";
var __LegalDisclaimerFragment = gql3(_templateObject2());
var LegalDisclaimer = function(param) {
    var data = param.data;
    var legalDisclaimer = data.legalDisclaimer;
    if (!legalDisclaimer || legalDisclaimer.content.length === 0) {
        return null;
    }
    var legalDisclaimerHTMLContent = legalDisclaimer.content.filter(function(content) {
        return content.markupType === "HTML";
    }).map(function(content) {
        return content.text;
    }).join("<br/><br/>");
    return /* @__PURE__ */ React6.createElement(UitkSpacing4, {
        margin: {
            block: "four"
        }
    }, /* @__PURE__ */ React6.createElement(UitkCard, {
        padded: true
    }, /* @__PURE__ */ React6.createElement("p", {
        dangerouslySetInnerHTML: {
            __html: legalDisclaimerHTMLContent
        }
    })));
};
LegalDisclaimer.fragment = __LegalDisclaimerFragment;
LegalDisclaimer.displayName = "LegalDisclaimer";
// src/components/lodging-one-key-burn-switch/lodging-one-key-burn-switch.tsx
import React11 from "react";
import { gql as gql9 } from "@apollo/client";
// ../internal/src/components/common/client-side-analytics/client-side-analytics.ts
import { useCallback } from "react";
import { gql as gql4 } from "@apollo/client";
import { ITrackType, useClickstreamAnalytics } from "@shared-ui/clickstream-analytics-context";
var clientSideAnalyticsFragment = gql4(_templateObject3());
var referrerMap = {
    CLICK: "click",
    IMPRESSION: "impression"
};
var trackAnalyticsList = function(clickstreamAnalytics, analytics2) {
    if (analytics2) {
        var _uisPrimeMessages;
        var track = clickstreamAnalytics.track;
        var referrerId = analytics2.referrerId, linkName = analytics2.linkName, uisPrimeMessages = analytics2.uisPrimeMessages;
        var _analytics2_eventType;
        var eventType = referrerMap[(_analytics2_eventType = analytics2.eventType) !== null && _analytics2_eventType !== void 0 ? _analytics2_eventType : "CLICK"];
        var message = {
            schemaName: "referrer",
            messageContent: {
                referrerId: referrerId,
                linkName: linkName,
                eventType: eventType
            }
        };
        var data = !((_uisPrimeMessages = uisPrimeMessages) === null || _uisPrimeMessages === void 0 ? void 0 : _uisPrimeMessages.length) ? message : [
            message
        ].concat(_to_consumable_array(uisPrimeMessages.map(function(param) {
            var schemaName = param.schemaName, messageContent = param.messageContent;
            return {
                schemaName: schemaName,
                messageContent: JSON.parse(messageContent)
            };
        })));
        track(ITrackType.EVENT, {
            data: data
        });
    }
};
var useTrackClientSideAnalytics = function(analytics2) {
    var clickstreamAnalytics = useClickstreamAnalytics();
    return useCallback(function() {
        if (analytics2) {
            trackAnalyticsList(clickstreamAnalytics, analytics2);
        }
    }, [
        analytics2,
        clickstreamAnalytics
    ]);
};
// ../internal/src/components/common/ui-graphic.tsx
import React10 from "react";
import { gql as gql8 } from "@apollo/client";
// ../internal/src/components/common/icon.tsx
import React7 from "react";
import { gql as gql5 } from "@apollo/client";
import { UitkIcon as UitkIcon2, UitkIconSize } from "uitk-react-icons";
var fragment = gql5(_templateObject4());
var _obj;
var SPOTLIGHT_MAP = (_obj = {}, _define_property(_obj, "INFO" /* INFO */ , "info"), _define_property(_obj, "POSITIVE" /* POSITIVE */ , "positive"), _define_property(_obj, "STANDARD" /* STANDARD */ , "standard"), _define_property(_obj, "WARNING" /* WARNING */ , "warning"), _obj);
var _data_title, _data_theme, _data_spotLight;
var Icon = function(param) {
    var className = param.className, data = param.data, spotlight = param.spotlight;
    return /* @__PURE__ */ React7.createElement(UitkIcon2, {
        className: className,
        description: data.description,
        id: data.id,
        name: data.id,
        size: data.iconSize ? UitkIconSize[data.iconSize] : void 0,
        title: (_data_title = data.title) !== null && _data_title !== void 0 ? _data_title : void 0,
        theme: (_data_theme = data.theme) !== null && _data_theme !== void 0 ? _data_theme : void 0,
        shadow: Boolean(data.withBackground),
        spotlight: spotlight !== null && spotlight !== void 0 ? spotlight : SPOTLIGHT_MAP[(_data_spotLight = data.spotLight) !== null && _data_spotLight !== void 0 ? _data_spotLight : ""]
    });
};
Icon.displayName = "UitkIcon";
Icon.fragment = fragment;
// ../internal/src/components/common/illustration.tsx
import React8 from "react";
import { gql as gql6 } from "@apollo/client";
import { UitkIllustrations } from "uitk-react-illustrations";
var fragment2 = gql6(_templateObject5());
var Illustration = function(param) {
    var className = param.className, data = param.data;
    return /* @__PURE__ */ React8.createElement(UitkIllustrations, {
        alt: data.description,
        url: data.link,
        className: className
    });
};
Illustration.displayName = "Illustration";
Illustration.fragment = fragment2;
// ../internal/src/components/common/mark.tsx
import React9 from "react";
import { gql as gql7 } from "@apollo/client";
import { UitkMark, UitkMarkSize } from "uitk-react-mark";
var fragment3 = gql7(_templateObject6());
var Mark = function(param) {
    var className = param.className, markSize = param.markSize, data = param.data;
    var _data_url;
    return /* @__PURE__ */ React9.createElement(UitkMark, {
        className: className,
        description: data.description,
        id: data.id,
        name: data.id,
        size: markSize !== null && markSize !== void 0 ? markSize : data.markSize ? UitkMarkSize[data.markSize] : void 0,
        url: (_data_url = data.url) === null || _data_url === void 0 ? void 0 : _data_url.value
    });
};
Mark.displayName = "Mark";
Mark.fragment = fragment3;
// ../internal/src/components/common/ui-graphic.tsx
var __UIGraphicFragment = gql8(_templateObject7(), Icon.fragment, Mark.fragment, Illustration.fragment);
var UiGraphic = function(param) {
    var className = param.className, markSize = param.markSize, data = param.data;
    switch(data.__typename){
        case "Icon":
            return /* @__PURE__ */ React10.createElement(Icon, {
                className: className,
                data: data
            });
        case "Mark":
            return /* @__PURE__ */ React10.createElement(Mark, {
                className: className,
                data: data,
                markSize: markSize
            });
        case "Illustration":
            return /* @__PURE__ */ React10.createElement(Illustration, {
                data: data,
                className: className
            });
        default:
            return null;
    }
};
UiGraphic.displayName = "UiGraphic";
UiGraphic.fragment = __UIGraphicFragment;
// src/components/lodging-one-key-burn-switch/lodging-one-key-burn-switch.tsx
import { OneKeyBurnSwitch } from "@shared-ui/retail-loyalty-one-key-burn-switch";
var __LodgingOneKeyBurnSwitchFragment = gql9(_templateObject8(), clientSideAnalyticsFragment, UiGraphic.fragment);
var LodgingOneKeyBurnSwitch = function(param) {
    var data = param.data, handler = param.handler, markSize = param.markSize, className = param.className, showBorder = param.showBorder;
    if (!data.lodgingOneKeyBurnSwitch) {
        return null;
    }
    return /* @__PURE__ */ React11.createElement(OneKeyBurnSwitch, {
        className: className,
        data: data.lodgingOneKeyBurnSwitch,
        handler: handler,
        markSize: markSize,
        showBorder: showBorder
    });
};
LodgingOneKeyBurnSwitch.displayName = "LodgingOneKeyBurnSwitch";
LodgingOneKeyBurnSwitch.fragment = __LodgingOneKeyBurnSwitchFragment;
// src/components/loyalty-discount-toggle/loyalty-discount-toggle.tsx
import React12 from "react";
import { gql as gql10 } from "@apollo/client";
import { useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";
import { UitkSpacing as UitkSpacing5 } from "uitk-react-spacing";
import { UitkSwitch } from "uitk-react-switch";
var __LoyaltyDiscountToggleFragment = gql10(_templateObject9());
var LoyaltyDiscountToggle = function(param) {
    var data = param.data, _param_checked = param.checked, checked = _param_checked === void 0 ? false : _param_checked, onChange = param.onChange;
    var loyaltyDiscount = data.loyaltyDiscount;
    var _React12_useState = _sliced_to_array(React12.useState(checked), 2), isChecked = _React12_useState[0], setIsChecked = _React12_useState[1];
    var track = useClickTracker2();
    if (!loyaltyDiscount) {
        return null;
    }
    var handleChange = function() {
        var _onChange;
        setIsChecked(!isChecked);
        (_onChange = onChange) === null || _onChange === void 0 ? void 0 : _onChange(!isChecked);
        track("swpToggle: ".concat(loyaltyDiscount.saveWithPointsActionMessage), "", true);
    };
    return /* @__PURE__ */ React12.createElement(UitkSpacing5, {
        padding: {
            block: "two"
        }
    }, /* @__PURE__ */ React12.createElement("div", null, /* @__PURE__ */ React12.createElement(UitkSwitch, {
        id: "swpToggle",
        checked: isChecked,
        onChange: handleChange,
        labelClassName: "uitk-type-300"
    }, loyaltyDiscount.saveWithPointsMessage || "")));
};
LoyaltyDiscountToggle.displayName = "LoyaltyDiscountToggle";
LoyaltyDiscountToggle.fragment = __LoyaltyDiscountToggleFragment;
// src/components/new-vip-module/vip-module.tsx
import React14 from "react";
import { gql as gql12 } from "@apollo/client";
// src/components/new-vip-module/__private/__fragments/vip-module-detail.tsx
import React13 from "react";
import { gql as gql11 } from "@apollo/client";
import { useClickTracker as useClickTracker3 } from "@shared-ui/clickstream-analytics-context";
import { UitkBadgeSize, UitkBadgeTheme, UitkMemberBadge } from "uitk-react-badge";
import { UitkCard as UitkCard2, UitkCardContentSection } from "uitk-react-cards";
import { UitkIcon as UitkIcon3 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex2, UitkLayoutFlexItem as UitkLayoutFlexItem2 } from "uitk-react-layout-flex";
import { FitContent as FitContent2, UitkLayoutGrid as UitkLayoutGrid3, UitkLayoutGridItem as UitkLayoutGridItem3, withUitkLayoutGrid } from "uitk-react-layout-grid";
import { UitkLink } from "uitk-react-link";
import { UitkList, UitkListItem } from "uitk-react-list";
import { UitkMark as UitkMark2, UitkMarkSize as UitkMarkSize2 } from "uitk-react-mark";
import { UitkSpacing as UitkSpacing6 } from "uitk-react-spacing";
import { UitkHeading, UitkText as UitkText2 } from "uitk-react-text";
var fragment4 = gql11(_templateObject10());
var VipModuleDetail = function(param) {
    var data = param.data;
    var _subSections, _rightSection_contents, _rightSection, _header, _leftSection_title, _leftSection_footerLink_icon, _rightSection_title, _rightSection_title_badge, _rightSection_title1, _rightSection_title_badge1, _rightSection_title2, _rightSection_title_badge2, _rightSection_title3, _rightSection_title4, _rightSection_footerLink_icon;
    var label = data.label, header = data.header, subSections = data.subSections;
    var track = useClickTracker3();
    if (!((_subSections = subSections) === null || _subSections === void 0 ? void 0 : _subSections.length)) {
        return null;
    }
    var leftSection = subSections[0];
    var rightSection = subSections[1];
    if (!((_rightSection = rightSection) === null || _rightSection === void 0 ? void 0 : (_rightSection_contents = _rightSection.contents) === null || _rightSection_contents === void 0 ? void 0 : _rightSection_contents.length)) {
        return null;
    }
    var contents = subSections[1].contents;
    var onClickLearnMoreLink = function() {
        var _leftSection_footerLink;
        if (!((_leftSection_footerLink = leftSection.footerLink) === null || _leftSection_footerLink === void 0 ? void 0 : _leftSection_footerLink.link.referrerId)) {
            return;
        }
        track(leftSection.footerLink.link.referrerId, label || "Clicked Learn More Link of VipModule");
    };
    var onClickSignInLink = function() {
        var _rightSection_footerLink;
        if (!((_rightSection_footerLink = rightSection.footerLink) === null || _rightSection_footerLink === void 0 ? void 0 : _rightSection_footerLink.link.referrerId)) {
            return;
        }
        track(rightSection.footerLink.link.referrerId, label || "Clicked Sign In Sign Up Link of VipModule");
    };
    var List = function(props) {
        var _rightSection_title;
        return ((_rightSection_title = rightSection.title) === null || _rightSection_title === void 0 ? void 0 : _rightSection_title.badge) ? /* @__PURE__ */ React13.createElement(UitkList, _object_spread({}, props), contents.map(function(content, index) {
            var value = content.value;
            return /* @__PURE__ */ React13.createElement(UitkListItem, {
                key: "property-highlight-list-item-".concat(index)
            }, value);
        })) : /* @__PURE__ */ React13.createElement(UitkLayoutGrid3, {
            space: "two",
            "data-stid": "contentList",
            rows: {
                small: [
                    FitContent2("0x"),
                    "1fr",
                    "1fr"
                ],
                medium: [
                    FitContent2("0x"),
                    "1fr"
                ]
            }
        }, contents.map(function(content, index) {
            var _badge, _badge1;
            var badge = content.badge, value = content.value;
            return /* @__PURE__ */ React13.createElement("div", {
                key: "property-highlight-list-item-".concat(index)
            }, /* @__PURE__ */ React13.createElement(UitkLayoutGrid3, {
                columns: [
                    "15x",
                    "7fr"
                ]
            }, /* @__PURE__ */ React13.createElement(UitkLayoutGridItem3, null, /* @__PURE__ */ React13.createElement(UitkText2, null, /* @__PURE__ */ React13.createElement(UitkMemberBadge, {
                text: ((_badge = badge) === null || _badge === void 0 ? void 0 : _badge.text) || "",
                theme: ((_badge1 = badge) === null || _badge1 === void 0 ? void 0 : _badge1.theme_temp) && UitkBadgeTheme[badge.theme_temp] || "",
                size: UitkBadgeSize.LARGE
            }))), /* @__PURE__ */ React13.createElement(UitkLayoutFlex2, {
                alignItems: "center"
            }, /* @__PURE__ */ React13.createElement(UitkLayoutGridItem3, null, /* @__PURE__ */ React13.createElement(UitkText2, null, value)))));
        }));
    };
    var MessagesListWithGrid = withUitkLayoutGrid(List);
    var messagesRowsCount = Math.ceil(contents.length / 2);
    return /* @__PURE__ */ React13.createElement("div", null, /* @__PURE__ */ React13.createElement(UitkCard2, null, /* @__PURE__ */ React13.createElement(UitkSpacing6, {
        padding: {
            blockstart: "four",
            small: {
                blockend: "six",
                inline: "four"
            },
            medium: {
                blockend: "one",
                inline: "six"
            }
        }
    }, /* @__PURE__ */ React13.createElement(UitkCardContentSection, null, /* @__PURE__ */ React13.createElement(UitkLayoutGrid3, {
        columns: {
            medium: [
                "1fr",
                "2fr"
            ]
        },
        rows: {
            small: [
                "1fr"
            ],
            medium: [
                "1fr"
            ]
        }
    }, /* @__PURE__ */ React13.createElement(UitkLayoutGridItem3, {
        colSpan: {
            small: 1,
            medium: 3
        }
    }, /* @__PURE__ */ React13.createElement(UitkCardContentSection, {
        border: "bottom",
        padded: false
    }, /* @__PURE__ */ React13.createElement(UitkSpacing6, {
        padding: {
            blockend: "three"
        }
    }, /* @__PURE__ */ React13.createElement("div", null, /* @__PURE__ */ React13.createElement(UitkText2, {
        className: "is-visually-hidden"
    }, label), ((_header = header) === null || _header === void 0 ? void 0 : _header.mark) && /* @__PURE__ */ React13.createElement(UitkSpacing6, {
        margin: {
            inlineend: "three"
        }
    }, /* @__PURE__ */ React13.createElement(UitkMark2, {
        name: header.mark.id,
        size: UitkMarkSize2.MEDIUM_LARGE
    })))))), /* @__PURE__ */ React13.createElement(UitkLayoutGridItem3, null, /* @__PURE__ */ React13.createElement(UitkSpacing6, {
        padding: {
            block: "four"
        }
    }, /* @__PURE__ */ React13.createElement(UitkLayoutFlex2, {
        direction: "column",
        space: "two"
    }, /* @__PURE__ */ React13.createElement(UitkLayoutFlexItem2, null, /* @__PURE__ */ React13.createElement(UitkHeading, {
        tag: "h3",
        size: 7
    }, /* @__PURE__ */ React13.createElement(UitkText2, {
        weight: "bold"
    }, (_leftSection_title = leftSection.title) === null || _leftSection_title === void 0 ? void 0 : _leftSection_title.value))), /* @__PURE__ */ React13.createElement(UitkLayoutFlexItem2, null, /* @__PURE__ */ React13.createElement(UitkSpacing6, {
        padding: {
            small: {
                inlineend: "unset"
            },
            medium: {
                inlineend: "six"
            }
        }
    }, /* @__PURE__ */ React13.createElement(UitkText2, null, leftSection.description))), /* @__PURE__ */ React13.createElement(UitkLayoutFlexItem2, null, /* @__PURE__ */ React13.createElement(UitkSpacing6, {
        margin: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React13.createElement("div", null, leftSection.footerLink && /* @__PURE__ */ React13.createElement(UitkLink, {
        onClick: onClickLearnMoreLink
    }, /* @__PURE__ */ React13.createElement("a", {
        href: leftSection.footerLink.link.uri.value,
        target: leftSection.footerLink.link.target || ""
    }, leftSection.footerLink.value, /* @__PURE__ */ React13.createElement("span", {
        className: "is-visually-hidden"
    }, leftSection.footerLink.accessibilityLabel), /* @__PURE__ */ React13.createElement(UitkIcon3, {
        name: ((_leftSection_footerLink_icon = leftSection.footerLink.icon) === null || _leftSection_footerLink_icon === void 0 ? void 0 : _leftSection_footerLink_icon.id) || ""
    }))))))))), /* @__PURE__ */ React13.createElement(UitkLayoutGridItem3, {
        colSpan: {
            small: 1,
            medium: 2
        }
    }, /* @__PURE__ */ React13.createElement(UitkSpacing6, {
        padding: {
            small: {
                block: "unset"
            },
            medium: {
                block: "three",
                inlinestart: "twelve"
            }
        }
    }, /* @__PURE__ */ React13.createElement(UitkLayoutFlex2, {
        direction: "column",
        space: "two"
    }, /* @__PURE__ */ React13.createElement(UitkSpacing6, {
        margin: {
            small: {
                blockstart: "four",
                blockend: "two"
            },
            medium: {
                blockstart: "one"
            }
        }
    }, /* @__PURE__ */ React13.createElement(UitkLayoutFlexItem2, null, /* @__PURE__ */ React13.createElement(UitkLayoutFlex2, {
        space: "two",
        alignItems: "center"
    }, ((_rightSection_title = rightSection.title) === null || _rightSection_title === void 0 ? void 0 : _rightSection_title.badge) && /* @__PURE__ */ React13.createElement(UitkLayoutFlexItem2, null, /* @__PURE__ */ React13.createElement(UitkMemberBadge, {
        text: ((_rightSection_title1 = rightSection.title) === null || _rightSection_title1 === void 0 ? void 0 : (_rightSection_title_badge = _rightSection_title1.badge) === null || _rightSection_title_badge === void 0 ? void 0 : _rightSection_title_badge.text) || "",
        theme: ((_rightSection_title2 = rightSection.title) === null || _rightSection_title2 === void 0 ? void 0 : (_rightSection_title_badge1 = _rightSection_title2.badge) === null || _rightSection_title_badge1 === void 0 ? void 0 : _rightSection_title_badge1.theme_temp) && UitkBadgeTheme[(_rightSection_title3 = rightSection.title) === null || _rightSection_title3 === void 0 ? void 0 : (_rightSection_title_badge2 = _rightSection_title3.badge) === null || _rightSection_title_badge2 === void 0 ? void 0 : _rightSection_title_badge2.theme_temp] || "",
        size: UitkBadgeSize.LARGE
    })), /* @__PURE__ */ React13.createElement(UitkLayoutFlexItem2, null, /* @__PURE__ */ React13.createElement(UitkHeading, {
        tag: "h3",
        size: 7
    }, /* @__PURE__ */ React13.createElement(UitkText2, {
        weight: "regular"
    }, (_rightSection_title4 = rightSection.title) === null || _rightSection_title4 === void 0 ? void 0 : _rightSection_title4.value)))))), /* @__PURE__ */ React13.createElement(UitkLayoutFlexItem2, null, /* @__PURE__ */ React13.createElement(UitkLayoutFlex2, null, /* @__PURE__ */ React13.createElement(MessagesListWithGrid, {
        rows: messagesRowsCount
    }))), /* @__PURE__ */ React13.createElement(UitkLayoutFlexItem2, null, /* @__PURE__ */ React13.createElement(UitkSpacing6, {
        margin: {
            small: {
                block: "unset"
            },
            medium: {
                block: "two"
            }
        }
    }, /* @__PURE__ */ React13.createElement("div", null, rightSection.footerLink && /* @__PURE__ */ React13.createElement(UitkLink, {
        onClick: onClickSignInLink
    }, /* @__PURE__ */ React13.createElement("a", {
        href: rightSection.footerLink.link.uri.value,
        target: rightSection.footerLink.link.target || ""
    }, rightSection.footerLink.value, /* @__PURE__ */ React13.createElement(UitkIcon3, {
        name: ((_rightSection_footerLink_icon = rightSection.footerLink.icon) === null || _rightSection_footerLink_icon === void 0 ? void 0 : _rightSection_footerLink_icon.id) || ""
    }))))))))))))));
};
VipModuleDetail.fragment = fragment4;
VipModuleDetail.displayName = "VipModule";
// src/components/new-vip-module/vip-module.tsx
var __NewVipModuleFragment = gql12(_templateObject11(), VipModuleDetail.fragment);
var NewVipModule = function(param) {
    var data = param.data;
    var propertyHighlightSection = data.propertyHighlightSection;
    if (!propertyHighlightSection) {
        return null;
    }
    return /* @__PURE__ */ React14.createElement(VipModuleDetail, {
        data: propertyHighlightSection
    });
};
NewVipModule.fragment = __NewVipModuleFragment;
NewVipModule.displayName = "NewVipModule";
// src/components/property-filter-pills/property-filter-pills.tsx
import React18 from "react";
import { gql as gql16 } from "@apollo/client";
import { useClickTracker as useClickTracker4 } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/components/lodging-egds-basic-pill/lodging-egds-basic-pill.tsx
import React15 from "react";
import { gql as gql13 } from "@apollo/client";
import { UitkPill } from "uitk-react-pill";
var fragment5 = gql13(_templateObject12());
var LodgingEGDSBasicPill = function(param) {
    var data = param.data, onChange = param.onChange, _param_disabled = param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled;
    var name = data.name, value = data.value, primary = data.primary, accessibility = data.accessibility, selected = data.selected;
    return /* @__PURE__ */ React15.createElement(UitkPill, {
        id: "".concat(name, "-").concat(value),
        onChange: function(e) {
            return onChange(e, name, value);
        },
        checked: selected,
        value: value !== null && value !== void 0 ? value : "",
        altText: accessibility !== null && accessibility !== void 0 ? accessibility : "",
        disabled: disabled
    }, primary);
};
LodgingEGDSBasicPill.fragment = fragment5;
LodgingEGDSBasicPill.displayName = "LodgingEGDSBasicPill";
// ../internal/src/components/lodging-egds-filter-dialog-pill/lodging-filter-dialog-pill.tsx
import React17, { useEffect, useState } from "react";
import { gql as gql15 } from "@apollo/client";
import { useDialog } from "@shared-ui/dialog-context";
import { UitkTriggerPill } from "uitk-react-pill";
// ../internal/src/components/lodging-egds-filter-dialog-pill/lodging-dialog-pill.tsx
import React16 from "react";
import { gql as gql14 } from "@apollo/client";
import { ViewMedium, Viewport as Viewport2, ViewSmall as ViewSmall2 } from "@shared-ui/viewport-context";
import { UitkButtonSize, UitkPrimaryButton, UitkTertiaryButton } from "uitk-react-button";
import { UitkCheckbox, UitkCheckboxGroup } from "uitk-react-checkbox";
import { UitkDialogContent, UitkDialogFooter } from "uitk-react-dialog";
import { UitkSheet } from "uitk-react-sheet";
import { UitkToolbar } from "uitk-react-toolbar";
var __FilterDialogPillFragment = gql14(_templateObject13());
var LodgingDialogPill = function(param) {
    var data = param.data, handleSubmit = param.handleSubmit, closeDialog = param.closeDialog;
    var _checkboxOptions, _clearAll, _buttons_;
    var dialog = data.dialog, clearAll = data.clearAll, filterSection = data.filterSection, title = data.toolbar.title;
    var buttons = dialog.footer.buttons;
    var options = filterSection.options, id = filterSection.id;
    var _React16_useState = _sliced_to_array(React16.useState(options), 2), checkboxOptions = _React16_useState[0], setCheckboxOptions = _React16_useState[1];
    if (!((_checkboxOptions = checkboxOptions) === null || _checkboxOptions === void 0 ? void 0 : _checkboxOptions.length)) {
        return null;
    }
    var handleOnChange = function(event) {
        var _event_currentTarget = event.currentTarget, selected = _event_currentTarget.checked, value = _event_currentTarget.value;
        setCheckboxOptions(function(prevSelectedOptions) {
            return prevSelectedOptions.map(function(option) {
                return option.value === value ? _object_spread_props(_object_spread({}, option), {
                    selected: selected
                }) : option;
            });
        });
    };
    var handleClearAll = function() {
        setCheckboxOptions(function(prevSelectedOptions) {
            return prevSelectedOptions.map(function(option) {
                return _object_spread_props(_object_spread({}, option), {
                    selected: false
                });
            });
        });
    };
    var toolbarActionContent = ((_clearAll = clearAll) === null || _clearAll === void 0 ? void 0 : _clearAll.primary) ? /* @__PURE__ */ React16.createElement(UitkTertiaryButton, {
        onClick: handleClearAll
    }, clearAll.primary) : void 0;
    var content = /* @__PURE__ */ React16.createElement(React16.Fragment, null, /* @__PURE__ */ React16.createElement(UitkToolbar, {
        toolbarTitle: title,
        toolbarTitleTag: "h1",
        toolbarActionContent: toolbarActionContent,
        navigationContent: {
            onClick: closeDialog,
            navType: "close"
        }
    }), /* @__PURE__ */ React16.createElement(UitkDialogContent, null, /* @__PURE__ */ React16.createElement(UitkCheckboxGroup, {
        group: "dialog-checkbox-group-".concat(id)
    }, checkboxOptions.map(function(option, index) {
        return /* @__PURE__ */ React16.createElement(UitkCheckbox, {
            key: "".concat(option.id, "-").concat(index),
            id: "".concat(option.id, "-").concat(index),
            checked: option.selected,
            onChange: handleOnChange,
            value: option.value
        }, option.primary);
    })), ((_buttons_ = buttons[0]) === null || _buttons_ === void 0 ? void 0 : _buttons_.primary) && /* @__PURE__ */ React16.createElement(UitkDialogFooter, null, /* @__PURE__ */ React16.createElement(UitkPrimaryButton, {
        type: "button",
        onClick: function() {
            return handleSubmit(checkboxOptions);
        },
        isFullWidth: false,
        size: UitkButtonSize.LARGE
    }, buttons[0].primary))));
    return /* @__PURE__ */ React16.createElement(Viewport2, null, /* @__PURE__ */ React16.createElement(ViewSmall2, null, /* @__PURE__ */ React16.createElement(UitkSheet, {
        type: "centered",
        centeredSheetSize: "small",
        isVisible: true,
        triggerRef: null
    }, content)), /* @__PURE__ */ React16.createElement(ViewMedium, null, /* @__PURE__ */ React16.createElement(UitkSheet, {
        type: "centered",
        isVisible: true,
        triggerRef: null
    }, content)));
};
LodgingDialogPill.fragment = __FilterDialogPillFragment;
LodgingDialogPill.displayName = "LodgingDialogPill";
// ../internal/src/components/lodging-egds-filter-dialog-pill/lodging-filter-dialog-pill.tsx
var __LodgingFilterTriggerPillFragment = gql15(_templateObject14(), LodgingDialogPill.fragment);
var LodgingFilterDialogPill = function(param) {
    var data = param.data, onChange = param.onChange, _param_disabled = param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled;
    var _primary;
    var triggerPill = data.triggerPill, filterDialog = data.filterDialog;
    var primary = triggerPill.primary, selected = triggerPill.selected;
    var primaryId = (_primary = primary) === null || _primary === void 0 ? void 0 : _primary.replace(/\s+/g, "");
    var _useDialog = _sliced_to_array(useDialog("dialog-filter-pill-".concat(primaryId)), 3), isOpen = _useDialog[0], _useDialog_ = _useDialog[1], openDialog = _useDialog_.openDialog, closeDialog = _useDialog_.closeDialog, DialogComponent = _useDialog[2];
    var _useState = _sliced_to_array(useState(), 2), options = _useState[0], setOptions = _useState[1];
    var ref = React17.useRef(null);
    useEffect(function() {
        if (options) {
            onChange(options);
        }
        return function() {
            setOptions(null);
        };
    }, [
        isOpen
    ]);
    var handlePillClick = React17.useCallback(function() {
        openDialog();
    }, [
        openDialog
    ]);
    if (!primary) {
        return null;
    }
    var setFocusOnAggregatedPill = function() {
        var _ref;
        if ((_ref = ref) === null || _ref === void 0 ? void 0 : _ref.current) {
            var _focusElement;
            var focusElement = ref.current.firstElementChild;
            (_focusElement = focusElement) === null || _focusElement === void 0 ? void 0 : _focusElement.focus();
        }
    };
    var onDismiss = function() {
        closeDialog();
        setFocusOnAggregatedPill();
    };
    var handleSubmit = function(checkboxOptions) {
        setOptions(checkboxOptions);
        closeDialog();
    };
    return /* @__PURE__ */ React17.createElement("div", {
        ref: ref,
        tabIndex: -1
    }, /* @__PURE__ */ React17.createElement(UitkTriggerPill, {
        id: "dialog-trigger-pill-".concat(primaryId),
        onClick: handlePillClick,
        selected: selected,
        name: primary,
        disabled: disabled
    }, primary), /* @__PURE__ */ React17.createElement(DialogComponent, null, /* @__PURE__ */ React17.createElement(LodgingDialogPill, {
        data: filterDialog,
        handleSubmit: handleSubmit,
        closeDialog: onDismiss
    })));
};
LodgingFilterDialogPill.fragment = __LodgingFilterTriggerPillFragment;
LodgingFilterDialogPill.displayName = "LodgingFilterDialogPill";
// src/components/property-filter-pills/property-filter-pills.tsx
import { ViewLarge as ViewLarge2, Viewport as Viewport3, ViewSmall as ViewSmall3 } from "@shared-ui/viewport-context";
import { UitkPillContainer as UitkPillContainer2 } from "uitk-react-pill";
import { UitkSpacing as UitkSpacing7 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading2 } from "uitk-react-text";
import { liveAnnounce } from "uitk-react-utils";
var __PropertyFilterPillsFragment = gql16(_templateObject15(), LodgingEGDSBasicPill.fragment, LodgingFilterDialogPill.fragment);
var PropertyFilterPills = function(param) {
    var data = param.data, updateSearchAndFilters = param.updateSearchAndFilters, _param_disabled = param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled;
    var _data, _offerFilters, _offerFilters1, _filterPills, _filterPills1, _offerFilters2, _offerFilters_heading, _offerFilters3;
    var offerFilters = (_data = data) === null || _data === void 0 ? void 0 : _data.offerFilters;
    var filterPills = (_offerFilters = offerFilters) === null || _offerFilters === void 0 ? void 0 : _offerFilters.filterPills;
    var _React18_useState = _sliced_to_array(React18.useState(false), 2), isFiltered = _React18_useState[0], setIsFiltered = _React18_useState[1];
    var clickTracker = useClickTracker4();
    var ref = React18.useRef(null);
    React18.useEffect(function() {
        var _offerFilters;
        if (((_offerFilters = offerFilters) === null || _offerFilters === void 0 ? void 0 : _offerFilters.liveAnnounce) && isFiltered && !disabled) {
            var _offerFilters1, _ref;
            liveAnnounce((_offerFilters1 = offerFilters) === null || _offerFilters1 === void 0 ? void 0 : _offerFilters1.liveAnnounce);
            if ((_ref = ref) === null || _ref === void 0 ? void 0 : _ref.current) {
                var _focusElement;
                var focusElement = ref.current.firstElementChild;
                (_focusElement = focusElement) === null || _focusElement === void 0 ? void 0 : _focusElement.focus();
            }
        }
    }, [
        isFiltered,
        (_offerFilters1 = offerFilters) === null || _offerFilters1 === void 0 ? void 0 : _offerFilters1.liveAnnounce,
        disabled
    ]);
    if (!((_filterPills = filterPills) === null || _filterPills === void 0 ? void 0 : _filterPills.length)) {
        return null;
    }
    var handleChange = function(selectedPill) {
        if (updateSearchAndFilters) {
            updateSearchAndFilters(selectedPill);
            setIsFiltered(true);
        }
    };
    var handleEGDSBasicPillChange = function(event, type, name) {
        var _event_currentTarget = event.currentTarget, selected = _event_currentTarget.checked;
        var selectedPill = {
            type: type,
            name: name,
            selected: selected
        };
        clickTracker("RoomFilter.".concat(name, ".").concat(selected), "PDP Filter pills clicked");
        handleChange(selectedPill);
    };
    var pills = (_filterPills1 = filterPills) === null || _filterPills1 === void 0 ? void 0 : _filterPills1.map(function(pill, index) {
        if (pill.__typename === "EGDSBasicPill") {
            return /* @__PURE__ */ React18.createElement(LodgingEGDSBasicPill, {
                key: "filterPill".concat(index),
                data: pill,
                onChange: handleEGDSBasicPillChange,
                disabled: disabled
            });
        }
        if (pill.__typename === "LodgingFilterDialogPill") {
            var handleOnAggregatedPillChange = function(options) {
                options.forEach(function(option) {
                    clickTracker("RoomFilter.".concat(option.value, ".").concat(option.selected), "PDP Dialog Filter pills clicked");
                });
                handleChange(options);
            };
            return /* @__PURE__ */ React18.createElement(LodgingFilterDialogPill, {
                key: "filterPill".concat(index),
                data: pill,
                onChange: handleOnAggregatedPillChange,
                disabled: disabled
            });
        }
        return null;
    });
    return /* @__PURE__ */ React18.createElement(UitkSpacing7, {
        margin: {
            block: "three"
        }
    }, /* @__PURE__ */ React18.createElement("div", {
        ref: ref
    }, /* @__PURE__ */ React18.createElement(UitkHeading2, {
        className: "is-visually-hidden",
        tabIndex: -1
    }, (_offerFilters2 = offerFilters) === null || _offerFilters2 === void 0 ? void 0 : _offerFilters2.accessibilityHeader), /* @__PURE__ */ React18.createElement(UitkHeading2, {
        size: 5,
        "aria-hidden": "true"
    }, (_offerFilters3 = offerFilters) === null || _offerFilters3 === void 0 ? void 0 : (_offerFilters_heading = _offerFilters3.heading) === null || _offerFilters_heading === void 0 ? void 0 : _offerFilters_heading.text), /* @__PURE__ */ React18.createElement(Viewport3, null, /* @__PURE__ */ React18.createElement(ViewSmall3, null, /* @__PURE__ */ React18.createElement(UitkSpacing7, {
        margin: {
            blockstart: "half"
        }
    }, /* @__PURE__ */ React18.createElement(UitkPillContainer2, null, pills))), /* @__PURE__ */ React18.createElement(ViewLarge2, null, /* @__PURE__ */ React18.createElement(UitkSpacing7, {
        margin: {
            blockstart: "half"
        }
    }, /* @__PURE__ */ React18.createElement(UitkPillContainer2, {
        wrap: true
    }, pills))))));
};
PropertyFilterPills.displayName = "PropertyFilterPills";
PropertyFilterPills.fragment = __PropertyFilterPillsFragment;
// src/components/property-level-offers-card/property-level-offers-card.tsx
import React26 from "react";
import { gql as gql25 } from "@apollo/client";
// ../internal/src/components/egds/egds-standard-messaging-card/egds-standard-messaging-card.tsx
import React25 from "react";
import { gql as gql24 } from "@apollo/client";
import { IntersectionTracker as IntersectionTracker2 } from "@shared-ui/clickstream-analytics-context";
import { UitkButtonSize as UitkButtonSize2 } from "uitk-react-button";
import { UitkCard as UitkCard3, UitkCardBackgroundThemes, UitkCardContentSection as UitkCardContentSection2, UitkCardLink } from "uitk-react-cards";
import { UitkLayoutFlex as UitkLayoutFlex3, UitkLayoutFlexItem as UitkLayoutFlexItem3 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing8 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading3, UitkText as UitkText4 } from "uitk-react-text";
// ../internal/src/components/lodging-egds-button/lodging-egds-button.tsx
import React20 from "react";
import { gql as gql19 } from "@apollo/client";
import { UitkPrimaryButton as UitkPrimaryButton2, UitkSecondaryButton, UitkTertiaryButton as UitkTertiaryButton2 } from "uitk-react-button";
// ../internal/src/components/lodging-egds-icon/lodging-egds-icon.tsx
import React19 from "react";
import { gql as gql17 } from "@apollo/client";
import { UitkIcon as UitkIcon4, UitkIconSize as UitkIconSize2 } from "uitk-react-icons";
var fragment6 = gql17(_templateObject16());
var LodgingEGDSIcon = function(param) {
    var ariaHidden = param.ariaHidden, data = param.data;
    var description = data.description, id = data.id, size = data.size, theme = data.theme;
    var _ref;
    return /* @__PURE__ */ React19.createElement(UitkIcon4, {
        description: ariaHidden ? void 0 : description,
        title: ariaHidden ? void 0 : description,
        id: id,
        name: id,
        size: (_ref = size && UitkIconSize2[size]) !== null && _ref !== void 0 ? _ref : void 0,
        theme: theme !== null && theme !== void 0 ? theme : void 0
    });
};
LodgingEGDSIcon.fragment = fragment6;
LodgingEGDSIcon.displayName = "LodgingEGDSIcon";
// ../internal/src/components/lodging-ui-link-action/lodging-ui-link-action.ts
import { gql as gql18 } from "@apollo/client";
var _obj1;
// ../internal/src/components/uitk-link-target-mapper.tsx
var UILinkTargetMap = (_obj1 = {}, _define_property(_obj1, "EXTERNAL" /* EXTERNAL */ , "_blank"), _define_property(_obj1, "INTERNAL" /* INTERNAL */ , "_self"), _obj1);
// ../internal/src/components/lodging-ui-link-action/lodging-ui-link-action.ts
var fragment7 = gql18(_templateObject17());
var getLodgingUILinkActionPath = function(action) {
    if (action.resource.__typename !== "HttpURI") {
        return null;
    }
    return action.useRelativePath ? action.resource.relativePath : action.resource.value;
};
var getLodgingUILinkActionTarget = function(action) {
    return UILinkTargetMap[action.target];
};
// ../internal/src/components/lodging-egds-button/lodging-egds-button.tsx
var fragment8 = gql19(_templateObject18(), clientSideAnalyticsFragment, fragment7, LodgingEGDSIcon.fragment);
var deriveLinkProps = function(action) {
    var _action;
    if (((_action = action) === null || _action === void 0 ? void 0 : _action.__typename) !== "UILinkAction") {
        return {};
    }
    var path = getLodgingUILinkActionPath(action);
    if (!path) {
        return {};
    }
    return {
        href: path,
        target: getLodgingUILinkActionTarget(action),
        tag: "a"
    };
};
var buttonComponents = {
    UIPrimaryButton: UitkPrimaryButton2,
    UISecondaryButton: UitkSecondaryButton,
    UITertiaryButton: UitkTertiaryButton2
};
var LodgingEGDSButton = function(_param) {
    var onClick = _param.onClick, _param_data = _param.data, __typename = _param_data.__typename, accessibility = _param_data.accessibility, analytics2 = _param_data.analytics, disabled = _param_data.disabled, primary = _param_data.primary, action = _param_data.action, icon = _param_data.icon, dataStid = _param.dataStid, props = _object_without_properties(_param, [
        "onClick",
        "data",
        "dataStid"
    ]);
    var trackClick = useTrackClientSideAnalytics(analytics2);
    var linkProps = deriveLinkProps(action);
    var handleClick = React20.useCallback(function(event) {
        var _onClick;
        trackClick();
        (_onClick = onClick) === null || _onClick === void 0 ? void 0 : _onClick(event);
    }, [
        onClick,
        trackClick
    ]);
    var buttonProps = _object_spread({
        "aria-label": accessibility !== null && accessibility !== void 0 ? accessibility : void 0,
        disabled: disabled,
        onClick: handleClick
    }, linkProps, props);
    var Button = buttonComponents[__typename];
    if (Button) {
        return /* @__PURE__ */ React20.createElement(Button, _object_spread_props(_object_spread({}, buttonProps), {
            "data-stid": dataStid
        }), icon ? /* @__PURE__ */ React20.createElement(LodgingEGDSIcon, {
            data: icon
        }) : null, primary);
    }
    return null;
};
LodgingEGDSButton.fragment = fragment8;
LodgingEGDSButton.displayName = "EGDSButton";
// ../internal/src/components/lodging-egds-button/lodging-egds-floating-action-button.tsx
import React21 from "react";
import { gql as gql20 } from "@apollo/client";
import { UitkFloatingActionButton } from "uitk-react-button";
var fragment9 = gql20(_templateObject19());
var deriveLinkProps2 = function(action) {
    var _action;
    if (((_action = action) === null || _action === void 0 ? void 0 : _action.__typename) !== "UILinkAction") {
        return {};
    }
    var path = getLodgingUILinkActionPath(action);
    if (!path) {
        return {};
    }
    return {
        href: path,
        target: getLodgingUILinkActionTarget(action),
        tag: "a"
    };
};
var LodgingEGDSFloatingActionButton = function(_param) {
    var onClick = _param.onClick, _param_data = _param.data, accessibility = _param_data.accessibility, analytics2 = _param_data.analytics, disabled = _param_data.disabled, action = _param_data.action, icon = _param_data.icon, props = _object_without_properties(_param, [
        "onClick",
        "data"
    ]);
    var trackClick = useTrackClientSideAnalytics(analytics2);
    var linkProps = deriveLinkProps2(action);
    var handleClick = React21.useCallback(function(event) {
        var _onClick;
        trackClick();
        (_onClick = onClick) === null || _onClick === void 0 ? void 0 : _onClick(event);
    }, [
        onClick,
        trackClick
    ]);
    var buttonProps = _object_spread({
        "aria-label": accessibility !== null && accessibility !== void 0 ? accessibility : void 0,
        disabled: disabled,
        onClick: handleClick
    }, linkProps, props);
    return icon ? /* @__PURE__ */ React21.createElement(UitkFloatingActionButton, _object_spread({}, buttonProps), /* @__PURE__ */ React21.createElement(LodgingEGDSIcon, {
        data: icon
    })) : null;
};
LodgingEGDSFloatingActionButton.fragment = fragment9;
LodgingEGDSFloatingActionButton.displayName = "EGDSFloatingActionButton";
// ../internal/src/components/lodging-egds-button/lodging-egds-floating-button.tsx
import React22 from "react";
import { gql as gql21 } from "@apollo/client";
import { UitkFloatingButton } from "uitk-react-button";
var fragment10 = gql21(_templateObject20());
var deriveLinkProps3 = function(action) {
    var _action;
    if (((_action = action) === null || _action === void 0 ? void 0 : _action.__typename) !== "UILinkAction") {
        return {};
    }
    var path = getLodgingUILinkActionPath(action);
    if (!path) {
        return {};
    }
    return {
        href: path,
        target: getLodgingUILinkActionTarget(action),
        tag: "a"
    };
};
var LodgingEGDSFloatingButton = function(_param) {
    var onClick = _param.onClick, _param_data = _param.data, accessibility = _param_data.accessibility, analytics2 = _param_data.analytics, disabled = _param_data.disabled, primary = _param_data.primary, action = _param_data.action, icon = _param_data.icon, props = _object_without_properties(_param, [
        "onClick",
        "data"
    ]);
    var trackClick = useTrackClientSideAnalytics(analytics2);
    var linkProps = deriveLinkProps3(action);
    var handleClick = React22.useCallback(function(event) {
        var _onClick;
        trackClick();
        (_onClick = onClick) === null || _onClick === void 0 ? void 0 : _onClick(event);
    }, [
        onClick,
        trackClick
    ]);
    var buttonProps = _object_spread({
        "aria-label": accessibility !== null && accessibility !== void 0 ? accessibility : void 0,
        disabled: disabled,
        onClick: handleClick
    }, linkProps, props);
    return /* @__PURE__ */ React22.createElement(UitkFloatingButton, _object_spread({}, buttonProps), icon ? /* @__PURE__ */ React22.createElement(LodgingEGDSIcon, {
        data: icon
    }) : null, primary);
};
LodgingEGDSFloatingButton.fragment = fragment10;
LodgingEGDSFloatingButton.displayName = "EGDSFloatingButton";
// ../internal/src/components/egds/egds-standard-link/egds-standard-link.tsx
import React23 from "react";
import { gql as gql22 } from "@apollo/client";
import { useClickTracker as useClickTracker5 } from "@shared-ui/clickstream-analytics-context";
import { UitkLink as UitkLink2 } from "uitk-react-link";
import { UitkText as UitkText3 } from "uitk-react-text";
var _obj2;
// ../internal/src/components/__private/link-map.ts
var linkSizeMapper = (_obj2 = {}, _define_property(_obj2, "SMALL" /* SMALL */ , "small"), _define_property(_obj2, "MEDIUM" /* MEDIUM */ , "medium"), _define_property(_obj2, "LARGE" /* LARGE */ , "large"), _obj2);
var _obj3;
var UILinkTargetMap2 = (_obj3 = {}, _define_property(_obj3, "EXTERNAL" /* EXTERNAL */ , "_blank"), _define_property(_obj3, "INTERNAL" /* INTERNAL */ , "_self"), _obj3);
// ../internal/src/components/egds/egds-standard-link/egds-standard-link.tsx
var fragment11 = gql22(_templateObject21(), Icon.fragment);
var EGDSStandardLink = function(_param) {
    var _param_data = _param.data, _param_data_action = _param_data.action, analytics2 = _param_data_action.analytics, resource = _param_data_action.resource, target = _param_data_action.target, accessibility = _param_data_action.accessibility, useRelativePath = _param_data_action.useRelativePath, disabled = _param_data.disabled, iconPosition = _param_data.iconPosition, standardLinkIcon = _param_data.standardLinkIcon, size = _param_data.size, text = _param_data.text, dataStid = _param.dataStid, uitkLinkProps = _object_without_properties(_param, [
        "data",
        "dataStid"
    ]);
    var clickTracker = useClickTracker5();
    var onClick = React23.useCallback(function() {
        clickTracker(analytics2.referrerId, analytics2.linkName);
    }, [
        clickTracker,
        analytics2
    ]);
    var path = React23.useMemo(function() {
        switch(resource.__typename){
            case "HttpURI":
                return useRelativePath ? resource.relativePath : resource.value;
            default:
                return resource.value;
        }
    }, [
        resource,
        useRelativePath
    ]);
    return /* @__PURE__ */ React23.createElement(UitkLink2, _object_spread({
        "data-stid": dataStid,
        size: linkSizeMapper[size],
        onClickCapture: onClick,
        disabled: disabled
    }, uitkLinkProps), /* @__PURE__ */ React23.createElement("a", {
        target: UILinkTargetMap2[target],
        href: path
    }, standardLinkIcon ? /* @__PURE__ */ React23.createElement(React23.Fragment, null, iconPosition === "LEADING" /* LEADING */  && /* @__PURE__ */ React23.createElement(Icon, {
        data: standardLinkIcon
    }), text, iconPosition === "TRAILING" /* TRAILING */  && /* @__PURE__ */ React23.createElement(Icon, {
        data: standardLinkIcon
    })) : text, accessibility && /* @__PURE__ */ React23.createElement(UitkText3, {
        className: "is-visually-hidden"
    }, accessibility)));
};
EGDSStandardLink.fragment = fragment11;
EGDSStandardLink.displayName = "EGDSStandardLink";
// ../internal/src/components/egds/egds-ui-link-action/egds-ui-link-action.tsx
import React24 from "react";
import { gql as gql23 } from "@apollo/client";
import { useClickTracker as useClickTracker6 } from "@shared-ui/clickstream-analytics-context";
var __fragment = gql23(_templateObject22());
var EGDSUILinkAction = function(param) {
    var data = param.data;
    var resource = data.resource, target = data.target, analytics2 = data.analytics, accessibility = data.accessibility, useRelativePath = data.useRelativePath;
    var navigationTarget = target === "INTERNAL" /* INTERNAL */  ? "_self" : "_blank";
    var clickTracker = useClickTracker6();
    var onClickCapture = React24.useCallback(function() {
        if (analytics2) {
            clickTracker(analytics2.referrerId, analytics2.linkName);
        }
    }, [
        analytics2,
        clickTracker
    ]);
    var path = React24.useMemo(function() {
        switch(resource.__typename){
            case "HttpURI":
                return useRelativePath ? resource.relativePath : resource.value;
            default:
                return resource.value;
        }
    }, [
        resource,
        useRelativePath
    ]);
    return /* @__PURE__ */ React24.createElement("a", {
        href: path,
        target: navigationTarget,
        rel: "noopener noreferrer",
        onClickCapture: onClickCapture,
        "aria-label": accessibility !== null && accessibility !== void 0 ? accessibility : ""
    }, accessibility);
};
EGDSUILinkAction.fragment = __fragment;
EGDSUILinkAction.displayName = "EGDSUILinkAction";
// ../internal/src/components/egds/egds-standard-messaging-card/egds-standard-messaging-card.tsx
var fragment12 = gql24(_templateObject23(), Icon.fragment, UiGraphic.fragment, EGDSStandardLink.fragment, LodgingEGDSButton.fragment, clientSideAnalyticsFragment);
var EGDSStandardMessagingCard = function(param) {
    var data = param.data, dataStid = param.dataStid, markSize = param.markSize, className = param.className, actionProps = param.actionProps, _param_showBorder = param.showBorder, showBorder = _param_showBorder === void 0 ? true : _param_showBorder;
    var message = data.message, _data_background = data.background, background = _data_background === void 0 ? UitkCardBackgroundThemes.PRIMARY : _data_background, links = data.links, graphic = data.graphic, heading = data.heading, rightIcon = data.rightIcon, buttons = data.buttons, themes = data.themes, impressionTracking = data.impressionTracking;
    var cardPadding = background === UitkCardBackgroundThemes.GLOBAL_LOYALTY_STANDARD ? {
        inline: "three",
        block: "three"
    } : {
        inline: "one",
        block: "one"
    };
    var isBgColored = background !== null && background !== UitkCardBackgroundThemes.PRIMARY && background !== UitkCardBackgroundThemes.SECONDARY;
    var isBordered = themes ? themes.includes("BORDERED" /* BORDERED */ ) : showBorder;
    var isPadding = themes ? themes.includes("PADDED" /* PADDED */ ) : true;
    var cardPaddingTheme = isPadding ? cardPadding : {};
    var egdsLinksMemo = React25.useMemo(function() {
        var _links;
        return /* @__PURE__ */ React25.createElement(UitkSpacing8, null, /* @__PURE__ */ React25.createElement(UitkLayoutFlex3, null, (_links = links) === null || _links === void 0 ? void 0 : _links.map(function(linkData, linkIndex) {
            return /* @__PURE__ */ React25.createElement(UitkSpacing8, {
                margin: {
                    inlinestart: linkIndex === 0 ? "unset" : "two"
                },
                key: linkIndex
            }, /* @__PURE__ */ React25.createElement(UitkLayoutFlexItem3, null, /* @__PURE__ */ React25.createElement("div", null, /* @__PURE__ */ React25.createElement(EGDSStandardLink, {
                data: linkData,
                dataStid: dataStid ? "".concat(dataStid, "-").concat(linkData.__typename) : void 0,
                theme: isBgColored ? "inverse" : "default"
            }))));
        })));
    }, [
        links,
        isBgColored
    ]);
    var egdsButtonsMemo = React25.useMemo(function() {
        var _buttons;
        return /* @__PURE__ */ React25.createElement(UitkSpacing8, null, /* @__PURE__ */ React25.createElement(UitkLayoutFlex3, null, (_buttons = buttons) === null || _buttons === void 0 ? void 0 : _buttons.map(function(buttonData, buttonIndex) {
            return /* @__PURE__ */ React25.createElement(UitkSpacing8, {
                margin: {
                    inlinestart: buttonIndex === 0 ? "unset" : "two"
                },
                key: buttonIndex
            }, /* @__PURE__ */ React25.createElement(UitkLayoutFlexItem3, null, /* @__PURE__ */ React25.createElement(LodgingEGDSButton, {
                data: buttonData,
                dataStid: dataStid ? "".concat(dataStid, "-").concat(buttonData.__typename) : void 0,
                size: UitkButtonSize2.SMALL,
                inverse: isBgColored && buttonData.__typename === "UITertiaryButton"
            })));
        })));
    }, [
        buttons,
        isBgColored
    ]);
    var messageOrHeader = React25.useMemo(function() {
        if (!message) {
            return null;
        }
        if (heading) {
            return /* @__PURE__ */ React25.createElement(UitkLayoutFlexItem3, null, /* @__PURE__ */ React25.createElement(UitkSpacing8, {
                margin: {
                    blockstart: "".concat(heading ? "half" : "unset")
                }
            }, /* @__PURE__ */ React25.createElement(UitkText4, {
                theme: isBgColored ? "inverse" : "default"
            }, message)));
        }
        return /* @__PURE__ */ React25.createElement(UitkLayoutFlexItem3, null, /* @__PURE__ */ React25.createElement(UitkHeading3, {
            className: isBgColored ? "uitk-text-inverse-theme" : ""
        }, message));
    }, [
        message,
        heading,
        isBgColored
    ]);
    var EgdsStandardMessagingCard = /* @__PURE__ */ React25.createElement(UitkCard3, {
        className: className,
        border: isBordered,
        padded: true,
        backgroundTheme: background
    }, /* @__PURE__ */ React25.createElement(UitkCardContentSection2, {
        "data-stid": dataStid
    }, /* @__PURE__ */ React25.createElement(UitkSpacing8, {
        padding: cardPaddingTheme
    }, /* @__PURE__ */ React25.createElement(UitkLayoutFlex3, {
        alignItems: "center"
    }, graphic && /* @__PURE__ */ React25.createElement(UitkSpacing8, {
        margin: {
            small: {
                inlineend: "three"
            },
            medium: {
                inlineend: isBgColored ? "six" : "three"
            }
        }
    }, /* @__PURE__ */ React25.createElement(UiGraphic, {
        data: graphic,
        markSize: markSize
    })), /* @__PURE__ */ React25.createElement(UitkLayoutFlexItem3, {
        grow: 1
    }, /* @__PURE__ */ React25.createElement(UitkCardContentSection2, {
        padded: false
    }, /* @__PURE__ */ React25.createElement(UitkLayoutFlex3, {
        direction: "row",
        alignItems: "center",
        justifyContent: "space-between",
        space: "two",
        wrap: rightIcon ? "nowrap" : "wrap"
    }, /* @__PURE__ */ React25.createElement(UitkLayoutFlexItem3, {
        grow: 1,
        minWidth: "88x"
    }, /* @__PURE__ */ React25.createElement(UitkLayoutFlex3, {
        direction: "column"
    }, heading && /* @__PURE__ */ React25.createElement(UitkLayoutFlexItem3, null, /* @__PURE__ */ React25.createElement(UitkHeading3, {
        className: isBgColored ? "uitk-text-inverse-theme" : ""
    }, heading)), messageOrHeader)), /* @__PURE__ */ React25.createElement(UitkLayoutFlexItem3, null, /* @__PURE__ */ React25.createElement(UitkLayoutFlex3, {
        alignItems: "center",
        space: "four",
        justifyContent: "end"
    }, buttons && buttons.length > 0 && /* @__PURE__ */ React25.createElement(UitkLayoutFlexItem3, null, egdsButtonsMemo), links && links.length > 0 && /* @__PURE__ */ React25.createElement(UitkLayoutFlexItem3, null, egdsLinksMemo))), rightIcon && /* @__PURE__ */ React25.createElement(UitkLayoutFlexItem3, null, /* @__PURE__ */ React25.createElement("div", null, /* @__PURE__ */ React25.createElement(Icon, {
        data: rightIcon
    })))))))), actionProps && /* @__PURE__ */ React25.createElement(UitkCardLink, null, /* @__PURE__ */ React25.createElement(EGDSUILinkAction, {
        data: actionProps
    }))));
    if (impressionTracking) {
        var referrerId = impressionTracking.referrerId, linkName = impressionTracking.linkName;
        return /* @__PURE__ */ React25.createElement(IntersectionTracker2, {
            referrerId: referrerId,
            linkName: linkName,
            intersectionOptions: {
                threshold: 0.5
            }
        }, EgdsStandardMessagingCard);
    }
    return /* @__PURE__ */ React25.createElement(React25.Fragment, null, EgdsStandardMessagingCard);
};
EGDSStandardMessagingCard.displayName = "EGDSStandardMessagingCard";
EGDSStandardMessagingCard.fragment = fragment12;
// src/components/property-level-offers-card/property-level-offers-card.tsx
var fragment13 = gql25(_templateObject24(), EGDSStandardMessagingCard.fragment);
var PropertyLevelOffersCard = function(param) {
    var data = param.data, showBorder = param.showBorder;
    var _data;
    if (!((_data = data) === null || _data === void 0 ? void 0 : _data.propertyLevelOffersCard)) {
        return null;
    }
    return /* @__PURE__ */ React26.createElement(EGDSStandardMessagingCard, {
        data: data.propertyLevelOffersCard,
        dataStid: "property-offers-message-card",
        markSize: 11,
        showBorder: showBorder
    });
};
PropertyLevelOffersCard.fragment = fragment13;
PropertyLevelOffersCard.displayName = "PropertyLevelOffersCard";
// src/components/property-level-offers-message/property-level-offers-message.tsx
import React30 from "react";
import { gql as gql29 } from "@apollo/client";
// ../internal/src/components/lodging-message-card/message-result.tsx
import React28 from "react";
import { gql as gql27 } from "@apollo/client";
import { useClickTracker as useClickTracker7 } from "@shared-ui/clickstream-analytics-context";
import { UitkCard as UitkCard4 } from "uitk-react-cards";
import { UitkLayoutFlex as UitkLayoutFlex4, UitkLayoutFlexItem as UitkLayoutFlexItem5 } from "uitk-react-layout-flex";
import { UitkLink as UitkLink3 } from "uitk-react-link";
import { UitkList as UitkList2, UitkListItem as UitkListItem2 } from "uitk-react-list";
import { UitkSpacing as UitkSpacing10 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading4, UitkText as UitkText5 } from "uitk-react-text";
// ../internal/src/components/lodging-message-card/messaging-result-title-media.tsx
import React27 from "react";
import { gql as gql26 } from "@apollo/client";
import { UitkIcon as UitkIcon5, UitkIconSize as UitkIconSize3 } from "uitk-react-icons";
import { UitkIllustrations as UitkIllustrations2 } from "uitk-react-illustrations";
import { UitkLayoutFlexItem as UitkLayoutFlexItem4 } from "uitk-react-layout-flex";
import { UitkMark as UitkMark3, UitkMarkSize as UitkMarkSize3 } from "uitk-react-mark";
import { UitkSpacing as UitkSpacing9 } from "uitk-react-spacing";
var fragment14 = gql26(_templateObject25());
var MessagingResultTitleMedia = function(param) {
    var data = param.data;
    var _icon, _egdsMark_url, _egdsMark, _illustration_assetUri;
    var egdsMark = data.egdsMark, icon = data.icon, illustration = data.illustration;
    if (!egdsMark && !icon && !illustration) {
        return null;
    }
    var graphic = egdsMark;
    var spotLight = ((_icon = icon) === null || _icon === void 0 ? void 0 : _icon.spotLight) ? icon.spotLight.toLowerCase() : void 0;
    var _egdsMark_url_value, _illustration_description, _illustration_assetUri_value;
    return /* @__PURE__ */ React27.createElement(React27.Fragment, null, graphic && /* @__PURE__ */ React27.createElement(UitkMark3, {
        id: graphic.id,
        name: graphic.id,
        size: UitkMarkSize3.MEDIUM_LARGE,
        description: graphic.description,
        url: (_egdsMark_url_value = (_egdsMark = egdsMark) === null || _egdsMark === void 0 ? void 0 : (_egdsMark_url = _egdsMark.url) === null || _egdsMark_url === void 0 ? void 0 : _egdsMark_url.value) !== null && _egdsMark_url_value !== void 0 ? _egdsMark_url_value : ""
    }), icon && /* @__PURE__ */ React27.createElement(UitkIcon5, {
        id: icon.id,
        title: icon.id,
        name: icon.id,
        size: UitkIconSize3.MEDIUM,
        description: icon.description,
        spotlight: spotLight
    }), illustration && /* @__PURE__ */ React27.createElement(UitkLayoutFlexItem4, {
        maxWidth: "18x"
    }, /* @__PURE__ */ React27.createElement(UitkSpacing9, {
        padding: {
            block: "half"
        }
    }, /* @__PURE__ */ React27.createElement(UitkIllustrations2, {
        alt: (_illustration_description = illustration.description) !== null && _illustration_description !== void 0 ? _illustration_description : "",
        url: (_illustration_assetUri_value = (_illustration_assetUri = illustration.assetUri) === null || _illustration_assetUri === void 0 ? void 0 : _illustration_assetUri.value) !== null && _illustration_assetUri_value !== void 0 ? _illustration_assetUri_value : ""
    }))));
};
MessagingResultTitleMedia.fragment = fragment14;
MessagingResultTitleMedia.displayName = "MessagingResultTitleMedia";
// ../internal/src/components/lodging-message-card/message-result.tsx
var fragment15 = gql27(_templateObject26(), MessagingResultTitleMedia.fragment);
var getAnalytics = function(linkName, referrerId, trackClick) {
    if (linkName && referrerId) {
        return {
            id: referrerId,
            callback: function() {
                return trackClick(referrerId, linkName);
            }
        };
    }
    return void 0;
};
var getMessageGraphic = function(title, subtitle) {
    if (title && (title.icon || title.egdsMark || title.illustration)) {
        return title;
    }
    if (subtitle && (subtitle.icon || subtitle.egdsMark)) {
        return subtitle;
    }
    return void 0;
};
var getLinkTarget = function(action) {
    switch(action){
        case "EXTERNAL_LINK":
            return {
                target: "_blank"
            };
        default:
            return {};
    }
};
var MessageResult = function(param) {
    var className = param.className, data = param.data, primaryActionClickHandler = param.primaryActionClickHandler, secondaryActionClickHandler = param.secondaryActionClickHandler, liveAnnounceLevel = param.liveAnnounceLevel;
    var _primary_analytics, _primary, _primary1, _secondary_analytics, _secondary, _secondary1, _primary_analytics1, _primary2, _primary3, _secondary_analytics1, _secondary2, _secondary3, _primary_actionDetails, _primary4, _title, _subtitle, _primary5, _primary6, _primary7, _secondary4, _secondary5, _secondary6;
    var title = data.title, subtitle = data.subtitle, action = data.action, footerText = data.footerText;
    var _ref = action || {}, primary = _ref.primary, secondary = _ref.secondary;
    var _primary_analytics_referrerId;
    var primaryReferrerId = (_primary_analytics_referrerId = (_primary = primary) === null || _primary === void 0 ? void 0 : (_primary_analytics = _primary.analytics) === null || _primary_analytics === void 0 ? void 0 : _primary_analytics.referrerId) !== null && _primary_analytics_referrerId !== void 0 ? _primary_analytics_referrerId : (_primary1 = primary) === null || _primary1 === void 0 ? void 0 : _primary1.referrerId;
    var _secondary_analytics_referrerId;
    var secondaryReferrerId = (_secondary_analytics_referrerId = (_secondary = secondary) === null || _secondary === void 0 ? void 0 : (_secondary_analytics = _secondary.analytics) === null || _secondary_analytics === void 0 ? void 0 : _secondary_analytics.referrerId) !== null && _secondary_analytics_referrerId !== void 0 ? _secondary_analytics_referrerId : (_secondary1 = secondary) === null || _secondary1 === void 0 ? void 0 : _secondary1.referrerId;
    var _primary_analytics_linkName;
    var primaryLinkName = (_primary_analytics_linkName = (_primary2 = primary) === null || _primary2 === void 0 ? void 0 : (_primary_analytics1 = _primary2.analytics) === null || _primary_analytics1 === void 0 ? void 0 : _primary_analytics1.linkName) !== null && _primary_analytics_linkName !== void 0 ? _primary_analytics_linkName : (_primary3 = primary) === null || _primary3 === void 0 ? void 0 : _primary3.text;
    var _secondary_analytics_linkName;
    var secondaryLinkName = (_secondary_analytics_linkName = (_secondary2 = secondary) === null || _secondary2 === void 0 ? void 0 : (_secondary_analytics1 = _secondary2.analytics) === null || _secondary_analytics1 === void 0 ? void 0 : _secondary_analytics1.linkName) !== null && _secondary_analytics_linkName !== void 0 ? _secondary_analytics_linkName : (_secondary3 = secondary) === null || _secondary3 === void 0 ? void 0 : _secondary3.text;
    var trackClick = useClickTracker7();
    if (!title && !subtitle) {
        return null;
    }
    var messageGraphic = getMessageGraphic(title, subtitle);
    var primaryLinkTargetAttributes = getLinkTarget((_primary4 = primary) === null || _primary4 === void 0 ? void 0 : (_primary_actionDetails = _primary4.actionDetails) === null || _primary_actionDetails === void 0 ? void 0 : _primary_actionDetails.action);
    return /* @__PURE__ */ React28.createElement(UitkCard4, {
        padded: true,
        className: className
    }, /* @__PURE__ */ React28.createElement(UitkLayoutFlex4, {
        alignItems: "center",
        "aria-live": liveAnnounceLevel,
        "data-stid": "lodging-message-card-message-result"
    }, messageGraphic && /* @__PURE__ */ React28.createElement(UitkLayoutFlexItem5, null, /* @__PURE__ */ React28.createElement(UitkSpacing10, {
        margin: {
            inlinestart: "half"
        }
    }, /* @__PURE__ */ React28.createElement("div", null, /* @__PURE__ */ React28.createElement(MessagingResultTitleMedia, {
        data: messageGraphic
    })))), /* @__PURE__ */ React28.createElement(UitkSpacing10, {
        margin: {
            inlinestart: "three"
        }
    }, /* @__PURE__ */ React28.createElement(UitkLayoutFlexItem5, null, /* @__PURE__ */ React28.createElement("div", null, /* @__PURE__ */ React28.createElement(React28.Fragment, null, /* @__PURE__ */ React28.createElement(UitkHeading4, {
        tag: "h3",
        size: 7
    }, (_title = title) === null || _title === void 0 ? void 0 : _title.text), /* @__PURE__ */ React28.createElement(UitkText5, {
        size: 300
    }, (_subtitle = subtitle) === null || _subtitle === void 0 ? void 0 : _subtitle.text)), (primary || secondary) && /* @__PURE__ */ React28.createElement(UitkList2, {
        bullet: "no-bullet",
        orientation: "inline",
        size: 2,
        spacing: true,
        type: "unordered"
    }, ((_primary5 = primary) === null || _primary5 === void 0 ? void 0 : _primary5.linkUrl) && /* @__PURE__ */ React28.createElement(UitkListItem2, null, /* @__PURE__ */ React28.createElement(UitkLink3, {
        analytics: getAnalytics(primaryLinkName, primaryReferrerId, trackClick)
    }, /* @__PURE__ */ React28.createElement("a", _object_spread({
        href: primary.linkUrl
    }, primaryLinkTargetAttributes), primary.text))), ((_primary6 = primary) === null || _primary6 === void 0 ? void 0 : _primary6.actionDetails) && ((_primary7 = primary) === null || _primary7 === void 0 ? void 0 : _primary7.text) && primaryActionClickHandler && /* @__PURE__ */ React28.createElement(UitkListItem2, null, /* @__PURE__ */ React28.createElement(UitkText5, {
        align: "left"
    }, /* @__PURE__ */ React28.createElement(UitkLink3, {
        onClick: primaryActionClickHandler,
        analytics: getAnalytics(primaryLinkName, primaryReferrerId, trackClick),
        inline: true
    }, /* @__PURE__ */ React28.createElement("button", {
        type: "button"
    }, primary.text)))), ((_secondary4 = secondary) === null || _secondary4 === void 0 ? void 0 : _secondary4.linkUrl) && /* @__PURE__ */ React28.createElement(UitkListItem2, null, /* @__PURE__ */ React28.createElement(UitkLink3, {
        analytics: getAnalytics(secondaryLinkName, secondaryReferrerId, trackClick)
    }, /* @__PURE__ */ React28.createElement("a", {
        href: secondary.linkUrl
    }, secondary.text))), ((_secondary5 = secondary) === null || _secondary5 === void 0 ? void 0 : _secondary5.actionDetails) && ((_secondary6 = secondary) === null || _secondary6 === void 0 ? void 0 : _secondary6.text) && /* @__PURE__ */ React28.createElement(UitkListItem2, null, /* @__PURE__ */ React28.createElement(UitkText5, {
        align: "left"
    }, /* @__PURE__ */ React28.createElement(UitkLink3, {
        onClick: secondaryActionClickHandler,
        analytics: getAnalytics(secondaryLinkName, secondaryReferrerId, trackClick),
        inline: true
    }, /* @__PURE__ */ React28.createElement("button", {
        type: "button"
    }, secondary.text))))), footerText && /* @__PURE__ */ React28.createElement(UitkText5, {
        align: "left",
        size: 100,
        spacing: "two"
    }, footerText))))));
};
MessageResult.fragment = fragment15;
MessageResult.displayName = "MessageResult";
// ../internal/src/components/lodging-sparkle-banner/lodging-sparkle-banner.tsx
import React29 from "react";
import { gql as gql28 } from "@apollo/client";
import { IntersectionTracker as IntersectionTracker3, useClickTracker as useClickTracker8 } from "@shared-ui/clickstream-analytics-context";
import { Experiment, ExperimentControl, ExperimentVariant } from "@shared-ui/experiment-context";
import { ViewMedium as ViewMedium2, Viewport as Viewport4, ViewSmall as ViewSmall4 } from "@shared-ui/viewport-context";
import { UitkButtonSize as UitkButtonSize3, UitkPrimaryButton as UitkPrimaryButton3 } from "uitk-react-button";
import { UitkCardBrandTheme, UitkCardContentSection as UitkCardContentSection3 } from "uitk-react-cards";
import { UitkLayoutFlex as UitkLayoutFlex5, UitkLayoutFlexItem as UitkLayoutFlexItem6 } from "uitk-react-layout-flex";
import { UitkLayoutGrid as UitkLayoutGrid4, UitkLayoutGridItem as UitkLayoutGridItem4 } from "uitk-react-layout-grid";
import { UitkSpacing as UitkSpacing11 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading5, UitkText as UitkText6 } from "uitk-react-text";
var fragment16 = gql28(_templateObject27(), MessagingResultTitleMedia.fragment);
var getMessageGraphic2 = function(title) {
    var _title, _title1;
    return ((_title = title) === null || _title === void 0 ? void 0 : _title.egdsMark) || ((_title1 = title) === null || _title1 === void 0 ? void 0 : _title1.illustration) ? title : void 0;
};
var SparkleBanner = function(param) {
    var className = param.className, data = param.data, liveAnnounceLevel = param.liveAnnounceLevel, bannerToAddMargin = param.bannerToAddMargin;
    var _primary, _primary1, _componentAnalytics, _componentAnalytics1, _title, _title1, _primary2, _primary3, _componentAnalytics2, _componentAnalytics3, _title2, _title3, _primary4, _primary5;
    var trackClick = useClickTracker8();
    var action = data.action, title = data.title, type = data.type;
    var primary = (action || {}).primary;
    var bannerTheme;
    var buttonTheme;
    var buttonTextColor = type === "BRANDED_THEME_ACCENT" ? "loyalty" : "inverse";
    if (type === "BRANDED_THEME_ACCENT") {
        bannerTheme = "accent";
        buttonTheme = true;
    } else {
        bannerTheme = "dark";
        buttonTheme = false;
    }
    var componentAnalytics = (_primary = primary) === null || _primary === void 0 ? void 0 : _primary.analytics;
    var shouldTrackAnalyticsForAuthenticatedUsers = ((_primary1 = primary) === null || _primary1 === void 0 ? void 0 : _primary1.linkUrl) === "";
    var handleClick = function() {
        if (componentAnalytics) {
            var _componentAnalytics, _componentAnalytics1;
            trackClick((_componentAnalytics = componentAnalytics) === null || _componentAnalytics === void 0 ? void 0 : _componentAnalytics.referrerId.replace(".Impression", ".Click"), "".concat((_componentAnalytics1 = componentAnalytics) === null || _componentAnalytics1 === void 0 ? void 0 : _componentAnalytics1.linkName, " Click"));
        }
    };
    var messageGraphic = getMessageGraphic2(title);
    var shouldAddMargin = bannerToAddMargin === "sparklePDP";
    var _componentAnalytics_referrerId, _componentAnalytics_linkName, _componentAnalytics_referrerId1, _componentAnalytics_linkName1;
    return /* @__PURE__ */ React29.createElement("div", {
        "data-stid": "lodging-sparkle-banner-message-result-".concat(bannerTheme),
        role: "presentation",
        onClick: shouldTrackAnalyticsForAuthenticatedUsers ? handleClick : void 0
    }, /* @__PURE__ */ React29.createElement(Experiment, {
        name: "Reduce_sparkle_banner_height"
    }, /* @__PURE__ */ React29.createElement(ExperimentControl, null, /* @__PURE__ */ React29.createElement(UitkSpacing11, {
        margin: shouldAddMargin ? {
            small: "three",
            medium: "unset",
            large: "unset"
        } : "unset"
    }, /* @__PURE__ */ React29.createElement(IntersectionTracker3, {
        referrerId: (_componentAnalytics_referrerId = (_componentAnalytics = componentAnalytics) === null || _componentAnalytics === void 0 ? void 0 : _componentAnalytics.referrerId) !== null && _componentAnalytics_referrerId !== void 0 ? _componentAnalytics_referrerId : "",
        linkName: (_componentAnalytics_linkName = (_componentAnalytics1 = componentAnalytics) === null || _componentAnalytics1 === void 0 ? void 0 : _componentAnalytics1.linkName) !== null && _componentAnalytics_linkName !== void 0 ? _componentAnalytics_linkName : ""
    }, /* @__PURE__ */ React29.createElement(UitkCardBrandTheme, {
        brandTheme: bannerTheme,
        padded: true,
        className: className,
        "aria-live": liveAnnounceLevel
    }, /* @__PURE__ */ React29.createElement(UitkLayoutGrid4, {
        alignItems: "center",
        autoColumns: [
            "minmax(var(--uitk-layoutgrid-egds-size__0x), 1fr)"
        ],
        columns: [
            "0fr",
            "1fr",
            "max-content"
        ],
        display: "grid"
    }, /* @__PURE__ */ React29.createElement(UitkLayoutGridItem4, {
        alignSelf: "start"
    }, /* @__PURE__ */ React29.createElement(UitkCardContentSection3, {
        padded: [
            "blockstart",
            "blockend",
            "inlinestart"
        ]
    }, messageGraphic && /* @__PURE__ */ React29.createElement(UitkSpacing11, {
        margin: shouldAddMargin ? {
            inlinestart: "half"
        } : "unset"
    }, /* @__PURE__ */ React29.createElement("div", null, /* @__PURE__ */ React29.createElement(MessagingResultTitleMedia, {
        data: messageGraphic
    }))))), /* @__PURE__ */ React29.createElement(UitkLayoutFlex5, {
        wrap: "wrap",
        justifyContent: "space-between",
        alignItems: "center"
    }, /* @__PURE__ */ React29.createElement(UitkLayoutFlexItem6, {
        grow: 1,
        maxWidth: "180x",
        alignSelf: "center"
    }, /* @__PURE__ */ React29.createElement(UitkCardContentSection3, {
        padded: true
    }, /* @__PURE__ */ React29.createElement(Viewport4, null, /* @__PURE__ */ React29.createElement(ViewSmall4, null, /* @__PURE__ */ React29.createElement(UitkHeading5, {
        size: 7
    }, (_title = title) === null || _title === void 0 ? void 0 : _title.text)), /* @__PURE__ */ React29.createElement(ViewMedium2, null, /* @__PURE__ */ React29.createElement(UitkSpacing11, {
        margin: {
            medium: {
                inlinestart: "one"
            },
            large: {
                inlinestart: "two"
            },
            extra_large: {
                inlinestart: "one"
            }
        }
    }, /* @__PURE__ */ React29.createElement(UitkHeading5, {
        size: 6
    }, (_title1 = title) === null || _title1 === void 0 ? void 0 : _title1.text)))))), /* @__PURE__ */ React29.createElement(UitkLayoutGrid4, null, ((_primary2 = primary) === null || _primary2 === void 0 ? void 0 : _primary2.linkUrl) && /* @__PURE__ */ React29.createElement(UitkLayoutFlexItem6, {
        alignSelf: "center"
    }, /* @__PURE__ */ React29.createElement(UitkCardContentSection3, null, /* @__PURE__ */ React29.createElement(UitkSpacing11, {
        margin: {
            medium: {
                inlinestart: "one"
            },
            large: {
                inlinestart: "two"
            },
            extra_large: {
                inlinestart: "one"
            }
        }
    }, /* @__PURE__ */ React29.createElement(UitkPrimaryButton3, {
        href: (_primary3 = primary) === null || _primary3 === void 0 ? void 0 : _primary3.linkUrl,
        inverse: buttonTheme,
        onClick: handleClick,
        size: UitkButtonSize3.SMALL
    }, /* @__PURE__ */ React29.createElement(UitkText6, {
        theme: buttonTextColor
    }, primary.text)))))))))))), /* @__PURE__ */ React29.createElement(ExperimentVariant, {
        bucket: 1
    }, /* @__PURE__ */ React29.createElement(UitkSpacing11, {
        margin: shouldAddMargin ? {
            small: "three",
            medium: "unset",
            large: "unset"
        } : "unset"
    }, /* @__PURE__ */ React29.createElement(IntersectionTracker3, {
        referrerId: (_componentAnalytics_referrerId1 = (_componentAnalytics2 = componentAnalytics) === null || _componentAnalytics2 === void 0 ? void 0 : _componentAnalytics2.referrerId) !== null && _componentAnalytics_referrerId1 !== void 0 ? _componentAnalytics_referrerId1 : "",
        linkName: (_componentAnalytics_linkName1 = (_componentAnalytics3 = componentAnalytics) === null || _componentAnalytics3 === void 0 ? void 0 : _componentAnalytics3.linkName) !== null && _componentAnalytics_linkName1 !== void 0 ? _componentAnalytics_linkName1 : ""
    }, /* @__PURE__ */ React29.createElement(UitkCardBrandTheme, {
        brandTheme: bannerTheme,
        className: className,
        "aria-live": liveAnnounceLevel
    }, /* @__PURE__ */ React29.createElement(UitkSpacing11, {
        padding: {
            inlinestart: "three",
            inlineend: "three",
            blockstart: "one",
            blockend: "one"
        }
    }, /* @__PURE__ */ React29.createElement(UitkLayoutGrid4, {
        alignItems: "center",
        autoColumns: [
            "minmax(var(--uitk-layoutgrid-egds-size__0x), 1fr)"
        ],
        columns: [
            "0fr",
            "1fr",
            "max-content"
        ],
        display: "grid"
    }, /* @__PURE__ */ React29.createElement(UitkLayoutGridItem4, {
        alignSelf: "start"
    }, /* @__PURE__ */ React29.createElement(UitkCardContentSection3, {
        padded: [
            "blockstart",
            "blockend",
            "inlinestart"
        ]
    }, messageGraphic && /* @__PURE__ */ React29.createElement(UitkSpacing11, {
        margin: shouldAddMargin ? {
            inlinestart: "half"
        } : "unset"
    }, /* @__PURE__ */ React29.createElement("div", null, /* @__PURE__ */ React29.createElement(MessagingResultTitleMedia, {
        data: messageGraphic
    }))))), /* @__PURE__ */ React29.createElement(UitkLayoutFlex5, {
        wrap: "wrap",
        justifyContent: "space-between",
        alignItems: "center"
    }, /* @__PURE__ */ React29.createElement(UitkLayoutFlexItem6, {
        grow: 1,
        maxWidth: "180x",
        alignSelf: "center"
    }, /* @__PURE__ */ React29.createElement(UitkCardContentSection3, {
        padded: true
    }, /* @__PURE__ */ React29.createElement(Viewport4, null, /* @__PURE__ */ React29.createElement(ViewSmall4, null, /* @__PURE__ */ React29.createElement(UitkHeading5, {
        size: 7
    }, (_title2 = title) === null || _title2 === void 0 ? void 0 : _title2.text)), /* @__PURE__ */ React29.createElement(ViewMedium2, null, /* @__PURE__ */ React29.createElement(UitkSpacing11, {
        margin: {
            medium: {
                inlinestart: "one"
            },
            large: {
                inlinestart: "two"
            },
            extra_large: {
                inlinestart: "one"
            }
        }
    }, /* @__PURE__ */ React29.createElement(UitkHeading5, {
        size: 6
    }, (_title3 = title) === null || _title3 === void 0 ? void 0 : _title3.text)))))), /* @__PURE__ */ React29.createElement(UitkLayoutGrid4, null, ((_primary4 = primary) === null || _primary4 === void 0 ? void 0 : _primary4.linkUrl) && /* @__PURE__ */ React29.createElement(UitkLayoutFlexItem6, {
        alignSelf: "center"
    }, /* @__PURE__ */ React29.createElement(UitkCardContentSection3, null, /* @__PURE__ */ React29.createElement(UitkSpacing11, {
        margin: {
            medium: {
                inlinestart: "one"
            },
            large: {
                inlinestart: "two"
            },
            extra_large: {
                inlinestart: "one"
            }
        }
    }, /* @__PURE__ */ React29.createElement(UitkPrimaryButton3, {
        href: (_primary5 = primary) === null || _primary5 === void 0 ? void 0 : _primary5.linkUrl,
        inverse: buttonTheme,
        onClick: handleClick,
        size: UitkButtonSize3.SMALL
    }, /* @__PURE__ */ React29.createElement(UitkText6, {
        theme: buttonTextColor
    }, primary.text)))))))))))))));
};
SparkleBanner.fragment = fragment16;
SparkleBanner.displayName = "SparkleBanner";
// src/components/property-level-offers-message/property-level-offers-message.tsx
var __PropertyLevelOffersMessageFragment = gql29(_templateObject28(), MessageResult.fragment, SparkleBanner.fragment);
var PropertyLevelOffersMessage = function(param) {
    var data = param.data, className = param.className;
    var propertyLevelOffersMessage = data.propertyLevelOffersMessage;
    if (!propertyLevelOffersMessage) {
        return null;
    }
    return propertyLevelOffersMessage.type === "BRANDED_THEME_DARK" || propertyLevelOffersMessage.type === "BRANDED_THEME_ACCENT" ? /* @__PURE__ */ React30.createElement(SparkleBanner, {
        data: propertyLevelOffersMessage,
        className: className,
        bannerToAddMargin: "sparklePDP"
    }) : /* @__PURE__ */ React30.createElement(MessageResult, {
        data: propertyLevelOffersMessage,
        className: className
    });
};
PropertyLevelOffersMessage.fragment = __PropertyLevelOffersMessageFragment;
PropertyLevelOffersMessage.displayName = "PropertyLevelOffersMessage";
// src/components/property-offers/listings-header.tsx
import React31 from "react";
import { gql as gql30 } from "@apollo/client";
import { ViewLarge as ViewLarge3, Viewport as Viewport5, ViewSmall as ViewSmall5 } from "@shared-ui/viewport-context";
import { UitkHeading as UitkHeading6 } from "uitk-react-text";
var __ListingsHeaderFragment = gql30(_templateObject29());
var ListingsHeader = function(param) {
    var className = param.className, data = param.data;
    var listingsHeader = data.listingsHeader;
    if (!listingsHeader.text) {
        return null;
    }
    return /* @__PURE__ */ React31.createElement("div", {
        className: className
    }, /* @__PURE__ */ React31.createElement(Viewport5, null, /* @__PURE__ */ React31.createElement(ViewSmall5, null, /* @__PURE__ */ React31.createElement(UitkHeading6, {
        tag: "h2",
        size: 4
    }, listingsHeader.text)), /* @__PURE__ */ React31.createElement(ViewLarge3, null, /* @__PURE__ */ React31.createElement(UitkHeading6, {
        tag: "h2",
        size: 3,
        tabIndex: -1
    }, listingsHeader.text))));
};
ListingsHeader.displayName = "ListingsHeader";
ListingsHeader.fragment = __ListingsHeaderFragment;
// src/components/property-offers/listings-placeholder.tsx
import React142 from "react";
import { useBexApi as useBexApi6 } from "@shared-ui/bex-api-context";
import { useExperiment as useExperiment3 } from "@shared-ui/experiment-context";
// ../internal/src/utils/find-react-child-by-type.ts
import React32 from "react";
var findReactChildByType = function(children, type) {
    return React32.Children.toArray(children).find(function(child) {
        return React32.isValidElement(child) && child.type === type;
    });
};
// src/components/property-offers/listings-placeholder.tsx
import { ViewLarge as ViewLarge5, ViewMedium as ViewMedium17, Viewport as Viewport21, ViewSmall as ViewSmall20 } from "@shared-ui/viewport-context";
import { UitkCard as UitkCard24, UitkCardContentSection as UitkCardContentSection17 } from "uitk-react-cards";
import { UitkCarousel as UitkCarousel2 } from "uitk-react-carousel";
import { UitkFigure as UitkFigure5, UitkFigureAspectRatioType as UitkFigureAspectRatioType6 } from "uitk-react-images";
import { UitkLayoutFlex as UitkLayoutFlex32 } from "uitk-react-layout-flex";
import { UitkLayoutGrid as UitkLayoutGrid21, UitkLayoutGridItem as UitkLayoutGridItem18 } from "uitk-react-layout-grid";
import { UitkBlockSkeleton, UitkLineSkeleton as UitkLineSkeleton2 } from "uitk-react-skeleton";
import { UitkSpacing as UitkSpacing75 } from "uitk-react-spacing";
// src/components/property-offers/property-offers.tsx
import React141 from "react";
import { gql as gql113 } from "@apollo/client";
import { usePropertyActivitiesCrossSellContext as usePropertyActivitiesCrossSellContext2 } from "@shared-ui/retail-lodging-property-activities-cross-sell";
import { UitkLayoutFlex as UitkLayoutFlex31 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing74 } from "uitk-react-spacing";
// src/components/__private/__fragments/alternate-dates.tsx
import React34 from "react";
import { gql as gql32 } from "@apollo/client";
import { UitkCard as UitkCard5, UitkCardContentSection as UitkCardContentSection4 } from "uitk-react-cards";
import { UitkLayoutGrid as UitkLayoutGrid5 } from "uitk-react-layout-grid";
import { UitkSpacing as UitkSpacing12 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading7, UitkText as UitkText8 } from "uitk-react-text";
// src/components/__private/__fragments/alternate-dates-option.tsx
import React33 from "react";
import { gql as gql31 } from "@apollo/client";
import { useClickTracker as useClickTracker9 } from "@shared-ui/clickstream-analytics-context";
import { UitkLayoutFlex as UitkLayoutFlex6, UitkLayoutFlexItem as UitkLayoutFlexItem7 } from "uitk-react-layout-flex";
import { UitkLayoutGridItem as UitkLayoutGridItem5 } from "uitk-react-layout-grid";
import { UitkLink as UitkLink4 } from "uitk-react-link";
import { UitkText as UitkText7 } from "uitk-react-text";
var fragment17 = gql31(_templateObject30());
var AlternateDateOption = function(param) {
    var data = param.data, id = param.id, _param_justifyContent = param.justifyContent, justifyContent = _param_justifyContent === void 0 ? "start" : _param_justifyContent;
    var _price;
    var track = useClickTracker9();
    var Link = useLinkComponent().Link;
    if (!data) {
        return null;
    }
    var trackClick = function() {
        track("Alternate Dates Selection", "AlternateDates.SoldOut".concat(id + 1));
    };
    var dates = data.dates, price = data.price;
    var option = /* @__PURE__ */ React33.createElement(React33.Fragment, null, /* @__PURE__ */ React33.createElement(UitkLayoutFlexItem7, null, /* @__PURE__ */ React33.createElement(UitkLink4, {
        onClick: trackClick,
        inline: true
    }, /* @__PURE__ */ React33.createElement(Link, {
        href: dates.link.uri.relativePath
    }, dates.value))), ((_price = price) === null || _price === void 0 ? void 0 : _price.displayPrice) && /* @__PURE__ */ React33.createElement(UitkLayoutFlexItem7, null, /* @__PURE__ */ React33.createElement(UitkText7, null, price.displayPrice.formatted)));
    return /* @__PURE__ */ React33.createElement(UitkLayoutGridItem5, {
        key: "alternate-date-option-".concat(id)
    }, /* @__PURE__ */ React33.createElement(UitkLayoutFlex6, {
        space: "six",
        justifyContent: justifyContent
    }, option));
};
AlternateDateOption.fragment = fragment17;
AlternateDateOption.displayName = "AlternateDateOption";
// src/components/__private/__fragments/alternate-dates.tsx
var fragment18 = gql32(_templateObject31(), AlternateDateOption.fragment);
var AlternateDates = function(param) {
    var data = param.data, className = param.className, columns = param.columns, _param_justifyContent = param.justifyContent, justifyContent = _param_justifyContent === void 0 ? "start" : _param_justifyContent;
    var alternateDates = data.alternateDates;
    if (!alternateDates || !alternateDates.header || !alternateDates.options.length) {
        return null;
    }
    var header = alternateDates.header, options = alternateDates.options;
    var text = header.text, subText = header.subText;
    var cols = {
        small: 1,
        medium: columns || 2,
        large: columns || 3
    };
    return /* @__PURE__ */ React34.createElement(UitkCard5, {
        className: className,
        key: "alternate-dates",
        "data-stid": "alternate-dates"
    }, /* @__PURE__ */ React34.createElement(UitkCardContentSection4, null, text && /* @__PURE__ */ React34.createElement(UitkHeading7, {
        tag: "h3",
        size: 6,
        "data-stid": "alternate-dates-heading"
    }, text), subText && /* @__PURE__ */ React34.createElement(UitkText8, {
        size: 200,
        "data-stid": "alternate-dates-subheading"
    }, subText)), /* @__PURE__ */ React34.createElement(UitkCardContentSection4, {
        padded: false
    }, /* @__PURE__ */ React34.createElement(UitkSpacing12, {
        padding: {
            blockend: "three",
            inline: "three"
        }
    }, /* @__PURE__ */ React34.createElement(UitkLayoutGrid5, {
        columns: cols,
        space: "four"
    }, options.map(function(option, index) {
        return /* @__PURE__ */ React34.createElement(AlternateDateOption, {
            data: option,
            key: index,
            id: index,
            justifyContent: justifyContent
        });
    })))));
};
AlternateDates.displayName = "AlternateDates";
AlternateDates.fragment = fragment18;
// src/components/property-offers-included-perks/property-offers-included-perks.tsx
import React38 from "react";
import { gql as gql35 } from "@apollo/client";
import { IntersectionTracker as IntersectionTracker4 } from "@shared-ui/clickstream-analytics-context";
import { ViewMedium as ViewMedium3, Viewport as Viewport6, ViewSmall as ViewSmall6 } from "@shared-ui/viewport-context";
import { UitkCard as UitkCard6 } from "uitk-react-cards";
import { UitkIcon as UitkIcon8 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex8, UitkLayoutFlexItem as UitkLayoutFlexItem8 } from "uitk-react-layout-flex";
import { UitkLayoutGrid as UitkLayoutGrid7, UitkLayoutGridItem as UitkLayoutGridItem7 } from "uitk-react-layout-grid";
import { UitkMark as UitkMark5 } from "uitk-react-mark";
import { UitkSpacing as UitkSpacing15 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading8, UitkText as UitkText11 } from "uitk-react-text";
// src/components/property-offers/__private/__fragments/lodging-plain-fullscreen-dialog.tsx
import React37 from "react";
import { gql as gql34 } from "@apollo/client";
import { useClickTracker as useClickTracker10 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog2 } from "@shared-ui/dialog-context";
// ../internal/src/components/lodging-enriched-message/lodging-enriched-message.tsx
import React35 from "react";
import { gql as gql33 } from "@apollo/client";
import { UitkIcon as UitkIcon6, UitkIconSize as UitkIconSize4 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex7 } from "uitk-react-layout-flex";
import { UitkLayoutGrid as UitkLayoutGrid6, UitkLayoutGridItem as UitkLayoutGridItem6 } from "uitk-react-layout-grid";
import { UitkMark as UitkMark4, UitkMarkSize as UitkMarkSize4 } from "uitk-react-mark";
import { UitkSpacing as UitkSpacing13 } from "uitk-react-spacing";
import { UitkText as UitkText9 } from "uitk-react-text";
import { UitkUnformattedHtml } from "uitk-react-unformatted-html";
var fragment19 = gql33(_templateObject32());
var highlightedMessagesThemeToUitkTextTheme = {
    AGGRESSIVE: "negative",
    HIGHLIGHT: "positive",
    LOYALTY: "loyalty"
};
var highlightedMessagesThemeToUitkTextWeight = {
    STRONG: "bold"
};
var LodgingEnrichedMessage = function(param) {
    var data = param.data, markSize = param.markSize, textSize = param.textSize;
    var _egdsMark_url;
    var subText = data.subText, value = data.value, theme = data.theme, icon = data.icon, mark = data.mark, egdsMark = data.egdsMark, state = data.state, accessibilityLabel = data.accessibilityLabel;
    if (!value) {
        return null;
    }
    var plainTextElement = function(props) {
        return /* @__PURE__ */ React35.createElement("span", null, /* @__PURE__ */ React35.createElement(UitkText9, {
            size: textSize,
            weight: stateTheme && highlightedMessagesThemeToUitkTextWeight[stateTheme] || void 0,
            theme: stateTheme && highlightedMessagesThemeToUitkTextTheme[stateTheme] || void 0
        }, props.children));
    };
    var stateTheme = state || theme;
    return /* @__PURE__ */ React35.createElement(UitkLayoutGrid6, null, /* @__PURE__ */ React35.createElement(UitkLayoutGridItem6, null, /* @__PURE__ */ React35.createElement(UitkLayoutFlex7, {
        alignItems: "center"
    }, mark && !egdsMark && /* @__PURE__ */ React35.createElement(UitkSpacing13, {
        margin: {
            inlineend: "two"
        }
    }, /* @__PURE__ */ React35.createElement(UitkMark4, {
        name: mark.id,
        size: markSize
    })), icon && /* @__PURE__ */ React35.createElement(UitkSpacing13, {
        margin: {
            inlineend: "two"
        }
    }, /* @__PURE__ */ React35.createElement(UitkIcon6, {
        name: icon.id,
        size: icon.size ? UitkIconSize4[icon.size] : UitkIconSize4.MEDIUM,
        theme: icon.theme || "default"
    })), egdsMark && /* @__PURE__ */ React35.createElement(UitkSpacing13, {
        margin: {
            inlineend: "two"
        }
    }, /* @__PURE__ */ React35.createElement(UitkMark4, {
        url: (_egdsMark_url = egdsMark.url) === null || _egdsMark_url === void 0 ? void 0 : _egdsMark_url.value,
        size: markSize !== null && markSize !== void 0 ? markSize : UitkMarkSize4.MEDIUM
    })), accessibilityLabel && /* @__PURE__ */ React35.createElement("span", {
        className: "is-visually-hidden"
    }, accessibilityLabel), /* @__PURE__ */ React35.createElement("div", null, /* @__PURE__ */ React35.createElement(UitkUnformattedHtml, {
        htmlToParse: value,
        plainTextElement: plainTextElement
    })))), subText && /* @__PURE__ */ React35.createElement(UitkLayoutGridItem6, null, /* @__PURE__ */ React35.createElement(UitkText9, {
        size: 200,
        theme: "default"
    }, subText)));
};
LodgingEnrichedMessage.fragment = fragment19;
LodgingEnrichedMessage.displayName = "LodgingEnrichedMessage";
// ../internal/src/utils/use-dialog-id.ts
import React36 from "react";
var useDialogId = function() {
    return React36.useMemo(function() {
        return Math.random().toString(36).slice(2, 7);
    }, []);
};
// src/components/property-offers/__private/__fragments/lodging-plain-fullscreen-dialog.tsx
import { UitkDialogContent as UitkDialogContent2 } from "uitk-react-dialog";
import { UitkIcon as UitkIcon7, UitkIconSize as UitkIconSize5 } from "uitk-react-icons";
import { UitkMoreInfoTrigger } from "uitk-react-more-info-trigger";
import { UitkSheet as UitkSheet2 } from "uitk-react-sheet";
import { UitkSpacing as UitkSpacing14 } from "uitk-react-spacing";
import { UitkText as UitkText10 } from "uitk-react-text";
import { UitkToolbar as UitkToolbar2 } from "uitk-react-toolbar";
import { UitkUnformattedHtml as UitkUnformattedHtml2 } from "uitk-react-unformatted-html";
var fragment20 = gql34(_templateObject33());
var LodgingPlainFullscreenDialog = function(param) {
    var data = param.data, uniqueDialogId = param.uniqueDialogId, _param_isHtmlContent = param.isHtmlContent, isHtmlContent = _param_isHtmlContent === void 0 ? false : _param_isHtmlContent, _param_spacing = param.spacing, spacing = _param_spacing === void 0 ? {} : _param_spacing;
    var _toolbar, _toolbar_icon, _toolbar1;
    var dialogPostfix = useDialogId();
    var _useDialog2 = _sliced_to_array(useDialog2("".concat(uniqueDialogId, "-").concat(dialogPostfix), "pwaDialogNested"), 3), dialogActions = _useDialog2[1], DialogComponent = _useDialog2[2];
    var trackClick = useClickTracker10();
    var triggerRef = React37.useRef(null);
    if (!data) {
        return null;
    }
    var content = data.content, trigger = data.trigger, toolbar = data.toolbar;
    var openDialog = function() {
        var clientSideAnalytics = trigger.clientSideAnalytics;
        dialogActions.openDialog();
        if (clientSideAnalytics) {
            trackClick("HOT.HIS".concat(clientSideAnalytics.referrerId), clientSideAnalytics.linkName);
        }
    };
    var closeDialog = function() {
        var clientSideAnalytics = (toolbar || {}).clientSideAnalytics;
        dialogActions.closeDialog();
        if (clientSideAnalytics) {
            trackClick("HOT.HIS".concat(clientSideAnalytics.referrerId), clientSideAnalytics.linkName);
        }
    };
    var _toolbar_title;
    return /* @__PURE__ */ React37.createElement(React37.Fragment, null, /* @__PURE__ */ React37.createElement(UitkSpacing14, _object_spread({}, spacing), /* @__PURE__ */ React37.createElement(UitkMoreInfoTrigger, {
        onClick: openDialog
    }, /* @__PURE__ */ React37.createElement("button", {
        type: "button",
        ref: triggerRef
    }, /* @__PURE__ */ React37.createElement(UitkText10, {
        className: "uitk-layout-flex",
        size: 300,
        theme: trigger.theme ? highlightedMessagesThemeToUitkTextTheme[trigger.theme] : "default"
    }, trigger.value, trigger.icon && /* @__PURE__ */ React37.createElement(UitkIcon7, {
        name: trigger.icon.id,
        size: UitkIconSize5.SMALL
    }))))), /* @__PURE__ */ React37.createElement(DialogComponent, null, /* @__PURE__ */ React37.createElement(UitkSheet2, {
        type: "centered",
        isVisible: true,
        triggerRef: triggerRef,
        returnFocusOnClose: true
    }, /* @__PURE__ */ React37.createElement(UitkToolbar2, {
        key: "".concat(uniqueDialogId, "-toolbar"),
        toolbarTitle: (_toolbar_title = (_toolbar = toolbar) === null || _toolbar === void 0 ? void 0 : _toolbar.title) !== null && _toolbar_title !== void 0 ? _toolbar_title : void 0,
        navigationContent: {
            navIconLabel: (_toolbar1 = toolbar) === null || _toolbar1 === void 0 ? void 0 : (_toolbar_icon = _toolbar1.icon) === null || _toolbar_icon === void 0 ? void 0 : _toolbar_icon.description,
            navType: "close",
            onClick: closeDialog
        }
    }), /* @__PURE__ */ React37.createElement(UitkDialogContent2, null, content.map(function(item, contentIndex) {
        return isHtmlContent ? /* @__PURE__ */ React37.createElement(UitkSpacing14, {
            padding: "three",
            key: "".concat(uniqueDialogId, "-content-").concat(contentIndex)
        }, /* @__PURE__ */ React37.createElement(UitkUnformattedHtml2, {
            htmlToParse: item
        })) : /* @__PURE__ */ React37.createElement(UitkText10, {
            key: "".concat(uniqueDialogId, "-content-").concat(contentIndex),
            spacing: contentIndex !== 0 ? "four" : void 0
        }, item);
    })))));
};
LodgingPlainFullscreenDialog.fragment = fragment20;
LodgingPlainFullscreenDialog.displayName = "LodgingPlainFullscreenDialog";
// src/components/property-offers-included-perks/property-offers-included-perks.tsx
var fragment21 = gql35(_templateObject34(), LodgingPlainFullscreenDialog.fragment);
var listDirectionMapper = {
    small: "column",
    medium: "row"
};
var getGraphic = function(graphic) {
    var size = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "medium";
    var _graphic;
    switch((_graphic = graphic) === null || _graphic === void 0 ? void 0 : _graphic.__typename){
        case "Icon":
            return /* @__PURE__ */ React38.createElement(UitkIcon8, {
                name: graphic.id,
                description: graphic.description,
                size: size
            });
        case "Mark":
            var _graphic_url;
            return /* @__PURE__ */ React38.createElement(UitkMark5, {
                url: (_graphic_url = graphic.url) === null || _graphic_url === void 0 ? void 0 : _graphic_url.value,
                name: graphic.id,
                description: graphic.description,
                size: size
            });
        default:
            return null;
    }
};
var OrientedList = function(param) {
    var viewport = param.viewport, items = param.items;
    return /* @__PURE__ */ React38.createElement(UitkLayoutFlex8, {
        direction: listDirectionMapper[viewport],
        space: "two",
        wrap: "wrap",
        tag: "ul"
    }, items.map(function(param, index) {
        var accessibilityLabel = param.accessibilityLabel, graphic = param.graphic, text = param.text, moreInfoDialog = param.moreInfoDialog;
        return /* @__PURE__ */ React38.createElement(UitkLayoutFlexItem8, {
            key: index
        }, /* @__PURE__ */ React38.createElement(UitkSpacing15, {
            margin: {
                inlineend: "four"
            }
        }, /* @__PURE__ */ React38.createElement("li", {
            "aria-label": accessibilityLabel !== null && accessibilityLabel !== void 0 ? accessibilityLabel : void 0
        }, /* @__PURE__ */ React38.createElement(UitkLayoutFlex8, {
            alignItems: "center",
            space: "two"
        }, /* @__PURE__ */ React38.createElement(UitkLayoutFlexItem8, {
            alignSelf: "start"
        }, getGraphic(graphic, viewport)), /* @__PURE__ */ React38.createElement(UitkLayoutFlexItem8, null, moreInfoDialog ? /* @__PURE__ */ React38.createElement(LodgingPlainFullscreenDialog, {
            data: moreInfoDialog,
            uniqueDialogId: "perks-dialog",
            isHtmlContent: true
        }) : /* @__PURE__ */ React38.createElement(UitkText11, null, text))))));
    }));
};
var PerksContentSmall = function(param) {
    var includedPerks = param.includedPerks;
    var _icon, _icon_spotLight, _icon1, _header, _header1;
    var header = includedPerks.header, icon = includedPerks.icon, items = includedPerks.items;
    var _header_accessibilityLabel;
    return /* @__PURE__ */ React38.createElement(UitkSpacing15, {
        padding: {
            blockend: "one"
        }
    }, /* @__PURE__ */ React38.createElement(UitkLayoutGrid7, {
        columns: [
            "min-content",
            "auto"
        ],
        space: "three"
    }, /* @__PURE__ */ React38.createElement(UitkLayoutGridItem7, null, /* @__PURE__ */ React38.createElement("div", null, icon && /* @__PURE__ */ React38.createElement(UitkIcon8, {
        name: (_icon = icon) === null || _icon === void 0 ? void 0 : _icon.id,
        spotlight: (_icon1 = icon) === null || _icon1 === void 0 ? void 0 : (_icon_spotLight = _icon1.spotLight) === null || _icon_spotLight === void 0 ? void 0 : _icon_spotLight.toLowerCase()
    }))), /* @__PURE__ */ React38.createElement(UitkLayoutGridItem7, null, /* @__PURE__ */ React38.createElement("div", null, /* @__PURE__ */ React38.createElement(UitkSpacing15, {
        margin: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React38.createElement(UitkHeading8, {
        "aria-label": (_header_accessibilityLabel = (_header = header) === null || _header === void 0 ? void 0 : _header.accessibilityLabel) !== null && _header_accessibilityLabel !== void 0 ? _header_accessibilityLabel : void 0,
        size: 5
    }, (_header1 = header) === null || _header1 === void 0 ? void 0 : _header1.text)), /* @__PURE__ */ React38.createElement(UitkSpacing15, {
        margin: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React38.createElement("div", null, /* @__PURE__ */ React38.createElement(OrientedList, {
        items: items,
        viewport: "small"
    })))))));
};
var PerksContentMedium = function(param) {
    var includedPerks = param.includedPerks;
    var _icon, _icon_spotLight, _icon1, _header, _header1;
    var header = includedPerks.header, icon = includedPerks.icon, items = includedPerks.items;
    var _header_accessibilityLabel;
    return /* @__PURE__ */ React38.createElement(UitkSpacing15, {
        padding: "two"
    }, /* @__PURE__ */ React38.createElement(UitkLayoutGrid7, {
        columns: [
            "min-content",
            "max-content",
            "auto"
        ],
        space: "three"
    }, /* @__PURE__ */ React38.createElement(UitkLayoutGridItem7, null, /* @__PURE__ */ React38.createElement("div", null, icon && /* @__PURE__ */ React38.createElement(UitkIcon8, {
        name: (_icon = icon) === null || _icon === void 0 ? void 0 : _icon.id,
        spotlight: (_icon1 = icon) === null || _icon1 === void 0 ? void 0 : (_icon_spotLight = _icon1.spotLight) === null || _icon_spotLight === void 0 ? void 0 : _icon_spotLight.toLowerCase()
    }))), /* @__PURE__ */ React38.createElement(UitkLayoutGridItem7, null, /* @__PURE__ */ React38.createElement("div", null, /* @__PURE__ */ React38.createElement(UitkSpacing15, {
        margin: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React38.createElement(UitkHeading8, {
        "aria-label": (_header_accessibilityLabel = (_header = header) === null || _header === void 0 ? void 0 : _header.accessibilityLabel) !== null && _header_accessibilityLabel !== void 0 ? _header_accessibilityLabel : void 0,
        size: 5
    }, (_header1 = header) === null || _header1 === void 0 ? void 0 : _header1.text)))), /* @__PURE__ */ React38.createElement(UitkLayoutGridItem7, null, /* @__PURE__ */ React38.createElement("div", null, /* @__PURE__ */ React38.createElement(UitkSpacing15, {
        margin: {
            blockstart: "three",
            inlinestart: "two"
        }
    }, /* @__PURE__ */ React38.createElement("div", null, /* @__PURE__ */ React38.createElement(OrientedList, {
        items: items,
        viewport: "medium"
    })))))));
};
var PropertyOffersIncludedPerks = function(param) {
    var data = param.data;
    var _iconAnalytics, _iconAnalytics1, _iconAnalytics_uisPrimeMessages, _iconAnalytics2;
    if (!data || !data.includedPerks) {
        return null;
    }
    var iconAnalytics = data.includedPerks.iconAnalytics;
    var _iconAnalytics_referrerId, _iconAnalytics_linkName;
    var trackingProps = {
        referrerId: (_iconAnalytics_referrerId = (_iconAnalytics = iconAnalytics) === null || _iconAnalytics === void 0 ? void 0 : _iconAnalytics.referrerId) !== null && _iconAnalytics_referrerId !== void 0 ? _iconAnalytics_referrerId : "",
        linkName: (_iconAnalytics_linkName = (_iconAnalytics1 = iconAnalytics) === null || _iconAnalytics1 === void 0 ? void 0 : _iconAnalytics1.linkName) !== null && _iconAnalytics_linkName !== void 0 ? _iconAnalytics_linkName : "",
        additionalUisPrimeMicroMessages: (_iconAnalytics2 = iconAnalytics) === null || _iconAnalytics2 === void 0 ? void 0 : (_iconAnalytics_uisPrimeMessages = _iconAnalytics2.uisPrimeMessages) === null || _iconAnalytics_uisPrimeMessages === void 0 ? void 0 : _iconAnalytics_uisPrimeMessages.map(function(param) {
            var messageContent = param.messageContent, schemaName = param.schemaName;
            return {
                messageContent: JSON.parse(messageContent),
                schemaName: schemaName
            };
        })
    };
    return /* @__PURE__ */ React38.createElement(IntersectionTracker4, _object_spread({}, trackingProps), /* @__PURE__ */ React38.createElement(UitkSpacing15, {
        margin: {
            block: "three"
        }
    }, /* @__PURE__ */ React38.createElement(UitkCard6, {
        padded: true
    }, /* @__PURE__ */ React38.createElement("div", null, /* @__PURE__ */ React38.createElement(Viewport6, null, /* @__PURE__ */ React38.createElement(ViewSmall6, null, /* @__PURE__ */ React38.createElement(PerksContentSmall, {
        includedPerks: data.includedPerks
    })), /* @__PURE__ */ React38.createElement(ViewMedium3, null, /* @__PURE__ */ React38.createElement(PerksContentMedium, {
        includedPerks: data.includedPerks
    })))))));
};
PropertyOffersIncludedPerks.fragment = fragment21;
PropertyOffersIncludedPerks.displayName = "PropertyOffersIncludedPerks";
// src/components/property-offers/__private/__fragments/listings/listings.tsx
import React136 from "react";
import { gql as gql108 } from "@apollo/client";
import { useBexApi as useBexApi5 } from "@shared-ui/bex-api-context";
import { Experiment as Experiment7, ExperimentControl as ExperimentControl7, ExperimentVariant as ExperimentVariant7 } from "@shared-ui/experiment-context";
// ../internal/src/components/common/adaptex/adaptex-analytics-event-fragment.ts
import { gql as gql36 } from "@apollo/client";
var AdaptExAnalyticsEventFragment = gql36(_templateObject35());
// ../internal/src/components/common/adaptex/adaptex-analytics-events.tsx
import React39 from "react";
// ../internal/src/utils/adaptex-events-filter.ts
var filterAdaptExEventsByEventType = function(adaptexActionTracking, adaptExEvents) {
    var resultAdaptExEvents;
    if (adaptexActionTracking) {
        resultAdaptExEvents = adaptExEvents.reduce(function(results, adaptExEvent) {
            var foundTracking = adaptexActionTracking.find(function(tracking) {
                return tracking.campaignId === adaptExEvent.campaignId;
            });
            if (foundTracking) {
                var _filteredEvents;
                var filteredEvents;
                if (foundTracking.eventTarget) {
                    filteredEvents = adaptExEvent.events.filter(function(event) {
                        return foundTracking.eventTarget === event.eventTarget;
                    });
                } else {
                    filteredEvents = adaptExEvent.events;
                }
                if (((_filteredEvents = filteredEvents) === null || _filteredEvents === void 0 ? void 0 : _filteredEvents.length) > 0) {
                    results.push(_object_spread_props(_object_spread({}, adaptExEvent), {
                        events: filteredEvents
                    }));
                }
            }
            return results;
        }, []);
    } else {
        resultAdaptExEvents = adaptExEvents;
    }
    return resultAdaptExEvents;
};
// ../internal/src/components/common/adaptex/adaptex-analytics-events.tsx
var initialAdaptExEvents = {
    adaptExSuccessEvents: []
};
var AdaptExEventsContext = React39.createContext(initialAdaptExEvents);
var useAdaptExEvents = function() {
    var adaptexSuccessActionTracking = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    var allAdaptExEvents = React39.useContext(AdaptExEventsContext);
    var resultAdaptExSuccessEvents = filterAdaptExEventsByEventType(adaptexSuccessActionTracking, allAdaptExEvents.adaptExSuccessEvents);
    return {
        adaptExSuccessEvents: resultAdaptExSuccessEvents
    };
};
var AdaptExEventsProvider = function(param) {
    var children = param.children, value = param.value;
    return /* @__PURE__ */ React39.createElement(AdaptExEventsContext.Provider, {
        value: value
    }, children);
};
// src/components/property-offers/__private/__fragments/listings/listings.tsx
import { ViewMedium as ViewMedium16, Viewport as Viewport20, ViewSmall as ViewSmall19 } from "@shared-ui/viewport-context";
// src/components/property-offers/__private/__fragments/lodging-section-header.tsx
import React40 from "react";
import { gql as gql37 } from "@apollo/client";
import { IntersectionTracker as IntersectionTracker5 } from "@shared-ui/clickstream-analytics-context";
import { UitkSpacingHr } from "uitk-react-spacing";
import { UitkHeading as UitkHeading9 } from "uitk-react-text";
var fragment22 = gql37(_templateObject36());
var LodgingSectionHeader = function(param) {
    var data = param.data;
    var _impressionAnalytics, _impressionAnalytics1;
    var text = data.text, accessibilityLabel = data.accessibilityLabel, impressionAnalytics = data.impressionAnalytics;
    return /* @__PURE__ */ React40.createElement(React40.Fragment, null, text && /* @__PURE__ */ React40.createElement(IntersectionTracker5, {
        trackOnce: true,
        referrerId: "".concat((_impressionAnalytics = impressionAnalytics) === null || _impressionAnalytics === void 0 ? void 0 : _impressionAnalytics.referrerId),
        linkName: "".concat((_impressionAnalytics1 = impressionAnalytics) === null || _impressionAnalytics1 === void 0 ? void 0 : _impressionAnalytics1.event)
    }, /* @__PURE__ */ React40.createElement(UitkSpacingHr, null), /* @__PURE__ */ React40.createElement(UitkHeading9, {
        tag: "h4",
        size: 5
    }, text)), accessibilityLabel && /* @__PURE__ */ React40.createElement("span", {
        className: "is-visually-hidden"
    }, accessibilityLabel));
};
LodgingSectionHeader.displayName = "LodgingSectionHeader";
LodgingSectionHeader.fragment = fragment22;
// src/components/property-offers/__private/__fragments/vertical-messaging-card/vertical-message-card.tsx
import React41 from "react";
import { gql as gql38 } from "@apollo/client";
import { useClickTracker as useClickTracker11 } from "@shared-ui/clickstream-analytics-context";
import { ViewMedium as ViewMedium4, Viewport as Viewport7 } from "@shared-ui/viewport-context";
import { UitkCard as UitkCard7, UitkCardContentSection as UitkCardContentSection5 } from "uitk-react-cards";
import { UitkFigure, UitkImage } from "uitk-react-images";
import { UitkLayoutFlex as UitkLayoutFlex9, UitkLayoutFlexItem as UitkLayoutFlexItem9 } from "uitk-react-layout-flex";
import { UitkLink as UitkLink5 } from "uitk-react-link";
import { UitkSpacing as UitkSpacing16 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading10, UitkText as UitkText12 } from "uitk-react-text";
var fragment23 = gql38(_templateObject37());
var analytics = function(linkName, referrerId, trackClick) {
    if (linkName && referrerId) {
        return {
            id: referrerId,
            callback: function() {
                return trackClick(referrerId, linkName);
            }
        };
    }
    return void 0;
};
var VerticalMessagingCard = function(param) {
    var data = param.data, primaryActionClickHandler = param.primaryActionClickHandler, secondaryActionClickHandler = param.secondaryActionClickHandler;
    var _title, _subtitle, _primary, _secondary;
    var title = data.title, subtitle = data.subtitle, action = data.action, featuredImage = data.featuredImage;
    var trackClick = useClickTracker11();
    if (!title && !subtitle) {
        return null;
    }
    var _$_object_spread = _object_spread({}, featuredImage), url = _$_object_spread.url, description = _$_object_spread.description;
    var _$_object_spread1 = _object_spread({}, action), primary = _$_object_spread1.primary, secondary = _$_object_spread1.secondary;
    return /* @__PURE__ */ React41.createElement(UitkLayoutFlex9, {
        direction: "column"
    }, /* @__PURE__ */ React41.createElement(UitkCard7, {
        border: true,
        "data-stid": "vertical-messaging-card"
    }, /* @__PURE__ */ React41.createElement(Viewport7, null, /* @__PURE__ */ React41.createElement(ViewMedium4, null, /* @__PURE__ */ React41.createElement(UitkFigure, null, /* @__PURE__ */ React41.createElement(UitkImage, {
        placeholderImage: true,
        alt: description,
        src: url
    })))), /* @__PURE__ */ React41.createElement(UitkCardContentSection5, null, /* @__PURE__ */ React41.createElement(UitkHeading10, {
        tag: "h3",
        size: 7
    }, (_title = title) === null || _title === void 0 ? void 0 : _title.text), /* @__PURE__ */ React41.createElement(UitkSpacing16, {
        margin: {
            blockstart: "two",
            blockend: "one"
        }
    }, /* @__PURE__ */ React41.createElement(UitkText12, {
        size: 300
    }, (_subtitle = subtitle) === null || _subtitle === void 0 ? void 0 : _subtitle.text)), /* @__PURE__ */ React41.createElement(UitkLayoutFlex9, {
        direction: "column"
    }, ((_primary = primary) === null || _primary === void 0 ? void 0 : _primary.text) && /* @__PURE__ */ React41.createElement(UitkLayoutFlexItem9, null, /* @__PURE__ */ React41.createElement(UitkSpacing16, {
        margin: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React41.createElement(UitkLink5, {
        analytics: analytics(primary.text, primary.referrerId, trackClick)
    }, /* @__PURE__ */ React41.createElement("button", {
        type: "button",
        onClick: primaryActionClickHandler
    }, primary.text)))), ((_secondary = secondary) === null || _secondary === void 0 ? void 0 : _secondary.text) && /* @__PURE__ */ React41.createElement(UitkLayoutFlexItem9, null, /* @__PURE__ */ React41.createElement(UitkSpacing16, {
        margin: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React41.createElement(UitkLink5, {
        analytics: analytics(secondary.text, secondary.referrerId, trackClick)
    }, /* @__PURE__ */ React41.createElement("button", {
        type: "button",
        onClick: secondaryActionClickHandler
    }, secondary.text))))))));
};
VerticalMessagingCard.fragment = fragment23;
VerticalMessagingCard.displayName = "VerticalMessagingCard";
// src/components/property-offers/__private/__fragments/listings/control-property-unit.tsx
import React115 from "react";
import { gql as gql98 } from "@apollo/client";
import { useClickTracker as useClickTracker32 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog16 } from "@shared-ui/dialog-context";
import { ViewLarge as ViewLarge4, Viewport as Viewport18, ViewSmall as ViewSmall17 } from "@shared-ui/viewport-context";
import { UitkFigureAspectRatioType as UitkFigureAspectRatioType4 } from "uitk-react-images";
// src/components/__private/__fragments/space-details.tsx
import React46 from "react";
import { gql as gql43 } from "@apollo/client";
import { UitkCard as UitkCard9 } from "uitk-react-cards";
import { UitkSpacing as UitkSpacing19 } from "uitk-react-spacing";
// src/components/__private/__fragments/space-details-floor-plan.tsx
import React42 from "react";
import { gql as gql39 } from "@apollo/client";
import { useClickTracker as useClickTracker12 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog3 } from "@shared-ui/dialog-context";
import { UitkLink as UitkLink6 } from "uitk-react-link";
import { UitkMediaGalleryImageDialog, UitkMediaGalleryImageView } from "uitk-react-media-gallery";
var mapImages = function(image) {
    var _image, _image_image, _image1, _image_image1, _image2, _image3;
    return {
        alt: (_image = image) === null || _image === void 0 ? void 0 : _image.alt,
        caption: (_image1 = image) === null || _image1 === void 0 ? void 0 : (_image_image = _image1.image) === null || _image_image === void 0 ? void 0 : _image_image.description,
        src: (_image2 = image) === null || _image2 === void 0 ? void 0 : (_image_image1 = _image2.image) === null || _image_image1 === void 0 ? void 0 : _image_image1.url,
        subjectId: (_image3 = image) === null || _image3 === void 0 ? void 0 : _image3.subjectId
    };
};
var __SpaceDetailsFloorPlanFragment = gql39(_templateObject38());
var SpaceDetailsFloorPlan = function(param) {
    var data = param.data, rfrr = param.rfrr, className = param.className;
    var _floorPlan, _toolbar;
    var floorPlan = data.floorPlan;
    var dialogPostfix = useDialogId();
    var _useDialog3 = _sliced_to_array(useDialog3("space-details-".concat(dialogPostfix), "pwaDialogNested"), 3), dialogActions = _useDialog3[1], DialogComponent = _useDialog3[2];
    var track = useClickTracker12();
    if (!((_floorPlan = floorPlan) === null || _floorPlan === void 0 ? void 0 : _floorPlan.images.length)) {
        return null;
    }
    var images = floorPlan.images, toolbar = floorPlan.toolbar, trigger = floorPlan.trigger;
    var uitkImages = images.map(mapImages);
    var toolBarAttributes = {
        type: "close",
        header: (_toolbar = toolbar) === null || _toolbar === void 0 ? void 0 : _toolbar.title
    };
    var toolbarAnalytics = {
        id: rfrr,
        description: "Close floorplan dialog",
        callback: function(_id, _desc) {
            return track(_id, _desc, true);
        }
    };
    var mediaGalleryControlsAnalytics = {
        id: rfrr,
        description: "Change image in floorplan gallery",
        callback: function(_id, _desc) {
            return track(_id, _desc, true);
        }
    };
    var handleTriggerClick = function() {
        dialogActions.openDialog();
        track(rfrr, "Open floor plan dialog", true);
    };
    var mediaGalleryImageViewProps = {
        galleryName: "Floorplan",
        currentIndex: 0,
        analytics: mediaGalleryControlsAnalytics
    };
    return /* @__PURE__ */ React42.createElement(React42.Fragment, null, /* @__PURE__ */ React42.createElement(UitkLink6, {
        className: className
    }, /* @__PURE__ */ React42.createElement("button", {
        type: "button",
        onClick: handleTriggerClick
    }, trigger.value)), /* @__PURE__ */ React42.createElement(DialogComponent, null, /* @__PURE__ */ React42.createElement(UitkMediaGalleryImageDialog, _object_spread({
        dialogShow: true,
        strictFullscreen: true,
        onDismiss: dialogActions.closeDialog,
        analytics: toolbarAnalytics
    }, toolBarAttributes), /* @__PURE__ */ React42.createElement(UitkMediaGalleryImageView, _object_spread_props(_object_spread({}, mediaGalleryImageViewProps), {
        images: uitkImages,
        stretchToFill: false
    })))));
};
SpaceDetailsFloorPlan.displayName = "SpaceDetailsFloorPlan";
SpaceDetailsFloorPlan.fragment = __SpaceDetailsFloorPlanFragment;
// src/components/__private/__fragments/space-details-header.tsx
import React43 from "react";
import { gql as gql40 } from "@apollo/client";
import { UitkHeading as UitkHeading11, UitkText as UitkText13 } from "uitk-react-text";
var __SpaceDetailsHeaderFragment = gql40(_templateObject39());
var SpaceDetailsHeader = function(param) {
    var data = param.data, _param_headingSize = param.headingSize, headingSize = _param_headingSize === void 0 ? 4 : _param_headingSize;
    var _summary;
    var header = data.header, summary = data.summary;
    return /* @__PURE__ */ React43.createElement(React43.Fragment, null, /* @__PURE__ */ React43.createElement(UitkHeading11, {
        size: headingSize,
        tag: "h3"
    }, header.text), (_summary = summary) === null || _summary === void 0 ? void 0 : _summary.map(function(value, index) {
        return /* @__PURE__ */ React43.createElement(UitkText13, {
            theme: "default",
            key: "spacedetails-summary-".concat(index),
            spacing: index === 0 ? "three" : void 0
        }, value);
    }));
};
SpaceDetailsHeader.displayName = "SpaceDetailsHeader";
SpaceDetailsHeader.fragment = __SpaceDetailsHeaderFragment;
// src/components/__private/__fragments/space-details-spaces.tsx
import React44 from "react";
import { gql as gql41 } from "@apollo/client";
import { UitkIcon as UitkIcon9, UitkIconSize as UitkIconSize7 } from "uitk-react-icons";
import { UitkLayoutGrid as UitkLayoutGrid8, UitkLayoutGridItem as UitkLayoutGridItem8 } from "uitk-react-layout-grid";
import { UitkSpacing as UitkSpacing17 } from "uitk-react-spacing";
import { UitkText as UitkText14 } from "uitk-react-text";
var __SpaceDetailsSpacesFragment = gql41(_templateObject40());
var SpaceDetailsSpaces = function(param) {
    var data = param.data, className = param.className;
    var _spaces;
    var spaces = data.spaces;
    if (!((_spaces = spaces) === null || _spaces === void 0 ? void 0 : _spaces.length)) {
        return null;
    }
    var numLargeColumns = spaces.length > 6 ? 3 : 2;
    return /* @__PURE__ */ React44.createElement(UitkLayoutGrid8, {
        className: className,
        space: "two",
        columns: {
            large: numLargeColumns,
            small: 2
        }
    }, spaces.map(function(space, index) {
        var _space_icons, _space_description;
        return /* @__PURE__ */ React44.createElement(UitkLayoutGridItem8, {
            key: "spacedetails-spaces-".concat(index)
        }, /* @__PURE__ */ React44.createElement(UitkSpacing17, {
            margin: {
                blockend: "four"
            }
        }, /* @__PURE__ */ React44.createElement("div", null, /* @__PURE__ */ React44.createElement(UitkSpacing17, {
            padding: {
                blockend: "half"
            }
        }, /* @__PURE__ */ React44.createElement(UitkText14, {
            size: 500,
            weight: "bold"
        }, space.name)), (_space_icons = space.icons) === null || _space_icons === void 0 ? void 0 : _space_icons.map(function(icon, iconIndex) {
            var _space_icons;
            return /* @__PURE__ */ React44.createElement(UitkSpacing17, {
                margin: {
                    inlineend: "two"
                },
                key: "".concat(space.name, "-").concat(iconIndex)
            }, /* @__PURE__ */ React44.createElement(UitkIcon9, {
                name: icon.id,
                size: ((_space_icons = space.icons) === null || _space_icons === void 0 ? void 0 : _space_icons.length) && space.icons.length > 1 ? UitkIconSize7.SMALL : UitkIconSize7.MEDIUM,
                description: icon.description,
                theme: "secondary"
            }));
        }), /* @__PURE__ */ React44.createElement("ul", {
            className: "no-bullet"
        }, (_space_description = space.description) === null || _space_description === void 0 ? void 0 : _space_description.map(function(desc, descIndex) {
            return /* @__PURE__ */ React44.createElement(UitkText14, {
                spacing: "two",
                theme: "default",
                size: 300,
                key: "description-".concat(descIndex)
            }, desc);
        })))));
    }));
};
SpaceDetailsSpaces.displayName = "SpaceDetailsSpaces";
SpaceDetailsSpaces.fragment = __SpaceDetailsSpacesFragment;
// src/components/__private/__fragments/virtual-tour-prompt.tsx
import React45 from "react";
import { gql as gql42 } from "@apollo/client";
import { UitkOverlayButton } from "uitk-react-button";
import { UitkCard as UitkCard8, UitkCardLink as UitkCardLink2 } from "uitk-react-cards";
import { UitkIcon as UitkIcon10 } from "uitk-react-icons";
import { UitkFigure as UitkFigure2, UitkFigureAspectRatioType, UitkImage as UitkImage2 } from "uitk-react-images";
import { UitkLayoutGrid as UitkLayoutGrid9, UitkLayoutGridItem as UitkLayoutGridItem9 } from "uitk-react-layout-grid";
import { UitkLayoutPosition } from "uitk-react-layout-position";
import { UitkSpacing as UitkSpacing18 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading12, UitkText as UitkText15 } from "uitk-react-text";
var __VirtualTourPromptFragment = gql42(_templateObject41());
var VirtualTourPrompt = function(param) {
    var data = param.data, className = param.className, _param_headingSize = param.headingSize, headingSize = _param_headingSize === void 0 ? 4 : _param_headingSize, _param_captionSize = param.captionSize, captionSize = _param_captionSize === void 0 ? 200 : _param_captionSize;
    var _heading, _heroImage, _heroImage1, _button_icon, _button_icon1, _button_icon2, _button_action;
    if (!data) {
        return null;
    }
    var heading = data.heading, button = data.button, heroImage = data.heroImage, caption = data.caption;
    return /* @__PURE__ */ React45.createElement("div", {
        className: className
    }, /* @__PURE__ */ React45.createElement(UitkHeading12, {
        size: headingSize,
        tag: "h3"
    }, (_heading = heading) === null || _heading === void 0 ? void 0 : _heading.text), button && /* @__PURE__ */ React45.createElement(UitkSpacing18, {
        margin: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React45.createElement(UitkCard8, null, /* @__PURE__ */ React45.createElement(UitkFigure2, {
        ratio: UitkFigureAspectRatioType.R16_9
    }, /* @__PURE__ */ React45.createElement(UitkImage2, {
        placeholderImage: true,
        alt: (_heroImage = heroImage) === null || _heroImage === void 0 ? void 0 : _heroImage.description,
        src: (_heroImage1 = heroImage) === null || _heroImage1 === void 0 ? void 0 : _heroImage1.url
    }), /* @__PURE__ */ React45.createElement(UitkLayoutPosition, {
        type: "absolute",
        position: {
            top: "zero",
            right: "zero",
            bottom: "zero",
            left: "zero"
        },
        cloneElement: true
    }, /* @__PURE__ */ React45.createElement(UitkLayoutGrid9, {
        alignItems: "center",
        justifyItems: "center"
    }, /* @__PURE__ */ React45.createElement(UitkLayoutGridItem9, null, /* @__PURE__ */ React45.createElement(UitkOverlayButton, null, /* @__PURE__ */ React45.createElement(UitkIcon10, {
        description: (_button_icon = button.icon) === null || _button_icon === void 0 ? void 0 : _button_icon.description,
        id: (_button_icon1 = button.icon) === null || _button_icon1 === void 0 ? void 0 : _button_icon1.id,
        name: ((_button_icon2 = button.icon) === null || _button_icon2 === void 0 ? void 0 : _button_icon2.id) || ""
    }), button.primary))))), /* @__PURE__ */ React45.createElement(UitkCardLink2, null, /* @__PURE__ */ React45.createElement("a", {
        href: (_button_action = button.action) === null || _button_action === void 0 ? void 0 : _button_action.resource.value,
        target: "_blank",
        rel: "noreferrer"
    }, button.accessibility)))), caption && /* @__PURE__ */ React45.createElement(UitkSpacing18, {
        padding: {
            blockstart: "one"
        }
    }, /* @__PURE__ */ React45.createElement(UitkText15, {
        size: captionSize,
        weight: "regular"
    }, caption.text)));
};
VirtualTourPrompt.displayName = "VirtualTourPrompt";
VirtualTourPrompt.fragment = __VirtualTourPromptFragment;
// src/components/__private/__fragments/space-details.tsx
var __SpaceDetailsFragment = gql43(_templateObject42(), SpaceDetailsHeader.fragment, SpaceDetailsSpaces.fragment, SpaceDetailsFloorPlan.fragment, VirtualTourPrompt.fragment);
var SpaceDetails = function(param) {
    var spaceDetails = param.data, className = param.className;
    if (!spaceDetails) {
        return null;
    }
    return /* @__PURE__ */ React46.createElement(UitkSpacing19, {
        className: className
    }, /* @__PURE__ */ React46.createElement(UitkCard9, null, /* @__PURE__ */ React46.createElement(SpaceDetailsHeader, {
        data: spaceDetails
    }), /* @__PURE__ */ React46.createElement(UitkSpacing19, {
        padding: {
            blockstart: "six"
        }
    }, /* @__PURE__ */ React46.createElement(SpaceDetailsFloorPlan, {
        data: spaceDetails,
        rfrr: "HOT.HIS.SpaceDetails.SingleiUnit.Floorplan"
    })), /* @__PURE__ */ React46.createElement(UitkSpacing19, {
        padding: {
            blockstart: "six"
        }
    }, /* @__PURE__ */ React46.createElement(SpaceDetailsSpaces, {
        data: spaceDetails
    })), spaceDetails.virtualTourPrompt ? /* @__PURE__ */ React46.createElement(UitkSpacing19, {
        padding: {
            blockstart: "six"
        }
    }, /* @__PURE__ */ React46.createElement(VirtualTourPrompt, {
        data: spaceDetails.virtualTourPrompt
    })) : null));
};
SpaceDetails.displayName = "SpaceDetails";
SpaceDetails.fragment = __SpaceDetailsFragment;
// src/components/property-offers/__private/__fragments/availability-cta/availability-cta.tsx
import React48 from "react";
import { gql as gql45 } from "@apollo/client";
// src/components/property-offers/__private/__fragments/availability-cta/availability-call-to-action.tsx
import React47 from "react";
import { gql as gql44 } from "@apollo/client";
import { useClickTracker as useClickTracker13 } from "@shared-ui/clickstream-analytics-context";
import { useRefContext } from "@shared-ui/ref-context";
import { useSignalPublisher } from "@shared-ui/signal-events-context";
import { UitkPrimaryButton as UitkPrimaryButton4 } from "uitk-react-button";
import { UitkText as UitkText16 } from "uitk-react-text";
// src/utils/constants.ts
var INTERACTION = "Interaction";
var RECOMMENDATION_MODULE = "recommendation_module";
var MODULE_SELECTED = "selected";
var PropertyOffersSignalNames = /* @__PURE__ */ function(PropertyOffersSignalNames2) {
    PropertyOffersSignalNames2["AVAILABILITY_CALL_TO_ACTION_CTA_BUTTON_CLICK"] = "PROPERTY_OFFERS_AVAILABILITY_CALL_TO_ACTION_CTA_BUTTON_CLICK";
    return PropertyOffersSignalNames2;
}(PropertyOffersSignalNames || {});
// src/components/property-offers/__private/__fragments/availability-cta/availability-call-to-action.tsx
var fragment24 = gql44(_templateObject43());
var START_DATE_REF_NAME = "startDate";
var AvailabilityCallToAction = function(param) {
    var closeDialog = param.closeDialog, listingIndex = param.listingIndex, data = param.data;
    var availabilityCallToAction = data;
    var clickTrack = useClickTracker13();
    var getTargets = useRefContext().getTargets;
    var publishSignal = useSignalPublisher().publishSignal;
    if (!availabilityCallToAction) {
        return null;
    }
    var handleCtaButtonClick = function() {
        var _clickRef_current, _clickRef;
        publishSignal({
            payload: {},
            type: "PROPERTY_OFFERS_AVAILABILITY_CALL_TO_ACTION_CTA_BUTTON_CLICK" /* AVAILABILITY_CALL_TO_ACTION_CTA_BUTTON_CLICK */ 
        });
        if (closeDialog && typeof closeDialog === "function") {
            closeDialog();
        }
        var _getTargets = getTargets([
            START_DATE_REF_NAME
        ]), clickRef = _getTargets.startDate;
        (_clickRef = clickRef) === null || _clickRef === void 0 ? void 0 : (_clickRef_current = _clickRef.current) === null || _clickRef_current === void 0 ? void 0 : _clickRef_current.click();
        clickTrack("Go to select dates", "ROOM[".concat(listingIndex, "].CHOOSEDATE.CTA"));
    };
    if (availabilityCallToAction.__typename === "LodgingButton" && availabilityCallToAction.text) {
        return /* @__PURE__ */ React47.createElement(UitkPrimaryButton4, {
            onClick: handleCtaButtonClick
        }, availabilityCallToAction.text);
    }
    if (availabilityCallToAction.__typename === "LodgingPlainMessage" && availabilityCallToAction.value) {
        return /* @__PURE__ */ React47.createElement(UitkText16, {
            weight: "bold",
            theme: "negative"
        }, availabilityCallToAction.value);
    }
    return null;
};
AvailabilityCallToAction.displayName = "AvailabilityCallToAction";
AvailabilityCallToAction.fragment = fragment24;
// src/components/property-offers/__private/__fragments/availability-cta/availability-cta.tsx
var fragment25 = gql45(_templateObject44());
var AvailabilityCta = function(param) {
    var closeDialog = param.closeDialog, listingIndex = param.listingIndex, data = param.data;
    var availabilityCallToAction = data.availabilityCallToAction;
    if (!availabilityCallToAction) {
        return null;
    }
    return /* @__PURE__ */ React48.createElement(AvailabilityCallToAction, {
        closeDialog: closeDialog,
        listingIndex: listingIndex,
        data: availabilityCallToAction
    });
};
AvailabilityCta.displayName = "AvailabilityCta";
AvailabilityCta.fragment = fragment25;
// src/components/property-offers/__private/__fragments/details-dialog-trigger/dialog/sections/dialog-info-section/sections/sleeping-arrangements.tsx
import React49 from "react";
import { gql as gql46 } from "@apollo/client";
import { UitkSpacing as UitkSpacing20 } from "uitk-react-spacing";
var __SleepingArrangementsFragment = gql46(_templateObject45(), SpaceDetailsHeader.fragment, SpaceDetailsSpaces.fragment, SpaceDetailsFloorPlan.fragment);
var SleepingArrangements = function(param) {
    var data = param.data;
    if (!data) {
        return null;
    }
    return /* @__PURE__ */ React49.createElement("div", null, /* @__PURE__ */ React49.createElement(SpaceDetailsHeader, {
        data: data,
        headingSize: 5
    }), /* @__PURE__ */ React49.createElement(SpaceDetailsFloorPlan, {
        data: data,
        rfrr: "HOT.HIS.SpaceDetails.MultiUnit.Floorplan"
    }), /* @__PURE__ */ React49.createElement(UitkSpacing20, {
        margin: {
            blockstart: "four"
        }
    }, /* @__PURE__ */ React49.createElement(SpaceDetailsSpaces, {
        data: data
    })));
};
SleepingArrangements.displayName = "SleepingArrangements";
SleepingArrangements.fragment = __SleepingArrangementsFragment;
// src/components/property-offers/__private/__fragments/details-dialog-trigger/dialog/sections/dialog-rate-plan-section.tsx
import React96 from "react";
import { UitkCard as UitkCard14 } from "uitk-react-cards";
import { MinMax as MinMax2, Repeat, UitkLayoutGrid as UitkLayoutGrid14, UitkLayoutGridItem as UitkLayoutGridItem13 } from "uitk-react-layout-grid";
import { UitkSpacing as UitkSpacing45 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading19 } from "uitk-react-text";
// src/components/property-offers/__private/__fragments/rate-plan/rate-plan-with-amenities.tsx
import React95 from "react";
import { gql as gql88 } from "@apollo/client";
// ../internal/src/components/common/pricing-fragments.ts
import { gql as gql47 } from "@apollo/client";
var PriceSummaryFragment = gql47(_templateObject46());
// ../internal/src/components/dialog-context.tsx
import React50 from "react";
var DialogContext = React50.createContext(false);
var dialog_context_default = DialogContext;
// ../internal/src/components/lodging-price-summary.tsx
import React51 from "react";
import { gql as gql48 } from "@apollo/client";
import { useClickTracker as useClickTracker14 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog4 } from "@shared-ui/dialog-context";
import { UitkDialog, UitkDialogContent as UitkDialogContent3, UitkDialogFooter as UitkDialogFooter2 } from "uitk-react-dialog";
import { UitkPriceLockup, UitkPriceLockupAlign } from "uitk-react-price-lockup";
var fragment26 = gql48(_templateObject47());
var formatStrikeOutText = function(price, points, unit, leadingCaption, isPointsFirst) {
    if (!price && !points) {
        return void 0;
    }
    if (!points) {
        var _price;
        return (_price = price) === null || _price === void 0 ? void 0 : _price.formatted;
    }
    if (!price) {
        return "".concat(points.formatted, " ").concat(unit);
    }
    if (isPointsFirst) {
        return "".concat(points.formatted, " ").concat(unit, " ").concat(leadingCaption, " ").concat(price.formatted);
    }
    return "".concat(price.formatted, " ").concat(leadingCaption, " ").concat(points.formatted, " ").concat(unit);
};
var buildUitkPriceLockupProps = function(options) {
    var _displayPrice, _displayPrice1, _otherOption, _loyaltyPoints, _loyaltyPoints1, _otherOption1, _otherOption2, _loyaltyPoints_amount, _loyaltyPoints2, _loyaltyPoints3, _priceDisclaimer_trigger_icon, _priceDisclaimer_trigger, _priceDisclaimer;
    var _options = _sliced_to_array(options, 3), leadOption = _options[0], otherOption = _options[1], disclaimerForPoints = _options[2];
    var _ref = leadOption !== null && leadOption !== void 0 ? leadOption : {}, leadingCaption = _ref.leadingCaption, loyaltyPrice = _ref.loyaltyPrice, displayPrice = _ref.displayPrice, accessibilityLabel = _ref.accessibilityLabel, priceDisclaimer = _ref.priceDisclaimer, strikeOut = _ref.strikeOut;
    if (options.length === 1 && loyaltyPrice) {
        var _loyaltyPrice_totalStrikeOutPoints, _loyaltyPrice_amount;
        var strikeThroughPoints = loyaltyPrice.totalStrikeOutPoints ? "".concat((_loyaltyPrice_totalStrikeOutPoints = loyaltyPrice.totalStrikeOutPoints) === null || _loyaltyPrice_totalStrikeOutPoints === void 0 ? void 0 : _loyaltyPrice_totalStrikeOutPoints.formatted, " ").concat(loyaltyPrice.unit) : "";
        return {
            isStrikeThroughFirst: true,
            lockupFormattedPoints: "".concat((_loyaltyPrice_amount = loyaltyPrice.amount) === null || _loyaltyPrice_amount === void 0 ? void 0 : _loyaltyPrice_amount.formatted, " ").concat(loyaltyPrice.unit),
            strikeThroughPrice: strikeThroughPoints,
            a11yPrice: accessibilityLabel || ""
        };
    }
    if (loyaltyPrice) {
        var _otherOption3, _otherOption_displayPrice, _otherOption4, _loyaltyPrice_amount1, _otherOption5, _disclaimerForPoints, _otherOption6, _disclaimerForPoints_priceDisclaimer_trigger_icon, _disclaimerForPoints_priceDisclaimer_trigger, _disclaimerForPoints_priceDisclaimer, _disclaimerForPoints1;
        var moneyPrice = "".concat((_otherOption3 = otherOption) === null || _otherOption3 === void 0 ? void 0 : _otherOption3.leadingCaption, " ").concat((_otherOption4 = otherOption) === null || _otherOption4 === void 0 ? void 0 : (_otherOption_displayPrice = _otherOption4.displayPrice) === null || _otherOption_displayPrice === void 0 ? void 0 : _otherOption_displayPrice.formatted);
        var _disclaimerForPoints_strikeOut, _otherOption_leadingCaption;
        return {
            isStrikeThroughFirst: true,
            isPointsFirst: true,
            lockupPrice: moneyPrice,
            lockupFormattedPoints: "".concat((_loyaltyPrice_amount1 = loyaltyPrice.amount) === null || _loyaltyPrice_amount1 === void 0 ? void 0 : _loyaltyPrice_amount1.formatted, " ").concat(loyaltyPrice.unit),
            a11yPrice: ((_otherOption5 = otherOption) === null || _otherOption5 === void 0 ? void 0 : _otherOption5.accessibilityLabel) || "",
            strikeThroughPrice: formatStrikeOutText((_disclaimerForPoints_strikeOut = (_disclaimerForPoints = disclaimerForPoints) === null || _disclaimerForPoints === void 0 ? void 0 : _disclaimerForPoints.strikeOut) !== null && _disclaimerForPoints_strikeOut !== void 0 ? _disclaimerForPoints_strikeOut : null, loyaltyPrice.totalStrikeOutPoints, loyaltyPrice.unit, (_otherOption_leadingCaption = (_otherOption6 = otherOption) === null || _otherOption6 === void 0 ? void 0 : _otherOption6.leadingCaption) !== null && _otherOption_leadingCaption !== void 0 ? _otherOption_leadingCaption : null, true),
            a11yStrikeThroughDialogTrigger: (_disclaimerForPoints1 = disclaimerForPoints) === null || _disclaimerForPoints1 === void 0 ? void 0 : (_disclaimerForPoints_priceDisclaimer = _disclaimerForPoints1.priceDisclaimer) === null || _disclaimerForPoints_priceDisclaimer === void 0 ? void 0 : (_disclaimerForPoints_priceDisclaimer_trigger = _disclaimerForPoints_priceDisclaimer.trigger) === null || _disclaimerForPoints_priceDisclaimer_trigger === void 0 ? void 0 : (_disclaimerForPoints_priceDisclaimer_trigger_icon = _disclaimerForPoints_priceDisclaimer_trigger.icon) === null || _disclaimerForPoints_priceDisclaimer_trigger_icon === void 0 ? void 0 : _disclaimerForPoints_priceDisclaimer_trigger_icon.description
        };
    }
    var leadPrice = leadingCaption ? "".concat(leadingCaption, " ").concat((_displayPrice = displayPrice) === null || _displayPrice === void 0 ? void 0 : _displayPrice.formatted) : (_displayPrice1 = displayPrice) === null || _displayPrice1 === void 0 ? void 0 : _displayPrice1.formatted;
    if (options.length === 1) {
        var _strikeOut, _priceDisclaimer_trigger_icon1, _priceDisclaimer_trigger1, _priceDisclaimer1;
        return {
            lockupPrice: leadPrice,
            a11yPrice: accessibilityLabel || "",
            strikeThroughPrice: (_strikeOut = strikeOut) === null || _strikeOut === void 0 ? void 0 : _strikeOut.formatted,
            a11yStrikeThroughDialogTrigger: (_priceDisclaimer1 = priceDisclaimer) === null || _priceDisclaimer1 === void 0 ? void 0 : (_priceDisclaimer_trigger1 = _priceDisclaimer1.trigger) === null || _priceDisclaimer_trigger1 === void 0 ? void 0 : (_priceDisclaimer_trigger_icon1 = _priceDisclaimer_trigger1.icon) === null || _priceDisclaimer_trigger_icon1 === void 0 ? void 0 : _priceDisclaimer_trigger_icon1.description
        };
    }
    var loyaltyPoints = (_otherOption = otherOption) === null || _otherOption === void 0 ? void 0 : _otherOption.loyaltyPrice;
    var _otherOption_leadingCaption1;
    return {
        isStrikeThroughFirst: true,
        isPointsFirst: false,
        strikeThroughPrice: formatStrikeOutText(strikeOut !== null && strikeOut !== void 0 ? strikeOut : null, (_loyaltyPoints = loyaltyPoints) === null || _loyaltyPoints === void 0 ? void 0 : _loyaltyPoints.totalStrikeOutPoints, (_loyaltyPoints1 = loyaltyPoints) === null || _loyaltyPoints1 === void 0 ? void 0 : _loyaltyPoints1.unit, (_otherOption_leadingCaption1 = (_otherOption1 = otherOption) === null || _otherOption1 === void 0 ? void 0 : _otherOption1.leadingCaption) !== null && _otherOption_leadingCaption1 !== void 0 ? _otherOption_leadingCaption1 : null, false),
        lockupPrice: leadPrice,
        lockupFormattedPoints: "".concat((_otherOption2 = otherOption) === null || _otherOption2 === void 0 ? void 0 : _otherOption2.leadingCaption, " ").concat((_loyaltyPoints2 = loyaltyPoints) === null || _loyaltyPoints2 === void 0 ? void 0 : (_loyaltyPoints_amount = _loyaltyPoints2.amount) === null || _loyaltyPoints_amount === void 0 ? void 0 : _loyaltyPoints_amount.formatted, " ").concat((_loyaltyPoints3 = loyaltyPoints) === null || _loyaltyPoints3 === void 0 ? void 0 : _loyaltyPoints3.unit),
        a11yStrikeThroughDialogTrigger: (_priceDisclaimer = priceDisclaimer) === null || _priceDisclaimer === void 0 ? void 0 : (_priceDisclaimer_trigger = _priceDisclaimer.trigger) === null || _priceDisclaimer_trigger === void 0 ? void 0 : (_priceDisclaimer_trigger_icon = _priceDisclaimer_trigger.icon) === null || _priceDisclaimer_trigger_icon === void 0 ? void 0 : _priceDisclaimer_trigger_icon.description,
        a11yPrice: accessibilityLabel || ""
    };
};
var getPriceDisclaimer = function(options) {
    var _options_, _options_1;
    return ((_options_ = options[0]) === null || _options_ === void 0 ? void 0 : _options_.priceDisclaimer) || ((_options_1 = options[2]) === null || _options_1 === void 0 ? void 0 : _options_1.priceDisclaimer);
};
var LodgingPriceSummary = function(param) {
    var _param_showPriceDetails = param.showPriceDetails, showPriceDetails = _param_showPriceDetails === void 0 ? true : _param_showPriceDetails, _param_align = param.align, align = _param_align === void 0 ? UitkPriceLockupAlign.LEFT : _param_align, data = param.data;
    var _price, _priceMessaging, _priceMessaging1, _priceMessaging2, _priceSubtextStandardRawData, _priceMessaging_, _priceMessaging_priceSubtextBoldIndex, _priceDisclaimer_primaryButton;
    var price = data.price;
    var trackClick = useClickTracker14();
    var dialogPostfix = useDialogId();
    var _useDialog4 = _sliced_to_array(useDialog4("property-price-messaging-dialog-".concat(dialogPostfix), "pwaDialogNested"), 3), isDialogOpen = _useDialog4[0], dialogActions = _useDialog4[1], DialogComponent = _useDialog4[2];
    if (!((_price = price) === null || _price === void 0 ? void 0 : _price.options) || price.options.length === 0) {
        return null;
    }
    var priceMessaging = price.priceMessaging, options = price.options;
    var priceSubtextBoldIndex = ((_priceMessaging = priceMessaging) === null || _priceMessaging === void 0 ? void 0 : _priceMessaging.findIndex(function(msg) {
        return msg.theme === "STRONG" /* STRONG */ ;
    })) || -1;
    var priceSubtextStandardRawData = priceSubtextBoldIndex === -1 ? (_priceMessaging1 = priceMessaging) === null || _priceMessaging1 === void 0 ? void 0 : _priceMessaging1.slice(1) : (_priceMessaging2 = priceMessaging) === null || _priceMessaging2 === void 0 ? void 0 : _priceMessaging2.slice(1).splice(priceSubtextBoldIndex, 1);
    var priceSubtextStandard = (_priceSubtextStandardRawData = priceSubtextStandardRawData) === null || _priceSubtextStandardRawData === void 0 ? void 0 : _priceSubtextStandardRawData.map(function(msg) {
        return msg.value;
    });
    var openStrikeThroughPriceDialog = function() {
        dialogActions.openDialog();
        trackClick("HOT.HIS.Price.DisclaimerDialog", "Price Disclaimer Dialog");
    };
    var priceProps = buildUitkPriceLockupProps(options);
    var priceDisclaimer = getPriceDisclaimer(options);
    return /* @__PURE__ */ React51.createElement("div", null, /* @__PURE__ */ React51.createElement(UitkPriceLockup, _object_spread_props(_object_spread({}, priceProps), {
        align: align,
        priceSubtextFirst: showPriceDetails && priceMessaging ? (_priceMessaging_ = priceMessaging[0]) === null || _priceMessaging_ === void 0 ? void 0 : _priceMessaging_.value : "",
        priceSubtextStandard: showPriceDetails ? priceSubtextStandard : void 0,
        priceSubtextBold: showPriceDetails && priceMessaging && priceSubtextBoldIndex !== -1 ? (_priceMessaging_priceSubtextBoldIndex = priceMessaging[priceSubtextBoldIndex]) === null || _priceMessaging_priceSubtextBoldIndex === void 0 ? void 0 : _priceMessaging_priceSubtextBoldIndex.value : "",
        strikeThroughTrigger: !!priceDisclaimer && /* @__PURE__ */ React51.createElement("button", {
            onClick: openStrikeThroughPriceDialog,
            type: "button",
            className: "uitk-more-info-trigger"
        }),
        stids: {
            lockupId: "price-lockup-text",
            subtextBoldId: "price-lockup-bold-subtext",
            wrapperId: "price-lockup-wrapper"
        }
    })), !!priceDisclaimer && /* @__PURE__ */ React51.createElement(DialogComponent, null, /* @__PURE__ */ React51.createElement(UitkDialog, {
        dialogShow: isDialogOpen,
        returnFocusOnClose: true
    }, /* @__PURE__ */ React51.createElement(UitkDialogContent3, null, priceDisclaimer.content[0], /* @__PURE__ */ React51.createElement(UitkDialogFooter2, {
        buttonOne: {
            onClick: dialogActions.closeDialog,
            text: ((_priceDisclaimer_primaryButton = priceDisclaimer.primaryButton) === null || _priceDisclaimer_primaryButton === void 0 ? void 0 : _priceDisclaimer_primaryButton.text) || "",
            type: "tertiary"
        }
    })))));
};
LodgingPriceSummary.fragment = fragment26;
LodgingPriceSummary.displayName = "LodgingPriceSummary";
// src/components/property-offers/__private/__fragments/rate-plan/rate-plan-with-amenities.tsx
import { PriceSummary as PriceSummary2 } from "@shared-ui/pricing-price-summary";
import { UitkLayoutFlex as UitkLayoutFlex23, UitkLayoutFlexItem as UitkLayoutFlexItem16 } from "uitk-react-layout-flex";
import { UitkPriceLockupAlign as UitkPriceLockupAlign4 } from "uitk-react-price-lockup";
import { UitkSpacing as UitkSpacing44 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading18, UitkText as UitkText34 } from "uitk-react-text";
// src/utils/analytics.ts
var roomSchema = function(roomTypeCode, ratePlans) {
    return {
        schemaName: "room",
        messageContent: {
            roomTypeCode: roomTypeCode,
            ratePlans: ratePlans
        }
    };
};
var allRoomsSchema = function(params) {
    var rateUpsell = params.rateUpsell, additionalAmount = params.additionalAmount, ratePlanCode = params.ratePlanCode, roomId = params.roomId, propertyId = params.propertyId, roomUpsell = params.roomUpsell, propertyUpsellAmount = params.propertyUpsellAmount, ratePlanDenseRank = params.ratePlanDenseRank, roomUpgradeEligible = params.roomUpgradeEligible, rateUpgradeEligible = params.rateUpgradeEligible;
    return [
        {
            messageContent: {
                numOfProducts: 1,
                hotelProducts: [
                    {
                        productId: parseInt(propertyId, 10)
                    }
                ]
            },
            schemaName: "allHotelProducts"
        },
        {
            messageContent: {
                productId: parseInt(propertyId, 10),
                rooms: [
                    {
                        roomTypeCode: roomId,
                        propertyUpsell: {
                            roomUpsell: roomUpsell,
                            additionalAmount: propertyUpsellAmount,
                            roomUpgradeEligible: roomUpgradeEligible
                        },
                        ratePlans: [
                            {
                                ratePlanCode: ratePlanCode,
                                ratePlanDenseRank: ratePlanDenseRank,
                                upsell: {
                                    rateUpsell: rateUpsell,
                                    additionalAmount: additionalAmount,
                                    rateUpgradeEligible: rateUpgradeEligible
                                }
                            }
                        ]
                    }
                ]
            },
            schemaName: "allRooms"
        }
    ];
};
var egRecommendationClickstreamBuilder = function(recommendationResponseId, ratePlanId, eventName, eventType, listingIndex, clientSideAnalytics) {
    return [
        {
            messageContent: {
                eventName: eventName,
                eventType: eventType,
                egRecommendationResponseId: recommendationResponseId,
                redirectedDestinationName: clientSideAnalytics.referrerId,
                recommendations: [
                    {
                        recommendationId: ratePlanId,
                        rank: listingIndex
                    }
                ]
            },
            schemaName: "allRecommendations"
        },
        {
            messageContent: {
                referrerId: clientSideAnalytics.referrerId,
                linkName: clientSideAnalytics.linkName
            },
            schemaName: "referrer"
        }
    ];
};
// src/components/__private/__fragments/marketing-section.tsx
import React52 from "react";
import { gql as gql49 } from "@apollo/client";
import { useClickTracker as useClickTracker15 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog5 } from "@shared-ui/dialog-context";
import { UitkCard as UitkCard10, UitkCardContentSection as UitkCardContentSection6 } from "uitk-react-cards";
import { UitkDialog as UitkDialog2, UitkDialogContent as UitkDialogContent4, UitkDialogFooter as UitkDialogFooter3 } from "uitk-react-dialog";
import { UitkIcon as UitkIcon11, UitkIconSize as UitkIconSize8 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex10, UitkLayoutFlexItem as UitkLayoutFlexItem10 } from "uitk-react-layout-flex";
import { UitkLink as UitkLink7 } from "uitk-react-link";
import { UitkMark as UitkMark6, UitkMarkSize as UitkMarkSize6 } from "uitk-react-mark";
import { UitkSpacing as UitkSpacing21 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading13, UitkText as UitkText17 } from "uitk-react-text";
var fragment27 = gql49(_templateObject48(), LodgingEnrichedMessage.fragment);
var MarketingSection = function(param) {
    var data = param.data;
    var _title, _title1, _icon, _content, _tertiaryUIButton, _tertiaryUIButton1;
    var dialogPostfix = useDialogId();
    var _useDialog5 = _sliced_to_array(useDialog5("marketing-info-".concat(dialogPostfix), "pwaDialogNested"), 3), isDialogOpen = _useDialog5[0], dialogActions = _useDialog5[1], DialogComponent = _useDialog5[2];
    var track = useClickTracker15();
    var isWithinDetailsDialog = React52.useContext(dialog_context_default);
    if (!data) {
        return null;
    }
    var title = data.title, feeDialog = data.feeDialog, paymentDetails = data.paymentDetails;
    var content = feeDialog.content, dialogTitle = feeDialog.title, tertiaryUIButton = feeDialog.tertiaryUIButton, trigger = feeDialog.trigger;
    var clientSideAnalytics = trigger.clientSideAnalytics, icon = trigger.icon, mark = trigger.mark, value = trigger.value;
    var handleOpenDialog = function() {
        dialogActions.openDialog();
        if (clientSideAnalytics) {
            track("HOT.HIS.".concat(clientSideAnalytics.referrerId), "".concat(clientSideAnalytics.linkName));
        }
    };
    return /* @__PURE__ */ React52.createElement(React52.Fragment, null, /* @__PURE__ */ React52.createElement(UitkCard10, {
        padded: true,
        border: true,
        "data-stid": "marketing-fee-info"
    }, ((_title = title) === null || _title === void 0 ? void 0 : _title.text) && /* @__PURE__ */ React52.createElement(UitkSpacing21, {
        padding: {
            blockend: "two"
        }
    }, /* @__PURE__ */ React52.createElement(UitkHeading13, {
        tag: "h4",
        size: 7
    }, (_title1 = title) === null || _title1 === void 0 ? void 0 : _title1.text)), /* @__PURE__ */ React52.createElement(UitkCardContentSection6, {
        padded: false
    }, /* @__PURE__ */ React52.createElement(UitkLayoutFlex10, {
        space: "two",
        direction: "column",
        alignItems: "start"
    }, value && /* @__PURE__ */ React52.createElement(UitkLayoutFlexItem10, null, /* @__PURE__ */ React52.createElement(UitkLink7, null, /* @__PURE__ */ React52.createElement("button", {
        onClick: handleOpenDialog,
        type: "button"
    }, mark && /* @__PURE__ */ React52.createElement(UitkSpacing21, {
        margin: {
            inlineend: "two"
        }
    }, /* @__PURE__ */ React52.createElement(UitkMark6, {
        name: mark.id,
        size: UitkMarkSize6.SMALL
    })), /* @__PURE__ */ React52.createElement(UitkText17, {
        size: 200,
        theme: "default",
        inline: true
    }, value), ((_icon = icon) === null || _icon === void 0 ? void 0 : _icon.id) && /* @__PURE__ */ React52.createElement(UitkSpacing21, {
        margin: {
            inline: "one"
        }
    }, /* @__PURE__ */ React52.createElement(UitkIcon11, {
        name: icon.id.toLowerCase(),
        id: icon.id,
        size: icon.size ? UitkIconSize8[icon.size] : UitkIconSize8.SMALL
    }))))), paymentDetails && /* @__PURE__ */ React52.createElement(UitkLayoutFlexItem10, null, /* @__PURE__ */ React52.createElement(UitkText17, {
        size: 200,
        inline: true
    }, /* @__PURE__ */ React52.createElement(LodgingEnrichedMessage, {
        data: paymentDetails
    }))), dialogTitle && ((_content = content) === null || _content === void 0 ? void 0 : _content.length) && !isWithinDetailsDialog && /* @__PURE__ */ React52.createElement(DialogComponent, null, /* @__PURE__ */ React52.createElement(UitkDialog2, {
        dialogShow: isDialogOpen,
        returnFocusOnClose: true
    }, /* @__PURE__ */ React52.createElement(UitkDialogContent4, null, /* @__PURE__ */ React52.createElement(UitkSpacing21, {
        padding: {
            blockend: "two"
        }
    }, /* @__PURE__ */ React52.createElement(UitkText17, {
        size: 500,
        weight: "bold"
    }, dialogTitle)), content.map(function(item, i) {
        return /* @__PURE__ */ React52.createElement(UitkText17, {
            key: "taap-content-".concat(i)
        }, item);
    }), ((_tertiaryUIButton = tertiaryUIButton) === null || _tertiaryUIButton === void 0 ? void 0 : _tertiaryUIButton.primary) && /* @__PURE__ */ React52.createElement(UitkDialogFooter3, {
        buttonOne: {
            onClick: dialogActions.closeDialog,
            text: (_tertiaryUIButton1 = tertiaryUIButton) === null || _tertiaryUIButton1 === void 0 ? void 0 : _tertiaryUIButton1.primary,
            type: "tertiary"
        }
    }))))))));
};
MarketingSection.fragment = fragment27;
MarketingSection.displayName = "MarketingSection";
// src/components/property-offers/__private/__fragments/lodging-highlighted-messages.tsx
import React63 from "react";
import { gql as gql61 } from "@apollo/client";
import { UitkLayoutGrid as UitkLayoutGrid11 } from "uitk-react-layout-grid";
import { UitkSpacing as UitkSpacing27 } from "uitk-react-spacing";
// src/components/property-offers/__private/__fragments/lodging-plain-dialog.tsx
import React53 from "react";
import { gql as gql51 } from "@apollo/client";
import { useClickTracker as useClickTracker16 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog6 } from "@shared-ui/dialog-context";
import { UitkTertiaryButton as UitkTertiaryButton3 } from "uitk-react-button";
import { UitkDialog as UitkDialog3, UitkDialogContent as UitkDialogContent5, UitkDialogFooter as UitkDialogFooter4 } from "uitk-react-dialog";
import { UitkIcon as UitkIcon12, UitkIconSize as UitkIconSize9 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex11 } from "uitk-react-layout-flex";
import { UitkLink as UitkLink8 } from "uitk-react-link";
import { UitkSpacing as UitkSpacing22 } from "uitk-react-spacing";
import { UitkText as UitkText18 } from "uitk-react-text";
import { UitkUnformattedHtml as UitkUnformattedHtml3 } from "uitk-react-unformatted-html";
// src/components/property-offers/__private/__fragments/ui-button.tsx
import { gql as gql50 } from "@apollo/client";
var __UIPrimaryButtonFragment = gql50(_templateObject49());
var __UISecondaryButtonFragment = gql50(_templateObject50());
var getUiButtonProps = function(action, track, closeDialog) {
    if (!action) {
        return {
            onClick: closeDialog
        };
    }
    var analytics2 = action.analytics;
    var onClick = function() {
        track("HOT.HIS".concat(analytics2.referrerId), analytics2.linkName, false);
        if (action.__typename !== "UILinkAction") {
            closeDialog();
        }
    };
    var href = action.__typename === "UILinkAction" ? action.resource.value : void 0;
    return {
        onClick: onClick,
        href: href
    };
};
// src/components/property-offers/__private/__fragments/lodging-plain-dialog.tsx
var fragment28 = gql51(_templateObject51(), __UIPrimaryButtonFragment, __UISecondaryButtonFragment);
var LodgingPlainDialog = function(param) {
    var data = param.data, text = param.text, uniqueDialogId = param.uniqueDialogId;
    var _data_content, _data, _primaryButton;
    var dialogPostfix = useDialogId();
    var _useDialog6 = _sliced_to_array(useDialog6("".concat(uniqueDialogId, "-").concat(dialogPostfix), "nestedLodgingPlainDialog"), 3), isDialogOpen = _useDialog6[0], dialogActions = _useDialog6[1], DialogComponent = _useDialog6[2];
    var triggerRef = React53.useRef(null);
    var trackClick = useClickTracker16();
    var isHtmlContent = ((_data = data) === null || _data === void 0 ? void 0 : (_data_content = _data.content) === null || _data_content === void 0 ? void 0 : _data_content.length) <= 1;
    if (!data || !data.trigger) {
        return null;
    }
    var content = data.content, trigger = data.trigger, primaryButton = data.primaryButton, primaryUIButton = data.primaryUIButton, secondaryUIButton = data.secondaryUIButton;
    var openDialog = function() {
        var clientSideAnalytics = trigger.clientSideAnalytics;
        dialogActions.openDialog();
        if (clientSideAnalytics) {
            trackClick("HOT.HIS".concat(clientSideAnalytics.referrerId), clientSideAnalytics.linkName);
        }
    };
    var closeDialog = function() {
        var _ref = primaryButton || {}, analytics2 = _ref.analytics;
        dialogActions.closeDialog();
        if (analytics2) {
            trackClick("HOT.HIS".concat(analytics2.referrerId), analytics2.linkName);
        }
    };
    return /* @__PURE__ */ React53.createElement(UitkLayoutFlex11, null, /* @__PURE__ */ React53.createElement(UitkSpacing22, {
        padding: {
            blockstart: "half"
        }
    }, /* @__PURE__ */ React53.createElement("div", null, /* @__PURE__ */ React53.createElement(UitkLink8, {
        onClick: openDialog
    }, /* @__PURE__ */ React53.createElement("button", {
        type: "button",
        ref: triggerRef
    }, /* @__PURE__ */ React53.createElement(UitkText18, {
        size: 300,
        theme: trigger.theme ? highlightedMessagesThemeToUitkTextTheme[trigger.theme] : "default"
    }, text || trigger.value, trigger.icon && /* @__PURE__ */ React53.createElement(UitkSpacing22, {
        padding: {
            inline: "two"
        }
    }, /* @__PURE__ */ React53.createElement(UitkIcon12, {
        name: trigger.icon.id,
        size: UitkIconSize9.SMALL
    }))))), trigger.secondaryValue && /* @__PURE__ */ React53.createElement(UitkText18, {
        theme: "default",
        size: 200
    }, trigger.secondaryValue), /* @__PURE__ */ React53.createElement(DialogComponent, null, /* @__PURE__ */ React53.createElement(UitkDialog3, {
        dialogShow: isDialogOpen,
        returnFocusOnClose: true,
        triggerRef: triggerRef
    }, /* @__PURE__ */ React53.createElement(UitkDialogContent5, null, content.map(function(item, contentIndex) {
        return isHtmlContent ? /* @__PURE__ */ React53.createElement(UitkSpacing22, {
            padding: "three",
            key: "content-".concat(contentIndex)
        }, /* @__PURE__ */ React53.createElement(UitkUnformattedHtml3, {
            htmlToParse: item
        })) : /* @__PURE__ */ React53.createElement(UitkText18, {
            key: "content-".concat(contentIndex),
            spacing: contentIndex !== 0 ? "four" : void 0
        }, item);
    }), primaryButton && /* @__PURE__ */ React53.createElement(UitkDialogFooter4, {
        stacked: false,
        buttonOne: {
            onClick: closeDialog,
            text: (_primaryButton = primaryButton) === null || _primaryButton === void 0 ? void 0 : _primaryButton.text,
            type: "tertiary"
        }
    }), primaryUIButton && /* @__PURE__ */ React53.createElement(UitkDialogFooter4, null, /* @__PURE__ */ React53.createElement(UitkTertiaryButton3, _object_spread({}, getUiButtonProps(primaryUIButton.action, trackClick, closeDialog)), primaryUIButton.primary || ""), secondaryUIButton && /* @__PURE__ */ React53.createElement(UitkTertiaryButton3, _object_spread({}, getUiButtonProps(secondaryUIButton.action, trackClick, closeDialog)), secondaryUIButton.primary || ""))))))));
};
LodgingPlainDialog.fragment = fragment28;
LodgingPlainDialog.displayName = "LodgingPlainDialog";
// src/components/property-offers/__private/__fragments/lodging-plain-message.tsx
import React54 from "react";
import { gql as gql52 } from "@apollo/client";
import { UitkText as UitkText19 } from "uitk-react-text";
var fragment29 = gql52(_templateObject52());
var LodgingPlainMessage = function(param) {
    var value = param.data.value;
    return /* @__PURE__ */ React54.createElement(UitkText19, null, value);
};
LodgingPlainMessage.displayName = "LodgingPlainMessage";
LodgingPlainMessage.fragment = fragment29;
// src/components/property-offers/__private/__fragments/lodging-policy-dialog.tsx
import React61 from "react";
import { gql as gql59 } from "@apollo/client";
import { useClickTracker as useClickTracker18 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog7 } from "@shared-ui/dialog-context";
// ../internal/src/components/lodging-detailed-timeline/lodging-detailed-timeline.tsx
import React60 from "react";
import { gql as gql58 } from "@apollo/client";
import { useClickTracker as useClickTracker17 } from "@shared-ui/clickstream-analytics-context";
import { UitkSpacing as UitkSpacing25 } from "uitk-react-spacing";
import { UitkTab, UitkTabs, UitkTabsType } from "uitk-react-tabs";
import { UitkHeading as UitkHeading14 } from "uitk-react-text";
// ../internal/src/components/lodging-detailed-timeline/__private/lodging-cancellation-policy.tsx
import React59 from "react";
import { gql as gql57 } from "@apollo/client";
// ../internal/src/components/lodging-detailed-timeline/__private/lodging-cancellation-policy-messages.tsx
import React57 from "react";
import { gql as gql55 } from "@apollo/client";
import { UitkLayoutGrid as UitkLayoutGrid10, UitkLayoutGridItem as UitkLayoutGridItem10 } from "uitk-react-layout-grid";
import { UitkSpacing as UitkSpacing23 } from "uitk-react-spacing";
// ../internal/src/components/lodging-detailed-timeline/__private/lodging-cancellation-policy-primary-info.tsx
import React55 from "react";
import { gql as gql53 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex12 } from "uitk-react-layout-flex";
import { UitkText as UitkText20 } from "uitk-react-text";
var __LodgingCancellationPolicyPrimaryInfoFragment = gql53(_templateObject53());
var LodgingCancellationPolicyPrimaryInfo = function(param) {
    var data = param.data;
    var heading = data.heading, subheading = data.subheading;
    return /* @__PURE__ */ React55.createElement(UitkLayoutFlex12, {
        direction: "column"
    }, /* @__PURE__ */ React55.createElement(UitkText20, {
        size: 200,
        weight: "medium",
        theme: "emphasis"
    }, heading.text), /* @__PURE__ */ React55.createElement(UitkText20, {
        size: 400,
        weight: "medium",
        theme: "emphasis"
    }, subheading.text));
};
LodgingCancellationPolicyPrimaryInfo.displayName = "LodgingCancellationPolicyPrimaryInfo";
LodgingCancellationPolicyPrimaryInfo.fragment = __LodgingCancellationPolicyPrimaryInfoFragment;
// ../internal/src/components/lodging-detailed-timeline/__private/lodging-cancellation-policy-secondary-info.tsx
import React56 from "react";
import { gql as gql54 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex13 } from "uitk-react-layout-flex";
import { UitkText as UitkText21 } from "uitk-react-text";
var __LodgingCancellationPolicySecondaryInfoFragment = gql54(_templateObject54());
var LodgingCancellationPolicySecondaryInfo = function(param) {
    var data = param.data;
    var _title;
    var title = data.title, message = data.message;
    return /* @__PURE__ */ React56.createElement(UitkLayoutFlex13, {
        direction: "column"
    }, ((_title = title) === null || _title === void 0 ? void 0 : _title.text) && /* @__PURE__ */ React56.createElement(UitkText21, {
        size: 400,
        weight: "medium",
        theme: "emphasis"
    }, title.text), /* @__PURE__ */ React56.createElement(UitkText21, {
        size: 200,
        theme: "default",
        weight: "regular",
        spacing: "one"
    }, message));
};
LodgingCancellationPolicySecondaryInfo.displayName = "LodgingCancellationPolicySecondaryInfo";
LodgingCancellationPolicySecondaryInfo.fragment = __LodgingCancellationPolicySecondaryInfoFragment;
// ../internal/src/components/lodging-detailed-timeline/__private/lodging-cancellation-policy-messages.tsx
var Separator = function(param) {
    var index = param.index, messageSectionLength = param.messageSectionLength;
    if (index === messageSectionLength - 1) {
        return null;
    }
    return /* @__PURE__ */ React57.createElement(UitkLayoutGridItem10, {
        colSpan: "all"
    }, /* @__PURE__ */ React57.createElement(UitkSpacing23, {
        border: [
            "blockend"
        ],
        margin: {
            block: "four"
        }
    }, /* @__PURE__ */ React57.createElement("div", null)));
};
Separator.displayName = "Separator";
var __LodgingCancellationPolicyMessagesFragment = gql55(_templateObject55(), LodgingCancellationPolicyPrimaryInfo.fragment, LodgingCancellationPolicySecondaryInfo.fragment);
var LodgingCancellationPolicyMessages = function(param) {
    var data = param.data;
    var messageSections = data.messageSections;
    return /* @__PURE__ */ React57.createElement(UitkSpacing23, {
        padding: {
            block: "three"
        }
    }, /* @__PURE__ */ React57.createElement(UitkLayoutGrid10, {
        columns: [
            "24x",
            "1fr"
        ],
        space: {
            column: "four"
        }
    }, messageSections.map(function(messageSection, index) {
        return /* @__PURE__ */ React57.createElement(React57.Fragment, {
            key: index
        }, /* @__PURE__ */ React57.createElement(UitkLayoutGridItem10, {
            colStart: 1
        }, /* @__PURE__ */ React57.createElement(UitkSpacing23, null, /* @__PURE__ */ React57.createElement(LodgingCancellationPolicyPrimaryInfo, {
            data: messageSection.primaryInfo
        }))), /* @__PURE__ */ React57.createElement(UitkLayoutGridItem10, {
            colStart: 2
        }, /* @__PURE__ */ React57.createElement(UitkSpacing23, null, /* @__PURE__ */ React57.createElement(LodgingCancellationPolicySecondaryInfo, {
            data: messageSection.secondaryInfo
        }))), /* @__PURE__ */ React57.createElement(Separator, {
            index: index,
            messageSectionLength: messageSections.length
        }));
    })));
};
LodgingCancellationPolicyMessages.displayName = "LodgingCancellationPolicyMessages";
LodgingCancellationPolicyMessages.fragment = __LodgingCancellationPolicyMessagesFragment;
// ../internal/src/components/lodging-detailed-timeline/__private/lodging-cancellation-policy-step-indicator.tsx
import React58 from "react";
import { gql as gql56 } from "@apollo/client";
import { StepIndicator } from "@egds/react-lodging";
import { ViewMedium as ViewMedium5, Viewport as Viewport8, ViewSmall as ViewSmall7 } from "@shared-ui/viewport-context";
import { UitkCard as UitkCard11, UitkCardContentSection as UitkCardContentSection7 } from "uitk-react-cards";
import { UitkLayoutFlex as UitkLayoutFlex14 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing24 } from "uitk-react-spacing";
var LodgingCancellationPolicyStepIndicatorFragment = gql56(_templateObject56());
var LodgingCancellationPolicyStepIndicator = function(param) {
    var data = param.data;
    var steppers = data.steppers;
    if (steppers.length === 0) {
        return null;
    }
    var _step_track_text_accessibility;
    var steps = steppers.map(function(step) {
        var _step_track_text, _step_track, _step, _step_track_text1, _step_track1, _step1;
        return {
            label: step.text.text,
            trackLabelText: (_step = step) === null || _step === void 0 ? void 0 : (_step_track = _step.track) === null || _step_track === void 0 ? void 0 : (_step_track_text = _step_track.text) === null || _step_track_text === void 0 ? void 0 : _step_track_text.text,
            trackLabelA11y: (_step_track_text_accessibility = (_step1 = step) === null || _step1 === void 0 ? void 0 : (_step_track1 = _step1.track) === null || _step_track1 === void 0 ? void 0 : (_step_track_text1 = _step_track1.text) === null || _step_track_text1 === void 0 ? void 0 : _step_track_text1.accessibility) !== null && _step_track_text_accessibility !== void 0 ? _step_track_text_accessibility : void 0
        };
    });
    var activeStepIndex = steppers.findIndex(function(step) {
        return step.state === "CURRENT" /* CURRENT */ ;
    }) + 1;
    return /* @__PURE__ */ React58.createElement("section", {
        "aria-label": data.accessibilityLabel
    }, /* @__PURE__ */ React58.createElement(UitkCard11, {
        backgroundTheme: "secondary"
    }, /* @__PURE__ */ React58.createElement(UitkSpacing24, {
        margin: {
            block: "three"
        },
        padding: {
            block: "six"
        }
    }, /* @__PURE__ */ React58.createElement(UitkCardContentSection7, null, /* @__PURE__ */ React58.createElement(Viewport8, null, /* @__PURE__ */ React58.createElement(ViewSmall7, null, /* @__PURE__ */ React58.createElement(UitkLayoutFlex14, {
        justifyContent: "center"
    }, /* @__PURE__ */ React58.createElement(StepIndicator, {
        steps: steps,
        activeStep: activeStepIndex,
        direction: "vertical"
    }))), /* @__PURE__ */ React58.createElement(ViewMedium5, null, /* @__PURE__ */ React58.createElement(StepIndicator, {
        steps: steps,
        activeStep: activeStepIndex,
        direction: "horizontal"
    })))))));
};
LodgingCancellationPolicyStepIndicator.displayName = "LodgingCancellationPolicyStepIndicator";
LodgingCancellationPolicyStepIndicator.fragment = LodgingCancellationPolicyStepIndicatorFragment;
// ../internal/src/components/lodging-detailed-timeline/__private/lodging-cancellation-policy.tsx
var __LodgingCancellationPolicyFragment = gql57(_templateObject57(), LodgingCancellationPolicyMessages.fragment, LodgingCancellationPolicyStepIndicator.fragment);
var LodgingCancellationPolicy = function(param) {
    var data = param.data;
    return /* @__PURE__ */ React59.createElement(React59.Fragment, null, /* @__PURE__ */ React59.createElement(LodgingCancellationPolicyStepIndicator, {
        data: data.stepIndicator
    }), /* @__PURE__ */ React59.createElement(LodgingCancellationPolicyMessages, {
        data: data
    }));
};
LodgingCancellationPolicy.displayName = "LodgingCancellationPolicy";
LodgingCancellationPolicy.fragment = __LodgingCancellationPolicyFragment;
// ../internal/src/components/lodging-detailed-timeline/lodging-detailed-timeline.tsx
var __LodgingDetailedTimelineFragment = gql58(_templateObject58(), LodgingCancellationPolicy.fragment);
var LodgingDetailedTimeline = function(param) {
    var data = param.data;
    var _title;
    var policies = data.policies, title = data.title;
    var _React60_useState = _sliced_to_array(React60.useState(0), 2), activeTab = _React60_useState[0], setTabSelection = _React60_useState[1];
    var clickTracker = useClickTracker17();
    var trackTabClickAnalytics = React60.useCallback(function(analytics2) {
        if (analytics2) {
            clickTracker(analytics2.referrerId, analytics2.linkName);
        }
    }, [
        clickTracker
    ]);
    var handleTabChange = function(tabIndex) {
        var _policies_tabIndex;
        setTabSelection(tabIndex);
        trackTabClickAnalytics((_policies_tabIndex = policies[tabIndex]) === null || _policies_tabIndex === void 0 ? void 0 : _policies_tabIndex.policyClientSideAnalytics);
    };
    if (policies.length === 0) {
        return null;
    }
    return /* @__PURE__ */ React60.createElement(React60.Fragment, null, ((_title = title) === null || _title === void 0 ? void 0 : _title.text) && /* @__PURE__ */ React60.createElement(UitkHeading14, {
        tag: "h3",
        size: 3
    }, title.text), /* @__PURE__ */ React60.createElement(UitkSpacing25, {
        margin: {
            block: "three"
        }
    }, policies.length > 1 ? /* @__PURE__ */ React60.createElement(UitkTabs, {
        selectedTab: activeTab,
        onTabSelect: handleTabChange,
        tabsType: UitkTabsType.NATURAL,
        withBorder: false
    }, policies.map(function(policy, index) {
        var _policy_title, _policy;
        return policy.title && /* @__PURE__ */ React60.createElement(UitkTab, {
            key: "tab-key-".concat(index),
            targetURI: "#",
            name: (_policy = policy) === null || _policy === void 0 ? void 0 : (_policy_title = _policy.title) === null || _policy_title === void 0 ? void 0 : _policy_title.text,
            id: "tab-id-".concat(index)
        }, /* @__PURE__ */ React60.createElement(LodgingCancellationPolicy, {
            data: policy,
            key: "LodgingCancellationPolicy-".concat(index)
        }));
    })) : policies[0] && /* @__PURE__ */ React60.createElement(LodgingCancellationPolicy, {
        data: policies[0],
        key: "LodgingCancellationPolicy-0"
    })));
};
LodgingDetailedTimeline.displayName = "LodgingDetailedTimeline";
LodgingDetailedTimeline.fragment = __LodgingDetailedTimelineFragment;
// src/components/property-offers/__private/__fragments/lodging-policy-dialog.tsx
import { ViewMedium as ViewMedium6, Viewport as Viewport9, ViewSmall as ViewSmall8 } from "@shared-ui/viewport-context";
import { UitkDialogContent as UitkDialogContent6 } from "uitk-react-dialog";
import { UitkIcon as UitkIcon13, UitkIconSize as UitkIconSize10 } from "uitk-react-icons";
import { UitkLink as UitkLink9 } from "uitk-react-link";
import { UitkSheet as UitkSheet3 } from "uitk-react-sheet";
import { UitkSpacing as UitkSpacing26 } from "uitk-react-spacing";
import { UitkText as UitkText22 } from "uitk-react-text";
import { UitkToolbar as UitkToolbar3 } from "uitk-react-toolbar";
var fragment30 = gql59(_templateObject59(), LodgingDetailedTimeline.fragment);
var LodgingPolicyDialog = function(param) {
    var data = param.data, uniqueDialogId = param.uniqueDialogId, _param_policyType = param.policyType, policyType = _param_policyType === void 0 ? "SINGLE" /* SINGLE */  : _param_policyType;
    var _data, _toolbar, _toolbar_icon, _toolbar1;
    var dialogPostfix = useDialogId();
    var _useDialog7 = _sliced_to_array(useDialog7("".concat(uniqueDialogId, "-").concat(dialogPostfix), "lodging-policy-dialog"), 3), isDialogOpen = _useDialog7[0], dialogActions = _useDialog7[1], DialogComponent = _useDialog7[2];
    var triggerRef = React61.useRef(null);
    var trackClick = useClickTracker18();
    if (!((_data = data) === null || _data === void 0 ? void 0 : _data.trigger)) {
        return null;
    }
    var policyContent = data.policyContent, trigger = data.trigger, toolbar = data.toolbar;
    var openDialog = function() {
        var clientSideAnalytics = trigger.clientSideAnalytics;
        dialogActions.openDialog();
        if (clientSideAnalytics) {
            trackClick(clientSideAnalytics.referrerId, clientSideAnalytics.linkName);
        }
    };
    var closeDialog = function() {
        var _toolbar;
        var clientSideAnalytics = (_toolbar = toolbar) === null || _toolbar === void 0 ? void 0 : _toolbar.clientSideAnalytics;
        dialogActions.closeDialog();
        if (clientSideAnalytics) {
            trackClick(clientSideAnalytics.referrerId, clientSideAnalytics.linkName);
        }
    };
    var _toolbar_title;
    var dialogContent = /* @__PURE__ */ React61.createElement(React61.Fragment, null, /* @__PURE__ */ React61.createElement(UitkToolbar3, {
        toolbarTitle: (_toolbar_title = (_toolbar = toolbar) === null || _toolbar === void 0 ? void 0 : _toolbar.title) !== null && _toolbar_title !== void 0 ? _toolbar_title : void 0,
        navigationContent: {
            onClick: closeDialog,
            navIconLabel: (_toolbar1 = toolbar) === null || _toolbar1 === void 0 ? void 0 : (_toolbar_icon = _toolbar1.icon) === null || _toolbar_icon === void 0 ? void 0 : _toolbar_icon.description
        }
    }), /* @__PURE__ */ React61.createElement(UitkDialogContent6, null, /* @__PURE__ */ React61.createElement(LodgingDetailedTimeline, {
        data: policyContent
    })));
    return /* @__PURE__ */ React61.createElement(UitkSpacing26, {
        padding: policyType === "SINGLE" /* SINGLE */  ? {
            blockstart: "half"
        } : {
            blockstart: "half",
            blockend: "one"
        }
    }, /* @__PURE__ */ React61.createElement("div", null, /* @__PURE__ */ React61.createElement(UitkSpacing26, {
        padding: policyType === "MULTIPLE" /* MULTIPLE */  ? {
            block: "two"
        } : {}
    }, /* @__PURE__ */ React61.createElement(UitkLink9, {
        onClick: openDialog,
        "aria-label": trigger.accessibilityLabel
    }, /* @__PURE__ */ React61.createElement("button", {
        type: "button",
        ref: triggerRef
    }, /* @__PURE__ */ React61.createElement(UitkText22, {
        size: policyType === "SINGLE" /* SINGLE */  ? 300 : 200,
        theme: trigger.theme ? highlightedMessagesThemeToUitkTextTheme[trigger.theme] : "default"
    }, trigger.value, trigger.icon && /* @__PURE__ */ React61.createElement(UitkSpacing26, {
        padding: policyType === "SINGLE" /* SINGLE */  ? {
            inline: "two"
        } : {}
    }, /* @__PURE__ */ React61.createElement(UitkIcon13, {
        name: trigger.icon.id,
        size: UitkIconSize10.SMALL
    })))))), trigger.secondaryValue && /* @__PURE__ */ React61.createElement(UitkText22, {
        theme: "default",
        size: 200
    }, trigger.secondaryValue), /* @__PURE__ */ React61.createElement(DialogComponent, null, /* @__PURE__ */ React61.createElement(Viewport9, null, /* @__PURE__ */ React61.createElement(ViewSmall8, null, /* @__PURE__ */ React61.createElement(UitkSheet3, {
        type: "full",
        isVisible: isDialogOpen,
        returnFocusOnClose: true,
        triggerRef: triggerRef
    }, dialogContent)), /* @__PURE__ */ React61.createElement(ViewMedium6, null, /* @__PURE__ */ React61.createElement(UitkSheet3, {
        type: "centered",
        isVisible: isDialogOpen,
        centeredSheetSize: "small",
        returnFocusOnClose: true,
        triggerRef: triggerRef
    }, dialogContent))))));
};
LodgingPolicyDialog.fragment = fragment30;
LodgingPolicyDialog.displayName = "LodgingPlainDialog";
// src/components/property-offers/__private/__fragments/rate-plan-message.tsx
import React62 from "react";
import { gql as gql60 } from "@apollo/client";
var fragment31 = gql60(_templateObject60(), LodgingEnrichedMessage.fragment, LodgingPlainDialog.fragment, LodgingPolicyDialog.fragment, LodgingPlainMessage.fragment);
var RatePlanMessage = function(param) {
    var data = param.data;
    var _data;
    switch((_data = data) === null || _data === void 0 ? void 0 : _data.__typename){
        case "LodgingEnrichedMessage":
            return /* @__PURE__ */ React62.createElement(LodgingEnrichedMessage, {
                data: data
            });
        case "LodgingPlainDialog":
            return /* @__PURE__ */ React62.createElement(LodgingPlainDialog, {
                data: data,
                uniqueDialogId: "cancellation-policy-dialog"
            });
        case "LodgingPolicyDialog":
            return /* @__PURE__ */ React62.createElement(LodgingPolicyDialog, {
                data: data,
                uniqueDialogId: "lodging-cancellation-policy-dialog",
                policyType: "SINGLE" /* SINGLE */ 
            });
        case "LodgingPlainMessage":
            return /* @__PURE__ */ React62.createElement(LodgingPlainMessage, {
                data: data
            });
        default:
            return null;
    }
};
RatePlanMessage.fragment = fragment31;
RatePlanMessage.displayName = "RatePlanMessage";
// src/components/property-offers/__private/__fragments/lodging-highlighted-messages.tsx
var fragment32 = gql61(_templateObject61(), LodgingEnrichedMessage.fragment, LodgingPlainDialog.fragment, LodgingPolicyDialog.fragment, LodgingPlainMessage.fragment);
var LodgingHighlightedMessages = function(param) {
    var data = param.data;
    var highlightedMessages = data.highlightedMessages, id = data.id;
    if (!highlightedMessages) {
        return null;
    }
    var mappedMessages = highlightedMessages.map(function(highlightedMessage, index) {
        return highlightedMessage ? /* @__PURE__ */ React63.createElement(RatePlanMessage, {
            key: "mapped-msg-".concat(index),
            data: highlightedMessage
        }) : null;
    });
    return /* @__PURE__ */ React63.createElement(React63.Fragment, null, mappedMessages.length > 0 && /* @__PURE__ */ React63.createElement(UitkSpacing27, {
        padding: {
            blockend: "one"
        }
    }, /* @__PURE__ */ React63.createElement(UitkLayoutGrid11, {
        "data-stid": "cancellation-policy-".concat(id),
        space: "three"
    }, mappedMessages)));
};
LodgingHighlightedMessages.fragment = fragment32;
LodgingHighlightedMessages.displayName = "LodgingHighlightedMessages";
// src/components/property-offers/__private/__fragments/marketing-section-link.tsx
import React64 from "react";
import { useClickTracker as useClickTracker19 } from "@shared-ui/clickstream-analytics-context";
import { UitkCardContentSection as UitkCardContentSection8 } from "uitk-react-cards";
import { UitkLink as UitkLink10 } from "uitk-react-link";
import { UitkSpacing as UitkSpacing28 } from "uitk-react-spacing";
var MarketingSectionLink = function(param) {
    var shareUrl = param.shareUrl, _param_linkAlignment = param.linkAlignment, linkAlignment = _param_linkAlignment === void 0 ? "left" : _param_linkAlignment;
    var _link_uri, _link, _shareUrl, _shareUrl1;
    var track = useClickTracker19();
    if (!shareUrl) {
        return null;
    }
    var link = shareUrl.link;
    var handleLinkInNewTab = function() {
        var _link;
        if ((_link = link) === null || _link === void 0 ? void 0 : _link.clientSideAnalytics) {
            track(link.clientSideAnalytics.referrerId, link.clientSideAnalytics.linkName);
        }
    };
    return /* @__PURE__ */ React64.createElement(UitkCardContentSection8, {
        border: "top",
        padded: false
    }, /* @__PURE__ */ React64.createElement(UitkSpacing28, {
        padding: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React64.createElement("div", null, /* @__PURE__ */ React64.createElement(UitkLink10, {
        align: linkAlignment,
        "data-stid": "marketing-link-info",
        onClick: handleLinkInNewTab
    }, /* @__PURE__ */ React64.createElement("a", {
        href: (_link = link) === null || _link === void 0 ? void 0 : (_link_uri = _link.uri) === null || _link_uri === void 0 ? void 0 : _link_uri.relativePath,
        target: "_blank",
        rel: "noopener noreferrer"
    }, (_shareUrl = shareUrl) === null || _shareUrl === void 0 ? void 0 : _shareUrl.value, /* @__PURE__ */ React64.createElement("span", {
        className: "is-visually-hidden"
    }, (_shareUrl1 = shareUrl) === null || _shareUrl1 === void 0 ? void 0 : _shareUrl1.accessibilityLabel))))));
};
MarketingSectionLink.displayName = "MarketingSectionLink";
// src/components/property-offers/__private/__fragments/price-breakdown-summary/price-breakdown-summary.tsx
import React70 from "react";
import { ViewMedium as ViewMedium7, Viewport as Viewport10, ViewSmall as ViewSmall9 } from "@shared-ui/viewport-context";
import { UitkSpacing as UitkSpacing34 } from "uitk-react-spacing";
// src/components/property-offers/__private/__fragments/price-breakdown-summary/price-breakdown-dialog.tsx
import React68 from "react";
import { useClickTracker as useClickTracker20 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog8 } from "@shared-ui/dialog-context";
import { UitkDialogContent as UitkDialogContent7 } from "uitk-react-dialog";
import { UitkIcon as UitkIcon14, UitkIconSize as UitkIconSize11 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex16, UitkLayoutFlexItem as UitkLayoutFlexItem12 } from "uitk-react-layout-flex";
import { UitkLink as UitkLink11 } from "uitk-react-link";
import { UitkScrim, UitkScrimType } from "uitk-react-scrim";
import { UitkSheet as UitkSheet4 } from "uitk-react-sheet";
import { UitkSpacing as UitkSpacing32 } from "uitk-react-spacing";
import { UitkText as UitkText25 } from "uitk-react-text";
import { UitkToolbar as UitkToolbar4 } from "uitk-react-toolbar";
// src/components/property-offers/__private/__fragments/price-breakdown-summary/__private/__fragments/price-summary-section.tsx
import React67 from "react";
import { gql as gql64 } from "@apollo/client";
import { UitkSpacing as UitkSpacing31 } from "uitk-react-spacing";
import { UitkText as UitkText24 } from "uitk-react-text";
// src/components/property-offers/__private/__fragments/price-breakdown-summary/__private/__fragments/price-summary-footer.tsx
import React65 from "react";
import { gql as gql62 } from "@apollo/client";
import { UitkSpacing as UitkSpacing29 } from "uitk-react-spacing";
var __PriceSummaryFooterFragment = gql62(_templateObject62(), LodgingEnrichedMessage.fragment);
var PriceSummaryFooter = function(param) {
    var data = param.data;
    var _footerMessages;
    var footerMessages = data.footerMessages;
    if (!((_footerMessages = footerMessages) === null || _footerMessages === void 0 ? void 0 : _footerMessages.length)) {
        return null;
    }
    return /* @__PURE__ */ React65.createElement(UitkSpacing29, {
        margin: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React65.createElement("div", null, footerMessages.map(function(message, index) {
        return /* @__PURE__ */ React65.createElement(LodgingEnrichedMessage, {
            key: "price-summary-footer-message-".concat(index),
            data: message
        });
    })));
};
PriceSummaryFooter.fragment = __PriceSummaryFooterFragment;
PriceSummaryFooter.displayName = "PriceSummaryFooter";
// src/components/property-offers/__private/__fragments/price-breakdown-summary/__private/__fragments/price-summary-line-item.tsx
import React66 from "react";
import { gql as gql63 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex15, UitkLayoutFlexItem as UitkLayoutFlexItem11 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing30 } from "uitk-react-spacing";
import { UitkText as UitkText23 } from "uitk-react-text";
var __PriceSummaryLineItemFragment = gql63(_templateObject63(), LodgingEnrichedMessage.fragment);
var PriceSummaryLineItem = function(param) {
    var data = param.data;
    var _name_secondaryMessages, _value_secondaryMessages;
    var name = data.name, value = data.value;
    return /* @__PURE__ */ React66.createElement(UitkSpacing30, {
        padding: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React66.createElement(UitkLayoutFlex15, {
        justifyContent: "space-between"
    }, /* @__PURE__ */ React66.createElement(UitkLayoutFlexItem11, null, /* @__PURE__ */ React66.createElement("div", null, /* @__PURE__ */ React66.createElement(UitkText23, {
        size: name.primaryMessage.theme === "STRONG" /* STRONG */  ? 400 : 300,
        weight: "regular",
        theme: "emphasis"
    }, /* @__PURE__ */ React66.createElement(LodgingEnrichedMessage, {
        data: name.primaryMessage
    })), (_name_secondaryMessages = name.secondaryMessages) === null || _name_secondaryMessages === void 0 ? void 0 : _name_secondaryMessages.map(function(message, index) {
        return /* @__PURE__ */ React66.createElement(UitkText23, {
            size: 200,
            theme: "default",
            key: "line-item-name-".concat(index)
        }, /* @__PURE__ */ React66.createElement(LodgingEnrichedMessage, {
            data: message
        }));
    }))), /* @__PURE__ */ React66.createElement(UitkLayoutFlexItem11, null, /* @__PURE__ */ React66.createElement("div", null, /* @__PURE__ */ React66.createElement(UitkText23, {
        size: value.primaryMessage.theme === "STRONG" /* STRONG */  ? 400 : 300,
        weight: "regular",
        theme: "emphasis"
    }, /* @__PURE__ */ React66.createElement(LodgingEnrichedMessage, {
        data: value.primaryMessage
    })), (_value_secondaryMessages = value.secondaryMessages) === null || _value_secondaryMessages === void 0 ? void 0 : _value_secondaryMessages.map(function(message, index) {
        return /* @__PURE__ */ React66.createElement(LodgingEnrichedMessage, {
            data: message,
            key: "line-item-value-".concat(index)
        });
    })))));
};
PriceSummaryLineItem.fragment = __PriceSummaryLineItemFragment;
PriceSummaryLineItem.displayName = "PriceSummaryLineItem";
// src/components/property-offers/__private/__fragments/price-breakdown-summary/__private/__fragments/price-summary-section.tsx
var __PriceSummarySectionFragment = gql64(_templateObject64(), LodgingEnrichedMessage.fragment, PriceSummaryLineItem.fragment, PriceSummaryFooter.fragment);
var PriceSummarySection = function(param) {
    var data = param.data, lastSection = param.lastSection;
    var sectionHeading = data.sectionHeading, sectionFooter = data.sectionFooter, items = data.items;
    return /* @__PURE__ */ React67.createElement(UitkSpacing31, _object_spread({
        padding: {
            block: "three"
        }
    }, !lastSection ? {
        border: [
            "blockend"
        ]
    } : {}), /* @__PURE__ */ React67.createElement("div", null, sectionHeading && /* @__PURE__ */ React67.createElement(UitkText24, {
        size: 300
    }, /* @__PURE__ */ React67.createElement(LodgingEnrichedMessage, {
        data: sectionHeading
    })), items.map(function(item, index) {
        return /* @__PURE__ */ React67.createElement(PriceSummaryLineItem, {
            data: item,
            key: "price-summary-line-item-".concat(index)
        });
    }), sectionFooter && /* @__PURE__ */ React67.createElement(PriceSummaryFooter, {
        data: sectionFooter
    })));
};
PriceSummarySection.fragment = __PriceSummarySectionFragment;
PriceSummarySection.displayName = "PriceSummarySection";
// src/components/property-offers/__private/__fragments/price-breakdown-summary/price-breakdown-summary-fragment.tsx
import { gql as gql65 } from "@apollo/client";
var fragment33 = gql65(_templateObject65(), LodgingEnrichedMessage.fragment, PriceSummarySection.fragment);
// src/components/property-offers/__private/__fragments/price-breakdown-summary/price-breakdown-dialog.tsx
var PriceBreakdownDialog = function(param) {
    var data = param.data, actionButton = param.actionButton;
    var _sections, _priceSummaryHeading;
    var dialogPostfix = useDialogId();
    var _useDialog8 = _sliced_to_array(useDialog8("price-breakdown-summary-".concat(dialogPostfix), "pwaDialogNested"), 3), dialogActions = _useDialog8[1], DialogComponent = _useDialog8[2];
    var isWithinDetailsDialog = React68.useContext(dialog_context_default);
    var track = useClickTracker20();
    var triggerRef = React68.useRef(null);
    var _ref = data.priceBreakDownSummary || {}, priceSummaryHeading = _ref.priceSummaryHeading, sections = _ref.sections, disclaimers = _ref.disclaimers;
    var rfrrSuffix = isWithinDetailsDialog ? "RoomInfo" : "RoomsAndRates";
    var onClick = function() {
        track("HOT.HIS.".concat(rfrrSuffix, ".PriceDetailDialog"), "price.breakdown.details");
        dialogActions.openDialog();
    };
    var onClose = function() {
        track("HOT.HIS.".concat(rfrrSuffix, ".PriceDetailDialog.Close"), "price.breakdown.details");
        dialogActions.closeDialog();
    };
    if (!((_sections = sections) === null || _sections === void 0 ? void 0 : _sections.length)) {
        return null;
    }
    var _ref1 = priceSummaryHeading || {}, triggerText = _ref1.value;
    return /* @__PURE__ */ React68.createElement(React68.Fragment, null, /* @__PURE__ */ React68.createElement(UitkLink11, {
        onClick: onClick,
        inline: true
    }, /* @__PURE__ */ React68.createElement("button", {
        type: "button",
        ref: triggerRef
    }, triggerText, /* @__PURE__ */ React68.createElement(UitkIcon14, {
        name: "chevron_right",
        size: UitkIconSize11.SMALL
    }))), /* @__PURE__ */ React68.createElement(DialogComponent, null, /* @__PURE__ */ React68.createElement(UitkSheet4, {
        type: "full",
        isVisible: true,
        triggerRef: triggerRef,
        returnFocusOnClose: true
    }, /* @__PURE__ */ React68.createElement(UitkToolbar4, {
        toolbarTitle: (_priceSummaryHeading = priceSummaryHeading) === null || _priceSummaryHeading === void 0 ? void 0 : _priceSummaryHeading.value,
        navigationContent: {
            navType: "close",
            onClick: onClose
        }
    }), /* @__PURE__ */ React68.createElement(UitkDialogContent7, {
        zeroPadding: true
    }, /* @__PURE__ */ React68.createElement(UitkSpacing32, {
        padding: {
            inline: "four"
        }
    }, /* @__PURE__ */ React68.createElement("div", null, sections.map(function(section, index) {
        var _sections;
        return /* @__PURE__ */ React68.createElement(PriceSummarySection, {
            data: section,
            key: "price-summary-section-".concat(index),
            lastSection: index === ((_sections = sections) === null || _sections === void 0 ? void 0 : _sections.length) - 1
        });
    }))), /* @__PURE__ */ React68.createElement(UitkScrim, {
        type: UitkScrimType.BUTTON
    }, actionButton), disclaimers && disclaimers.length > 0 && /* @__PURE__ */ React68.createElement(UitkSpacing32, {
        margin: {
            blockstart: "three",
            inline: "four"
        }
    }, /* @__PURE__ */ React68.createElement(UitkLayoutFlex16, {
        direction: "row"
    }, disclaimers.map(function(message, index) {
        return /* @__PURE__ */ React68.createElement(UitkLayoutFlexItem12, {
            key: "price-summary-disclaimer-message-".concat(index)
        }, /* @__PURE__ */ React68.createElement(UitkText25, {
            size: 100
        }, /* @__PURE__ */ React68.createElement(LodgingEnrichedMessage, {
            data: message
        })));
    })))))));
};
PriceBreakdownDialog.fragment = fragment33;
PriceBreakdownDialog.displayName = "PriceBreakdownDialog";
// src/components/property-offers/__private/__fragments/price-breakdown-summary/price-breakdown-menu.tsx
import React69 from "react";
import { useClickTracker as useClickTracker21 } from "@shared-ui/clickstream-analytics-context";
import { UitkIcon as UitkIcon15, UitkIconSize as UitkIconSize12 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex17, UitkLayoutFlexItem as UitkLayoutFlexItem13 } from "uitk-react-layout-flex";
import { UitkLink as UitkLink12 } from "uitk-react-link";
import { PositionType, UitkMenu, UitkMenuContainer, UitkMenuTrigger } from "uitk-react-menu";
import { UitkSpacing as UitkSpacing33 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading15, UitkText as UitkText26 } from "uitk-react-text";
var PriceBreakdownSummaryMenu = function(param) {
    var data = param.data, actionButton = param.actionButton, _param_menuContainerPosition = param.menuContainerPosition, menuContainerPosition = _param_menuContainerPosition === void 0 ? PositionType.RIGHT : _param_menuContainerPosition, roomTypeId = param.roomTypeId, ratePlanId = param.ratePlanId;
    var _sections;
    var priceBreakDownSummary = data.priceBreakDownSummary;
    var _ref = priceBreakDownSummary || {}, priceSummaryHeading = _ref.priceSummaryHeading, sections = _ref.sections, disclaimers = _ref.disclaimers;
    var _React69_useState = _sliced_to_array(React69.useState(false), 2), isMenuOpen = _React69_useState[0], setIsMenuOpen = _React69_useState[1];
    var track = useClickTracker21();
    var isWithinDetailsDialog = React69.useContext(dialog_context_default);
    var rfrrSuffix = isWithinDetailsDialog ? "RoomInfo" : "RoomsAndRates";
    var toggleMenuOpen = function() {
        if (!isMenuOpen) {
            track("HOT.HIS.".concat(rfrrSuffix, ".PriceDetail.").concat(roomTypeId, ".").concat(ratePlanId), "price.breakdown.details");
        }
        setIsMenuOpen(!isMenuOpen);
    };
    if (!((_sections = sections) === null || _sections === void 0 ? void 0 : _sections.length)) {
        return null;
    }
    var _ref1 = priceSummaryHeading || {}, triggerText = _ref1.value, accessibilityLabel = _ref1.accessibilityLabel;
    return /* @__PURE__ */ React69.createElement(UitkMenu, {
        isOpen: isMenuOpen,
        onTriggerClick: toggleMenuOpen
    }, /* @__PURE__ */ React69.createElement(UitkMenuTrigger, null, /* @__PURE__ */ React69.createElement(UitkLink12, null, /* @__PURE__ */ React69.createElement("button", {
        type: "button"
    }, /* @__PURE__ */ React69.createElement("span", {
        "aria-hidden": accessibilityLabel !== null
    }, triggerText), accessibilityLabel && /* @__PURE__ */ React69.createElement("span", {
        className: "is-visually-hidden"
    }, accessibilityLabel), /* @__PURE__ */ React69.createElement(UitkIcon15, {
        name: "expand_more",
        size: UitkIconSize12.SMALL
    })))), /* @__PURE__ */ React69.createElement(UitkMenuContainer, {
        position: menuContainerPosition,
        width: 275
    }, /* @__PURE__ */ React69.createElement(UitkSpacing33, {
        padding: {
            inline: "four"
        }
    }, /* @__PURE__ */ React69.createElement("div", null, priceSummaryHeading && /* @__PURE__ */ React69.createElement(UitkHeading15, {
        align: "left",
        tag: "h4",
        size: 6
    }, priceSummaryHeading.value), sections.map(function(section, index) {
        return /* @__PURE__ */ React69.createElement(PriceSummarySection, {
            data: section,
            key: "price-summary-section-".concat(index),
            lastSection: index === sections.length - 1
        });
    }), /* @__PURE__ */ React69.createElement(UitkSpacing33, {
        padding: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React69.createElement("div", null, actionButton)), disclaimers && disclaimers.length > 0 && /* @__PURE__ */ React69.createElement(UitkSpacing33, {
        margin: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React69.createElement(UitkLayoutFlex17, {
        direction: "row"
    }, disclaimers.map(function(message, index) {
        return /* @__PURE__ */ React69.createElement(UitkLayoutFlexItem13, {
            key: "price-summary-disclaimer-message-".concat(index)
        }, /* @__PURE__ */ React69.createElement(UitkText26, {
            size: 100
        }, /* @__PURE__ */ React69.createElement(LodgingEnrichedMessage, {
            data: message
        })));
    })))))));
};
PriceBreakdownSummaryMenu.fragment = fragment33;
PriceBreakdownSummaryMenu.displayName = "PriceBreakdownSummaryMenu";
// src/components/property-offers/__private/__fragments/price-breakdown-summary/price-breakdown-summary.tsx
var PriceBreakdownSummary = function(param) {
    var data = param.data, actionButton = param.actionButton, menuContainerPosition = param.menuContainerPosition, roomTypeId = param.roomTypeId, ratePlanId = param.ratePlanId;
    return /* @__PURE__ */ React70.createElement(UitkSpacing34, {
        padding: {
            blockstart: "one"
        }
    }, /* @__PURE__ */ React70.createElement("div", null, /* @__PURE__ */ React70.createElement(Viewport10, null, /* @__PURE__ */ React70.createElement(ViewSmall9, null, /* @__PURE__ */ React70.createElement(PriceBreakdownDialog, {
        data: data,
        actionButton: actionButton
    })), /* @__PURE__ */ React70.createElement(ViewMedium7, null, /* @__PURE__ */ React70.createElement(PriceBreakdownSummaryMenu, {
        data: data,
        actionButton: actionButton,
        menuContainerPosition: menuContainerPosition,
        roomTypeId: roomTypeId,
        ratePlanId: ratePlanId
    })))));
};
PriceBreakdownSummary.fragment = fragment33;
PriceBreakdownSummary.displayName = "PriceBreakdownSummary";
// src/components/property-offers/__private/__fragments/price-presentation-dialog/price-presentation-dialog.tsx
import React71 from "react";
import { useClickTracker as useClickTracker22 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog9 } from "@shared-ui/dialog-context";
import { PricePresentation } from "@shared-ui/pricing-price-details";
import { ViewMedium as ViewMedium8, Viewport as Viewport11, ViewSmall as ViewSmall10 } from "@shared-ui/viewport-context";
import { UitkDialogContent as UitkDialogContent8 } from "uitk-react-dialog";
import { UitkIcon as UitkIcon16, UitkIconSize as UitkIconSize13 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex18, UitkLayoutFlexItem as UitkLayoutFlexItem14 } from "uitk-react-layout-flex";
import { UitkLink as UitkLink13 } from "uitk-react-link";
import { UitkSheet as UitkSheet5 } from "uitk-react-sheet";
import { UitkSpacing as UitkSpacing35 } from "uitk-react-spacing";
import { UitkToolbar as UitkToolbar5 } from "uitk-react-toolbar";
// src/components/property-offers/__private/__fragments/price-presentation-dialog/price-presentation-dialog-fragment.tsx
import { gql as gql66 } from "@apollo/client";
var PricePresentationDialogComponentFragment = gql66(_templateObject66(), UiGraphic.fragment);
// src/components/property-offers/__private/__fragments/price-presentation-dialog/price-presentation-dialog.tsx
var Dialog = function(param) {
    var data = param.data, onClose = param.onClose, triggerRef = param.triggerRef, actionButton = param.actionButton, viewport = param.viewport;
    var _toolbar, _toolbar_icon, _toolbar1;
    var pricePresentation = data.pricePresentation, pricePresentationDialog = data.pricePresentationDialog;
    var toolbar = pricePresentationDialog.toolbar;
    var _toolbar_title;
    return /* @__PURE__ */ React71.createElement(UitkSheet5, {
        type: viewport === "SMALL" ? "full" : "centered",
        isVisible: true,
        triggerRef: triggerRef,
        returnFocusOnClose: true
    }, /* @__PURE__ */ React71.createElement(UitkToolbar5, {
        toolbarTitle: (_toolbar_title = (_toolbar = toolbar) === null || _toolbar === void 0 ? void 0 : _toolbar.title) !== null && _toolbar_title !== void 0 ? _toolbar_title : void 0,
        navigationContent: {
            onClick: onClose,
            navType: "close",
            navIconLabel: (_toolbar1 = toolbar) === null || _toolbar1 === void 0 ? void 0 : (_toolbar_icon = _toolbar1.icon) === null || _toolbar_icon === void 0 ? void 0 : _toolbar_icon.description
        }
    }), /* @__PURE__ */ React71.createElement(UitkDialogContent8, {
        zeroPadding: true
    }, /* @__PURE__ */ React71.createElement(UitkSpacing35, {
        padding: viewport === "SMALL" ? {
            block: "four",
            inline: "four"
        } : {
            block: "six",
            inline: "six"
        }
    }, /* @__PURE__ */ React71.createElement(UitkLayoutFlex18, {
        direction: "column",
        justifyContent: viewport === "SMALL" ? "space-between" : void 0,
        blockSize: viewport === "SMALL" ? "full_size" : void 0
    }, /* @__PURE__ */ React71.createElement(UitkLayoutFlexItem14, null, /* @__PURE__ */ React71.createElement(PricePresentation, {
        data: pricePresentation
    })), /* @__PURE__ */ React71.createElement(UitkLayoutFlexItem14, null, viewport === "SMALL" ? /* @__PURE__ */ React71.createElement("div", null, React71.cloneElement(actionButton, {
        isFullWidth: true
    })) : /* @__PURE__ */ React71.createElement(UitkSpacing35, {
        padding: {
            blockstart: "six"
        }
    }, /* @__PURE__ */ React71.createElement("div", null, actionButton)))))));
};
var PricePresentationDialog = function(param) {
    var roomTypeId = param.roomTypeId, ratePlanId = param.ratePlanId, actionButton = param.actionButton, data = param.data;
    var dialogPostfix = useDialogId();
    var _useDialog9 = _sliced_to_array(useDialog9("price-presentation-".concat(dialogPostfix), "pwaDialogNested"), 3), dialogActions = _useDialog9[1], DialogComponent = _useDialog9[2];
    var isWithinDetailsDialog = React71.useContext(dialog_context_default);
    var track = useClickTracker22();
    var triggerRef = React71.useRef(null);
    var pricePresentation = data.pricePresentation, pricePresentationDialog = data.pricePresentationDialog;
    if (!pricePresentation || !pricePresentationDialog) {
        return null;
    }
    var toolbar = pricePresentationDialog.toolbar, trigger = pricePresentationDialog.trigger;
    var rfrrSuffix = isWithinDetailsDialog ? "RoomInfo" : "RoomsAndRates";
    var onClick = function() {
        var clientSideAnalytics = trigger.clientSideAnalytics;
        dialogActions.openDialog();
        if (clientSideAnalytics) {
            track("HOT.HIS.".concat(rfrrSuffix + clientSideAnalytics.referrerId, ".").concat(roomTypeId, ".").concat(ratePlanId), clientSideAnalytics.linkName);
        }
    };
    var onClose = function() {
        var clientSideAnalytics = (toolbar || {}).clientSideAnalytics;
        dialogActions.closeDialog();
        if (clientSideAnalytics) {
            track("HOT.HIS.".concat(rfrrSuffix + clientSideAnalytics.referrerId), clientSideAnalytics.linkName);
        }
    };
    var _trigger_accessibilityLabel;
    return /* @__PURE__ */ React71.createElement(React71.Fragment, null, /* @__PURE__ */ React71.createElement(UitkSpacing35, {
        padding: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React71.createElement(UitkLink13, {
        onClick: onClick
    }, /* @__PURE__ */ React71.createElement("button", {
        type: "button",
        ref: triggerRef,
        "aria-label": (_trigger_accessibilityLabel = trigger.accessibilityLabel) !== null && _trigger_accessibilityLabel !== void 0 ? _trigger_accessibilityLabel : void 0
    }, trigger.value, /* @__PURE__ */ React71.createElement(UitkIcon16, {
        name: "chevron_right",
        size: UitkIconSize13.SMALL
    })))), /* @__PURE__ */ React71.createElement(DialogComponent, null, /* @__PURE__ */ React71.createElement(Viewport11, null, /* @__PURE__ */ React71.createElement(ViewSmall10, null, /* @__PURE__ */ React71.createElement(Dialog, {
        data: data,
        onClose: onClose,
        triggerRef: triggerRef,
        actionButton: actionButton,
        viewport: "SMALL"
    })), /* @__PURE__ */ React71.createElement(ViewMedium8, null, /* @__PURE__ */ React71.createElement(Dialog, {
        data: data,
        onClose: onClose,
        triggerRef: triggerRef,
        actionButton: actionButton,
        viewport: "MEDIUM"
    })))));
};
PricePresentationDialog.fragment = PricePresentationDialogComponentFragment;
PricePresentationDialog.displayName = "PricePresentationDialog";
// src/components/property-offers/__private/__fragments/property-features.tsx
import React73 from "react";
import { gql as gql68 } from "@apollo/client";
import { UitkIcon as UitkIcon18 } from "uitk-react-icons";
import { UitkListItem as UitkListItem3 } from "uitk-react-list";
import { UitkMark as UitkMark7, UitkMarkSize as UitkMarkSize7 } from "uitk-react-mark";
// src/components/property-offers/__private/__fragments/logding-plain-sheet.tsx
import React72 from "react";
import { gql as gql67 } from "@apollo/client";
import { useClickTracker as useClickTracker23 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog10 } from "@shared-ui/dialog-context";
import { ViewMedium as ViewMedium9, Viewport as Viewport12, ViewSmall as ViewSmall11 } from "@shared-ui/viewport-context";
import { UitkIcon as UitkIcon17, UitkIconSize as UitkIconSize14 } from "uitk-react-icons";
import { UitkMoreInfoTrigger as UitkMoreInfoTrigger2 } from "uitk-react-more-info-trigger";
import { UitkSheet as UitkSheet6, UitkSheetContent } from "uitk-react-sheet";
import { UitkSpacing as UitkSpacing36 } from "uitk-react-spacing";
import { UitkText as UitkText27 } from "uitk-react-text";
import { UitkToolbar as UitkToolbar6 } from "uitk-react-toolbar";
import { UitkUnformattedHtml as UitkUnformattedHtml4 } from "uitk-react-unformatted-html";
var fragment34 = gql67(_templateObject67());
var LodgingPlainSheet = function(param) {
    var data = param.data, uniqueDialogId = param.uniqueDialogId, _param_isHtmlContent = param.isHtmlContent, isHtmlContent = _param_isHtmlContent === void 0 ? false : _param_isHtmlContent, _param_spacing = param.spacing, spacing = _param_spacing === void 0 ? {} : _param_spacing;
    var dialogPostfix = useDialogId();
    var _useDialog10 = _sliced_to_array(useDialog10("".concat(uniqueDialogId, "-").concat(dialogPostfix), "pwaDialogNested"), 3), isDialogOpen = _useDialog10[0], dialogActions = _useDialog10[1], DialogComponent = _useDialog10[2];
    var trackClick = useClickTracker23();
    if (!data) {
        return null;
    }
    var content = data.content, trigger = data.trigger, toolbar = data.toolbar;
    var openDialog = function() {
        var clientSideAnalytics = trigger.clientSideAnalytics;
        dialogActions.openDialog();
        if (clientSideAnalytics) {
            trackClick("HOT.HIS".concat(clientSideAnalytics.referrerId), clientSideAnalytics.linkName);
        }
    };
    var closeDialog = function() {
        var clientSideAnalytics = (toolbar || {}).clientSideAnalytics;
        dialogActions.closeDialog();
        if (clientSideAnalytics) {
            trackClick("HOT.HIS".concat(clientSideAnalytics.referrerId), clientSideAnalytics.linkName);
        }
    };
    var SheetComponent = function(param) {
        var sheetSize = param.sheetSize;
        var _toolbar, _toolbar_icon, _toolbar1;
        var _toolbar_title;
        return /* @__PURE__ */ React72.createElement(UitkSheet6, {
            triggerRef: null,
            isVisible: isDialogOpen,
            type: "centered",
            centeredSheetSize: sheetSize
        }, /* @__PURE__ */ React72.createElement(UitkToolbar6, {
            key: "".concat(uniqueDialogId, "-toolbar"),
            toolbarTitle: (_toolbar_title = (_toolbar = toolbar) === null || _toolbar === void 0 ? void 0 : _toolbar.title) !== null && _toolbar_title !== void 0 ? _toolbar_title : void 0,
            navigationContent: {
                navIconLabel: (_toolbar1 = toolbar) === null || _toolbar1 === void 0 ? void 0 : (_toolbar_icon = _toolbar1.icon) === null || _toolbar_icon === void 0 ? void 0 : _toolbar_icon.description,
                navType: "close",
                onClick: closeDialog
            }
        }), /* @__PURE__ */ React72.createElement(UitkSheetContent, null, content.map(function(item, contentIndex) {
            return isHtmlContent ? /* @__PURE__ */ React72.createElement(UitkSpacing36, {
                padding: "three",
                key: "".concat(uniqueDialogId, "-content-").concat(contentIndex)
            }, /* @__PURE__ */ React72.createElement(UitkUnformattedHtml4, {
                htmlToParse: item
            })) : /* @__PURE__ */ React72.createElement(UitkText27, {
                key: "".concat(uniqueDialogId, "-content-").concat(contentIndex),
                spacing: contentIndex !== 0 ? "four" : void 0
            }, item);
        })));
    };
    return /* @__PURE__ */ React72.createElement(React72.Fragment, null, /* @__PURE__ */ React72.createElement(UitkSpacing36, _object_spread({}, spacing), /* @__PURE__ */ React72.createElement(UitkMoreInfoTrigger2, {
        onClick: openDialog
    }, /* @__PURE__ */ React72.createElement("button", {
        type: "button"
    }, /* @__PURE__ */ React72.createElement(UitkText27, {
        className: "uitk-layout-flex",
        size: 300,
        theme: trigger.theme ? highlightedMessagesThemeToUitkTextTheme[trigger.theme] : "default"
    }, trigger.value, trigger.icon && /* @__PURE__ */ React72.createElement(UitkIcon17, {
        name: trigger.icon.id,
        size: UitkIconSize14.SMALL
    }))))), /* @__PURE__ */ React72.createElement(DialogComponent, null, /* @__PURE__ */ React72.createElement(Viewport12, null, /* @__PURE__ */ React72.createElement(ViewSmall11, null, /* @__PURE__ */ React72.createElement(SheetComponent, {
        sheetSize: "small"
    })), /* @__PURE__ */ React72.createElement(ViewMedium9, null, /* @__PURE__ */ React72.createElement(SheetComponent, {
        sheetSize: "medium"
    })))));
};
LodgingPlainSheet.fragment = fragment34;
LodgingPlainSheet.displayName = "LodgingPlainSheet";
// src/components/property-offers/__private/__fragments/property-features.tsx
var fragment35 = gql68(_templateObject68(), LodgingPlainSheet.fragment);
var PropertyFeatures = function(param) {
    var data = param.data, uniqueDialogId = param.uniqueDialogId;
    var _graphic_url;
    var text = data.text, moreInfoDialog = data.moreInfoDialog, graphic = data.graphic;
    return /* @__PURE__ */ React73.createElement(UitkListItem3, null, graphic && graphic.__typename === "Icon" && /* @__PURE__ */ React73.createElement(UitkIcon18, {
        name: graphic.id,
        description: graphic.description,
        id: graphic.id
    }), graphic && graphic.__typename === "Mark" && /* @__PURE__ */ React73.createElement(UitkMark7, {
        url: (_graphic_url = graphic.url) === null || _graphic_url === void 0 ? void 0 : _graphic_url.value,
        name: graphic.id,
        description: graphic.description,
        id: graphic.id,
        size: UitkMarkSize7.SMALL
    }), !moreInfoDialog && text, uniqueDialogId && moreInfoDialog && /* @__PURE__ */ React73.createElement(LodgingPlainSheet, {
        uniqueDialogId: uniqueDialogId,
        isHtmlContent: true,
        data: moreInfoDialog
    }));
};
PropertyFeatures.fragment = fragment35;
PropertyFeatures.displayName = "PropertyFeatures";
// src/components/property-offers/__private/__fragments/property-offers-price-change-message.tsx
import React74 from "react";
import { gql as gql69 } from "@apollo/client";
import { UitkCard as UitkCard12, UitkCardContentSection as UitkCardContentSection9 } from "uitk-react-cards";
import { UitkSpacing as UitkSpacing37 } from "uitk-react-spacing";
var __PropertyOffersPriceChangeMessageFragment = gql69(_templateObject69(), LodgingEnrichedMessage.fragment);
var PropertyOffersPriceChangeMessage = function(param) {
    var data = param.data;
    var headerMessage = data.headerMessage;
    if (!headerMessage) {
        return null;
    }
    return /* @__PURE__ */ React74.createElement(UitkSpacing37, {
        margin: {
            blockstart: "four",
            blockend: "three"
        }
    }, /* @__PURE__ */ React74.createElement(UitkCard12, {
        border: true
    }, /* @__PURE__ */ React74.createElement(UitkCardContentSection9, null, /* @__PURE__ */ React74.createElement(LodgingEnrichedMessage, {
        data: headerMessage
    }))));
};
PropertyOffersPriceChangeMessage.displayName = "PropertyOffersPriceChangeMessage";
PropertyOffersPriceChangeMessage.fragment = __PropertyOffersPriceChangeMessageFragment;
// src/components/property-offers/__private/__fragments/property-offers-scarcity.tsx
import React75 from "react";
import { gql as gql70 } from "@apollo/client";
import { UitkText as UitkText28 } from "uitk-react-text";
var fragment36 = gql70(_templateObject70());
var PropertyOffersRateViewScarcity = function(param) {
    var data = param.data;
    var _data_availability, _data;
    if (!((_data = data) === null || _data === void 0 ? void 0 : (_data_availability = _data.availability) === null || _data_availability === void 0 ? void 0 : _data_availability.scarcityMessage)) {
        return null;
    }
    return /* @__PURE__ */ React75.createElement(UitkText28, {
        size: 100,
        theme: "negative",
        align: "right"
    }, data.availability.scarcityMessage);
};
PropertyOffersRateViewScarcity.fragment = fragment36;
PropertyOffersRateViewScarcity.displayName = "PropertyOffersRateViewScarcity";
// src/components/property-offers/__private/__fragments/property-rate-plan-badge.tsx
import React76 from "react";
import { gql as gql71 } from "@apollo/client";
// ../internal/src/components/uitk-badge-theme-mapper.tsx
import { UitkBadgeLoyaltyThemes, UitkBadgeTheme as UitkBadgeTheme2 } from "uitk-react-badge";
var LOYALTY_EXTRA_HIGH_TIER = "loyalty-extra-high-tier";
var _obj4;
var UitkBadgeThemeMapper = (_obj4 = {}, _define_property(_obj4, UitkBadgeTheme2.DEAL_BUNDLED, "deal-bundled"), _define_property(_obj4, UitkBadgeTheme2.DEAL_GENERIC, "deal-generic"), _define_property(_obj4, UitkBadgeTheme2.DEAL_MEMBER, "deal-member"), _define_property(_obj4, UitkBadgeTheme2.NOTIFICATION_1, "notification-1"), _define_property(_obj4, UitkBadgeTheme2.NOTIFICATION_2, "notification-2"), _define_property(_obj4, UitkBadgeTheme2.VIP, "vip"), _define_property(_obj4, UitkBadgeTheme2.LOYALTY_HIGH_TIER, "loyalty-high-tier"), _define_property(_obj4, UitkBadgeTheme2.LOYALTY_MIDDLE_TIER, "loyalty-middle-tier"), _define_property(_obj4, UitkBadgeTheme2.LOYALTY_LOW_TIER, "loyalty-low-tier"), _define_property(_obj4, UitkBadgeTheme2.SPONSORED, "sponsored"), _define_property(_obj4, UitkBadgeTheme2.VIEWED, "viewed"), _define_property(_obj4, UitkBadgeTheme2.SAVED, "saved"), _define_property(_obj4, UitkBadgeTheme2.FAMILY_FRIENDLY, "family-friendly"), _define_property(_obj4, UitkBadgeTheme2.SUPPLIER_PROMO, "supplier-promo"), _define_property(_obj4, UitkBadgeTheme2.PROMOTED, "promoted"), _obj4);
var _obj5;
var UitkBadgeLoyaltyThemeMapper = (_obj5 = {}, _define_property(_obj5, LOYALTY_EXTRA_HIGH_TIER, UitkBadgeLoyaltyThemes.EXTRAHIGH), _define_property(_obj5, UitkBadgeTheme2.LOYALTY_HIGH_TIER, UitkBadgeLoyaltyThemes.HIGH), _define_property(_obj5, UitkBadgeTheme2.LOYALTY_MIDDLE_TIER, UitkBadgeLoyaltyThemes.MID), _define_property(_obj5, UitkBadgeTheme2.LOYALTY_LOW_TIER, UitkBadgeLoyaltyThemes.LOW), _obj5);
var UitkBadgeLoyaltyThemePerksMessageMapper = {
    LOYALTY_EXTRA_HIGH_TIER: UitkBadgeLoyaltyThemes.EXTRAHIGH,
    LOYALTY_HIGH_TIER: UitkBadgeLoyaltyThemes.HIGH,
    LOYALTY_MIDDLE_TIER: UitkBadgeLoyaltyThemes.MID,
    LOYALTY_LOW_TIER: UitkBadgeLoyaltyThemes.LOW,
    VIP: UitkBadgeLoyaltyThemes.VIP
};
// src/components/property-offers/__private/__fragments/property-rate-plan-badge.tsx
import { UitkBadge, UitkBadgeLoyalty } from "uitk-react-badge";
import { UitkIcon as UitkIcon19, UitkIconSize as UitkIconSize15 } from "uitk-react-icons";
import { UitkSpacing as UitkSpacing38 } from "uitk-react-spacing";
// src/components/property-offers/__private/__fragments/rate-plan-utils.tsx
import { UitkBadgeTheme as UitkBadgeTheme3 } from "uitk-react-badge";
var _obj6;
var badgeThemeToUitkTheme = (_obj6 = {}, _define_property(_obj6, "DEAL_GENERIC" /* DEAL_GENERIC */ , UitkBadgeTheme3.DEAL_GENERIC), _define_property(_obj6, "DEAL_BUNDLED" /* DEAL_BUNDLED */ , UitkBadgeTheme3.DEAL_BUNDLED), _define_property(_obj6, "DEAL_MEMBER" /* DEAL_MEMBER */ , UitkBadgeTheme3.DEAL_MEMBER), _define_property(_obj6, "SPONSORED" /* SPONSORED */ , UitkBadgeTheme3.SPONSORED), _define_property(_obj6, "FAMILY_FRIENDLY" /* FAMILY_FRIENDLY */ , UitkBadgeTheme3.FAMILY_FRIENDLY), _define_property(_obj6, "SAVED" /* SAVED */ , UitkBadgeTheme3.SAVED), _define_property(_obj6, "SUPPLIER_PROMO" /* SUPPLIER_PROMO */ , UitkBadgeTheme3.SUPPLIER_PROMO), _define_property(_obj6, "VIEWED" /* VIEWED */ , UitkBadgeTheme3.VIEWED), _define_property(_obj6, "NOTIFICATION" /* NOTIFICATION */ , UitkBadgeTheme3.NOTIFICATION_1), _define_property(_obj6, "VIP" /* VIP */ , UitkBadgeTheme3.VIP), _define_property(_obj6, "LOYALTY_HIGH_TIER" /* LOYALTY_HIGH_TIER */ , UitkBadgeTheme3.LOYALTY_HIGH_TIER), _define_property(_obj6, "LOYALTY_MIDDLE_TIER" /* LOYALTY_MIDDLE_TIER */ , UitkBadgeTheme3.LOYALTY_MIDDLE_TIER), _define_property(_obj6, "LOYALTY_LOW_TIER" /* LOYALTY_LOW_TIER */ , UitkBadgeTheme3.LOYALTY_LOW_TIER), _obj6);
// src/components/property-offers/__private/__fragments/property-rate-plan-badge.tsx
var fragment37 = gql71(_templateObject71());
var PropertyRatePlanBadge = function(param) {
    var data = param.data;
    var _badge;
    var badge = data.badge;
    if (!((_badge = badge) === null || _badge === void 0 ? void 0 : _badge.text)) {
        return null;
    }
    var text = badge.text, theme_temp = badge.theme_temp, icon_temp = badge.icon_temp;
    var theme = theme_temp ? badgeThemeToUitkTheme[theme_temp] : void 0;
    var isLoyaltyBadge = theme && UitkBadgeLoyaltyThemeMapper[theme];
    var children = icon_temp && /* @__PURE__ */ React76.createElement(UitkIcon19, {
        name: icon_temp.id,
        size: UitkIconSize15.SMALL,
        id: icon_temp.id,
        description: icon_temp.description,
        title: icon_temp.title || void 0
    });
    return /* @__PURE__ */ React76.createElement(UitkSpacing38, {
        margin: {
            blockend: "one"
        }
    }, isLoyaltyBadge ? /* @__PURE__ */ React76.createElement(UitkBadgeLoyalty, {
        theme: UitkBadgeLoyaltyThemeMapper[theme],
        text: text
    }, children) : /* @__PURE__ */ React76.createElement(UitkBadge, {
        theme: theme_temp ? badgeThemeToUitkTheme[theme_temp] : void 0,
        text: text
    }, children));
};
PropertyRatePlanBadge.fragment = fragment37;
PropertyRatePlanBadge.displayName = "PropertyRatePlanBadge";
// src/components/property-offers/__private/__fragments/reserve-button/dialog/property-info-message-fragments.tsx
import React77 from "react";
import { gql as gql72 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex19 } from "uitk-react-layout-flex";
import { UitkLayoutGrid as UitkLayoutGrid12, UitkLayoutGridItem as UitkLayoutGridItem11 } from "uitk-react-layout-grid";
import { UitkListItem as UitkListItem4 } from "uitk-react-list";
import { UitkMark as UitkMark8, UitkMarkSize as UitkMarkSize8 } from "uitk-react-mark";
import { UitkSpacing as UitkSpacing39 } from "uitk-react-spacing";
import { UitkText as UitkText29 } from "uitk-react-text";
import { UitkUnformattedHtml as UitkUnformattedHtml5 } from "uitk-react-unformatted-html";
var propertyInfoItemFragment = gql72(_templateObject72());
var PropertyInfoMessage = function(param) {
    var data = param.data, index = param.index, markSize = param.markSize, textSize = param.textSize;
    var _graphic, _graphic_markUrl, _graphic1;
    var text = data.text, state = data.state, graphic = data.graphic;
    var markUrl = ((_graphic = graphic) === null || _graphic === void 0 ? void 0 : _graphic.__typename) === "Mark" ? (_graphic1 = graphic) === null || _graphic1 === void 0 ? void 0 : (_graphic_markUrl = _graphic1.markUrl) === null || _graphic_markUrl === void 0 ? void 0 : _graphic_markUrl.value : "";
    if (state !== "LOYALTY") {
        return /* @__PURE__ */ React77.createElement(UitkListItem4, {
            key: "policy_".concat(index)
        }, text);
    }
    return /* @__PURE__ */ React77.createElement(React77.Fragment, null, /* @__PURE__ */ React77.createElement(UitkLayoutGrid12, null, /* @__PURE__ */ React77.createElement(UitkLayoutGridItem11, null, /* @__PURE__ */ React77.createElement(UitkLayoutFlex19, null, graphic && /* @__PURE__ */ React77.createElement(UitkSpacing39, {
        margin: {
            inlineend: "two"
        }
    }, /* @__PURE__ */ React77.createElement(UitkMark8, {
        url: markUrl !== null && markUrl !== void 0 ? markUrl : "",
        size: markSize !== null && markSize !== void 0 ? markSize : UitkMarkSize8.SMALL
    })), /* @__PURE__ */ React77.createElement(UitkUnformattedHtml5, {
        htmlToParse: text,
        plainTextElement: function(props) {
            return /* @__PURE__ */ React77.createElement(UitkText29, {
                size: textSize,
                weight: "regular",
                theme: state && highlightedMessagesThemeToUitkTextTheme[state] || void 0
            }, props.children);
        }
    })))));
};
PropertyInfoMessage.fragment = propertyInfoItemFragment;
PropertyInfoMessage.displayName = "PropertyInfoMessage";
// src/components/property-offers/__private/__fragments/reserve-button/property-reserve-button.tsx
import React92 from "react";
import { gql as gql85 } from "@apollo/client";
import { useClickTracker as useClickTracker28 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog14 } from "@shared-ui/dialog-context";
import { Experiment as Experiment4, ExperimentControl as ExperimentControl4, ExperimentVariant as ExperimentVariant4, useExperiment } from "@shared-ui/experiment-context";
// ../internal/src/components/lodging-egds-graphic-text/lodging-egds-graphic-text.tsx
import React78 from "react";
import { gql as gql73 } from "@apollo/client";
import { UitkIcon as UitkIcon20, UitkIconSize as UitkIconSize16 } from "uitk-react-icons";
import { UitkSpacing as UitkSpacing40 } from "uitk-react-spacing";
import { UitkText as UitkText30 } from "uitk-react-text";
var fragment38 = gql73(_templateObject73());
var LodgingEGDSGraphicText = function(param) {
    var data = param.data, textProps = param.textProps, customTextSize = param.customTextSize;
    var _graphic;
    var text = data.text, graphic = data.graphic;
    return /* @__PURE__ */ React78.createElement("div", null, ((_graphic = graphic) === null || _graphic === void 0 ? void 0 : _graphic.__typename) === "Icon" && graphic.id && /* @__PURE__ */ React78.createElement(UitkSpacing40, {
        padding: {
            inlineend: "two"
        }
    }, /* @__PURE__ */ React78.createElement(UitkIcon20, {
        name: graphic.id,
        size: graphic.size ? UitkIconSize16[graphic.size] : UitkIconSize16.EXTRA_SMALL
    })), /* @__PURE__ */ React78.createElement(UitkText30, _object_spread_props(_object_spread({
        size: customTextSize || 200
    }, textProps), {
        inline: !!graphic
    }), text));
};
LodgingEGDSGraphicText.fragment = fragment38;
LodgingEGDSGraphicText.displayName = "LodgingEGDSGraphicText";
// src/components/property-offers/__private/__fragments/reserve-button/property-reserve-button.tsx
import { ViewMedium as ViewMedium11, Viewport as Viewport14, ViewSmall as ViewSmall13 } from "@shared-ui/viewport-context";
import { UitkButtonSize as UitkButtonSize7, UitkPrimaryButton as UitkPrimaryButton8 } from "uitk-react-button";
import { UitkLayoutGrid as UitkLayoutGrid13, UitkLayoutGridItem as UitkLayoutGridItem12 } from "uitk-react-layout-grid";
import { UitkSheet as UitkSheet8, UitkSheetContent as UitkSheetContent3 } from "uitk-react-sheet";
import { UitkSpacing as UitkSpacing42 } from "uitk-react-spacing";
import { UitkToolbar as UitkToolbar8 } from "uitk-react-toolbar";
// src/components/property-offers/__private/__fragments/listings/property-unit-categorization/unit-rate-context.tsx
import React79, { useEffect as useEffect2 } from "react";
import { useClickTracker as useClickTracker24 } from "@shared-ui/clickstream-analytics-context";
var UnitRateContext = React79.createContext({});
var getUnitRateIndex = function(value) {
    var values = value.split("-");
    return parseInt(values[values.length - 1], 10);
};
var getUnitRateCategory = function(value) {
    var values = value.split("-");
    return values[values.length - 2];
};
var getEnabledIndexes = function(primarySelections, indexes) {
    var _primarySelections, _targetPrimary_primarySelection, _targetPrimary, _primarySelections1, _secondarySelections, _secondarySelections1, _secondarySelections2, _secondarySelections_secondaryIndex_secondarySelection, _secondarySelections_secondaryIndex, _tertiarySelections, _tertiarySelections1, _tertiarySelections_tertiaryIndex, _tertiarySelections2;
    var _ref = indexes || {
        primaryIndex: 0,
        secondaryIndex: 0,
        tertiaryIndex: 0
    }, primaryIndex = _ref.primaryIndex, secondaryIndex = _ref.secondaryIndex, tertiaryIndex = _ref.tertiaryIndex;
    var enabledPrimary = ((_primarySelections = primarySelections) === null || _primarySelections === void 0 ? void 0 : _primarySelections.find(function(param) {
        var primarySelection = param.primarySelection;
        var _primarySelection;
        return (_primarySelection = primarySelection) === null || _primarySelection === void 0 ? void 0 : _primarySelection.enabled;
    })) || primarySelections[0];
    var targetPrimary = primarySelections[primaryIndex];
    var enabledPrimaryIndex = ((_targetPrimary = targetPrimary) === null || _targetPrimary === void 0 ? void 0 : (_targetPrimary_primarySelection = _targetPrimary.primarySelection) === null || _targetPrimary_primarySelection === void 0 ? void 0 : _targetPrimary_primarySelection.enabled) ? primaryIndex : (_primarySelections1 = primarySelections) === null || _primarySelections1 === void 0 ? void 0 : _primarySelections1.indexOf(enabledPrimary);
    var secondarySelections = primarySelections[enabledPrimaryIndex].secondarySelections;
    var enabledSecondaryOption = ((_secondarySelections = secondarySelections) === null || _secondarySelections === void 0 ? void 0 : _secondarySelections.find(function(param) {
        var secondarySelection = param.secondarySelection;
        var _secondarySelection;
        return (_secondarySelection = secondarySelection) === null || _secondarySelection === void 0 ? void 0 : _secondarySelection.enabled;
    })) || ((_secondarySelections1 = secondarySelections) === null || _secondarySelections1 === void 0 ? void 0 : _secondarySelections1[0]);
    if (!secondarySelections || !enabledSecondaryOption) {
        return {
            primaryIndex: enabledPrimaryIndex,
            secondaryIndex: 0,
            tertiaryIndex: 0
        };
    }
    var defaultSecondaryIndex = (_secondarySelections2 = secondarySelections) === null || _secondarySelections2 === void 0 ? void 0 : _secondarySelections2.indexOf(enabledSecondaryOption);
    var hasSecondaryTarget = secondaryIndex && ((_secondarySelections_secondaryIndex = secondarySelections[secondaryIndex]) === null || _secondarySelections_secondaryIndex === void 0 ? void 0 : (_secondarySelections_secondaryIndex_secondarySelection = _secondarySelections_secondaryIndex.secondarySelection) === null || _secondarySelections_secondaryIndex_secondarySelection === void 0 ? void 0 : _secondarySelections_secondaryIndex_secondarySelection.enabled);
    var enabledSecondaryIndex = hasSecondaryTarget && secondaryIndex ? secondaryIndex : defaultSecondaryIndex;
    var tertiarySelections = secondarySelections[enabledSecondaryIndex].tertiarySelections;
    var enabledTertiaryOption = (_tertiarySelections = tertiarySelections) === null || _tertiarySelections === void 0 ? void 0 : _tertiarySelections.find(function(param) {
        var enabled = param.enabled;
        return enabled;
    });
    if (!tertiarySelections || !enabledTertiaryOption) {
        return {
            primaryIndex: enabledPrimaryIndex,
            secondaryIndex: enabledSecondaryIndex,
            tertiaryIndex: 0
        };
    }
    var defaultTertiaryIndex = enabledTertiaryOption && ((_tertiarySelections1 = tertiarySelections) === null || _tertiarySelections1 === void 0 ? void 0 : _tertiarySelections1.indexOf(enabledTertiaryOption));
    var hasTertiaryTarget = tertiaryIndex && ((_tertiarySelections2 = tertiarySelections) === null || _tertiarySelections2 === void 0 ? void 0 : (_tertiarySelections_tertiaryIndex = _tertiarySelections2[tertiaryIndex]) === null || _tertiarySelections_tertiaryIndex === void 0 ? void 0 : _tertiarySelections_tertiaryIndex.enabled);
    var enabledTertiaryIndex = hasTertiaryTarget && tertiaryIndex ? tertiaryIndex : defaultTertiaryIndex;
    return {
        primaryIndex: enabledPrimaryIndex,
        secondaryIndex: enabledSecondaryIndex,
        tertiaryIndex: enabledTertiaryIndex
    };
};
var getSelections = function(primarySelections, indexes) {
    var _secondarySelections, _secondaryTarget, _secondarySelections_secondaryIndex, _secondarySelections1, _tertiarySelections;
    var primaryIndex = indexes.primaryIndex, secondaryIndex = indexes.secondaryIndex, tertiaryIndex = indexes.tertiaryIndex;
    var _primarySelections_primaryIndex = primarySelections[primaryIndex], propertyUnit = _primarySelections_primaryIndex.propertyUnit, primarySelection = _primarySelections_primaryIndex.primarySelection, secondarySelections = _primarySelections_primaryIndex.secondarySelections;
    var secondaryTarget = (_secondarySelections = secondarySelections) === null || _secondarySelections === void 0 ? void 0 : _secondarySelections[secondaryIndex];
    var secondarySelection = (_secondaryTarget = secondaryTarget) === null || _secondaryTarget === void 0 ? void 0 : _secondaryTarget.secondarySelection;
    var tertiarySelections = (_secondarySelections1 = secondarySelections) === null || _secondarySelections1 === void 0 ? void 0 : (_secondarySelections_secondaryIndex = _secondarySelections1[secondaryIndex]) === null || _secondarySelections_secondaryIndex === void 0 ? void 0 : _secondarySelections_secondaryIndex.tertiarySelections;
    var tertiarySelection = (_tertiarySelections = tertiarySelections) === null || _tertiarySelections === void 0 ? void 0 : _tertiarySelections[tertiaryIndex];
    return {
        propertyUnit: propertyUnit,
        primarySelection: primarySelection,
        secondaryTarget: secondaryTarget,
        secondarySelection: secondarySelection,
        secondarySelections: secondarySelections,
        tertiarySelection: tertiarySelection
    };
};
var getRatePlan = function(selections) {
    var _selections_primarySelection, _selections, _selections_secondarySelection, _selections1, _selections_tertiarySelection, _selections2;
    var ratePlans = selections.propertyUnit.ratePlans;
    var primaryId = (_selections = selections) === null || _selections === void 0 ? void 0 : (_selections_primarySelection = _selections.primarySelection) === null || _selections_primarySelection === void 0 ? void 0 : _selections_primarySelection.optionId;
    var secondaryId = (_selections1 = selections) === null || _selections1 === void 0 ? void 0 : (_selections_secondarySelection = _selections1.secondarySelection) === null || _selections_secondarySelection === void 0 ? void 0 : _selections_secondarySelection.optionId;
    var tertiaryId = (_selections2 = selections) === null || _selections2 === void 0 ? void 0 : (_selections_tertiarySelection = _selections2.tertiarySelection) === null || _selections_tertiarySelection === void 0 ? void 0 : _selections_tertiarySelection.optionId;
    var optionId = tertiaryId || secondaryId || primaryId;
    var ratePlan = ratePlans.find(function(param) {
        var id = param.id;
        return id === optionId;
    }) || ratePlans[0];
    var ratePlanIndex = ratePlans.indexOf(ratePlan) + 1;
    return {
        ratePlan: ratePlan,
        ratePlanIndex: ratePlanIndex
    };
};
var getRoomType = function(selections) {
    var _selections_propertyUnit = selections.propertyUnit, roomTypeId = _selections_propertyUnit.id;
    return {
        roomTypeId: roomTypeId
    };
};
var selectedIndexOrZero = function(selectedIndex) {
    return selectedIndex && selectedIndex >= 0 ? selectedIndex : 0;
};
var getDefaultSelections = function(primarySelections) {
    var _primarySelections_primaryIndex, _secondarySelections, _secondarySelections_secondaryIndex_tertiarySelections, _secondarySelections_secondaryIndex, _secondarySelections1;
    var primaryIndex = selectedIndexOrZero(primarySelections.findIndex(function(param) {
        var primarySelection = param.primarySelection;
        var _primarySelection;
        return (_primarySelection = primarySelection) === null || _primarySelection === void 0 ? void 0 : _primarySelection.selected;
    }));
    var secondarySelections = (_primarySelections_primaryIndex = primarySelections[primaryIndex]) === null || _primarySelections_primaryIndex === void 0 ? void 0 : _primarySelections_primaryIndex.secondarySelections;
    var secondaryIndex = selectedIndexOrZero((_secondarySelections = secondarySelections) === null || _secondarySelections === void 0 ? void 0 : _secondarySelections.findIndex(function(param) {
        var secondarySelection = param.secondarySelection;
        var _secondarySelection;
        return (_secondarySelection = secondarySelection) === null || _secondarySelection === void 0 ? void 0 : _secondarySelection.selected;
    }));
    var tertiaryIndex = selectedIndexOrZero((_secondarySelections1 = secondarySelections) === null || _secondarySelections1 === void 0 ? void 0 : (_secondarySelections_secondaryIndex = _secondarySelections1[secondaryIndex]) === null || _secondarySelections_secondaryIndex === void 0 ? void 0 : (_secondarySelections_secondaryIndex_tertiarySelections = _secondarySelections_secondaryIndex.tertiarySelections) === null || _secondarySelections_secondaryIndex_tertiarySelections === void 0 ? void 0 : _secondarySelections_secondaryIndex_tertiarySelections.findIndex(function(param) {
        var selected = param.selected;
        return selected;
    }));
    return {
        primaryIndex: primaryIndex,
        secondaryIndex: secondaryIndex,
        tertiaryIndex: tertiaryIndex
    };
};
var hasRadioSelection = function(primarySelections, secondaryTarget) {
    var _secondaryTarget, _secondaryTarget_tertiarySelections, _secondaryTarget1;
    var hasPrimary = primarySelections.length > 1;
    var hasSecondary = Boolean((_secondaryTarget = secondaryTarget) === null || _secondaryTarget === void 0 ? void 0 : _secondaryTarget.secondarySelection);
    var hasTertiary = Boolean((_secondaryTarget1 = secondaryTarget) === null || _secondaryTarget1 === void 0 ? void 0 : (_secondaryTarget_tertiarySelections = _secondaryTarget1.tertiarySelections) === null || _secondaryTarget_tertiarySelections === void 0 ? void 0 : _secondaryTarget_tertiarySelections.length);
    return hasPrimary || hasSecondary || hasTertiary ? {
        hasPrimary: hasPrimary,
        hasSecondary: hasSecondary,
        hasTertiary: hasTertiary
    } : void 0;
};
var UnitRateContextProvider = function(param) {
    var isFullyRefundable = param.isFullyRefundable, primarySelections = param.primarySelections, setDismissMessagingCard = param.setDismissMessagingCard, setDefaultToFullyRefundable = param.setDefaultToFullyRefundable, children = param.children;
    var initialIndexes = getEnabledIndexes(primarySelections, getDefaultSelections(primarySelections));
    var _React79_useState = _sliced_to_array(React79.useState(initialIndexes.primaryIndex), 2), primaryIndex = _React79_useState[0], setPrimaryIndex = _React79_useState[1];
    var _React79_useState1 = _sliced_to_array(React79.useState(initialIndexes.secondaryIndex), 2), secondaryIndex = _React79_useState1[0], setSecondaryIndex = _React79_useState1[1];
    var _React79_useState2 = _sliced_to_array(React79.useState(initialIndexes.tertiaryIndex), 2), tertiaryIndex = _React79_useState2[0], setTertiaryIndex = _React79_useState2[1];
    var analyticsTracker = useClickTracker24();
    var selections = getSelections(primarySelections, {
        primaryIndex: primaryIndex,
        secondaryIndex: secondaryIndex,
        tertiaryIndex: tertiaryIndex
    });
    var _getRatePlan = getRatePlan(selections), ratePlan = _getRatePlan.ratePlan, ratePlanIndex = _getRatePlan.ratePlanIndex;
    var roomTypeId = getRoomType(selections).roomTypeId;
    var secondarySelections = selections.secondarySelections, secondaryTarget = selections.secondaryTarget;
    var radioSelections = hasRadioSelection(primarySelections, secondaryTarget);
    useEffect2(function() {
        setPrimaryIndex(initialIndexes.primaryIndex);
    }, [
        initialIndexes.primaryIndex
    ]);
    useEffect2(function() {
        setSecondaryIndex(initialIndexes.secondaryIndex);
    }, [
        initialIndexes.secondaryIndex
    ]);
    useEffect2(function() {
        setTertiaryIndex(initialIndexes.tertiaryIndex);
    }, [
        initialIndexes.tertiaryIndex
    ]);
    useEffect2(function() {
        if (isFullyRefundable) {
            var _secondarySelections;
            (_secondarySelections = secondarySelections) === null || _secondarySelections === void 0 ? void 0 : _secondarySelections.forEach(function(param, index) {
                var recommendedSelection = param.recommendedSelection;
                if (!recommendedSelection) {
                    return;
                }
                var indexes = getEnabledIndexes(primarySelections, {
                    primaryIndex: primaryIndex,
                    secondaryIndex: index,
                    tertiaryIndex: tertiaryIndex
                });
                setSecondaryIndex(index);
                if (setDismissMessagingCard) {
                    setDismissMessagingCard(true);
                }
                setTertiaryIndex(indexes.tertiaryIndex);
            });
            if (setDefaultToFullyRefundable) {
                setDefaultToFullyRefundable(false);
            }
        }
    }, [
        isFullyRefundable,
        primaryIndex,
        primarySelections,
        secondarySelections,
        setDefaultToFullyRefundable,
        setDismissMessagingCard,
        tertiaryIndex
    ]);
    var handleRadio = function(event) {
        var index = getUnitRateIndex(event.target.value);
        var category = getUnitRateCategory(event.target.value);
        var map = {
            roomFeatures: {
                getIndexes: function() {
                    return getEnabledIndexes(primarySelections, {
                        primaryIndex: index,
                        secondaryIndex: 0,
                        tertiaryIndex: 0
                    });
                },
                selectionKey: "primarySelection"
            },
            cancellationPolicy: {
                getIndexes: function() {
                    return getEnabledIndexes(primarySelections, {
                        primaryIndex: primaryIndex,
                        secondaryIndex: index,
                        tertiaryIndex: 0
                    });
                },
                selectionKey: "secondarySelection"
            },
            extras: {
                getIndexes: function() {
                    return getEnabledIndexes(primarySelections, {
                        primaryIndex: primaryIndex,
                        secondaryIndex: secondaryIndex,
                        tertiaryIndex: index
                    });
                },
                selectionKey: "tertiarySelection"
            }
        };
        var _map_category = map[category], getIndexes = _map_category.getIndexes, selectionKey = _map_category.selectionKey;
        var indexes = getIndexes();
        setPrimaryIndex(indexes.primaryIndex);
        setSecondaryIndex(indexes.secondaryIndex);
        setTertiaryIndex(indexes.tertiaryIndex);
        var clientSideAnalytics = getSelections(primarySelections, indexes)[selectionKey].clientSideAnalytics;
        analyticsTracker("".concat(clientSideAnalytics.referrerId, ".").concat(roomTypeId, ".").concat(ratePlan.id), clientSideAnalytics.linkName, true);
    };
    return /* @__PURE__ */ React79.createElement(UnitRateContext.Provider, {
        value: {
            primaryIndex: primaryIndex,
            ratePlan: ratePlan,
            ratePlanIndex: ratePlanIndex,
            secondaryIndex: secondaryIndex,
            tertiaryIndex: tertiaryIndex,
            handleRadio: handleRadio,
            radioSelections: radioSelections,
            roomTypeId: roomTypeId
        }
    }, children);
};
// src/components/property-offers/__private/__fragments/reserve-button/dateless-check-availability.tsx
import React80 from "react";
import { gql as gql74 } from "@apollo/client";
import { useRefContext as useRefContext2 } from "@shared-ui/ref-context";
var fragment39 = gql74(_templateObject74(), LodgingEGDSButton.fragment);
var DatelessCheckAvailability = function(param) {
    var data = param.data, clickRefTarget = param.clickRefTarget;
    var getTargets = useRefContext2().getTargets;
    var checkAvailabilityButton = data.checkAvailabilityButton;
    var handleClickOpenCalendar = function() {
        var _getTargets = getTargets([
            clickRefTarget
        ]), clickRef = _getTargets.startDate;
        setTimeout(function() {
            var _clickRef_current, _clickRef;
            (_clickRef = clickRef) === null || _clickRef === void 0 ? void 0 : (_clickRef_current = _clickRef.current) === null || _clickRef_current === void 0 ? void 0 : _clickRef_current.click();
        }, 50);
    };
    return /* @__PURE__ */ React80.createElement(LodgingEGDSButton, {
        data: checkAvailabilityButton,
        onClick: handleClickOpenCalendar,
        isFullWidth: true
    });
};
DatelessCheckAvailability.fragment = fragment39;
DatelessCheckAvailability.displayName = "DatelessCheckAvailability";
// src/components/property-offers/__private/__fragments/reserve-button/dialog/lodging-signin-dialog/lodging-sign-dialog.tsx
import React84 from "react";
import { gql as gql78 } from "@apollo/client";
import { useDialog as useDialog12 } from "@shared-ui/dialog-context";
import { UitkButtonSize as UitkButtonSize4, UitkPrimaryButton as UitkPrimaryButton5 } from "uitk-react-button";
// ../internal/src/components/egds/egds-dialog/egds-dialog.tsx
import React82 from "react";
import { gql as gql76 } from "@apollo/client";
import { useDialog as useDialog11 } from "@shared-ui/dialog-context";
// ../internal/src/components/egds/egds-dialog/egds-action-dialog.tsx
import React81 from "react";
import { gql as gql75 } from "@apollo/client";
import { useClickstreamAnalytics as useClickstreamAnalytics2 } from "@shared-ui/clickstream-analytics-context";
import { UitkDialog as UitkDialog4, UitkDialogContent as UitkDialogContent9, UitkDialogFooter as UitkDialogFooter5 } from "uitk-react-dialog";
import { UitkHeading as UitkHeading16, UitkParagraph } from "uitk-react-text";
var fragment40 = gql75(_templateObject75());
var EGDSActionDialog = function(param) {
    var data = param.data, actionsCallback = param.actionsCallback, closeDialog = param.closeDialog, content = param.content, title = param.title;
    var clickstreamAnalytics = useClickstreamAnalytics2();
    var _obj;
    var EGDSParagraphSizeMap2 = (_obj = {}, _define_property(_obj, "P1" /* P1 */ , 1), _define_property(_obj, "P2" /* P2 */ , 2), _define_property(_obj, "P3" /* P3 */ , 3), _obj);
    var _data_footer = data.footer, __typename = _data_footer.__typename, buttons = _data_footer.buttons;
    var handleLinkButtonClick = function(url) {
        window.location.replace(url);
    };
    var handleDialogTriggerClick = function(action) {
        var _action;
        trackAnalyticsList(clickstreamAnalytics, (_action = action) === null || _action === void 0 ? void 0 : _action.analytics);
        if (actionsCallback) {
            actionsCallback(action);
        } else {
            closeDialog();
        }
    };
    var handleActionButtonClick = function(analytics2) {
        trackAnalyticsList(clickstreamAnalytics, analytics2);
        closeDialog();
    };
    var _buttons_map = _sliced_to_array(buttons.map(function(currentButton) {
        if (currentButton.__typename === "UITertiaryButton") {
            var _currentButton_action, _currentButton;
            var primary2 = currentButton.primary;
            var tertiaryBtn = {
                text: primary2,
                type: "tertiary",
                onClick: function() {
                    return handleDialogTriggerClick(currentButton);
                }
            };
            if (((_currentButton = currentButton) === null || _currentButton === void 0 ? void 0 : (_currentButton_action = _currentButton.action) === null || _currentButton_action === void 0 ? void 0 : _currentButton_action.__typename) === "UILinkAction") {
                var _currentButton_action1, _currentButton1;
                var url = (_currentButton1 = currentButton) === null || _currentButton1 === void 0 ? void 0 : (_currentButton_action1 = _currentButton1.action) === null || _currentButton_action1 === void 0 ? void 0 : _currentButton_action1.resource.value;
                tertiaryBtn.onClick = function() {
                    return handleLinkButtonClick(url);
                };
            }
            return tertiaryBtn;
        }
        var primary = currentButton.primary;
        return {
            text: primary,
            type: "primary",
            onClick: function() {
                var _currentButton_action;
                return handleActionButtonClick((_currentButton_action = currentButton.action) === null || _currentButton_action === void 0 ? void 0 : _currentButton_action.analytics);
            }
        };
    }), 3), buttonOne = _buttons_map[0], buttonTwo = _buttons_map[1], buttonThree = _buttons_map[2];
    return /* @__PURE__ */ React81.createElement(UitkDialog4, {
        dialogShow: true,
        returnFocusOnClose: true
    }, /* @__PURE__ */ React81.createElement(UitkDialogContent9, null, /* @__PURE__ */ React81.createElement(UitkHeading16, {
        size: 5,
        key: "dialogHeading"
    }, title), /* @__PURE__ */ React81.createElement(UitkParagraph, {
        key: "dialogParagraph",
        size: EGDSParagraphSizeMap2[content.style]
    }, content.text), /* @__PURE__ */ React81.createElement(UitkDialogFooter5, {
        stacked: __typename === "EGDSStackedDialogFooter",
        buttonOne: buttonOne,
        buttonTwo: buttonTwo,
        buttonThree: buttonThree
    })));
};
EGDSActionDialog.fragment = fragment40;
EGDSActionDialog.displayName = "EGDSActionDialog";
// ../internal/src/components/egds/egds-dialog/egds-dialog.tsx
var fragment41 = gql76(_templateObject76(), EGDSActionDialog.fragment);
var EGDSDialog = function(param) {
    var data = param.data, title = param.title, dialogId = param.dialogId, dialogContent = param.dialogContent, handleActionsCallback = param.handleActionsCallback;
    var _useDialog11 = _sliced_to_array(useDialog11(dialogId), 3), dialogActions = _useDialog11[1], DialogComponent = _useDialog11[2];
    var closeDialog = function() {
        dialogActions.closeDialog();
    };
    if (!dialogContent) {
        return null;
    }
    return /* @__PURE__ */ React82.createElement("div", {
        "data-stid": dialogId
    }, /* @__PURE__ */ React82.createElement(DialogComponent, null, /* @__PURE__ */ React82.createElement(EGDSActionDialog, {
        data: data,
        content: dialogContent,
        closeDialog: closeDialog,
        title: title,
        actionsCallback: handleActionsCallback
    })));
};
EGDSDialog.fragment = fragment41;
EGDSDialog.displayName = "EGDSDialog";
// ../internal/src/components/egds/egds-text/egds-paragraph.tsx
import React83 from "react";
import { gql as gql77 } from "@apollo/client";
import { UitkParagraph as UitkParagraph2 } from "uitk-react-text";
var fragment42 = gql77(_templateObject77());
var _obj7;
var EGDSParagraphSizeMap = (_obj7 = {}, _define_property(_obj7, "P1" /* P1 */ , 1), _define_property(_obj7, "P2" /* P2 */ , 2), _define_property(_obj7, "P3" /* P3 */ , 3), _obj7);
var EGDSParagraph = function(param) {
    var data = param.data;
    return /* @__PURE__ */ React83.createElement(UitkParagraph2, {
        size: EGDSParagraphSizeMap[data.style]
    }, data.text);
};
EGDSParagraph.fragment = fragment42;
EGDSParagraph.displayName = "EGDSParagraph";
// src/components/property-offers/__private/__fragments/reserve-button/dialog/lodging-signin-dialog/lodging-sign-dialog.tsx
var fragment43 = gql78(_templateObject78(), EGDSParagraph.fragment, EGDSActionDialog.fragment);
var LodgingSignInDialog = function(param) {
    var data = param.data, showLargeBtn = param.showLargeBtn, isFullWidth = param.isFullWidth, dialogId = param.dialogId;
    var _dialogTrigger, _dialogTrigger1, _dialogTrigger2;
    var dialogContent = data.dialogContent, title = data.title, dialogTrigger = data.dialogTrigger;
    var actionDialog = data.actionDialog;
    var _useDialog12 = _sliced_to_array(useDialog12(dialogId), 2), openDialog = _useDialog12[1].openDialog;
    if (!dialogContent || !actionDialog) {
        return null;
    }
    return /* @__PURE__ */ React84.createElement(React84.Fragment, null, /* @__PURE__ */ React84.createElement(UitkPrimaryButton5, {
        onClick: function() {
            openDialog();
        },
        isFullWidth: isFullWidth,
        "data-stid": "submit-hotel-reserve",
        size: showLargeBtn ? UitkButtonSize4.LARGE : UitkButtonSize4.MEDIUM
    }, /* @__PURE__ */ React84.createElement(React84.Fragment, null, ((_dialogTrigger = dialogTrigger) === null || _dialogTrigger === void 0 ? void 0 : _dialogTrigger.accessibilityLabel) && /* @__PURE__ */ React84.createElement("span", {
        className: "is-visually-hidden"
    }, dialogTrigger.accessibilityLabel), /* @__PURE__ */ React84.createElement("span", {
        "aria-hidden": ((_dialogTrigger1 = dialogTrigger) === null || _dialogTrigger1 === void 0 ? void 0 : _dialogTrigger1.accessibilityLabel) !== null
    }, (_dialogTrigger2 = dialogTrigger) === null || _dialogTrigger2 === void 0 ? void 0 : _dialogTrigger2.value))), /* @__PURE__ */ React84.createElement(EGDSDialog, {
        dialogContent: dialogContent,
        data: actionDialog,
        dialogId: dialogId,
        title: title
    }));
};
LodgingSignInDialog.fragment = fragment43;
LodgingSignInDialog.displayName = "LodgingSignInDialog";
// src/components/property-offers/__private/__fragments/reserve-button/dialog/property-payment-options.tsx
import React91 from "react";
import { gql as gql84 } from "@apollo/client";
import { useClickTracker as useClickTracker27 } from "@shared-ui/clickstream-analytics-context";
import { Experiment as Experiment3, ExperimentControl as ExperimentControl3, ExperimentVariant as ExperimentVariant3 } from "@shared-ui/experiment-context";
import { PriceSummary } from "@shared-ui/pricing-price-summary";
import { ViewMedium as ViewMedium10, Viewport as Viewport13, ViewSmall as ViewSmall12 } from "@shared-ui/viewport-context";
import { UitkCard as UitkCard13 } from "uitk-react-cards";
import { UitkIcon as UitkIcon21 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex22, UitkLayoutFlexItem as UitkLayoutFlexItem15 } from "uitk-react-layout-flex";
import { UitkList as UitkList3, UitkListItem as UitkListItem5 } from "uitk-react-list";
import { UitkMark as UitkMark9, UitkMarkSize as UitkMarkSize9 } from "uitk-react-mark";
import { UitkPriceLockupAlign as UitkPriceLockupAlign3 } from "uitk-react-price-lockup";
import { UitkSpacing as UitkSpacing41 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading17, UitkText as UitkText32 } from "uitk-react-text";
import { classNames } from "uitk-react-utils";
// src/components/property-offers/__private/__fragments/reserve-button/property-lodging-form-button.tsx
import React86, { useContext } from "react";
import { gql as gql80 } from "@apollo/client";
import { useBexApi as useBexApi2 } from "@shared-ui/bex-api-context";
import { ITrackType as ITrackType2, useClickstreamAnalytics as useClickstreamAnalytics3, useClickTracker as useClickTracker25 } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/utils/analytics.ts
var lightweightAdaptExMicroMessage = function(param) {
    var campaignId = param.campaignId, payloadId = param.payloadId, eventType = param.eventType, eventTarget = param.eventTarget, _param_banditDisplayed = param.banditDisplayed, banditDisplayed = _param_banditDisplayed === void 0 ? true : _param_banditDisplayed;
    return {
        schemaName: "multiArmedBandit",
        messageContent: {
            campaignId: campaignId,
            events: [
                {
                    payloadId: payloadId,
                    eventType: eventType,
                    eventTarget: eventTarget,
                    banditDisplayed: banditDisplayed
                }
            ]
        }
    };
};
var createAdaptExMicroMessage = function(campaignId, events) {
    var _events;
    var allEvents = (_events = events) === null || _events === void 0 ? void 0 : _events.reduce(function(acc, curr) {
        return _to_consumable_array(acc).concat([
            {
                payloadId: curr.payloadId,
                eventType: curr.eventType,
                eventTarget: curr.eventTarget,
                banditDisplayed: curr.banditDisplayed
            }
        ]);
    }, []);
    return {
        schemaName: "multiArmedBandit",
        messageContent: {
            campaignId: campaignId,
            events: allEvents
        }
    };
};
var adaptToAdaptExSuccessEventSchema = function(lodgingAdaptExAnalyticsEvent) {
    var mappedMessages = [];
    var campaignId = lodgingAdaptExAnalyticsEvent.campaignId, events = lodgingAdaptExAnalyticsEvent.events, clientSideAnalytics = lodgingAdaptExAnalyticsEvent.clientSideAnalytics;
    if (clientSideAnalytics) {
        var _eventType;
        var referrerId = clientSideAnalytics.referrerId, eventType = clientSideAnalytics.eventType, linkName = clientSideAnalytics.linkName;
        mappedMessages.push({
            messageContent: {
                referrerId: referrerId,
                eventType: ((_eventType = eventType) === null || _eventType === void 0 ? void 0 : _eventType.toLowerCase()) || "click",
                linkName: linkName
            },
            schemaName: "referrer"
        });
    }
    if (campaignId && events) {
        mappedMessages.push(createAdaptExMicroMessage(campaignId, events));
    }
    return mappedMessages;
};
// src/components/property-offers/__private/__fragments/reserve-button/property-lodging-form-button.tsx
import { AmenitiesAdaptExContext } from "@shared-ui/lodging-property-details";
import { usePackageOperations } from "@shared-ui/multi-item-operations-providers";
import { UitkButtonSize as UitkButtonSize5, UitkPrimaryButton as UitkPrimaryButton6 } from "uitk-react-button";
import { UitkLayoutFlex as UitkLayoutFlex20 } from "uitk-react-layout-flex";
// src/components/property-offers/multi-item-select-products.tsx
import { gql as gql79, useMutation } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
import { useLogger } from "@shared-ui/logger-context";
// src/components/property-offers/__private/context/multi-item-context.tsx
import React85 from "react";
var initialMultiItemContext = {
    packageType: void 0,
    sessionId: void 0,
    handleMultiItemCallback: void 0,
    error: void 0,
    setDefaultError: void 0,
    setError: void 0
};
var MultiItemContext = React85.createContext(initialMultiItemContext);
var useMultiItemContext = function() {
    return React85.useContext(MultiItemContext);
};
var MultiItemProvider = function(param) {
    var children = param.children, defaultError = param.defaultError, multiItemContext = param.multiItemContext;
    var _React85_useState = _sliced_to_array(React85.useState(null), 2), error = _React85_useState[0], setErrorState = _React85_useState[1];
    var setDefaultError = function() {
        return setErrorState(defaultError);
    };
    var setError = function(errorMessage) {
        return setErrorState(errorMessage);
    };
    var finalMultiItemContext = _object_spread_props(_object_spread({}, multiItemContext), {
        error: error,
        setDefaultError: setDefaultError,
        setError: setError
    });
    return /* @__PURE__ */ React85.createElement(MultiItemContext.Provider, {
        value: finalMultiItemContext
    }, children);
};
var setMultiItemContext = function(shoppingContext) {
    var _shoppingContext_multiItem, _shoppingContext, _shoppingContext_multiItem1, _shoppingContext1;
    return {
        sessionId: (_shoppingContext = shoppingContext) === null || _shoppingContext === void 0 ? void 0 : (_shoppingContext_multiItem = _shoppingContext.multiItem) === null || _shoppingContext_multiItem === void 0 ? void 0 : _shoppingContext_multiItem.id,
        packageType: (_shoppingContext1 = shoppingContext) === null || _shoppingContext1 === void 0 ? void 0 : (_shoppingContext_multiItem1 = _shoppingContext1.multiItem) === null || _shoppingContext_multiItem1 === void 0 ? void 0 : _shoppingContext_multiItem1.packageType
    };
};
// src/components/property-offers/multi-item-select-products.tsx
var MutationSelectProducts = gql79(_templateObject79());
function useSelectProducts() {
    var _useMutation = _sliced_to_array(useMutation(MutationSelectProducts), 1), selectProducts = _useMutation[0];
    var _useLogger = useLogger(), logError = _useLogger.error;
    var context = useBexApi().context;
    var _useMultiItemContext = useMultiItemContext(), sessionId = _useMultiItemContext.sessionId, setError = _useMultiItemContext.setError, setDefaultError = _useMultiItemContext.setDefaultError;
    return function selectProductsCall(priceDetail) {
        var _priceDetail_price;
        if (!setError || !setDefaultError) {
            return;
        }
        var omitTypename = function(key, value) {
            return key === "__typename" ? void 0 : value;
        };
        var multiItemProperties = priceDetail.propertyNaturalKeys;
        var variables = {
            context: context,
            sessionId: sessionId,
            priceToken: (_priceDetail_price = priceDetail.price) === null || _priceDetail_price === void 0 ? void 0 : _priceDetail_price.multiItemPriceToken,
            properties: JSON.parse(JSON.stringify(multiItemProperties), omitTypename),
            dealMarker: priceDetail.dealMarker
        };
        selectProducts({
            variables: variables
        }).then(function(param) {
            var data = param.data, errors = param.errors;
            var _selectProductsData_shoppingContext_multiItem, _selectProductsData_shoppingContext_multiItem1;
            var selectProductsData = data.multiItemShopping.selectProducts;
            if (selectProductsData.__typename === "MultiItemSearchContextCreatedResponse" && ((_selectProductsData_shoppingContext_multiItem = selectProductsData.shoppingContext.multiItem) === null || _selectProductsData_shoppingContext_multiItem === void 0 ? void 0 : _selectProductsData_shoppingContext_multiItem.id) && ((_selectProductsData_shoppingContext_multiItem1 = selectProductsData.shoppingContext.multiItem) === null || _selectProductsData_shoppingContext_multiItem1 === void 0 ? void 0 : _selectProductsData_shoppingContext_multiItem1.packageType) && selectProductsData.redirectUrl) {
                window.location.href = selectProductsData.redirectUrl.toString();
            } else if (selectProductsData.__typename === "MultiItemSearchContextErrorResponse" && selectProductsData.message) {
                logError("BEX_API_MULTI_ITEM_SELECT_PRODUCTS_ERROR" /* BEX_API_MULTI_ITEM_SELECT_PRODUCTS_ERROR */ , errors || "error response returned from selectProducts");
                setError(selectProductsData.message);
            } else {
                logError("BEX_API_MULTI_ITEM_SELECT_PRODUCTS_ERROR" /* BEX_API_MULTI_ITEM_SELECT_PRODUCTS_ERROR */ , errors || "error while selecting products");
                setDefaultError();
            }
        }).catch(function(error) {
            logError("BEX_API_MULTI_ITEM_SELECT_PRODUCTS_ERROR" /* BEX_API_MULTI_ITEM_SELECT_PRODUCTS_ERROR */ , error);
            setDefaultError();
        });
    };
}
var multi_item_select_products_default = useSelectProducts;
// src/components/property-offers/__private/__fragments/reserve-button/property-lodging-form-button.tsx
var fragment44 = gql80(_templateObject80(), AdaptExAnalyticsEventFragment);
var getInputType = function(inputType) {
    return inputType ? inputType.toLowerCase() : "hidden";
};
var onSubmit = function(event) {
    var formRef = event.target;
    event.preventDefault();
    window.requestAnimationFrame(function() {
        window.requestAnimationFrame(function() {
            formRef.submit();
        });
    });
};
var getInputValue = function(inputs, inputName) {
    var _inputs_filter_, _inputs_filter;
    return (_inputs_filter = inputs.filter(function(input) {
        var _input;
        return ((_input = input) === null || _input === void 0 ? void 0 : _input.name) === inputName;
    })) === null || _inputs_filter === void 0 ? void 0 : (_inputs_filter_ = _inputs_filter[0]) === null || _inputs_filter_ === void 0 ? void 0 : _inputs_filter_.value;
};
var getBusinessModel = function(hotelCollect) {
    return hotelCollect ? "HC" /* HC */  : "EC" /* EC */ ;
};
var PropertyLodgingFormButton = function(param) {
    var data = param.data, trackReserveButtonClick = param.trackReserveButtonClick, isFullWidth = param.isFullWidth, propertyNaturalKeys = param.propertyNaturalKeys, hotelCollect = param.hotelCollect, noCreditCard = param.noCreditCard, priceDetail = param.priceDetail, showLargeBtn = param.showLargeBtn, listingIndex = param.listingIndex;
    var _inputs, _inputs1;
    var formRef = React86.createRef();
    var _useMultiItemContext = useMultiItemContext(), packageType = _useMultiItemContext.packageType, sessionId = _useMultiItemContext.sessionId, handleMultiItemCallback = _useMultiItemContext.handleMultiItemCallback;
    var selectPackage = usePackageOperations().selectPackage;
    var selectedProductsCall = multi_item_select_products_default();
    var _useAdaptExEvents = useAdaptExEvents(), offerAdaptExSuccessEvents = _useAdaptExEvents.adaptExSuccessEvents;
    var context = useBexApi2().context;
    var action = data.action, inputs = data.inputs, method = data.method, submit = data.submit;
    var selectionEvent = "".concat(RECOMMENDATION_MODULE, ".").concat(MODULE_SELECTED);
    var track = useClickTracker25();
    var _useClickstreamAnalytics3 = useClickstreamAnalytics3(), clickStreamTrack = _useClickstreamAnalytics3.track;
    var _useContext = _sliced_to_array(useContext(AmenitiesAdaptExContext), 1), adaptExState = _useContext[0];
    var reserveAdaptExSuccessEvents = adaptExState.reserveAdaptExSuccessEvents;
    if (!((_inputs = inputs) === null || _inputs === void 0 ? void 0 : _inputs.length)) {
        return null;
    }
    var rateUpsell = getInputValue(inputs, "rateUpsell") === "true";
    var roomUpsell = getInputValue(inputs, "roomUpsell") === "true";
    var ratePlanDenseRank = getInputValue(inputs, "ratePlanDenseRank");
    var additionalAmount = getInputValue(inputs, "additionalAmount");
    var propertyUpsellAmount = getInputValue(inputs, "propertyUpsellAmount");
    var roomUpgradeEligible = getInputValue(inputs, "roomUpgradeEligible") === "true";
    var rateUpgradeEligible = getInputValue(inputs, "rateUpgradeEligible") === "true";
    var roomTypeCode = getInputValue(inputs, "roomTypeCode") || getInputValue(inputs, "bookingRequest.items[0].roomTypeCode");
    var ratePlanCode = getInputValue(inputs, "ratePlanCode") || getInputValue(inputs, "bookingRequest.items[0].rateCode");
    var hotelID = getInputValue(inputs, "hotelID") || getInputValue(inputs, "bookingRequest.expediaPropertyId");
    var submitText = submit.text, accessibilityLabel = submit.accessibilityLabel, adaptExSuccessEvents = submit.adaptExSuccessEvents, lodgingRecommendationClickstreamEvent = submit.lodgingRecommendationClickstreamEvent;
    var trackReserveAdaptExSuccessEvents = function() {
        var _reserveAdaptExSuccessEvents;
        if ((_reserveAdaptExSuccessEvents = reserveAdaptExSuccessEvents) === null || _reserveAdaptExSuccessEvents === void 0 ? void 0 : _reserveAdaptExSuccessEvents.length) {
            reserveAdaptExSuccessEvents.forEach(function(reserveAdaptExSuccessEvent) {
                clickStreamTrack(ITrackType2.EVENT, {
                    data: lightweightAdaptExMicroMessage({
                        campaignId: reserveAdaptExSuccessEvent.campaignId,
                        payloadId: reserveAdaptExSuccessEvent.events[0].payloadId,
                        eventType: reserveAdaptExSuccessEvent.events[0].eventType,
                        eventTarget: reserveAdaptExSuccessEvent.events[0].eventTarget
                    })
                });
            });
        }
    };
    var trackReserveButton = function() {
        if (additionalAmount && propertyUpsellAmount && roomTypeCode && ratePlanCode && hotelID && ratePlanDenseRank) {
            track("HOT.HIS.RoomsAndRates.Upsell", "Click on reserve button", void 0, allRoomsSchema({
                additionalAmount: parseInt(additionalAmount, 10),
                propertyId: hotelID,
                propertyUpsellAmount: parseInt(propertyUpsellAmount, 10),
                rateUpsell: rateUpsell,
                ratePlanCode: ratePlanCode,
                ratePlanDenseRank: parseInt(ratePlanDenseRank, 10),
                roomId: roomTypeCode,
                roomUpsell: roomUpsell,
                roomUpgradeEligible: roomUpgradeEligible,
                rateUpgradeEligible: rateUpgradeEligible
            }));
        }
        trackReserveButtonClick();
    };
    var handleSubmit = function(event) {
        if (submit.analytics) {
            var _submit_analytics, _submit_analytics1, _lodgingRecommendationClickstreamEvent;
            track((_submit_analytics = submit.analytics) === null || _submit_analytics === void 0 ? void 0 : _submit_analytics.referrerId, (_submit_analytics1 = submit.analytics) === null || _submit_analytics1 === void 0 ? void 0 : _submit_analytics1.linkName);
            if (((_lodgingRecommendationClickstreamEvent = lodgingRecommendationClickstreamEvent) === null || _lodgingRecommendationClickstreamEvent === void 0 ? void 0 : _lodgingRecommendationClickstreamEvent.recommendationResponseId) && ratePlanCode) {
                clickStreamTrack(ITrackType2.EVENT, {
                    data: egRecommendationClickstreamBuilder(lodgingRecommendationClickstreamEvent.recommendationResponseId, ratePlanCode, selectionEvent, INTERACTION, listingIndex, submit.analytics)
                });
            }
        }
        trackReserveAdaptExSuccessEvents();
        _to_consumable_array(offerAdaptExSuccessEvents).concat(_to_consumable_array(adaptExSuccessEvents)).forEach(function(adaptExEvent) {
            clickStreamTrack(ITrackType2.EVENT, {
                data: adaptToAdaptExSuccessEventSchema(_object_spread_props(_object_spread({}, adaptExEvent), {
                    events: [
                        adaptExEvent.events[0]
                    ]
                }))
            });
        });
        if (handleMultiItemCallback && typeof handleMultiItemCallback === "function") {
            if (event && typeof event.preventDefault === "function") {
                event.preventDefault();
                track("MultiProp.Reserve", "Clicking on Reserve into multi property experiment");
                handleMultiItemCallback(propertyNaturalKeys, getBusinessModel(hotelCollect), noCreditCard, void 0, formRef);
            }
        } else {
            trackReserveButton();
        }
    };
    if (packageType) {
        var handlePackageSubmit = function(event) {
            if (event && typeof event.preventDefault === "function") {
                event.preventDefault();
            }
            trackReserveButton();
            if (priceDetail) {
                var _priceDetail_action;
                if (((_priceDetail_action = priceDetail.action) === null || _priceDetail_action === void 0 ? void 0 : _priceDetail_action.__typename) === "SelectPackageActionInput" && sessionId && priceDetail.action.packageOfferId) {
                    var variables = {
                        context: context,
                        multiItemSessionId: sessionId,
                        packageOfferId: priceDetail.action.packageOfferId
                    };
                    selectPackage(variables, "PACKAGE_ADD");
                } else if (handleMultiItemCallback) {
                    var _priceDetail_price;
                    var _priceDetail_dealMarker;
                    handleMultiItemCallback(propertyNaturalKeys, void 0, void 0, (_priceDetail_price = priceDetail.price) === null || _priceDetail_price === void 0 ? void 0 : _priceDetail_price.multiItemPriceToken, void 0, (_priceDetail_dealMarker = priceDetail.dealMarker) !== null && _priceDetail_dealMarker !== void 0 ? _priceDetail_dealMarker : void 0);
                } else {
                    selectedProductsCall(priceDetail);
                }
            }
        };
        return /* @__PURE__ */ React86.createElement(UitkPrimaryButton6, {
            size: showLargeBtn ? UitkButtonSize5.LARGE : UitkButtonSize5.MEDIUM,
            isFullWidth: isFullWidth,
            type: "submit",
            onClick: handlePackageSubmit,
            "data-stid": "submit-hotel-reserve",
            role: "link"
        }, /* @__PURE__ */ React86.createElement(React86.Fragment, null, /* @__PURE__ */ React86.createElement("span", {
            "aria-hidden": Boolean(accessibilityLabel)
        }, submitText), accessibilityLabel && /* @__PURE__ */ React86.createElement("span", {
            className: "is-visually-hidden"
        }, accessibilityLabel)));
    }
    var reserveButtonBase = /* @__PURE__ */ React86.createElement(UitkPrimaryButton6, {
        size: UitkButtonSize5.MEDIUM,
        isFullWidth: isFullWidth,
        type: "submit",
        onClick: handleSubmit,
        "data-stid": "submit-hotel-reserve",
        role: "link"
    }, /* @__PURE__ */ React86.createElement(React86.Fragment, null, /* @__PURE__ */ React86.createElement("span", {
        "aria-hidden": Boolean(accessibilityLabel)
    }, submitText), accessibilityLabel && /* @__PURE__ */ React86.createElement("span", {
        className: "is-visually-hidden"
    }, accessibilityLabel)));
    var reserveButton = !isFullWidth ? /* @__PURE__ */ React86.createElement(UitkLayoutFlex20, {
        justifyContent: "end"
    }, reserveButtonBase) : reserveButtonBase;
    return /* @__PURE__ */ React86.createElement("form", {
        action: action,
        method: method,
        ref: formRef,
        onSubmit: onSubmit,
        "data-stid": "property-lodging-form-button-form"
    }, (_inputs1 = inputs) === null || _inputs1 === void 0 ? void 0 : _inputs1.map(function(input, index) {
        var _input, _input1, _input2, _input3, _input4;
        return ((_input = input) === null || _input === void 0 ? void 0 : _input.name) && ((_input1 = input) === null || _input1 === void 0 ? void 0 : _input1.value) && /* @__PURE__ */ React86.createElement("input", {
            key: "formBtn-".concat(index),
            type: getInputType((_input2 = input) === null || _input2 === void 0 ? void 0 : _input2.type),
            name: (_input3 = input) === null || _input3 === void 0 ? void 0 : _input3.name,
            value: (_input4 = input) === null || _input4 === void 0 ? void 0 : _input4.value
        });
    }), reserveButton);
};
PropertyLodgingFormButton.fragment = fragment44;
PropertyLodgingFormButton.displayName = "PropertyLodgingFormButton";
// src/components/property-offers/__private/__fragments/reserve-button/property-lodging-prepare-checkout.tsx
import React88, { useContext as useContext2, useEffect as useEffect4, useRef } from "react";
import { gql as gql82, useMutation as useMutation2 } from "@apollo/client";
import { useBexApi as useBexApi3 } from "@shared-ui/bex-api-context";
import { ITrackType as ITrackType3, useClickstreamAnalytics as useClickstreamAnalytics4, useClickTracker as useClickTracker26 } from "@shared-ui/clickstream-analytics-context";
import { AmenitiesAdaptExContext as AmenitiesAdaptExContext2 } from "@shared-ui/lodging-property-details";
import { usePropertyActivitiesCrossSellContext } from "@shared-ui/retail-lodging-property-activities-cross-sell";
import { UitkButtonSize as UitkButtonSize6, UitkPrimaryButton as UitkPrimaryButton7 } from "uitk-react-button";
import { UitkLayoutFlex as UitkLayoutFlex21 } from "uitk-react-layout-flex";
// src/components/property-offers/__private/__fragments/reserve-button/prepare-checkout-loading-and-error-handling.tsx
import React87, { useEffect as useEffect3 } from "react";
import { useDialog as useDialog13 } from "@shared-ui/dialog-context";
import { UitkPageLoader } from "uitk-react-loader";
import { UitkSheet as UitkSheet7, UitkSheetContent as UitkSheetContent2 } from "uitk-react-sheet";
import { UitkText as UitkText31 } from "uitk-react-text";
import { UitkToolbar as UitkToolbar7 } from "uitk-react-toolbar";
var PrepareCheckoutLoadingAndErrorHandling = function(param) {
    var prepareCheckoutLoading = param.prepareCheckoutLoading, prepareCheckoutData = param.prepareCheckoutData, failureReason = param.failureReason, buttonRef = param.buttonRef;
    var _prepareCheckoutData_prepareCheckout, _prepareCheckoutData;
    var _useDialog13 = _sliced_to_array(useDialog13("prepare-checkout-error"), 3), dialogActions = _useDialog13[1], DialogComponent = _useDialog13[2];
    useEffect3(function() {
        if (failureReason) {
            dialogActions.openDialog();
        }
    }, [
        failureReason
    ]);
    return /* @__PURE__ */ React87.createElement(React87.Fragment, null, (prepareCheckoutLoading || ((_prepareCheckoutData = prepareCheckoutData) === null || _prepareCheckoutData === void 0 ? void 0 : (_prepareCheckoutData_prepareCheckout = _prepareCheckoutData.prepareCheckout) === null || _prepareCheckoutData_prepareCheckout === void 0 ? void 0 : _prepareCheckoutData_prepareCheckout.checkoutUrl)) && /* @__PURE__ */ React87.createElement(UitkPageLoader, {
        visible: true
    }), failureReason && /* @__PURE__ */ React87.createElement(DialogComponent, null, /* @__PURE__ */ React87.createElement(UitkSheet7, {
        isVisible: true,
        type: "centered",
        triggerRef: buttonRef
    }, /* @__PURE__ */ React87.createElement(UitkToolbar7, {
        navigationContent: {
            onClick: function() {
                return dialogActions.closeDialog();
            },
            navIconLabel: "Close Toolbar"
        },
        toolbarTitle: failureReason.message
    }), /* @__PURE__ */ React87.createElement(UitkSheetContent2, null, /* @__PURE__ */ React87.createElement(UitkText31, {
        size: 300
    }, failureReason.description)))));
};
PrepareCheckoutLoadingAndErrorHandling.displayName = "PrepareCheckoutLoadingAndErrorHandling";
// src/components/property-offers/__private/__fragments/reserve-button/prepare-checkout-mutation.ts
import { gql as gql81 } from "@apollo/client";
var PrepareCheckoutMutation = gql81(_templateObject81());
// src/components/property-offers/__private/__fragments/reserve-button/property-lodging-prepare-checkout.tsx
var fragment45 = gql82(_templateObject82(), __UIPrimaryButtonFragment);
var getInputValue2 = function(checkoutOptions, typeName) {
    var _checkoutOptions, _checkoutOptions_filter_, _checkoutOptions_filter;
    return ((_checkoutOptions = checkoutOptions) === null || _checkoutOptions === void 0 ? void 0 : _checkoutOptions.length) ? (_checkoutOptions_filter = checkoutOptions.filter(function(option) {
        var _option;
        return ((_option = option) === null || _option === void 0 ? void 0 : _option.type) === typeName;
    })) === null || _checkoutOptions_filter === void 0 ? void 0 : (_checkoutOptions_filter_ = _checkoutOptions_filter[0]) === null || _checkoutOptions_filter_ === void 0 ? void 0 : _checkoutOptions_filter_.value : "";
};
var PropertyLodgingPrepareCheckout = function(param) {
    var trackReserveButtonClick = param.trackReserveButtonClick, propertyNaturalKeys = param.propertyNaturalKeys, isFullWidth = param.isFullWidth, showLargeBtn = param.showLargeBtn, listingIndex = param.listingIndex, data = param.data;
    var _usePropertyActivitiesCrossSellContext, _prepareCheckoutData_prepareCheckout, _prepareCheckoutData;
    var _useAdaptExEvents = useAdaptExEvents(), offerAdaptExSuccessEvents = _useAdaptExEvents.adaptExSuccessEvents;
    var context = useBexApi3().context;
    var buttonRef = useRef(null);
    var _useClickstreamAnalytics4 = useClickstreamAnalytics4(), clickStreamTrack = _useClickstreamAnalytics4.track;
    var trackClick = useClickTracker26();
    var activityNaturalKey = (_usePropertyActivitiesCrossSellContext = usePropertyActivitiesCrossSellContext()) === null || _usePropertyActivitiesCrossSellContext === void 0 ? void 0 : _usePropertyActivitiesCrossSellContext.activityNaturalKey;
    var checkoutButton = data.checkoutButton;
    var _data_action = data.action, checkoutOptions = _data_action.checkoutOptions, offerTokens = _data_action.offerTokens, totalPrice = _data_action.totalPrice, analytics2 = _data_action.analytics, analyticsList = _data_action.analyticsList, lodgingRecommendationClickstreamEvent = _data_action.lodgingRecommendationClickstreamEvent;
    var selectionEvent = "".concat(RECOMMENDATION_MODULE, ".").concat(MODULE_SELECTED);
    var rateUpsell = getInputValue2(checkoutOptions, "RATE_UPSELL") === "true";
    var roomUpsell = getInputValue2(checkoutOptions, "ROOM_UPSELL") === "true";
    var additionalAmount = getInputValue2(checkoutOptions, "RATE_UPSELL_AMOUNT");
    var propertyUpsellAmount = getInputValue2(checkoutOptions, "PROPERTY_UPSELL_AMOUNT");
    var roomUpgradeEligible = getInputValue2(checkoutOptions, "ROOM_UPGRADE_ELIGIBLE") === "true";
    var rateUpgradeEligible = getInputValue2(checkoutOptions, "RATE_UPGRADE_ELIGIBLE") === "true";
    var roomTypeCode = propertyNaturalKeys[0].roomTypeId;
    var ratePlanCode = propertyNaturalKeys[0].ratePlanId;
    var hotelID = propertyNaturalKeys[0].id;
    var _useMutation2 = _sliced_to_array(useMutation2(PrepareCheckoutMutation), 2), prepareCheckout = _useMutation2[0], _useMutation2_ = _useMutation2[1], prepareCheckoutData = _useMutation2_.data, prepareCheckoutLoading = _useMutation2_.loading;
    var failureReason = (_prepareCheckoutData = prepareCheckoutData) === null || _prepareCheckoutData === void 0 ? void 0 : (_prepareCheckoutData_prepareCheckout = _prepareCheckoutData.prepareCheckout) === null || _prepareCheckoutData_prepareCheckout === void 0 ? void 0 : _prepareCheckoutData_prepareCheckout.failureReason;
    var _useContext2 = _sliced_to_array(useContext2(AmenitiesAdaptExContext2), 1), adaptExState = _useContext2[0];
    var reserveAdaptExSuccessEvents = adaptExState.reserveAdaptExSuccessEvents;
    var trackReserveAdaptExSuccessEvents = function() {
        var _reserveAdaptExSuccessEvents;
        if ((_reserveAdaptExSuccessEvents = reserveAdaptExSuccessEvents) === null || _reserveAdaptExSuccessEvents === void 0 ? void 0 : _reserveAdaptExSuccessEvents.length) {
            reserveAdaptExSuccessEvents.forEach(function(reserveAdaptExSuccessEvent) {
                clickStreamTrack(ITrackType3.EVENT, {
                    data: lightweightAdaptExMicroMessage({
                        campaignId: reserveAdaptExSuccessEvent.campaignId,
                        payloadId: reserveAdaptExSuccessEvent.events[0].payloadId,
                        eventType: reserveAdaptExSuccessEvent.events[0].eventType,
                        eventTarget: reserveAdaptExSuccessEvent.events[0].eventTarget
                    })
                });
            });
        }
    };
    useEffect4(function() {
        var _prepareCheckoutData;
        if ((_prepareCheckoutData = prepareCheckoutData) === null || _prepareCheckoutData === void 0 ? void 0 : _prepareCheckoutData.prepareCheckout.checkoutUrl) {
            window.location.href = prepareCheckoutData.prepareCheckout.checkoutUrl;
        }
    }, [
        prepareCheckoutData
    ]);
    var removeTypename = function(key, value) {
        return key === "__typename" ? void 0 : value;
    };
    var handleSubmit = function(event) {
        var _lodgingRecommendationClickstreamEvent, _analyticsList, _activityNaturalKey, _totalPrice_currencyInfo;
        event.preventDefault();
        if (((_lodgingRecommendationClickstreamEvent = lodgingRecommendationClickstreamEvent) === null || _lodgingRecommendationClickstreamEvent === void 0 ? void 0 : _lodgingRecommendationClickstreamEvent.recommendationResponseId) && ratePlanCode && analytics2) {
            clickStreamTrack(ITrackType3.EVENT, {
                data: egRecommendationClickstreamBuilder(lodgingRecommendationClickstreamEvent.recommendationResponseId, ratePlanCode, selectionEvent, INTERACTION, listingIndex, analytics2)
            });
        }
        trackReserveAdaptExSuccessEvents();
        offerAdaptExSuccessEvents.forEach(function(adaptExEvent) {
            clickStreamTrack(ITrackType3.EVENT, {
                data: adaptToAdaptExSuccessEventSchema(_object_spread_props(_object_spread({}, adaptExEvent), {
                    events: [
                        adaptExEvent.events[0]
                    ]
                }))
            });
        });
        if (additionalAmount && propertyUpsellAmount && roomTypeCode && ratePlanCode && hotelID) {
            trackClick("HOT.HIS.RoomsAndRates.Upsell", "Click on reserve button", void 0, allRoomsSchema({
                additionalAmount: parseInt(additionalAmount, 10),
                propertyId: hotelID,
                propertyUpsellAmount: parseInt(propertyUpsellAmount, 10),
                rateUpsell: rateUpsell,
                ratePlanCode: ratePlanCode,
                ratePlanDenseRank: 0,
                roomId: roomTypeCode,
                roomUpsell: roomUpsell,
                roomUpgradeEligible: roomUpgradeEligible,
                rateUpgradeEligible: rateUpgradeEligible
            }));
        }
        trackReserveButtonClick();
        if ((_analyticsList = analyticsList) === null || _analyticsList === void 0 ? void 0 : _analyticsList.length) {
            analyticsList.forEach(function(param) {
                var referrerId = param.referrerId, linkName = param.linkName;
                trackClick(referrerId, linkName);
            });
        }
        prepareCheckout({
            variables: _object_spread(_object_spread_props(_object_spread({
                context: context
            }, ((_activityNaturalKey = activityNaturalKey) === null || _activityNaturalKey === void 0 ? void 0 : _activityNaturalKey.offerToken) && {
                activities: activityNaturalKey
            }), {
                properties: JSON.parse(JSON.stringify(propertyNaturalKeys), removeTypename),
                checkoutOptions: JSON.parse(JSON.stringify(checkoutOptions), removeTypename),
                offerTokens: JSON.parse(JSON.stringify(offerTokens), removeTypename)
            }), totalPrice && {
                totalPrice: {
                    amount: totalPrice.amount,
                    currency: (_totalPrice_currencyInfo = totalPrice.currencyInfo) === null || _totalPrice_currencyInfo === void 0 ? void 0 : _totalPrice_currencyInfo.code
                }
            })
        });
    };
    var reserveButtonBase = /* @__PURE__ */ React88.createElement(UitkPrimaryButton7, {
        size: showLargeBtn ? UitkButtonSize6.LARGE : UitkButtonSize6.MEDIUM,
        isFullWidth: isFullWidth,
        type: "submit",
        onClick: handleSubmit,
        "data-stid": "submit-hotel-reserve",
        role: "link",
        ref: buttonRef,
        disabled: prepareCheckoutLoading
    }, /* @__PURE__ */ React88.createElement(React88.Fragment, null, /* @__PURE__ */ React88.createElement("span", {
        "aria-hidden": Boolean(checkoutButton.accessibility)
    }, checkoutButton.primary), checkoutButton.accessibility && /* @__PURE__ */ React88.createElement("span", {
        className: "is-visually-hidden"
    }, checkoutButton.accessibility)));
    var reserveButton = !isFullWidth ? /* @__PURE__ */ React88.createElement(UitkLayoutFlex21, {
        justifyContent: "end"
    }, reserveButtonBase) : reserveButtonBase;
    return /* @__PURE__ */ React88.createElement(React88.Fragment, null, /* @__PURE__ */ React88.createElement(PrepareCheckoutLoadingAndErrorHandling, {
        prepareCheckoutLoading: prepareCheckoutLoading,
        prepareCheckoutData: prepareCheckoutData,
        failureReason: failureReason,
        buttonRef: buttonRef
    }), reserveButton);
};
PropertyLodgingPrepareCheckout.fragment = fragment45;
PropertyLodgingPrepareCheckout.displayName = "PropertyLodgingPrepareCheckout";
// src/components/property-offers/__private/__fragments/reserve-button/property-lodging-prepare-checkout-experiment-component.tsx
import React89 from "react";
import { Experiment as Experiment2, ExperimentControl as ExperimentControl2, ExperimentVariant as ExperimentVariant2 } from "@shared-ui/experiment-context";
var Control = function(param) {
    var trackReserveButtonClick = param.trackReserveButtonClick, isFullWidth = param.isFullWidth, propertyNaturalKeys = param.propertyNaturalKeys, hotelCollect = param.hotelCollect, noCreditCard = param.noCreditCard, priceDetail = param.priceDetail, showLargeBtn = param.showLargeBtn, listingIndex = param.listingIndex, offerBookButton = param.offerBookButton;
    return /* @__PURE__ */ React89.createElement(React89.Fragment, null, offerBookButton && /* @__PURE__ */ React89.createElement(PropertyLodgingFormButton, {
        data: offerBookButton,
        isFullWidth: isFullWidth,
        trackReserveButtonClick: trackReserveButtonClick,
        propertyNaturalKeys: propertyNaturalKeys,
        noCreditCard: noCreditCard,
        hotelCollect: hotelCollect,
        priceDetail: priceDetail,
        showLargeBtn: showLargeBtn,
        listingIndex: listingIndex
    }));
};
var PropertyLodgingPrepareCheckoutComponent = function(props) {
    var packageType = useMultiItemContext().packageType;
    var trackReserveButtonClick = props.trackReserveButtonClick, isFullWidth = props.isFullWidth, lodgingPrepareCheckout = props.lodgingPrepareCheckout, propertyNaturalKeys = props.propertyNaturalKeys, listingIndex = props.listingIndex;
    return packageType ? /* @__PURE__ */ React89.createElement(Control, _object_spread({}, props)) : /* @__PURE__ */ React89.createElement(Experiment2, {
        name: "Lodging_use_prepareCheckout_mutation"
    }, /* @__PURE__ */ React89.createElement(ExperimentControl2, null, /* @__PURE__ */ React89.createElement(Control, _object_spread({}, props))), /* @__PURE__ */ React89.createElement(ExperimentVariant2, {
        bucket: 1
    }, lodgingPrepareCheckout && /* @__PURE__ */ React89.createElement(PropertyLodgingPrepareCheckout, {
        trackReserveButtonClick: trackReserveButtonClick,
        isFullWidth: isFullWidth,
        propertyNaturalKeys: propertyNaturalKeys,
        listingIndex: listingIndex,
        data: lodgingPrepareCheckout
    })));
};
PropertyLodgingPrepareCheckoutComponent.displayName = "PropertyLodgingFormButton";
// src/components/property-offers/__private/__fragments/reserve-button/dialog/property-payment-price.tsx
import React90 from "react";
import { gql as gql83 } from "@apollo/client";
import { UitkPriceLockup as UitkPriceLockup2, UitkPriceLockupAlign as UitkPriceLockupAlign2 } from "uitk-react-price-lockup";
var fragment46 = gql83(_templateObject83());
var PropertyPaymentPrice = function(param) {
    var data = param.data, alignment = param.alignment;
    var _price_lead, _price, _price1, _priceMessaging, _priceMessaging1, _priceMessaging2, _priceSubtextStandardRawData;
    var price = data.price;
    if (!((_price = price) === null || _price === void 0 ? void 0 : (_price_lead = _price.lead) === null || _price_lead === void 0 ? void 0 : _price_lead.formatted) || !((_price1 = price) === null || _price1 === void 0 ? void 0 : _price1.options) || price.options.length === 0) {
        return null;
    }
    var priceMessaging = price.priceMessaging, lead = price.lead, options = price.options;
    var priceSubtextBoldIndex = ((_priceMessaging = priceMessaging) === null || _priceMessaging === void 0 ? void 0 : _priceMessaging.findIndex(function(msg) {
        return msg.theme === "STRONG" /* STRONG */ ;
    })) || -1;
    var priceSubtextStandardRawData = priceSubtextBoldIndex === -1 ? (_priceMessaging1 = priceMessaging) === null || _priceMessaging1 === void 0 ? void 0 : _priceMessaging1.slice(1) : (_priceMessaging2 = priceMessaging) === null || _priceMessaging2 === void 0 ? void 0 : _priceMessaging2.slice(1).splice(priceSubtextBoldIndex, 1);
    var priceSubtextStandard = (_priceSubtextStandardRawData = priceSubtextStandardRawData) === null || _priceSubtextStandardRawData === void 0 ? void 0 : _priceSubtextStandardRawData.map(function(msg) {
        return msg.value;
    });
    var priceProps = buildUitkPriceLockupProps2(options);
    return /* @__PURE__ */ React90.createElement(React90.Fragment, null, /* @__PURE__ */ React90.createElement(UitkPriceLockup2, _object_spread_props(_object_spread({}, priceProps), {
        a11yPrice: lead.formatted || "",
        align: alignment !== null && alignment !== void 0 ? alignment : UitkPriceLockupAlign2.RIGHT,
        priceSubtextFirst: priceMessaging && priceMessaging.length > 0 ? priceMessaging[0].value : "",
        stids: {
            subtextStandardId: "property-payment-price-standard-first"
        },
        priceSubtextStandard: priceSubtextStandard,
        priceSubtextBold: priceMessaging && priceMessaging.length > 0 && priceSubtextBoldIndex !== -1 ? priceMessaging[priceSubtextBoldIndex].value : ""
    })));
};
var formatStrikeOutText2 = function(price, points, unit, leadingCaption, isPointsFirst) {
    if (!price && !points) {
        return void 0;
    }
    if (!points) {
        var _price;
        return (_price = price) === null || _price === void 0 ? void 0 : _price.formatted;
    }
    if (!price) {
        return "".concat(points.formatted, " ").concat(unit);
    }
    if (isPointsFirst) {
        return "".concat(points.formatted, " ").concat(unit, " ").concat(leadingCaption, " ").concat(price.formatted);
    }
    return "".concat(price.formatted, " ").concat(leadingCaption, " ").concat(points.formatted, " ").concat(unit);
};
var buildUitkPriceLockupProps2 = function(options) {
    var _displayPrice, _displayPrice1, _loyaltyPoints, _loyaltyPoints1, _loyaltyPoints_amount, _loyaltyPoints2, _loyaltyPoints3, _priceDisclaimer_trigger_icon, _priceDisclaimer_trigger, _priceDisclaimer;
    var _options = _sliced_to_array(options, 3), leadOption = _options[0], otherOption = _options[1], disclaimerForPoints = _options[2];
    var leadingCaption = leadOption.leadingCaption, loyaltyPrice = leadOption.loyaltyPrice, displayPrice = leadOption.displayPrice, accessibilityLabel = leadOption.accessibilityLabel, priceDisclaimer = leadOption.priceDisclaimer, strikeOut = leadOption.strikeOut;
    if (options.length === 1 && loyaltyPrice) {
        var _loyaltyPrice_totalStrikeOutPoints, _loyaltyPrice_amount;
        var strikeThroughPoints = loyaltyPrice.totalStrikeOutPoints ? "".concat((_loyaltyPrice_totalStrikeOutPoints = loyaltyPrice.totalStrikeOutPoints) === null || _loyaltyPrice_totalStrikeOutPoints === void 0 ? void 0 : _loyaltyPrice_totalStrikeOutPoints.formatted, " ").concat(loyaltyPrice.unit) : "";
        return {
            isStrikeThroughFirst: true,
            lockupFormattedPoints: "".concat((_loyaltyPrice_amount = loyaltyPrice.amount) === null || _loyaltyPrice_amount === void 0 ? void 0 : _loyaltyPrice_amount.formatted, " ").concat(loyaltyPrice.unit),
            strikeThroughPrice: strikeThroughPoints,
            a11yPrice: accessibilityLabel || ""
        };
    }
    if (loyaltyPrice) {
        var _otherOption_displayPrice, _loyaltyPrice_amount1, _disclaimerForPoints, _disclaimerForPoints_priceDisclaimer_trigger_icon, _disclaimerForPoints_priceDisclaimer_trigger, _disclaimerForPoints_priceDisclaimer, _disclaimerForPoints1;
        var moneyPrice = "".concat(otherOption.leadingCaption, " ").concat((_otherOption_displayPrice = otherOption.displayPrice) === null || _otherOption_displayPrice === void 0 ? void 0 : _otherOption_displayPrice.formatted);
        return {
            isStrikeThroughFirst: true,
            isPointsFirst: true,
            lockupPrice: moneyPrice,
            lockupFormattedPoints: "".concat((_loyaltyPrice_amount1 = loyaltyPrice.amount) === null || _loyaltyPrice_amount1 === void 0 ? void 0 : _loyaltyPrice_amount1.formatted, " ").concat(loyaltyPrice.unit),
            a11yPrice: otherOption.accessibilityLabel || "",
            strikeThroughPrice: formatStrikeOutText2((_disclaimerForPoints = disclaimerForPoints) === null || _disclaimerForPoints === void 0 ? void 0 : _disclaimerForPoints.strikeOut, loyaltyPrice.totalStrikeOutPoints, loyaltyPrice.unit, otherOption.leadingCaption, true),
            a11yStrikeThroughDialogTrigger: (_disclaimerForPoints1 = disclaimerForPoints) === null || _disclaimerForPoints1 === void 0 ? void 0 : (_disclaimerForPoints_priceDisclaimer = _disclaimerForPoints1.priceDisclaimer) === null || _disclaimerForPoints_priceDisclaimer === void 0 ? void 0 : (_disclaimerForPoints_priceDisclaimer_trigger = _disclaimerForPoints_priceDisclaimer.trigger) === null || _disclaimerForPoints_priceDisclaimer_trigger === void 0 ? void 0 : (_disclaimerForPoints_priceDisclaimer_trigger_icon = _disclaimerForPoints_priceDisclaimer_trigger.icon) === null || _disclaimerForPoints_priceDisclaimer_trigger_icon === void 0 ? void 0 : _disclaimerForPoints_priceDisclaimer_trigger_icon.description
        };
    }
    var leadPrice = leadingCaption ? "".concat(leadingCaption, " ").concat((_displayPrice = displayPrice) === null || _displayPrice === void 0 ? void 0 : _displayPrice.formatted) : (_displayPrice1 = displayPrice) === null || _displayPrice1 === void 0 ? void 0 : _displayPrice1.formatted;
    if (options.length === 1) {
        var _strikeOut, _priceDisclaimer_trigger_icon1, _priceDisclaimer_trigger1, _priceDisclaimer1;
        return {
            lockupPrice: leadPrice,
            a11yPrice: accessibilityLabel || "",
            strikeThroughPrice: (_strikeOut = strikeOut) === null || _strikeOut === void 0 ? void 0 : _strikeOut.formatted,
            a11yStrikeThroughDialogTrigger: (_priceDisclaimer1 = priceDisclaimer) === null || _priceDisclaimer1 === void 0 ? void 0 : (_priceDisclaimer_trigger1 = _priceDisclaimer1.trigger) === null || _priceDisclaimer_trigger1 === void 0 ? void 0 : (_priceDisclaimer_trigger_icon1 = _priceDisclaimer_trigger1.icon) === null || _priceDisclaimer_trigger_icon1 === void 0 ? void 0 : _priceDisclaimer_trigger_icon1.description
        };
    }
    var loyaltyPoints = otherOption.loyaltyPrice;
    return {
        isStrikeThroughFirst: true,
        isPointsFirst: false,
        strikeThroughPrice: formatStrikeOutText2(strikeOut, (_loyaltyPoints = loyaltyPoints) === null || _loyaltyPoints === void 0 ? void 0 : _loyaltyPoints.totalStrikeOutPoints, (_loyaltyPoints1 = loyaltyPoints) === null || _loyaltyPoints1 === void 0 ? void 0 : _loyaltyPoints1.unit, otherOption.leadingCaption, false),
        lockupPrice: leadPrice,
        lockupFormattedPoints: "".concat(otherOption.leadingCaption, " ").concat((_loyaltyPoints2 = loyaltyPoints) === null || _loyaltyPoints2 === void 0 ? void 0 : (_loyaltyPoints_amount = _loyaltyPoints2.amount) === null || _loyaltyPoints_amount === void 0 ? void 0 : _loyaltyPoints_amount.formatted, " ").concat((_loyaltyPoints3 = loyaltyPoints) === null || _loyaltyPoints3 === void 0 ? void 0 : _loyaltyPoints3.unit),
        a11yStrikeThroughDialogTrigger: (_priceDisclaimer = priceDisclaimer) === null || _priceDisclaimer === void 0 ? void 0 : (_priceDisclaimer_trigger = _priceDisclaimer.trigger) === null || _priceDisclaimer_trigger === void 0 ? void 0 : (_priceDisclaimer_trigger_icon = _priceDisclaimer_trigger.icon) === null || _priceDisclaimer_trigger_icon === void 0 ? void 0 : _priceDisclaimer_trigger_icon.description,
        a11yPrice: accessibilityLabel || ""
    };
};
PropertyPaymentPrice.fragment = fragment46;
PropertyPaymentPrice.displayName = "PropertyPaymentPrice";
// src/components/property-offers/__private/__fragments/reserve-button/dialog/property-payment-options.tsx
var fragment47 = gql84(_templateObject84(), PropertyLodgingPrepareCheckout.fragment, PropertyLodgingFormButton.fragment, PropertyPaymentPrice.fragment, PriceSummaryFragment);
var _obj8;
var propertyPaymentTypeToModel = (_obj8 = {}, _define_property(_obj8, "PAY_LATER" /* PAY_LATER */ , "PAY_LATER" /* PAY_LATER */ ), _define_property(_obj8, "PAY_LATER_WITH_DEPOSIT" /* PAY_LATER_WITH_DEPOSIT */ , "PAY_LATER_WITH_DEPOSIT" /* PAY_LATER_WITH_DEPOSIT */ ), _define_property(_obj8, "PAY_NOW" /* PAY_NOW */ , "PAY_NOW" /* PAY_NOW */ ), _obj8);
var trackPaymentOptionClickInEtpDialog = function(param) {
    var noCreditCard = param.noCreditCard, paymentModel = param.paymentModel, propertyNaturalKeys = param.propertyNaturalKeys, track = param.track;
    var LINK_NAME2 = "Book selected room choice";
    var RFRR_MRP_PREFIX2 = "HOT.HIS.MRP.RoomsAndRates.";
    var _propertyNaturalKeys = _sliced_to_array(propertyNaturalKeys, 1), _propertyNaturalKeys_ = _propertyNaturalKeys[0], ratePlanId = _propertyNaturalKeys_.ratePlanId, roomTypeId = _propertyNaturalKeys_.roomTypeId;
    var uisMicroMessage = roomSchema(roomTypeId, [
        {
            ratePlanCode: ratePlanId
        }
    ]);
    var paymentRfrr;
    if (paymentModel === "PAY_LATER" /* PAY_LATER */ ) {
        paymentRfrr = "PayLater";
    } else if (paymentModel === "PAY_LATER_WITH_DEPOSIT" /* PAY_LATER_WITH_DEPOSIT */ ) {
        paymentRfrr = "PayDeposit";
    } else if (noCreditCard) {
        paymentRfrr = "NoCreditCardRequired";
    } else {
        paymentRfrr = "PayNow";
    }
    track("".concat(RFRR_MRP_PREFIX2).concat(paymentRfrr), LINK_NAME2, void 0, [
        uisMicroMessage
    ]);
};
var stidGenerator = function(items) {
    return items.map(function(i) {
        return i.text;
    }).join("-").toLowerCase();
};
var findIcon = function(items) {
    return items.find(function(i) {
        return i.icon;
    });
};
var getListBulletType = function(items) {
    return findIcon(items) ? "icon-alternate" : "default";
};
var HandleCompatibilityCase = function(param) {
    var heading = param.heading, items = param.items, mktDescIndex = param.mktDescIndex;
    var _items;
    return heading && /* @__PURE__ */ React91.createElement(React91.Fragment, null, /* @__PURE__ */ React91.createElement(UitkSpacing41, {
        padding: {
            blockstart: "three"
        },
        key: "policy_description_0"
    }, /* @__PURE__ */ React91.createElement(UitkHeading17, {
        tag: "h3",
        size: 7
    }, heading)), /* @__PURE__ */ React91.createElement(UitkList3, {
        bullet: getListBulletType(items),
        size: 3,
        "data-stid": stidGenerator(items)
    }, (_items = items) === null || _items === void 0 ? void 0 : _items.map(function(param, mktDescItemIndex) {
        var text = param.text, icon = param.icon;
        var _icon;
        return /* @__PURE__ */ React91.createElement(UitkListItem5, {
            key: "policy_".concat(mktDescIndex, "_").concat(mktDescItemIndex),
            "data-stid": "pppdescr-".concat((_icon = icon) === null || _icon === void 0 ? void 0 : _icon.token)
        }, icon && /* @__PURE__ */ React91.createElement(UitkIcon21, {
            name: icon.id,
            className: "pppdescr-".concat(icon.token)
        }), /* @__PURE__ */ React91.createElement(UitkText32, null, text));
    })));
};
var PropertyPaymentPolicyDescriptions = function(param) {
    var descriptions = param.descriptions;
    return descriptions.map(function(param, mktDescIndex) {
        var header = param.header, heading = param.heading, items = param.items;
        var _header_mark_url, _header_mark, _header_mark1, _items;
        return !header ? /* @__PURE__ */ React91.createElement(HandleCompatibilityCase, {
            heading: heading,
            items: items,
            mktDescIndex: mktDescIndex,
            key: "policy_description_".concat(mktDescIndex)
        }) : /* @__PURE__ */ React91.createElement(UitkSpacing41, {
            key: "policy_description_".concat(mktDescIndex)
        }, /* @__PURE__ */ React91.createElement(UitkList3, {
            bullet: getListBulletType(items),
            size: 3,
            "data-stid": stidGenerator(items)
        }, header && /* @__PURE__ */ React91.createElement(UitkListItem5, {
            key: "policy_-_".concat(mktDescIndex)
        }, /* @__PURE__ */ React91.createElement(UitkMark9, {
            url: (_header_mark = header.mark) === null || _header_mark === void 0 ? void 0 : (_header_mark_url = _header_mark.url) === null || _header_mark_url === void 0 ? void 0 : _header_mark_url.value,
            name: (_header_mark1 = header.mark) === null || _header_mark1 === void 0 ? void 0 : _header_mark1.id,
            size: UitkMarkSize9.SMALL
        }), /* @__PURE__ */ React91.createElement(UitkHeading17, {
            tag: "h3",
            size: 7
        }, header.text)), (_items = items) === null || _items === void 0 ? void 0 : _items.map(function(param, mktDescItemIndex) {
            var text = param.text, icon = param.icon;
            var _icon;
            return /* @__PURE__ */ React91.createElement(UitkListItem5, {
                key: "policy_".concat(mktDescIndex, "_").concat(mktDescItemIndex),
                "data-stid": "pppdescr-".concat((_icon = icon) === null || _icon === void 0 ? void 0 : _icon.token)
            }, icon && /* @__PURE__ */ React91.createElement(UitkIcon21, {
                name: icon.id,
                className: "pppdescr-".concat(icon.token)
            }), /* @__PURE__ */ React91.createElement(UitkText32, null, text));
        })));
    });
};
var PropertyPaymentOptions = function(param) {
    var data = param.data, paymentPolicy = param.paymentPolicy, isLastOption = param.isLastOption, paymentModel = param.paymentModel, propertyNaturalKeys = param.propertyNaturalKeys, hotelCollect = param.hotelCollect, noCreditCard = param.noCreditCard, listingIndex = param.listingIndex;
    var _paymentPolicy, _propertyPaymentPolicy_descriptions, _propertyPaymentPolicy;
    var getPaymentOptionsClasses = function(isDivider) {
        return classNames({
            "uitk-card-separator-bottom": isDivider
        });
    };
    var paymentOptionClasses = getPaymentOptionsClasses(!isLastOption);
    var loyaltyMessage = data.loyaltyMessage, offerBookButton = data.offerBookButton, lodgingPrepareCheckout = data.lodgingPrepareCheckout;
    var propertyPaymentPolicy = (_paymentPolicy = paymentPolicy) === null || _paymentPolicy === void 0 ? void 0 : _paymentPolicy.find(function(policy) {
        var _policy;
        return propertyPaymentTypeToModel[(_policy = policy) === null || _policy === void 0 ? void 0 : _policy.paymentType] === paymentModel;
    });
    var firstPolicy = (_propertyPaymentPolicy = propertyPaymentPolicy) === null || _propertyPaymentPolicy === void 0 ? void 0 : (_propertyPaymentPolicy_descriptions = _propertyPaymentPolicy.descriptions) === null || _propertyPaymentPolicy_descriptions === void 0 ? void 0 : _propertyPaymentPolicy_descriptions.find(function(element) {
        return element;
    });
    var track = useClickTracker27();
    var trackReserveButtonClick = function() {
        return trackPaymentOptionClickInEtpDialog({
            noCreditCard: noCreditCard,
            paymentModel: paymentModel,
            propertyNaturalKeys: propertyNaturalKeys,
            track: track
        });
    };
    var RewardsDescriptionList = function() {
        var list = React91.useMemo(function() {
            var _propertyPaymentPolicy_descriptions, _propertyPaymentPolicy;
            return (_propertyPaymentPolicy = propertyPaymentPolicy) === null || _propertyPaymentPolicy === void 0 ? void 0 : (_propertyPaymentPolicy_descriptions = _propertyPaymentPolicy.descriptions) === null || _propertyPaymentPolicy_descriptions === void 0 ? void 0 : _propertyPaymentPolicy_descriptions.filter(function(description, index) {
                var _description;
                return ((_description = description) === null || _description === void 0 ? void 0 : _description.items) && index > 0;
            });
        }, []);
        if (list === void 0) {
            return [];
        }
        return list;
    };
    var isRewardEligible = function() {
        return RewardsDescriptionList().length > 0;
    };
    var propertyPaymentPolicyHeader = function() {
        var _propertyPaymentPolicy, _propertyPaymentPolicy1, _firstPolicy_items, _firstPolicy, _loyaltyMessage, _firstPolicy1;
        return /* @__PURE__ */ React91.createElement("div", null, ((_propertyPaymentPolicy = propertyPaymentPolicy) === null || _propertyPaymentPolicy === void 0 ? void 0 : _propertyPaymentPolicy.heading) && /* @__PURE__ */ React91.createElement(UitkHeading17, {
            tag: "h4",
            size: 7
        }, (_propertyPaymentPolicy1 = propertyPaymentPolicy) === null || _propertyPaymentPolicy1 === void 0 ? void 0 : _propertyPaymentPolicy1.heading), !(!((_firstPolicy = firstPolicy) === null || _firstPolicy === void 0 ? void 0 : (_firstPolicy_items = _firstPolicy.items) === null || _firstPolicy_items === void 0 ? void 0 : _firstPolicy_items.length) && !((_loyaltyMessage = loyaltyMessage) === null || _loyaltyMessage === void 0 ? void 0 : _loyaltyMessage.value)) && /* @__PURE__ */ React91.createElement(UitkList3, {
            className: "uitk-type-list-300",
            "data-stid": "payment-options-details"
        }, (_firstPolicy1 = firstPolicy) === null || _firstPolicy1 === void 0 ? void 0 : _firstPolicy1.items.map(function(item, descItemIndex) {
            return item && /* @__PURE__ */ React91.createElement(PropertyInfoMessage, {
                index: descItemIndex,
                textSize: 300,
                markSize: UitkMarkSize9.SMALL,
                data: item
            });
        })));
    };
    var renderPropertyPaymentPolicyHeaderControl = function() {
        return /* @__PURE__ */ React91.createElement("div", null, propertyPaymentPolicyHeader(), /* @__PURE__ */ React91.createElement(PropertyPaymentPolicyDescriptions, {
            descriptions: RewardsDescriptionList()
        }));
    };
    var propertyPaymentOptionsControl = function() {
        var _propertyPaymentPolicy_price_displayMessages, _propertyPaymentPolicy_price, _propertyPaymentPolicy;
        return /* @__PURE__ */ React91.createElement(UitkSpacing41, {
            padding: {
                block: "six"
            }
        }, /* @__PURE__ */ React91.createElement("div", {
            className: paymentOptionClasses,
            "data-stid": "payment-options"
        }, /* @__PURE__ */ React91.createElement(UitkLayoutFlex22, {
            space: "two",
            justifyContent: "space-between"
        }, /* @__PURE__ */ React91.createElement(UitkLayoutFlexItem15, {
            maxWidth: "half_width"
        }, renderPropertyPaymentPolicyHeaderControl()), /* @__PURE__ */ React91.createElement(UitkLayoutFlexItem15, {
            className: "uitk-type-right"
        }, /* @__PURE__ */ React91.createElement("div", {
            "data-stid": "payment-option-".concat(paymentModel)
        }, ((_propertyPaymentPolicy = propertyPaymentPolicy) === null || _propertyPaymentPolicy === void 0 ? void 0 : (_propertyPaymentPolicy_price = _propertyPaymentPolicy.price) === null || _propertyPaymentPolicy_price === void 0 ? void 0 : (_propertyPaymentPolicy_price_displayMessages = _propertyPaymentPolicy_price.displayMessages) === null || _propertyPaymentPolicy_price_displayMessages === void 0 ? void 0 : _propertyPaymentPolicy_price_displayMessages.length) ? /* @__PURE__ */ React91.createElement(PriceSummary, {
            data: propertyPaymentPolicy.price
        }) : /* @__PURE__ */ React91.createElement(PropertyPaymentPrice, {
            data: data
        }), /* @__PURE__ */ React91.createElement(UitkSpacing41, {
            padding: {
                blockstart: "three"
            }
        }, /* @__PURE__ */ React91.createElement("div", null, /* @__PURE__ */ React91.createElement(PropertyLodgingPrepareCheckoutComponent, {
            isFullWidth: false,
            lodgingPrepareCheckout: lodgingPrepareCheckout,
            offerBookButton: offerBookButton,
            propertyNaturalKeys: propertyNaturalKeys,
            hotelCollect: hotelCollect,
            noCreditCard: noCreditCard,
            trackReserveButtonClick: trackReserveButtonClick,
            listingIndex: listingIndex
        }))))))));
    };
    var priceDisplayAndRewardsDescription = function() {
        var _propertyPaymentPolicy_price_displayMessages, _propertyPaymentPolicy_price, _propertyPaymentPolicy;
        var justifyContentClass = isRewardEligible() ? "space-between" : "end";
        return /* @__PURE__ */ React91.createElement(UitkLayoutFlex22, {
            direction: "row",
            justifyContent: justifyContentClass,
            space: "four",
            wrap: "nowrap"
        }, isRewardEligible() && /* @__PURE__ */ React91.createElement(UitkLayoutFlexItem15, null, /* @__PURE__ */ React91.createElement(PropertyPaymentPolicyDescriptions, {
            descriptions: RewardsDescriptionList()
        })), /* @__PURE__ */ React91.createElement(UitkLayoutFlexItem15, {
            alignSelf: "end"
        }, /* @__PURE__ */ React91.createElement("div", null, ((_propertyPaymentPolicy = propertyPaymentPolicy) === null || _propertyPaymentPolicy === void 0 ? void 0 : (_propertyPaymentPolicy_price = _propertyPaymentPolicy.price) === null || _propertyPaymentPolicy_price === void 0 ? void 0 : (_propertyPaymentPolicy_price_displayMessages = _propertyPaymentPolicy_price.displayMessages) === null || _propertyPaymentPolicy_price_displayMessages === void 0 ? void 0 : _propertyPaymentPolicy_price_displayMessages.length) ? /* @__PURE__ */ React91.createElement(PriceSummary, {
            data: propertyPaymentPolicy.price,
            flexAlignment: "end"
        }) : /* @__PURE__ */ React91.createElement(PropertyPaymentPrice, {
            data: data,
            alignment: UitkPriceLockupAlign3.RIGHT
        }))));
    };
    var propertyPaymentOptionsVariant = function() {
        return /* @__PURE__ */ React91.createElement(UitkLayoutFlex22, {
            blockSize: "full_size"
        }, /* @__PURE__ */ React91.createElement(UitkSpacing41, {
            padding: "four"
        }, /* @__PURE__ */ React91.createElement(UitkLayoutFlexItem15, {
            minWidth: "full_width"
        }, /* @__PURE__ */ React91.createElement(UitkCard13, {
            border: true
        }, /* @__PURE__ */ React91.createElement(UitkLayoutFlex22, {
            direction: "column",
            "data-stid": "payment-options"
        }, /* @__PURE__ */ React91.createElement(UitkLayoutFlexItem15, {
            grow: 1
        }, /* @__PURE__ */ React91.createElement("div", null, propertyPaymentPolicyHeader())), /* @__PURE__ */ React91.createElement(UitkSpacing41, {
            padding: {
                blockstart: "three"
            }
        }, /* @__PURE__ */ React91.createElement(UitkLayoutFlexItem15, {
            grow: 0
        }, /* @__PURE__ */ React91.createElement("div", {
            "data-stid": "payment-option-".concat(paymentModel)
        }, /* @__PURE__ */ React91.createElement(UitkSpacing41, {
            padding: {
                blockend: "three"
            }
        }, priceDisplayAndRewardsDescription()), /* @__PURE__ */ React91.createElement(PropertyLodgingPrepareCheckoutComponent, {
            isFullWidth: true,
            lodgingPrepareCheckout: lodgingPrepareCheckout,
            offerBookButton: offerBookButton,
            propertyNaturalKeys: propertyNaturalKeys,
            hotelCollect: hotelCollect,
            noCreditCard: noCreditCard,
            trackReserveButtonClick: trackReserveButtonClick,
            listingIndex: listingIndex
        })))))))));
    };
    return /* @__PURE__ */ React91.createElement(Viewport13, null, /* @__PURE__ */ React91.createElement(ViewSmall12, null, /* @__PURE__ */ React91.createElement(Experiment3, {
        name: "ETP_Layout_Redesign_mWeb"
    }, /* @__PURE__ */ React91.createElement(ExperimentControl3, null, propertyPaymentOptionsControl()), /* @__PURE__ */ React91.createElement(ExperimentVariant3, {
        bucket: 1
    }, propertyPaymentOptionsVariant()))), /* @__PURE__ */ React91.createElement(ViewMedium10, null, /* @__PURE__ */ React91.createElement(Experiment3, {
        name: "ETP_Layout_Redesign_Desktop"
    }, /* @__PURE__ */ React91.createElement(ExperimentControl3, null, propertyPaymentOptionsControl()), /* @__PURE__ */ React91.createElement(ExperimentVariant3, {
        bucket: 1
    }, propertyPaymentOptionsVariant()))));
};
PropertyPaymentOptions.fragment = fragment47;
PropertyPaymentOptions.displayName = "PropertyPaymentOptions";
// src/components/property-offers/__private/__fragments/reserve-button/property-reserve-button.tsx
var fragment48 = gql85(_templateObject85(), LodgingEGDSGraphicText.fragment, PropertyLodgingFormButton.fragment, MessageResult.fragment, PropertyPaymentOptions.fragment, LodgingSignInDialog.fragment, DatelessCheckAvailability.fragment);
var LINK_NAME = "Book selected room choice";
var RFRR_MRP_PREFIX = "HOT.HIS.MRP";
var RFRR_PREFIX = "HOT.HIS" /* Infosite */ ;
var START_DATE_REF_NAME2 = "startDate";
var getMicroMessages = function(priceDetails) {
    var _priceDetails_;
    var ratePlanCodes = priceDetails.map(function(param) {
        var propertyNaturalKeys = param.propertyNaturalKeys;
        var _propertyNaturalKeys_;
        return {
            ratePlanCode: (_propertyNaturalKeys_ = propertyNaturalKeys[0]) === null || _propertyNaturalKeys_ === void 0 ? void 0 : _propertyNaturalKeys_.ratePlanId
        };
    });
    var roomTypeId = (((_priceDetails_ = priceDetails[0]) === null || _priceDetails_ === void 0 ? void 0 : _priceDetails_.propertyNaturalKeys[0]) || {}).roomTypeId;
    var uisMicroMessage = roomSchema(roomTypeId, ratePlanCodes);
    return [
        uisMicroMessage
    ];
};
var getDealMarker = function(priceDetails) {
    var _priceDetails_;
    var marker = (_priceDetails_ = priceDetails[0]) === null || _priceDetails_ === void 0 ? void 0 : _priceDetails_.dealMarker;
    var markerMessage = marker ? ":BD:".concat(marker) : "";
    return markerMessage;
};
var trackReserveClickToCheckout = function(param) {
    var listingIndex = param.listingIndex, noCreditCard = param.noCreditCard, ratePlanIndex = param.ratePlanIndex, rfrrSuffix = param.rfrrSuffix, trackClick = param.trackClick, priceDetails = param.priceDetails, isWithinDetailsDialog = param.isWithinDetailsDialog;
    var uisMicroMessages = getMicroMessages(priceDetails);
    if (noCreditCard) {
        trackClick("".concat(RFRR_MRP_PREFIX, ".").concat(rfrrSuffix, ".NoCreditCardRequired"), LINK_NAME);
    } else {
        var rfrrBasePrefix = isWithinDetailsDialog ? RFRR_PREFIX : RFRR_MRP_PREFIX;
        var rfrrBaseSuffix = isWithinDetailsDialog ? "RoomInfoDialog.RoomsAndRates" /* Dialog */  : "RoomsAndRates" /* Standard */ ;
        var dealMarker = getDealMarker(priceDetails);
        trackClick("".concat(rfrrBasePrefix, ".").concat(rfrrBaseSuffix, ".BookButton.Room").concat(listingIndex, ".Rate").concat(ratePlanIndex).concat(dealMarker), LINK_NAME, void 0, uisMicroMessages);
    }
};
var trackEtpDialogButtonClick = function(param) {
    var isPayLater = param.isPayLater, isPayWithDeposit = param.isPayWithDeposit, listingIndex = param.listingIndex, noCreditCard = param.noCreditCard, ratePlanIndex = param.ratePlanIndex, rfrrSuffix = param.rfrrSuffix, trackClick = param.trackClick, priceDetails = param.priceDetails, isWithinDetailsDialog = param.isWithinDetailsDialog;
    var uisMicroMessages = getMicroMessages(priceDetails);
    var rfrrBasePrefix = isWithinDetailsDialog ? RFRR_PREFIX : RFRR_MRP_PREFIX;
    var rfrrBaseSuffix = isWithinDetailsDialog ? "RoomInfoDialog.RoomsAndRates" /* Dialog */  : "RoomsAndRates" /* Standard */ ;
    var dealMarker = getDealMarker(priceDetails);
    trackClick("".concat(rfrrBasePrefix, ".").concat(rfrrBaseSuffix, ".BookButton.Room").concat(listingIndex, ".Rate").concat(ratePlanIndex).concat(dealMarker), LINK_NAME, void 0, uisMicroMessages);
    if (isPayLater || isPayWithDeposit) {
        var paymentOption = isPayLater ? "PAY_LATER" /* PAY_LATER */  : "PAY_LATER_WITH_DEPOSIT" /* PAY_LATER_WITH_DEPOSIT */ ;
        trackClick("".concat(RFRR_PREFIX, ".").concat(rfrrSuffix, ".OpenEtpDialog"), "User opening payment options dialog");
        trackClick("".concat(RFRR_PREFIX, ".").concat(rfrrSuffix, ".EtpDialogOption.").concat(paymentOption), "User opened etp modal with ".concat(paymentOption, " option"));
        if (noCreditCard) {
            trackClick("".concat(RFRR_PREFIX, ".").concat(rfrrSuffix, ".EtpDialogOption.noCCRequired"), "User opened etp modal with noCCRequired option");
        }
    }
};
var PropertyReserveButton = function(param) {
    var data = param.data, dialogSuffix = param.dialogSuffix, isEtpCallToActionDisabled = param.isEtpCallToActionDisabled, isFullWidth = param.isFullWidth, listingIndex = param.listingIndex, paymentPolicy = param.paymentPolicy, rfrrSuffix = param.rfrrSuffix, showLargeBtn = param.showLargeBtn;
    var _reserveCallToAction, _reserveCallToAction1, _reserveCallToAction2, _reserveCallToAction3;
    var etpDialogTopMessage = data.etpDialogTopMessage, ratePlanId = data.id, priceDetails = data.priceDetails, reserveCallToAction = data.reserveCallToAction;
    var dialogPostfix = useDialogId();
    var _useDialog14 = _sliced_to_array(useDialog14("payment-".concat(dialogPostfix), "pwaPaymentDialog"), 3), isPaymentDialogOpen = _useDialog14[0], paymentDialogActions = _useDialog14[1], PaymentDialogComponent = _useDialog14[2];
    var isWithinDetailsDialog = React92.useContext(dialog_context_default);
    var _React92_useContext = React92.useContext(UnitRateContext), _React92_useContext_ratePlanIndex = _React92_useContext.ratePlanIndex, ratePlanIndex = _React92_useContext_ratePlanIndex === void 0 ? 1 : _React92_useContext_ratePlanIndex;
    var paymentOptionsTrigger = React92.useRef(null);
    var trackClick = useClickTracker28();
    var _useExperiment = useExperiment("Add_Currency_Code_to_Deposit_option_on_ETP_Web"), exposure = _useExperiment.exposure, logExperiment = _useExperiment.logExperiment;
    if (!reserveCallToAction) {
        return null;
    }
    var hasMultiplePaymentTypes = priceDetails && priceDetails.length > 1;
    var isPayWithDeposit = hasMultiplePaymentTypes && priceDetails.some(function(it) {
        return it.paymentModel === "PAY_LATER_WITH_DEPOSIT" /* PAY_LATER_WITH_DEPOSIT */ ;
    });
    var isPayLater = hasMultiplePaymentTypes && priceDetails.some(function(it) {
        return it.paymentModel === "PAY_LATER" /* PAY_LATER */ ;
    });
    var isNoCC = hasMultiplePaymentTypes && priceDetails.some(function(it) {
        return it.noCreditCard;
    });
    var closePaymentDialog = function() {
        var _paymentOptionsTrigger;
        paymentDialogActions.closeDialog();
        trackClick("".concat(RFRR_PREFIX, ".EtpDialog.Close"), "close payment options dialog");
        var focusElem = (_paymentOptionsTrigger = paymentOptionsTrigger) === null || _paymentOptionsTrigger === void 0 ? void 0 : _paymentOptionsTrigger.current;
        if (focusElem && typeof focusElem.focus === "function") {
            focusElem.focus();
        }
    };
    var openPaymentDialog = function() {
        paymentDialogActions.openDialog();
        if (isPayWithDeposit) {
            logExperiment(exposure);
        }
        trackEtpDialogButtonClick({
            isPayLater: isPayLater,
            isPayWithDeposit: isPayWithDeposit,
            listingIndex: listingIndex,
            noCreditCard: isNoCC,
            priceDetails: priceDetails,
            ratePlanIndex: ratePlanIndex,
            rfrrSuffix: rfrrSuffix,
            trackClick: trackClick,
            isWithinDetailsDialog: isWithinDetailsDialog
        });
    };
    var renderETPLayoutExperimentVariantContent = function() {
        var _reserveCallToAction, _etpDialogFragment_content, _etpDialogFragment, _etpDialogFragment_content_messages, _etpDialogFragment_content1, _etpDialogFragment1, _priceDetails;
        var propertyPaymentOptionsColSpan = priceDetails.length > 1 ? {
            small: 2,
            medium: 1
        } : 2;
        var etpDialogFragment = null;
        if (((_reserveCallToAction = reserveCallToAction) === null || _reserveCallToAction === void 0 ? void 0 : _reserveCallToAction.__typename) === "EtpDialog" && !isEtpCallToActionDisabled) {
            etpDialogFragment = reserveCallToAction;
        }
        return /* @__PURE__ */ React92.createElement(React92.Fragment, null, /* @__PURE__ */ React92.createElement(UitkSpacing42, {
            padding: {
                blockend: "two"
            }
        }, /* @__PURE__ */ React92.createElement(UitkLayoutGridItem12, {
            colSpan: 2
        }, ((_etpDialogFragment = etpDialogFragment) === null || _etpDialogFragment === void 0 ? void 0 : (_etpDialogFragment_content = _etpDialogFragment.content) === null || _etpDialogFragment_content === void 0 ? void 0 : _etpDialogFragment_content.messages) && /* @__PURE__ */ React92.createElement("div", null, (_etpDialogFragment1 = etpDialogFragment) === null || _etpDialogFragment1 === void 0 ? void 0 : (_etpDialogFragment_content1 = _etpDialogFragment1.content) === null || _etpDialogFragment_content1 === void 0 ? void 0 : (_etpDialogFragment_content_messages = _etpDialogFragment_content1.messages) === null || _etpDialogFragment_content_messages === void 0 ? void 0 : _etpDialogFragment_content_messages.map(function(etpMessage, etpMessageIndex) {
            var __typename = etpMessage.__typename, text = etpMessage.text, graphic = etpMessage.graphic;
            return etpMessage && /* @__PURE__ */ React92.createElement(UitkSpacing42, {
                padding: {
                    block: "one"
                },
                key: "etp-message-".concat(etpMessageIndex)
            }, /* @__PURE__ */ React92.createElement("div", null, /* @__PURE__ */ React92.createElement(LodgingEGDSGraphicText, {
                key: "etp-message-".concat(etpMessageIndex),
                data: {
                    __typename: __typename,
                    text: text,
                    graphic: graphic
                },
                customTextSize: 300
            })));
        })))), (_priceDetails = priceDetails) === null || _priceDetails === void 0 ? void 0 : _priceDetails.map(function(priceDetail2, priceDetailIndex) {
            var _priceDetail2;
            return priceDetail2 && /* @__PURE__ */ React92.createElement(UitkLayoutGridItem12, {
                colSpan: propertyPaymentOptionsColSpan,
                key: "price-details-".concat(priceDetailIndex)
            }, /* @__PURE__ */ React92.createElement("div", null, /* @__PURE__ */ React92.createElement(PropertyPaymentOptions, {
                data: priceDetail2,
                paymentPolicy: paymentPolicy,
                isLastOption: priceDetails.length - 1 === priceDetailIndex,
                paymentModel: (_priceDetail2 = priceDetail2) === null || _priceDetail2 === void 0 ? void 0 : _priceDetail2.paymentModel,
                propertyNaturalKeys: priceDetail2.propertyNaturalKeys,
                hotelCollect: priceDetail2.hotelCollect,
                noCreditCard: priceDetail2.noCreditCard,
                listingIndex: listingIndex
            })));
        }));
    };
    if (((_reserveCallToAction = reserveCallToAction) === null || _reserveCallToAction === void 0 ? void 0 : _reserveCallToAction.__typename) === "LodgingMemberSignInDialog") {
        return /* @__PURE__ */ React92.createElement(LodgingSignInDialog, {
            data: reserveCallToAction,
            showLargeBtn: showLargeBtn,
            isFullWidth: isFullWidth,
            dialogId: "lodging-signin-dialog-".concat(ratePlanId, "-").concat(dialogSuffix)
        });
    }
    if (((_reserveCallToAction1 = reserveCallToAction) === null || _reserveCallToAction1 === void 0 ? void 0 : _reserveCallToAction1.__typename) === "DatelessCheckAvailability") {
        return /* @__PURE__ */ React92.createElement(DatelessCheckAvailability, {
            data: reserveCallToAction,
            clickRefTarget: START_DATE_REF_NAME2
        });
    }
    if (((_reserveCallToAction2 = reserveCallToAction) === null || _reserveCallToAction2 === void 0 ? void 0 : _reserveCallToAction2.__typename) === "EtpDialog" && !isEtpCallToActionDisabled) {
        var _toolbar, _toolbar_icon, _toolbar1, _reserveCallToAction_content, _reserveCallToAction4, _reserveCallToAction_content_messages, _reserveCallToAction_content1, _reserveCallToAction5, _priceDetails;
        var etpDialogFragment = reserveCallToAction;
        var trigger = etpDialogFragment.trigger, toolbar = etpDialogFragment.toolbar;
        var _toolbar_title;
        var dialogControlContent = /* @__PURE__ */ React92.createElement(React92.Fragment, null, /* @__PURE__ */ React92.createElement(UitkToolbar8, {
            toolbarTitle: (_toolbar_title = (_toolbar = toolbar) === null || _toolbar === void 0 ? void 0 : _toolbar.title) !== null && _toolbar_title !== void 0 ? _toolbar_title : void 0,
            navigationContent: {
                onClick: closePaymentDialog,
                navIconLabel: (_toolbar1 = toolbar) === null || _toolbar1 === void 0 ? void 0 : (_toolbar_icon = _toolbar1.icon) === null || _toolbar_icon === void 0 ? void 0 : _toolbar_icon.description
            }
        }), /* @__PURE__ */ React92.createElement(UitkSheetContent3, {
            padded: false
        }, etpDialogTopMessage && /* @__PURE__ */ React92.createElement("div", {
            className: "uitk-card-separator-bottom"
        }, /* @__PURE__ */ React92.createElement(MessageResult, {
            data: etpDialogTopMessage
        })), ((_reserveCallToAction4 = reserveCallToAction) === null || _reserveCallToAction4 === void 0 ? void 0 : (_reserveCallToAction_content = _reserveCallToAction4.content) === null || _reserveCallToAction_content === void 0 ? void 0 : _reserveCallToAction_content.messages) && /* @__PURE__ */ React92.createElement(UitkSpacing42, {
            margin: {
                inline: "three"
            }
        }, /* @__PURE__ */ React92.createElement("div", null, (_reserveCallToAction5 = reserveCallToAction) === null || _reserveCallToAction5 === void 0 ? void 0 : (_reserveCallToAction_content1 = _reserveCallToAction5.content) === null || _reserveCallToAction_content1 === void 0 ? void 0 : (_reserveCallToAction_content_messages = _reserveCallToAction_content1.messages) === null || _reserveCallToAction_content_messages === void 0 ? void 0 : _reserveCallToAction_content_messages.map(function(etpMessage, etpMessageIndex) {
            var __typename = etpMessage.__typename, text = etpMessage.text, graphic = etpMessage.graphic;
            return etpMessage && /* @__PURE__ */ React92.createElement(UitkSpacing42, {
                padding: {
                    block: "three"
                },
                key: "etp-message-".concat(etpMessageIndex)
            }, /* @__PURE__ */ React92.createElement("div", null, /* @__PURE__ */ React92.createElement(LodgingEGDSGraphicText, {
                key: "etp-message-".concat(etpMessageIndex),
                data: {
                    __typename: __typename,
                    text: text,
                    graphic: graphic
                },
                customTextSize: 300
            })));
        }))), /* @__PURE__ */ React92.createElement(UitkSpacing42, {
            padding: {
                inline: "three"
            }
        }, /* @__PURE__ */ React92.createElement("section", {
            "data-stid": "content-payment-options"
        }, (_priceDetails = priceDetails) === null || _priceDetails === void 0 ? void 0 : _priceDetails.map(function(priceDetail2, priceDetailIndex) {
            var _priceDetail2;
            return priceDetail2 && /* @__PURE__ */ React92.createElement(PropertyPaymentOptions, {
                key: "price-details-".concat(priceDetailIndex),
                data: priceDetail2,
                paymentPolicy: paymentPolicy,
                isLastOption: priceDetails.length - 1 === priceDetailIndex,
                paymentModel: (_priceDetail2 = priceDetail2) === null || _priceDetail2 === void 0 ? void 0 : _priceDetail2.paymentModel,
                propertyNaturalKeys: priceDetail2.propertyNaturalKeys,
                hotelCollect: priceDetail2.hotelCollect,
                noCreditCard: priceDetail2.noCreditCard,
                listingIndex: listingIndex
            });
        })))));
        var sheetProps = {
            isVisible: isPaymentDialogOpen,
            triggerRef: paymentOptionsTrigger,
            returnFocusOnClose: true
        };
        var controlLayoutForDialog = function() {
            var _trigger, _trigger1, _trigger2;
            return /* @__PURE__ */ React92.createElement(React92.Fragment, null, /* @__PURE__ */ React92.createElement(UitkPrimaryButton8, {
                size: showLargeBtn ? UitkButtonSize7.LARGE : UitkButtonSize7.MEDIUM,
                onClick: openPaymentDialog,
                isFullWidth: isFullWidth,
                domRef: paymentOptionsTrigger,
                "data-stid": "submit-hotel-reserve"
            }, /* @__PURE__ */ React92.createElement(React92.Fragment, null, ((_trigger = trigger) === null || _trigger === void 0 ? void 0 : _trigger.accessibilityLabel) && /* @__PURE__ */ React92.createElement("span", {
                className: "is-visually-hidden"
            }, trigger.accessibilityLabel), /* @__PURE__ */ React92.createElement("span", {
                "aria-hidden": ((_trigger1 = trigger) === null || _trigger1 === void 0 ? void 0 : _trigger1.accessibilityLabel) !== null
            }, (_trigger2 = trigger) === null || _trigger2 === void 0 ? void 0 : _trigger2.value))), /* @__PURE__ */ React92.createElement(PaymentDialogComponent, null, /* @__PURE__ */ React92.createElement(Viewport14, null, /* @__PURE__ */ React92.createElement(ViewSmall13, null, /* @__PURE__ */ React92.createElement(UitkSheet8, _object_spread_props(_object_spread({}, sheetProps), {
                type: "full"
            }), dialogControlContent)), /* @__PURE__ */ React92.createElement(ViewMedium11, null, /* @__PURE__ */ React92.createElement(UitkSheet8, _object_spread_props(_object_spread({}, sheetProps), {
                type: "centered"
            }), dialogControlContent)))));
        };
        var variantLayoutForDialog = function() {
            var _trigger, _trigger1, _trigger2, _toolbar, _toolbar_icon, _toolbar1, _toolbar2, _toolbar_icon1, _toolbar3;
            var _toolbar_title, _toolbar_title1;
            return /* @__PURE__ */ React92.createElement(React92.Fragment, null, /* @__PURE__ */ React92.createElement(UitkPrimaryButton8, {
                size: showLargeBtn ? UitkButtonSize7.LARGE : UitkButtonSize7.MEDIUM,
                onClick: openPaymentDialog,
                isFullWidth: isFullWidth,
                domRef: paymentOptionsTrigger,
                "data-stid": "submit-hotel-reserve"
            }, /* @__PURE__ */ React92.createElement(React92.Fragment, null, ((_trigger = trigger) === null || _trigger === void 0 ? void 0 : _trigger.accessibilityLabel) && /* @__PURE__ */ React92.createElement("span", {
                className: "is-visually-hidden"
            }, trigger.accessibilityLabel), /* @__PURE__ */ React92.createElement("span", {
                "aria-hidden": ((_trigger1 = trigger) === null || _trigger1 === void 0 ? void 0 : _trigger1.accessibilityLabel) !== null
            }, (_trigger2 = trigger) === null || _trigger2 === void 0 ? void 0 : _trigger2.value))), /* @__PURE__ */ React92.createElement(PaymentDialogComponent, null, /* @__PURE__ */ React92.createElement(Viewport14, null, /* @__PURE__ */ React92.createElement(ViewSmall13, null, /* @__PURE__ */ React92.createElement(UitkSheet8, _object_spread_props(_object_spread({}, sheetProps), {
                type: "full"
            }), /* @__PURE__ */ React92.createElement(UitkToolbar8, {
                toolbarTitle: (_toolbar_title = (_toolbar = toolbar) === null || _toolbar === void 0 ? void 0 : _toolbar.title) !== null && _toolbar_title !== void 0 ? _toolbar_title : void 0,
                navigationContent: {
                    onClick: closePaymentDialog,
                    navIconLabel: (_toolbar1 = toolbar) === null || _toolbar1 === void 0 ? void 0 : (_toolbar_icon = _toolbar1.icon) === null || _toolbar_icon === void 0 ? void 0 : _toolbar_icon.description
                }
            }), /* @__PURE__ */ React92.createElement(UitkSpacing42, {
                padding: {
                    blockstart: "four",
                    blockend: "four",
                    inline: "four"
                }
            }, /* @__PURE__ */ React92.createElement(UitkSheetContent3, {
                padded: false
            }, /* @__PURE__ */ React92.createElement(UitkLayoutGrid13, {
                columns: 1,
                space: {
                    row: "three"
                },
                "data-stid": "content-payment-options"
            }, renderETPLayoutExperimentVariantContent()))))), /* @__PURE__ */ React92.createElement(ViewMedium11, null, /* @__PURE__ */ React92.createElement(UitkSheet8, _object_spread_props(_object_spread({}, sheetProps), {
                type: "centered"
            }), /* @__PURE__ */ React92.createElement(UitkToolbar8, {
                toolbarTitle: (_toolbar_title1 = (_toolbar2 = toolbar) === null || _toolbar2 === void 0 ? void 0 : _toolbar2.title) !== null && _toolbar_title1 !== void 0 ? _toolbar_title1 : void 0,
                navigationContent: {
                    onClick: closePaymentDialog,
                    navIconLabel: (_toolbar3 = toolbar) === null || _toolbar3 === void 0 ? void 0 : (_toolbar_icon1 = _toolbar3.icon) === null || _toolbar_icon1 === void 0 ? void 0 : _toolbar_icon1.description
                }
            }), /* @__PURE__ */ React92.createElement(UitkSpacing42, {
                padding: {
                    blockstart: "four",
                    blockend: "four",
                    inline: "four"
                }
            }, /* @__PURE__ */ React92.createElement(UitkSheetContent3, {
                padded: false
            }, /* @__PURE__ */ React92.createElement(UitkLayoutGrid13, {
                columns: 2,
                space: {
                    column: "three"
                },
                "data-stid": "content-payment-options"
            }, renderETPLayoutExperimentVariantContent()))))))));
        };
        return /* @__PURE__ */ React92.createElement(Viewport14, null, /* @__PURE__ */ React92.createElement(ViewSmall13, null, /* @__PURE__ */ React92.createElement(Experiment4, {
            name: "ETP_Layout_Redesign_mWeb",
            logExposure: isPaymentDialogOpen
        }, /* @__PURE__ */ React92.createElement(ExperimentControl4, null, controlLayoutForDialog()), /* @__PURE__ */ React92.createElement(ExperimentVariant4, {
            bucket: 1
        }, variantLayoutForDialog()))), /* @__PURE__ */ React92.createElement(ViewMedium11, null, /* @__PURE__ */ React92.createElement(Experiment4, {
            name: "ETP_Layout_Redesign_Desktop",
            logExposure: isPaymentDialogOpen
        }, /* @__PURE__ */ React92.createElement(ExperimentControl4, null, controlLayoutForDialog()), /* @__PURE__ */ React92.createElement(ExperimentVariant4, {
            bucket: 1
        }, variantLayoutForDialog()))));
    }
    var priceDetail = priceDetails[0];
    var lodgingFormFragment = ((_reserveCallToAction3 = reserveCallToAction) === null || _reserveCallToAction3 === void 0 ? void 0 : _reserveCallToAction3.__typename) === "EtpDialog" ? priceDetail.offerBookButton : reserveCallToAction;
    var noCreditCard = priceDetail.noCreditCard, hotelCollect = priceDetail.hotelCollect, lodgingPrepareCheckout = priceDetail.lodgingPrepareCheckout;
    var trackReserveButtonClick = function() {
        trackReserveClickToCheckout({
            listingIndex: listingIndex,
            noCreditCard: noCreditCard,
            ratePlanIndex: ratePlanIndex,
            rfrrSuffix: rfrrSuffix,
            trackClick: trackClick,
            priceDetails: priceDetails,
            isWithinDetailsDialog: isWithinDetailsDialog
        });
    };
    return /* @__PURE__ */ React92.createElement(PropertyLodgingPrepareCheckoutComponent, {
        lodgingPrepareCheckout: lodgingPrepareCheckout,
        offerBookButton: lodgingFormFragment,
        isFullWidth: isFullWidth,
        trackReserveButtonClick: trackReserveButtonClick,
        propertyNaturalKeys: priceDetail.propertyNaturalKeys,
        hotelCollect: hotelCollect,
        noCreditCard: noCreditCard,
        priceDetail: priceDetail,
        showLargeBtn: showLargeBtn,
        listingIndex: listingIndex
    });
};
PropertyReserveButton.fragment = fragment48;
PropertyReserveButton.displayName = "PropertyReserveButton";
// src/components/property-offers/__private/__fragments/rate-plan/amenities/rate-plan-amenities.tsx
import React93 from "react";
import { gql as gql86 } from "@apollo/client";
import { useClickTracker as useClickTracker29 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog15 } from "@shared-ui/dialog-context";
import { UitkDialogContent as UitkDialogContent10 } from "uitk-react-dialog";
import { UitkIcon as UitkIcon22, UitkIconSize as UitkIconSize17 } from "uitk-react-icons";
import { UitkMoreInfoTrigger as UitkMoreInfoTrigger3 } from "uitk-react-more-info-trigger";
import { UitkSheet as UitkSheet9 } from "uitk-react-sheet";
import { UitkSpacing as UitkSpacing43 } from "uitk-react-spacing";
import { UitkText as UitkText33 } from "uitk-react-text";
import { UitkToolbar as UitkToolbar9 } from "uitk-react-toolbar";
import { UitkUnformattedHtml as UitkUnformattedHtml6 } from "uitk-react-unformatted-html";
var fragment49 = gql86(_templateObject86());
var RatePlanAmenities = function(param) {
    var data = param.data, _param_textSize = param.textSize, textSize = _param_textSize === void 0 ? 200 : _param_textSize, listingIndex = param.listingIndex;
    var _icon, _icon1, _icon2, _icon3;
    var additionalInformation = data.additionalInformation, description = data.description, icon = data.icon;
    var dialogPostfix = useDialogId();
    var _useDialog15 = _sliced_to_array(useDialog15("rate-plan-additional-info-".concat(dialogPostfix), "pwaDialogNested"), 3), dialogActions = _useDialog15[1], DialogComponent = _useDialog15[2];
    var track = useClickTracker29();
    var triggerRef = React93.useRef(null);
    var onAdditionalInfoClick = React93.useCallback(function() {
        track("HOT.HIS.specialdealsinfo", "Open Special Deals Info Dialog");
        dialogActions.openDialog();
    }, [
        track,
        dialogActions
    ]);
    var handleToolbarClick = React93.useCallback(function() {
        dialogActions.closeDialog();
    }, [
        dialogActions
    ]);
    return /* @__PURE__ */ React93.createElement(React93.Fragment, null, /* @__PURE__ */ React93.createElement(UitkText33, {
        size: textSize,
        theme: "default",
        inline: true
    }, /* @__PURE__ */ React93.createElement(UitkSpacing43, {
        margin: {
            inlineend: "two"
        }
    }, /* @__PURE__ */ React93.createElement(UitkIcon22, {
        name: ((_icon = icon) === null || _icon === void 0 ? void 0 : _icon.id.toLowerCase()) || "done",
        description: ((_icon1 = icon) === null || _icon1 === void 0 ? void 0 : _icon1.description) || "",
        id: ((_icon2 = icon) === null || _icon2 === void 0 ? void 0 : _icon2.id) || "done",
        size: ((_icon3 = icon) === null || _icon3 === void 0 ? void 0 : _icon3.size) ? UitkIconSize17[icon.size] : UitkIconSize17.SMALL
    })), !additionalInformation && description, " ", additionalInformation && /* @__PURE__ */ React93.createElement(UitkMoreInfoTrigger3, {
        size: "small"
    }, /* @__PURE__ */ React93.createElement("button", {
        onClick: onAdditionalInfoClick,
        type: "button",
        ref: triggerRef
    }, /* @__PURE__ */ React93.createElement("span", null, description), /* @__PURE__ */ React93.createElement(UitkIcon22, {
        name: "info_outline",
        size: UitkIconSize17.SMALL
    })))), additionalInformation && /* @__PURE__ */ React93.createElement(DialogComponent, null, /* @__PURE__ */ React93.createElement(UitkSheet9, {
        type: "centered",
        isVisible: true,
        triggerRef: triggerRef,
        returnFocusOnClose: true
    }, /* @__PURE__ */ React93.createElement(UitkToolbar9, {
        toolbarTitle: description !== null && description !== void 0 ? description : void 0,
        navigationContent: {
            navType: "close",
            onClick: handleToolbarClick
        }
    }), /* @__PURE__ */ React93.createElement(UitkDialogContent10, null, /* @__PURE__ */ React93.createElement(UitkSpacing43, {
        margin: "six",
        padding: {
            blockstart: "six",
            inline: "six"
        }
    }, /* @__PURE__ */ React93.createElement(UitkUnformattedHtml6, {
        htmlToParse: additionalInformation
    }))))));
};
RatePlanAmenities.fragment = fragment49;
RatePlanAmenities.displayName = "RatePlanAmenities";
// src/components/property-offers/__private/__fragments/rate-plan/rate-plan-analytics-tracker.tsx
import React94 from "react";
import { gql as gql87 } from "@apollo/client";
import { IntersectionTracker as IntersectionTracker6 } from "@shared-ui/clickstream-analytics-context";
var fragment50 = gql87(_templateObject87());
var RatePlanAnalyticsTracker = function(param) {
    var children = param.children, data = param.data, ratePlanId = param.ratePlanId;
    var _clientSideAnalytics, _clientSideAnalytics1, _clientSideAnalytics2;
    var clientSideAnalytics = data.clientSideAnalytics;
    var _clientSideAnalytics_referrerId, _clientSideAnalytics_linkName;
    return /* @__PURE__ */ React94.createElement(IntersectionTracker6, {
        referrerId: (_clientSideAnalytics_referrerId = (_clientSideAnalytics = clientSideAnalytics) === null || _clientSideAnalytics === void 0 ? void 0 : _clientSideAnalytics.referrerId) !== null && _clientSideAnalytics_referrerId !== void 0 ? _clientSideAnalytics_referrerId : "",
        linkName: (_clientSideAnalytics_linkName = (_clientSideAnalytics1 = clientSideAnalytics) === null || _clientSideAnalytics1 === void 0 ? void 0 : _clientSideAnalytics1.linkName) !== null && _clientSideAnalytics_linkName !== void 0 ? _clientSideAnalytics_linkName : "",
        additionalUisPrimeMicroMessages: (_clientSideAnalytics2 = clientSideAnalytics) === null || _clientSideAnalytics2 === void 0 ? void 0 : _clientSideAnalytics2.uisPrimeMessages.map(function(msg) {
            return {
                messageContent: JSON.parse(msg.messageContent),
                schemaName: msg.schemaName
            };
        }),
        intersectionOptions: {
            threshold: 0.5
        },
        deps: [
            ratePlanId
        ]
    }, children);
};
RatePlanAnalyticsTracker.fragment = fragment50;
RatePlanAnalyticsTracker.displayName = "RatePlanAnalyticsTracker";
// src/components/property-offers/__private/__fragments/rate-plan/rate-plan-with-amenities.tsx
var fragment51 = gql88(_templateObject88(), PropertyFeatures.fragment, MarketingSection.fragment, LodgingHighlightedMessages.fragment, PropertyOffersRateViewScarcity.fragment, LodgingPriceSummary.fragment, PriceBreakdownSummary.fragment, PropertyRatePlanBadge.fragment, RatePlanAmenities.fragment, PropertyReserveButton.fragment, PropertyOffersPriceChangeMessage.fragment, LodgingEnrichedMessage.fragment, PriceSummaryFragment, PricePresentationDialog.fragment, PropertyInfoMessage.fragment, RatePlanAnalyticsTracker.fragment);
var ROOM_INFO_ETP_DIALOG_QUERY_PARAM = "infosite-room-info-dialog-ratePlans";
var RatePlanWithAmenities = function(param) {
    var data = param.data, listingIndex = param.listingIndex, roomId = param.roomId, _param_amenityTextSize = param.amenityTextSize, amenityTextSize = _param_amenityTextSize === void 0 ? 200 : _param_amenityTextSize;
    var _priceDetail, _priceDetail_price_displayMessages, _priceDetail_price;
    var _data_priceDetails = _sliced_to_array(data.priceDetails, 1), priceDetail = _data_priceDetails[0], amenities = data.amenities, loyaltyMessage = data.loyaltyMessage, marketingSection = data.marketingSection, shareUrl = data.shareUrl, paymentPolicy = data.paymentPolicy, id = data.id;
    var isWithinDetailsDialog = React95.useContext(dialog_context_default);
    if (!priceDetail) {
        return null;
    }
    return /* @__PURE__ */ React95.createElement(RatePlanAnalyticsTracker, {
        data: data,
        ratePlanId: id
    }, ((_priceDetail = priceDetail) === null || _priceDetail === void 0 ? void 0 : _priceDetail.optionTitle) && /* @__PURE__ */ React95.createElement(UitkHeading18, {
        tag: "h4",
        size: 7
    }, priceDetail.optionTitle.text), /* @__PURE__ */ React95.createElement(PropertyOffersPriceChangeMessage, {
        data: data
    }), /* @__PURE__ */ React95.createElement(UitkLayoutFlex23, {
        justifyContent: "space-between",
        wrap: "nowrap"
    }, /* @__PURE__ */ React95.createElement(UitkLayoutFlexItem16, {
        grow: 1
    }, /* @__PURE__ */ React95.createElement("div", null, /* @__PURE__ */ React95.createElement(LodgingHighlightedMessages, {
        data: data
    }), /* @__PURE__ */ React95.createElement("ul", {
        className: "no-bullet"
    }, amenities.map(function(amenity, amenityIndex) {
        return /* @__PURE__ */ React95.createElement(UitkSpacing44, {
            key: "rate-plan-amenity-".concat(amenityIndex),
            padding: {
                blockend: "one"
            }
        }, /* @__PURE__ */ React95.createElement("li", null, /* @__PURE__ */ React95.createElement(RatePlanAmenities, {
            textSize: amenityTextSize,
            data: amenity,
            listingIndex: listingIndex
        })));
    }), loyaltyMessage && /* @__PURE__ */ React95.createElement(UitkSpacing44, {
        padding: {
            blockend: "one"
        }
    }, /* @__PURE__ */ React95.createElement("li", null, /* @__PURE__ */ React95.createElement(LodgingEnrichedMessage, {
        data: loyaltyMessage
    })))), marketingSection && /* @__PURE__ */ React95.createElement(UitkSpacing44, {
        margin: {
            blockstart: "three",
            blockend: "two"
        }
    }, /* @__PURE__ */ React95.createElement("div", null, /* @__PURE__ */ React95.createElement(MarketingSection, {
        data: marketingSection
    }))))), /* @__PURE__ */ React95.createElement(UitkLayoutFlexItem16, {
        grow: 1,
        minWidth: "third_width",
        className: "uitk-type-right"
    }, /* @__PURE__ */ React95.createElement(UitkLayoutFlex23, {
        direction: "column",
        alignItems: "end"
    }, /* @__PURE__ */ React95.createElement("div", null, /* @__PURE__ */ React95.createElement(PropertyRatePlanBadge, {
        data: data
    })), ((_priceDetail_price = priceDetail.price) === null || _priceDetail_price === void 0 ? void 0 : (_priceDetail_price_displayMessages = _priceDetail_price.displayMessages) === null || _priceDetail_price_displayMessages === void 0 ? void 0 : _priceDetail_price_displayMessages.length) ? /* @__PURE__ */ React95.createElement(PriceSummary2, {
        data: priceDetail.price
    }) : /* @__PURE__ */ React95.createElement(LodgingPriceSummary, {
        align: UitkPriceLockupAlign4.RIGHT,
        data: priceDetail
    }), priceDetail.priceBreakDownSummary ? /* @__PURE__ */ React95.createElement(PriceBreakdownSummary, {
        data: priceDetail,
        actionButton: /* @__PURE__ */ React95.createElement(PropertyReserveButton, {
            paymentPolicy: paymentPolicy,
            dialogSuffix: "".concat(ROOM_INFO_ETP_DIALOG_QUERY_PARAM, "-price-breakdown"),
            data: data,
            isFullWidth: true,
            listingIndex: listingIndex,
            rfrrSuffix: isWithinDetailsDialog ? "RoomInfoDialog.RoomsAndRates" /* Dialog */  : "PriceDetailMenu.RoomsAndRates" /* Menu */ 
        })
    }) : /* @__PURE__ */ React95.createElement("div", null, /* @__PURE__ */ React95.createElement(PricePresentationDialog, {
        data: priceDetail,
        actionButton: /* @__PURE__ */ React95.createElement(PropertyReserveButton, {
            paymentPolicy: paymentPolicy,
            dialogSuffix: "".concat(ROOM_INFO_ETP_DIALOG_QUERY_PARAM, "-price-breakdown"),
            data: data,
            isFullWidth: true,
            listingIndex: listingIndex,
            rfrrSuffix: isWithinDetailsDialog ? "RoomInfoDialog.RoomsAndRates" /* Dialog */  : "PriceDetailMenu.RoomsAndRates" /* Menu */ 
        }),
        roomTypeId: roomId,
        ratePlanId: id
    })), priceDetail.pointsApplied && /* @__PURE__ */ React95.createElement(UitkSpacing44, {
        margin: {
            blockend: "one"
        }
    }, /* @__PURE__ */ React95.createElement(UitkText34, {
        size: 100,
        theme: "default",
        "data-stid": "price-points"
    }, priceDetail.pointsApplied)), /* @__PURE__ */ React95.createElement(PropertyOffersRateViewScarcity, {
        data: priceDetail
    }), /* @__PURE__ */ React95.createElement(UitkSpacing44, {
        padding: {
            block: "two"
        }
    }, /* @__PURE__ */ React95.createElement("div", null, /* @__PURE__ */ React95.createElement(PropertyReserveButton, {
        paymentPolicy: paymentPolicy,
        dialogSuffix: ROOM_INFO_ETP_DIALOG_QUERY_PARAM,
        data: data,
        listingIndex: listingIndex,
        rfrrSuffix: isWithinDetailsDialog ? "RoomInfoDialog.RoomsAndRates" /* Dialog */  : "RoomsAndRates" /* Standard */ 
    })))))), shareUrl && /* @__PURE__ */ React95.createElement(MarketingSectionLink, {
        shareUrl: shareUrl
    }));
};
RatePlanWithAmenities.fragment = fragment51;
RatePlanWithAmenities.displayName = "RatePlanWithAmenities";
// src/components/property-offers/__private/__fragments/details-dialog-trigger/dialog/sections/dialog-rate-plan-section.tsx
var DialogRatePlanSection = function(param) {
    var listing = param.listing, ratePlanTitle = param.ratePlanTitle, listingIndex = param.listingIndex, closeDialog = param.closeDialog;
    return /* @__PURE__ */ React96.createElement("div", null, listing.ratePlans.length > 0 && ratePlanTitle && /* @__PURE__ */ React96.createElement(UitkHeading19, {
        tag: "h3",
        size: 4,
        "data-stid": "property-offers-details-room-options-header"
    }, ratePlanTitle.text), listing && /* @__PURE__ */ React96.createElement(UitkSpacing45, {
        margin: {
            block: "two"
        }
    }, /* @__PURE__ */ React96.createElement("div", {
        className: "uitk-type-right"
    }, /* @__PURE__ */ React96.createElement(AvailabilityCta, {
        key: "availability-cta-".concat(listingIndex),
        data: listing,
        closeDialog: closeDialog,
        listingIndex: listingIndex
    }))), /* @__PURE__ */ React96.createElement(UitkLayoutGrid14, {
        columns: [
            Repeat("auto-fit", MinMax2("70x", "1fr"))
        ],
        space: "three"
    }, listing.ratePlans.map(function(ratePlan, index) {
        return /* @__PURE__ */ React96.createElement(UitkLayoutGridItem13, {
            key: "dialog-rate-plan-".concat(index)
        }, /* @__PURE__ */ React96.createElement(UitkCard14, {
            border: true,
            padded: true,
            overflow: true
        }, /* @__PURE__ */ React96.createElement(RatePlanWithAmenities, {
            data: ratePlan,
            listingIndex: listingIndex,
            roomId: listing.id
        })));
    })));
};
DialogRatePlanSection.displayName = "DialogRatePlanSection";
// src/components/property-offers/__private/__fragments/details-dialog-trigger/dialog/unit-property-offers-details-dialog.tsx
import React105 from "react";
import { gql as gql94 } from "@apollo/client";
import { usePackageOperations as usePackageOperations2 } from "@shared-ui/multi-item-operations-providers";
import { ViewMedium as ViewMedium12, Viewport as Viewport15, ViewSmall as ViewSmall14 } from "@shared-ui/viewport-context";
import { UitkSheet as UitkSheet10, UitkSheetContent as UitkSheetContent4 } from "uitk-react-sheet";
import { UitkToolbar as UitkToolbar10 } from "uitk-react-toolbar";
// src/components/property-offers/__private/__fragments/details-dialog-trigger/dialog/details-dialog-content.tsx
import React104 from "react";
import { Experiment as Experiment5, ExperimentControl as ExperimentControl5, ExperimentVariant as ExperimentVariant5 } from "@shared-ui/experiment-context";
import { PropertyRoomScore } from "@shared-ui/lodging-reviews";
import { UitkSpacing as UitkSpacing52 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading23, UitkText as UitkText36 } from "uitk-react-text";
// src/components/property-offers/__private/__fragments/listings/property-unit-categorization/expando-items-card.tsx
import React97 from "react";
import { gql as gql89 } from "@apollo/client";
import { IntersectionTracker as IntersectionTracker7 } from "@shared-ui/clickstream-analytics-context";
import { UitkBadgeLoyalty as UitkBadgeLoyalty2 } from "uitk-react-badge";
import { UitkCard as UitkCard15, UitkCardContentSection as UitkCardContentSection10 } from "uitk-react-cards";
import { UitkExpandoPeek } from "uitk-react-expando";
import { UitkIcon as UitkIcon23, UitkIconSize as UitkIconSize18 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex24 } from "uitk-react-layout-flex";
import { UitkList as UitkList4, UitkListItem as UitkListItem6 } from "uitk-react-list";
import { UitkSpacing as UitkSpacing46 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading20, UitkText as UitkText35 } from "uitk-react-text";
var __ExpandoItemsCardFragment = gql89(_templateObject89());
var ExpandoItemsCard = function(param) {
    var expandoItemsCard = param.data, isWithinDetailsDialog = param.isWithinDetailsDialog;
    var _header_egdsStandardBadge, _header, _header_egdsStandardBadge1, _header1, _header_egdsStandardBadge2, _header2, _header3, _expando, _expando1;
    var _React97_useState = _sliced_to_array(React97.useState(false), 2), isVisible = _React97_useState[0], setIsVisible = _React97_useState[1];
    if (!expandoItemsCard) {
        return null;
    }
    var header = expandoItemsCard.header, items = expandoItemsCard.items, expando = expandoItemsCard.expando;
    var theme = (_header = header) === null || _header === void 0 ? void 0 : (_header_egdsStandardBadge = _header.egdsStandardBadge) === null || _header_egdsStandardBadge === void 0 ? void 0 : _header_egdsStandardBadge.theme;
    var perksList = function() {
        return items ? /* @__PURE__ */ React97.createElement(UitkList4, {
            bullet: "icon-standard"
        }, items.map(function(item, index) {
            var _item_impressionAnalytics, _item_impressionAnalytics1, _item_icon;
            return item.text && /* @__PURE__ */ React97.createElement(IntersectionTracker7, {
                trackOnce: true,
                referrerId: ((_item_impressionAnalytics = item.impressionAnalytics) === null || _item_impressionAnalytics === void 0 ? void 0 : _item_impressionAnalytics.referrerId) || "",
                linkName: ((_item_impressionAnalytics1 = item.impressionAnalytics) === null || _item_impressionAnalytics1 === void 0 ? void 0 : _item_impressionAnalytics1.linkName) || ""
            }, /* @__PURE__ */ React97.createElement(UitkListItem6, {
                key: "bundled-perk-".concat(index)
            }, /* @__PURE__ */ React97.createElement(UitkIcon23, {
                name: ((_item_icon = item.icon) === null || _item_icon === void 0 ? void 0 : _item_icon.id) || "check",
                size: UitkIconSize18.SMALL
            }), /* @__PURE__ */ React97.createElement(UitkText35, null, item.text)));
        })) : null;
    };
    return /* @__PURE__ */ React97.createElement(React97.Fragment, null, /* @__PURE__ */ React97.createElement(UitkSpacing46, {
        margin: {
            blockstart: "two",
            blockend: "four",
            inlinestart: !isWithinDetailsDialog ? "three" : void 0,
            inlineend: !isWithinDetailsDialog ? "three" : void 0
        }
    }, /* @__PURE__ */ React97.createElement(UitkCard15, {
        padded: true,
        "data-testid": "recommendation-card",
        backgroundTheme: "secondary"
    }, /* @__PURE__ */ React97.createElement(UitkLayoutFlex24, {
        alignItems: "start",
        space: "two",
        direction: "row"
    }, /* @__PURE__ */ React97.createElement(UitkHeading20, {
        tag: "h4",
        size: 7
    }, theme && /* @__PURE__ */ React97.createElement(UitkBadgeLoyalty2, {
        text: ((_header1 = header) === null || _header1 === void 0 ? void 0 : (_header_egdsStandardBadge1 = _header1.egdsStandardBadge) === null || _header_egdsStandardBadge1 === void 0 ? void 0 : _header_egdsStandardBadge1.text) || "",
        theme: UitkBadgeLoyaltyThemeMapper[theme],
        a11yText: ((_header2 = header) === null || _header2 === void 0 ? void 0 : (_header_egdsStandardBadge2 = _header2.egdsStandardBadge) === null || _header_egdsStandardBadge2 === void 0 ? void 0 : _header_egdsStandardBadge2.accessibility) || ""
    }), /* @__PURE__ */ React97.createElement(UitkSpacing46, {
        padding: {
            inlinestart: "two"
        }
    }, ((_header3 = header) === null || _header3 === void 0 ? void 0 : _header3.text) && /* @__PURE__ */ React97.createElement(UitkText35, {
        theme: "default",
        inline: true,
        spacing: "six",
        "aria-hidden": "true"
    }, header.text)))), /* @__PURE__ */ React97.createElement(UitkCardContentSection10, {
        padded: false
    }, /* @__PURE__ */ React97.createElement(UitkList4, {
        bullet: "icon-alternate",
        type: "ordered",
        spacing: false
    }, !isWithinDetailsDialog ? /* @__PURE__ */ React97.createElement(UitkExpandoPeek, {
        isVisible: isVisible,
        expandLabel: (_expando = expando) === null || _expando === void 0 ? void 0 : _expando.expandedLabel,
        collapseLabel: (_expando1 = expando) === null || _expando1 === void 0 ? void 0 : _expando1.collapsedLabel,
        handleClick: function() {
            return setIsVisible(function(prevIsVisible) {
                return !prevIsVisible;
            });
        },
        items: 2
    }, perksList()) : perksList())))));
};
ExpandoItemsCard.displayName = "ExpandoItemsCard";
ExpandoItemsCard.fragment = __ExpandoItemsCardFragment;
// src/components/property-offers/__private/__fragments/room-amenities/room-amenities-description.tsx
import React102 from "react";
import { gql as gql93 } from "@apollo/client";
import { UitkLayoutGrid as UitkLayoutGrid15 } from "uitk-react-layout-grid";
import { UitkSpacing as UitkSpacing50 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading22 } from "uitk-react-text";
// src/components/property-offers/__private/__fragments/details-dialog-trigger/dialog/sections/dialog-info-section/sections/dialog-features.tsx
import React99 from "react";
import { UitkList as UitkList5 } from "uitk-react-list";
import { UitkSpacing as UitkSpacing47 } from "uitk-react-spacing";
// src/components/property-offers/__private/__fragments/property-dialog-features.tsx
import React98 from "react";
import { gql as gql90 } from "@apollo/client";
import { UitkIcon as UitkIcon24, UitkIconSize as UitkIconSize19 } from "uitk-react-icons";
import { UitkListItem as UitkListItem7 } from "uitk-react-list";
var fragment52 = gql90(_templateObject90());
var PropertyDialogFeatures = function(param) {
    var data = param.data;
    var text = data.text, icon = data.icon;
    return /* @__PURE__ */ React98.createElement(UitkListItem7, null, icon && icon.__typename === "Icon" && /* @__PURE__ */ React98.createElement(UitkIcon24, {
        name: icon.id,
        description: icon.description,
        id: icon.id,
        size: UitkIconSize19.SMALL
    }), text);
};
PropertyDialogFeatures.fragment = fragment52;
PropertyDialogFeatures.displayName = "PropertyDialogFeatures";
// src/components/property-offers/__private/__fragments/details-dialog-trigger/dialog/sections/dialog-info-section/sections/dialog-features.tsx
var DialogFeatures = function(param) {
    var dialogFeatures = param.dialogFeatures;
    if (!dialogFeatures) {
        return null;
    }
    return /* @__PURE__ */ React99.createElement(UitkSpacing47, {
        margin: {
            blockend: "six"
        }
    }, /* @__PURE__ */ React99.createElement(UitkList5, {
        bullet: "icon-alternate"
    }, dialogFeatures.listItems.map(function(featureData, index) {
        return /* @__PURE__ */ React99.createElement(PropertyDialogFeatures, {
            data: featureData,
            key: "feature-".concat(index)
        });
    })));
};
DialogFeatures.displayName = "DialogFeatures";
// src/components/property-offers/__private/__fragments/room-amenities/content/room-amenity-content.tsx
import React101 from "react";
import { gql as gql92 } from "@apollo/client";
import { UitkIcon as UitkIcon25 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex25, UitkLayoutFlexItem as UitkLayoutFlexItem17 } from "uitk-react-layout-flex";
import { UitkLayoutGridItem as UitkLayoutGridItem14 } from "uitk-react-layout-grid";
import { UitkSpacing as UitkSpacing49 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading21 } from "uitk-react-text";
// src/components/property-offers/__private/__fragments/room-amenities/content/room-amenity-content-text.tsx
import React100 from "react";
import { gql as gql91 } from "@apollo/client";
import { UitkSpacing as UitkSpacing48 } from "uitk-react-spacing";
import { UitkUnformattedHtml as UitkUnformattedHtml7 } from "uitk-react-unformatted-html";
var fragment53 = gql91(_templateObject91());
var RoomAmenityContentText = function(param) {
    var data = param.data;
    if (!data.content) {
        return null;
    }
    var content = data.content;
    return /* @__PURE__ */ React100.createElement(UitkSpacing48, {
        padding: {
            inlinestart: "three"
        }
    }, /* @__PURE__ */ React100.createElement("div", null, /* @__PURE__ */ React100.createElement(UitkUnformattedHtml7, {
        htmlToParse: content.text
    })));
};
RoomAmenityContentText.displayName = "RoomAmenityContentText";
RoomAmenityContentText.fragment = fragment53;
// src/components/property-offers/__private/__fragments/room-amenities/content/room-amenity-content.tsx
var fragment54 = gql92(_templateObject92(), RoomAmenityContentText.fragment);
var RoomAmenityContent = function(param) {
    var data = param.data;
    var _header_icon;
    var header = data.header, items = data.items;
    if (!header) {
        return null;
    }
    return /* @__PURE__ */ React101.createElement(UitkLayoutGridItem14, null, /* @__PURE__ */ React101.createElement("div", null, /* @__PURE__ */ React101.createElement(UitkLayoutFlex25, {
        space: "three"
    }, /* @__PURE__ */ React101.createElement(UitkLayoutFlexItem17, null, /* @__PURE__ */ React101.createElement(UitkIcon25, {
        name: ((_header_icon = header.icon) === null || _header_icon === void 0 ? void 0 : _header_icon.id) || ""
    })), /* @__PURE__ */ React101.createElement(UitkLayoutFlexItem17, null, /* @__PURE__ */ React101.createElement(UitkHeading21, {
        tag: "h4",
        size: 6
    }, header.text))), /* @__PURE__ */ React101.createElement(UitkSpacing49, {
        padding: {
            inlinestart: "six"
        }
    }, /* @__PURE__ */ React101.createElement("div", null, items.map(function(amenity, index) {
        return /* @__PURE__ */ React101.createElement(RoomAmenityContentText, {
            key: "amenities-content-".concat(index),
            data: amenity
        });
    })))));
};
RoomAmenityContent.displayName = "RoomAmenityContent";
RoomAmenityContent.fragment = fragment54;
// src/components/property-offers/__private/__fragments/room-amenities/room-amenities-description.tsx
var fragment55 = gql93(_templateObject93(), RoomAmenityContent.fragment);
var RoomAmenitiesDescription = function(param) {
    var data = param.data, dialogFeatures = param.dialogFeatures;
    var _bodySubSections__contents, _bodySubSections_, _bodySubSections;
    var header = data.header, bodySubSections = data.bodySubSections;
    if (!((_bodySubSections = bodySubSections) === null || _bodySubSections === void 0 ? void 0 : (_bodySubSections_ = _bodySubSections[0]) === null || _bodySubSections_ === void 0 ? void 0 : (_bodySubSections__contents = _bodySubSections_.contents) === null || _bodySubSections__contents === void 0 ? void 0 : _bodySubSections__contents.length) && !dialogFeatures) {
        return null;
    }
    return /* @__PURE__ */ React102.createElement(UitkSpacing50, {
        margin: {
            blockend: "six"
        }
    }, /* @__PURE__ */ React102.createElement("div", null, header && /* @__PURE__ */ React102.createElement(UitkSpacing50, {
        margin: {
            blockend: "six"
        }
    }, /* @__PURE__ */ React102.createElement(UitkHeading22, {
        tag: "h3",
        size: 5
    }, header.text)), dialogFeatures && /* @__PURE__ */ React102.createElement(DialogFeatures, {
        dialogFeatures: dialogFeatures
    }), bodySubSections.length > 0 && /* @__PURE__ */ React102.createElement(UitkLayoutGrid15, {
        columns: {
            small: 1,
            medium: 2
        },
        space: "six"
    }, bodySubSections.map(function(bodySection) {
        return bodySection.contents.map(function(content, index) {
            return /* @__PURE__ */ React102.createElement(RoomAmenityContent, {
                key: "dialog-room-amenity-".concat(index),
                data: content
            });
        });
    }))));
};
RoomAmenitiesDescription.displayName = "RoomAmenitiesDescription";
RoomAmenitiesDescription.fragment = fragment55;
// src/components/property-offers/__private/__fragments/details-dialog-trigger/dialog/sections/dialog-gallery-section.tsx
import React103 from "react";
import { useClickTracker as useClickTracker30 } from "@shared-ui/clickstream-analytics-context";
import { UitkCard as UitkCard16 } from "uitk-react-cards";
import { UitkGalleryCarousel } from "uitk-react-gallery-carousel";
import { UitkFigure as UitkFigure3, UitkFigureAspectRatioType as UitkFigureAspectRatioType2, UitkImage as UitkImage3 } from "uitk-react-images";
import { UitkSpacing as UitkSpacing51 } from "uitk-react-spacing";
var DialogGallerySection = function(param) {
    var unitGallery = param.unitGallery, roomTypeId = param.roomTypeId;
    var _unitGallery_images, _unitGallery, _unitGallery1;
    var track = useClickTracker30();
    var ratePlan = React103.useContext(UnitRateContext).ratePlan;
    var controlAnalytics = React103.useMemo(function() {
        var _ratePlan;
        return {
            id: "HOT.HIS.RoomInfoDialog.".concat(roomTypeId, ".").concat((_ratePlan = ratePlan) === null || _ratePlan === void 0 ? void 0 : _ratePlan.id),
            description: "Change image in gallery carousel",
            callback: function(id, desc) {
                return track(id, desc);
            }
        };
    }, [
        track
    ]);
    if (!((_unitGallery = unitGallery) === null || _unitGallery === void 0 ? void 0 : (_unitGallery_images = _unitGallery.images) === null || _unitGallery_images === void 0 ? void 0 : _unitGallery_images.length)) {
        return /* @__PURE__ */ React103.createElement(UitkSpacing51, {
            margin: {
                blockend: "three"
            }
        }, /* @__PURE__ */ React103.createElement(UitkFigure3, null, /* @__PURE__ */ React103.createElement(UitkImage3, {
            placeholderImage: true
        })));
    }
    var mappedImages = unitGallery.images.map(function(param) {
        var image = param.image;
        return {
            src: image.url,
            alt: image.description
        };
    });
    return /* @__PURE__ */ React103.createElement(UitkCard16, null, /* @__PURE__ */ React103.createElement(UitkSpacing51, {
        margin: {
            blockend: "six"
        }
    }, /* @__PURE__ */ React103.createElement("div", null, /* @__PURE__ */ React103.createElement(UitkGalleryCarousel, {
        carouselId: "property-offers-carousel",
        allyHeadingText: ((_unitGallery1 = unitGallery) === null || _unitGallery1 === void 0 ? void 0 : _unitGallery1.accessibilityLabel) || "",
        carouselName: "PhotoGallery",
        images: mappedImages,
        ratio: UitkFigureAspectRatioType2.R16_9,
        showGalleryButton: false,
        analytics: controlAnalytics
    }))));
};
DialogGallerySection.displayName = "DialogGallerySection";
// src/components/property-offers/__private/__fragments/details-dialog-trigger/dialog/details-dialog-content.tsx
var DetailsDialogContent = function(param) {
    var listing = param.listing, _param_swapDialogLayout = param.swapDialogLayout, swapDialogLayout = _param_swapDialogLayout === void 0 ? false : _param_swapDialogLayout, expandoItemsCard = param.expandoItemsCard, ratePlans = param.ratePlans;
    var _details;
    var propertyId = usePropertyOffersInputs().propertyId;
    var roomId = listing.id, roomAmenities = listing.roomAmenities, unitGallery = listing.unitGallery, spaceDetails = listing.spaceDetails;
    var detailsDialog = listing.detailsDialog;
    var _detailsDialog_content = detailsDialog.content, details = _detailsDialog_content.details, dialogFeatures = _detailsDialog_content.dialogFeatures;
    var header = (_details = details) === null || _details === void 0 ? void 0 : _details.header;
    var roomAmenitiesDescription = roomAmenities && /* @__PURE__ */ React104.createElement(RoomAmenitiesDescription, {
        data: roomAmenities,
        dialogFeatures: swapDialogLayout ? dialogFeatures : null
    });
    return /* @__PURE__ */ React104.createElement(UitkSpacing52, {
        padding: {
            inline: "three",
            blockstart: "three",
            blockend: "six"
        }
    }, /* @__PURE__ */ React104.createElement("div", null, /* @__PURE__ */ React104.createElement(DialogGallerySection, {
        unitGallery: unitGallery,
        roomTypeId: roomId
    }), /* @__PURE__ */ React104.createElement(UitkSpacing52, {
        padding: {
            inline: "three"
        }
    }, /* @__PURE__ */ React104.createElement("div", null, header && /* @__PURE__ */ React104.createElement(UitkSpacing52, {
        margin: {
            blockend: "three"
        }
    }, /* @__PURE__ */ React104.createElement("div", {
        "data-stid": "property-offers-details-dialog-header"
    }, /* @__PURE__ */ React104.createElement(UitkHeading23, {
        size: 5,
        tag: "h3"
    }, header.text), header.subText && /* @__PURE__ */ React104.createElement(UitkText36, {
        theme: "default"
    }, header.subText))), swapDialogLayout && /* @__PURE__ */ React104.createElement(UitkSpacing52, {
        margin: {
            blockend: "six"
        }
    }, /* @__PURE__ */ React104.createElement("div", null, ratePlans)), !swapDialogLayout && dialogFeatures && /* @__PURE__ */ React104.createElement(DialogFeatures, {
        dialogFeatures: dialogFeatures
    }), /* @__PURE__ */ React104.createElement(Experiment5, {
        name: "Room_Scores_OutOf10_with_Superlatives_web"
    }, /* @__PURE__ */ React104.createElement(ExperimentControl5, null), /* @__PURE__ */ React104.createElement(ExperimentVariant5, {
        bucket: 1
    }, /* @__PURE__ */ React104.createElement(PropertyRoomScore, {
        inputs: {
            propertyId: propertyId,
            withTags: true
        },
        roomId: roomId,
        withinDialog: true
    }))), spaceDetails && /* @__PURE__ */ React104.createElement(UitkSpacing52, {
        padding: {
            blockend: "two"
        }
    }, /* @__PURE__ */ React104.createElement(SpaceDetails, {
        data: spaceDetails
    })), expandoItemsCard && /* @__PURE__ */ React104.createElement(ExpandoItemsCard, {
        isWithinDetailsDialog: true,
        data: expandoItemsCard
    }), swapDialogLayout ? roomAmenitiesDescription : /* @__PURE__ */ React104.createElement(React104.Fragment, null, roomAmenitiesDescription, ratePlans)))));
};
// src/components/property-offers/__private/__fragments/details-dialog-trigger/dialog/unit-property-offers-details-dialog.tsx
var fragment56 = gql94(_templateObject94());
var UnitPropertyOffersDetailsDialog = function(param) {
    var closeDialog = param.closeDialog, isDialogOpen = param.isDialogOpen, listing = param.listing, data = param.data, ratePlans = param.ratePlans, featureHeader = param.featureHeader, expandoItemsCard = param.expandoItemsCard, _param_swapDialogLayout = param.swapDialogLayout, swapDialogLayout = _param_swapDialogLayout === void 0 ? false : _param_swapDialogLayout;
    var _toolbar, _toolbar_icon, _toolbar1;
    var content = data.content, toolbar = data.toolbar;
    var state = usePackageOperations2().state;
    var _React105_useState = _sliced_to_array(React105.useState(document.activeElement), 1), triggerRef = _React105_useState[0];
    React105.useEffect(function() {
        if (state.selectPackage.status === "IN_PROGRESS") {
            closeDialog();
        }
    }, [
        state.selectPackage.status,
        closeDialog
    ]);
    React105.useEffect(function() {
        return function() {
            var _triggerRef;
            return (_triggerRef = triggerRef) === null || _triggerRef === void 0 ? void 0 : _triggerRef.focus();
        };
    }, []);
    var detailsDialogProps = {
        ratePlans: ratePlans,
        featureHeader: featureHeader,
        expandoItemsCard: expandoItemsCard,
        swapDialogLayout: swapDialogLayout
    };
    var _toolbar_title;
    var dialog = /* @__PURE__ */ React105.createElement(React105.Fragment, null, /* @__PURE__ */ React105.createElement(UitkToolbar10, {
        toolbarTitle: (_toolbar_title = (_toolbar = toolbar) === null || _toolbar === void 0 ? void 0 : _toolbar.title) !== null && _toolbar_title !== void 0 ? _toolbar_title : void 0,
        navigationContent: {
            navIconLabel: (_toolbar1 = toolbar) === null || _toolbar1 === void 0 ? void 0 : (_toolbar_icon = _toolbar1.icon) === null || _toolbar_icon === void 0 ? void 0 : _toolbar_icon.description,
            navType: "close",
            onClick: closeDialog
        }
    }), /* @__PURE__ */ React105.createElement(UitkSheetContent4, {
        padded: false
    }, /* @__PURE__ */ React105.createElement(dialog_context_default.Provider, {
        value: true
    }, /* @__PURE__ */ React105.createElement(DetailsDialogContent, _object_spread_props(_object_spread({}, detailsDialogProps), {
        listing: listing
    })))));
    var sheetProps = {
        isVisible: isDialogOpen,
        triggerRef: null
    };
    return /* @__PURE__ */ React105.createElement(Viewport15, null, /* @__PURE__ */ React105.createElement(ViewSmall14, null, /* @__PURE__ */ React105.createElement(UitkSheet10, _object_spread_props(_object_spread({}, sheetProps), {
        type: "full"
    }), dialog)), /* @__PURE__ */ React105.createElement(ViewMedium12, null, /* @__PURE__ */ React105.createElement(UitkSheet10, _object_spread_props(_object_spread({}, sheetProps), {
        type: "centered"
    }), dialog)));
};
UnitPropertyOffersDetailsDialog.fragment = fragment56;
UnitPropertyOffersDetailsDialog.displayName = "UnitPropertyOffersDetailsDialog";
// src/components/property-offers/__private/__fragments/details-dialog-trigger/triggers/link-trigger.tsx
import React106 from "react";
import { gql as gql95 } from "@apollo/client";
import { UitkIcon as UitkIcon26, UitkIconSize as UitkIconSize20 } from "uitk-react-icons";
import { UitkLink as UitkLink14 } from "uitk-react-link";
var fragment57 = gql95(_templateObject95());
var LinkTrigger = function(param) {
    var data = param.data, openDialog = param.openDialog;
    var value = data.value, accessibilityLabel = data.accessibilityLabel;
    return /* @__PURE__ */ React106.createElement(UitkLink14, {
        onClick: openDialog
    }, /* @__PURE__ */ React106.createElement("button", {
        type: "button"
    }, /* @__PURE__ */ React106.createElement("span", {
        "aria-hidden": accessibilityLabel !== null
    }, value), accessibilityLabel && /* @__PURE__ */ React106.createElement("span", {
        className: "is-visually-hidden"
    }, accessibilityLabel), /* @__PURE__ */ React106.createElement(UitkIcon26, {
        name: "chevron_right",
        size: UitkIconSize20.SMALL
    })));
};
LinkTrigger.fragment = fragment57;
LinkTrigger.displayName = "LinkTrigger";
// src/components/property-offers/__private/__fragments/property-offers-header.tsx
import React107 from "react";
import { gql as gql96 } from "@apollo/client";
import { Experiment as Experiment6, ExperimentControl as ExperimentControl6, ExperimentVariant as ExperimentVariant6 } from "@shared-ui/experiment-context";
import { PropertyRoomScore as PropertyRoomScore2 } from "@shared-ui/lodging-reviews";
import { UitkSpacing as UitkSpacing53 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading24, UitkText as UitkText37 } from "uitk-react-text";
var fragment58 = gql96(_templateObject96());
var PropertyOffersHeader = function(param) {
    var data = param.data, _param_textSize = param.textSize, textSize = _param_textSize === void 0 ? 4 : _param_textSize, roomId = param.roomId;
    var text = data.text, subText = data.subText;
    var propertyId = usePropertyOffersInputs().propertyId;
    return /* @__PURE__ */ React107.createElement(React107.Fragment, null, /* @__PURE__ */ React107.createElement(UitkSpacing53, {
        padding: subText ? {} : {
            small: {
                blockend: "half"
            }
        }
    }, /* @__PURE__ */ React107.createElement("div", null, /* @__PURE__ */ React107.createElement(UitkHeading24, {
        tag: "h3",
        size: textSize
    }, text))), /* @__PURE__ */ React107.createElement(Experiment6, {
        name: "Room_Scores_OutOf10_with_Superlatives_web"
    }, /* @__PURE__ */ React107.createElement(ExperimentControl6, null), /* @__PURE__ */ React107.createElement(ExperimentVariant6, {
        bucket: 1
    }, /* @__PURE__ */ React107.createElement(PropertyRoomScore2, {
        inputs: {
            propertyId: propertyId,
            withTags: true
        },
        roomId: roomId
    }))), subText && /* @__PURE__ */ React107.createElement(UitkSpacing53, {
        padding: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React107.createElement(UitkText37, null, subText)));
};
PropertyOffersHeader.fragment = fragment58;
PropertyOffersHeader.displayName = "PropertyOffersHeader";
// src/components/property-offers/__private/__fragments/property-rate-plans-expando.tsx
import React108 from "react";
import { gql as gql97 } from "@apollo/client";
import { UitkExpandoLink } from "uitk-react-expando";
import { UitkSpacing as UitkSpacing54 } from "uitk-react-spacing";
var fragment59 = gql97(_templateObject97());
var RatePlansExpando = function(param) {
    var data = param.data, children = param.children;
    var collapseButton = data.collapseButton, expandButton = data.expandButton;
    return /* @__PURE__ */ React108.createElement(UitkSpacing54, {
        padding: {
            inlinestart: "one"
        }
    }, /* @__PURE__ */ React108.createElement(UitkExpandoLink, {
        size: "small",
        isVisible: false,
        expandoTitle: expandButton.text,
        expandedLabel: collapseButton.text
    }, children));
};
RatePlansExpando.fragment = fragment59;
RatePlansExpando.displayName = "RatePlansExpando";
// src/components/property-offers/__private/__fragments/listings/layouts/horizontal-one-row-property-unit-layout.tsx
import React109 from "react";
import { UitkCard as UitkCard17, UitkCardContentSection as UitkCardContentSection11 } from "uitk-react-cards";
import { UitkLayoutGrid as UitkLayoutGrid16, UitkLayoutGridItem as UitkLayoutGridItem15 } from "uitk-react-layout-grid";
import { UitkLayoutPosition as UitkLayoutPosition2 } from "uitk-react-layout-position";
import { UitkSpacing as UitkSpacing55 } from "uitk-react-spacing";
// src/utils/react-children-to-display-name-map.ts
import { Children } from "react";
function reactChildrenToDisplayNameMap(children) {
    if (!children) {
        return {};
    }
    var map = {};
    Children.forEach(children, function(c) {
        var _c_type, _c;
        var displayName = (_c = c) === null || _c === void 0 ? void 0 : (_c_type = _c.type) === null || _c_type === void 0 ? void 0 : _c_type.displayName;
        if (!displayName) {
            return;
        }
        if (!map[displayName]) {
            map[displayName] = [];
        }
        map[displayName].push(c);
    });
    return map;
}
// src/components/property-offers/__private/__fragments/listings/layouts/horizontal-one-row-property-unit-layout.tsx
var HorizontalOneRowPropertyUnitLayout = function(param) {
    var children = param.children, shouldRenderLargeImage = param.shouldRenderLargeImage;
    var _MediaSection2;
    if (!children) {
        return null;
    }
    var _reactChildrenToDisplayNameMap = reactChildrenToDisplayNameMap(children), MediaSection2 = _reactChildrenToDisplayNameMap.MediaSection, InfoSection2 = _reactChildrenToDisplayNameMap.InfoSection, RatePlanWithAmenities2 = _reactChildrenToDisplayNameMap.RatePlanWithAmenities, AvailabilityCta3 = _reactChildrenToDisplayNameMap.AvailabilityCta;
    return /* @__PURE__ */ React109.createElement(UitkCard17, {
        overflow: true,
        padded: !shouldRenderLargeImage
    }, /* @__PURE__ */ React109.createElement("div", {
        "data-stid": "horizontal-layout"
    }, /* @__PURE__ */ React109.createElement(UitkLayoutGrid16, {
        columns: 12,
        space: "three"
    }, /* @__PURE__ */ React109.createElement(UitkLayoutGridItem15, {
        colSpan: shouldRenderLargeImage ? 4 : 3
    }, /* @__PURE__ */ React109.createElement("div", null, ((_MediaSection2 = MediaSection2) === null || _MediaSection2 === void 0 ? void 0 : _MediaSection2.length) > 0 && React109.cloneElement(MediaSection2[0], {
        className: "uitk-rounded-border-top uitk-rounded-border-bottom"
    }))), /* @__PURE__ */ React109.createElement(UitkLayoutGridItem15, {
        colSpan: shouldRenderLargeImage ? 8 : 9
    }, /* @__PURE__ */ React109.createElement(UitkSpacing55, {
        padding: shouldRenderLargeImage ? {
            blockstart: "three",
            inlineend: "two"
        } : {}
    }, /* @__PURE__ */ React109.createElement(UitkCardContentSection11, {
        padded: false
    }, /* @__PURE__ */ React109.createElement(UitkLayoutGrid16, {
        columns: 8,
        space: "three"
    }, /* @__PURE__ */ React109.createElement(UitkLayoutGridItem15, {
        colSpan: 4
    }, /* @__PURE__ */ React109.createElement("div", null, InfoSection2)), /* @__PURE__ */ React109.createElement(UitkLayoutGridItem15, {
        colSpan: 4
    }, /* @__PURE__ */ React109.createElement("div", null, RatePlanWithAmenities2)))))), AvailabilityCta3 && /* @__PURE__ */ React109.createElement(UitkLayoutPosition2, {
        type: "absolute",
        position: {
            top: "three",
            right: "three"
        }
    }, AvailabilityCta3))));
};
HorizontalOneRowPropertyUnitLayout.displayName = "HorizontalOneRowPropertyUnitLayout";
// src/components/property-offers/__private/__fragments/listings/layouts/horizontal-two-row-property-unit-layout.tsx
import React110 from "react";
import { UitkCard as UitkCard18 } from "uitk-react-cards";
import { UitkLayoutGrid as UitkLayoutGrid17, UitkLayoutGridItem as UitkLayoutGridItem16 } from "uitk-react-layout-grid";
import { UitkLayoutPosition as UitkLayoutPosition3 } from "uitk-react-layout-position";
var HorizontalTwoRowsPropertyUnitLayout = function(param) {
    var children = param.children;
    var _MediaSection2, _RatePlanWithAmenities2;
    if (!children) {
        return null;
    }
    var _reactChildrenToDisplayNameMap = reactChildrenToDisplayNameMap(children), MediaSection2 = _reactChildrenToDisplayNameMap.MediaSection, InfoSection2 = _reactChildrenToDisplayNameMap.InfoSection, RatePlanWithAmenities2 = _reactChildrenToDisplayNameMap.RatePlanWithAmenities, AvailabilityCta3 = _reactChildrenToDisplayNameMap.AvailabilityCta;
    return /* @__PURE__ */ React110.createElement(UitkCard18, {
        padded: true,
        overflow: true
    }, /* @__PURE__ */ React110.createElement("div", {
        "data-stid": "horizontal-two-row-layout"
    }, /* @__PURE__ */ React110.createElement(UitkLayoutGrid17, {
        columns: 6,
        space: "three"
    }, /* @__PURE__ */ React110.createElement(UitkLayoutGridItem16, {
        colSpan: 2
    }, /* @__PURE__ */ React110.createElement("div", null, ((_MediaSection2 = MediaSection2) === null || _MediaSection2 === void 0 ? void 0 : _MediaSection2.length) > 0 && React110.cloneElement(MediaSection2[0], {
        className: "uitk-rounded-border-top uitk-rounded-border-bottom"
    }))), /* @__PURE__ */ React110.createElement(UitkLayoutGridItem16, {
        colSpan: 4
    }, /* @__PURE__ */ React110.createElement("div", null, InfoSection2)), (_RatePlanWithAmenities2 = RatePlanWithAmenities2) === null || _RatePlanWithAmenities2 === void 0 ? void 0 : _RatePlanWithAmenities2.map(function(child, index) {
        return /* @__PURE__ */ React110.createElement(UitkLayoutGridItem16, {
            key: "horizontal-two-rows-unit-".concat(index),
            colSpan: 3
        }, /* @__PURE__ */ React110.createElement("div", null, /* @__PURE__ */ React110.createElement(UitkCard18, {
            overflow: true,
            padded: true,
            border: true
        }, child)));
    }), AvailabilityCta3 && /* @__PURE__ */ React110.createElement(UitkLayoutPosition3, {
        type: "absolute",
        position: {
            top: "four",
            right: "four"
        }
    }, AvailabilityCta3))));
};
HorizontalTwoRowsPropertyUnitLayout.displayName = "HorizontalTwoRowsPropertyUnitLayout";
// src/components/property-offers/__private/__fragments/listings/layouts/vertical-property-unit-layout.tsx
import React111 from "react";
import { UitkCard as UitkCard19, UitkCardContentSection as UitkCardContentSection12 } from "uitk-react-cards";
import { UitkSpacing as UitkSpacing56 } from "uitk-react-spacing";
var VerticalPropertyUnitLayout = function(param) {
    var children = param.children, imageRatio = param.imageRatio;
    var _RatePlanWithAmenities2, _RatePlanWithAmenities21, _DynamicRatePlans, _MediaSection2, _StaticRatePlans;
    if (!children) {
        return null;
    }
    var _reactChildrenToDisplayNameMap = reactChildrenToDisplayNameMap(children), MediaSection2 = _reactChildrenToDisplayNameMap.MediaSection, InfoSection2 = _reactChildrenToDisplayNameMap.InfoSection, RatePlanWithAmenities2 = _reactChildrenToDisplayNameMap.RatePlanWithAmenities, AvailabilityCta3 = _reactChildrenToDisplayNameMap.AvailabilityCta, RatePlansExpando2 = _reactChildrenToDisplayNameMap.RatePlansExpando;
    var StaticRatePlans = ((_RatePlanWithAmenities2 = RatePlanWithAmenities2) === null || _RatePlanWithAmenities2 === void 0 ? void 0 : _RatePlanWithAmenities2.slice(0, 2)) || RatePlanWithAmenities2;
    var DynamicRatePlans = ((_RatePlanWithAmenities21 = RatePlanWithAmenities2) === null || _RatePlanWithAmenities21 === void 0 ? void 0 : _RatePlanWithAmenities21.length) > 2 && RatePlanWithAmenities2.slice(2) || null;
    var DynamicRatePlansComponents = (_DynamicRatePlans = DynamicRatePlans) === null || _DynamicRatePlans === void 0 ? void 0 : _DynamicRatePlans.map(function(child, index) {
        return /* @__PURE__ */ React111.createElement(UitkCardContentSection12, {
            key: "vertical-dynamic-unit-".concat(index),
            border: "top"
        }, child);
    });
    var ExpandoWrapper = DynamicRatePlansComponents && React111.cloneElement(RatePlansExpando2[0], {}, DynamicRatePlansComponents);
    return /* @__PURE__ */ React111.createElement(UitkSpacing56, {
        margin: {
            blockend: "three"
        }
    }, /* @__PURE__ */ React111.createElement(UitkCard19, {
        "data-stid": "vertical-layout",
        overflow: true
    }, ((_MediaSection2 = MediaSection2) === null || _MediaSection2 === void 0 ? void 0 : _MediaSection2.length) > 0 && React111.cloneElement(MediaSection2[0], {
        className: "uitk-rounded-border-top",
        imageRatio: imageRatio
    }), /* @__PURE__ */ React111.createElement(UitkCardContentSection12, {
        padded: false
    }, /* @__PURE__ */ React111.createElement(UitkSpacing56, {
        padding: {
            small: "three",
            medium: {
                blockstart: "four",
                blockend: "one",
                inline: "four"
            }
        }
    }, /* @__PURE__ */ React111.createElement("div", null, InfoSection2))), AvailabilityCta3 && /* @__PURE__ */ React111.createElement(UitkCardContentSection12, {
        className: "uitk-type-right",
        border: "top"
    }, AvailabilityCta3), (_StaticRatePlans = StaticRatePlans) === null || _StaticRatePlans === void 0 ? void 0 : _StaticRatePlans.map(function(child, index) {
        return /* @__PURE__ */ React111.createElement(UitkCardContentSection12, {
            key: "vertical-unit-".concat(index),
            border: "top"
        }, /* @__PURE__ */ React111.createElement(UitkSpacing56, {
            padding: {
                block: "two"
            }
        }, /* @__PURE__ */ React111.createElement("div", null, child)));
    }), ExpandoWrapper));
};
VerticalPropertyUnitLayout.displayName = "VerticalPropertyUnitLayout";
// src/components/property-offers/__private/__fragments/listings/sections/info-section.tsx
import React113 from "react";
import { ViewMedium as ViewMedium14, Viewport as Viewport17, ViewSmall as ViewSmall16 } from "@shared-ui/viewport-context";
import { UitkLayoutFlex as UitkLayoutFlex26 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing57 } from "uitk-react-spacing";
// src/components/property-offers/__private/__fragments/listings/sections/multi-column-features-section.tsx
import React112 from "react";
import { ViewMedium as ViewMedium13, Viewport as Viewport16, ViewSmall as ViewSmall15 } from "@shared-ui/viewport-context";
import { withUitkLayoutGrid as withUitkLayoutGrid2 } from "uitk-react-layout-grid";
import { UitkList as UitkList6 } from "uitk-react-list";
var Features = function(param) {
    var features = param.features, maxColumns = param.maxColumns;
    var list = function(props) {
        return /* @__PURE__ */ React112.createElement(UitkList6, _object_spread({
            bullet: "icon-standard"
        }, props), features.map(function(feature, index) {
            return /* @__PURE__ */ React112.createElement(PropertyFeatures, {
                data: feature,
                uniqueDialogId: "propertyunit-feature",
                key: "feature-".concat(index)
            });
        }));
    };
    var ListWithGrid = withUitkLayoutGrid2(list);
    return /* @__PURE__ */ React112.createElement(ListWithGrid, {
        columns: features.length <= 4 || maxColumns === 1 ? 1 : 2
    });
};
Features.displayName = "Features";
var MultiColumnFeaturesSection = function(param) {
    var features = param.features;
    var _features;
    if (!((_features = features) === null || _features === void 0 ? void 0 : _features.length)) {
        return null;
    }
    return /* @__PURE__ */ React112.createElement(Viewport16, null, /* @__PURE__ */ React112.createElement(ViewSmall15, null, /* @__PURE__ */ React112.createElement(Features, {
        features: features,
        maxColumns: 1
    })), /* @__PURE__ */ React112.createElement(ViewMedium13, null, /* @__PURE__ */ React112.createElement(Features, {
        features: features,
        maxColumns: 2
    })));
};
MultiColumnFeaturesSection.displayName = "MultiColumnFeaturesSection";
// src/components/property-offers/__private/__fragments/listings/sections/info-section.tsx
var InfoSection = function(param) {
    var children = param.children, headerData = param.headerData, features = param.features, roomId = param.roomId;
    return /* @__PURE__ */ React113.createElement("div", {
        "data-stid": "section-roomtype"
    }, /* @__PURE__ */ React113.createElement(UitkSpacing57, {
        padding: {
            large: {
                inlineend: "six"
            },
            extra_large: {
                inlineend: "six"
            }
        }
    }, /* @__PURE__ */ React113.createElement("div", null, /* @__PURE__ */ React113.createElement(Viewport17, null, /* @__PURE__ */ React113.createElement(ViewSmall16, null, /* @__PURE__ */ React113.createElement(PropertyOffersHeader, {
        data: headerData,
        textSize: 6,
        roomId: roomId
    })), /* @__PURE__ */ React113.createElement(ViewMedium14, null, /* @__PURE__ */ React113.createElement(PropertyOffersHeader, {
        data: headerData,
        textSize: 5,
        roomId: roomId
    }))))), /* @__PURE__ */ React113.createElement(MultiColumnFeaturesSection, {
        features: features
    }), /* @__PURE__ */ React113.createElement(Viewport17, null, /* @__PURE__ */ React113.createElement(ViewSmall16, null, /* @__PURE__ */ React113.createElement(UitkLayoutFlex26, {
        justifyContent: "start"
    }, /* @__PURE__ */ React113.createElement("div", null, children))), /* @__PURE__ */ React113.createElement(ViewMedium14, null, /* @__PURE__ */ React113.createElement("div", null, children))));
};
InfoSection.displayName = "InfoSection";
// src/components/property-offers/__private/__fragments/listings/sections/media-section.tsx
import React114 from "react";
import { useClickTracker as useClickTracker31 } from "@shared-ui/clickstream-analytics-context";
import { UitkGalleryCarousel as UitkGalleryCarousel2 } from "uitk-react-gallery-carousel";
import { UitkFigure as UitkFigure4, UitkImage as UitkImage4 } from "uitk-react-images";
var MediaSection = function(param) {
    var listingIndex = param.listingIndex, listingName = param.listingName, unitGallery = param.unitGallery, className = param.className, imageRatio = param.imageRatio, handleCarouselImageClick = param.handleCarouselImageClick, roomTypeId = param.roomTypeId, ratePlanId = param.ratePlanId;
    var _unitGallery, _unitGallery1, _unitGallery2;
    var _unitGallery_images_map;
    var srcImages = (_unitGallery_images_map = (_unitGallery = unitGallery) === null || _unitGallery === void 0 ? void 0 : _unitGallery.images.map(function(param) {
        var image = param.image;
        return {
            src: image.url,
            alt: image.description
        };
    })) !== null && _unitGallery_images_map !== void 0 ? _unitGallery_images_map : [];
    var track = useClickTracker31();
    var controlAnalytics = React114.useMemo(function() {
        return {
            id: "HOT.HIS.RatePlan.".concat(roomTypeId, ".").concat(ratePlanId),
            description: "Change image in gallery carousel",
            callback: function(id, desc) {
                return track(id, desc);
            }
        };
    }, [
        track
    ]);
    var carouselId = "property-offers-media-carousel-".concat(listingIndex);
    var handleClick = function() {
        var _handleCarouselImageClick;
        var referrerId = "HOT.HIS.RatePlan.PhotoGallery.Hero.MediaGalleryTrigger.".concat(roomTypeId, ".").concat(ratePlanId);
        var linkName = "Open Room Gallery dialog";
        track(referrerId, linkName);
        (_handleCarouselImageClick = handleCarouselImageClick) === null || _handleCarouselImageClick === void 0 ? void 0 : _handleCarouselImageClick();
    };
    return /* @__PURE__ */ React114.createElement("div", null, srcImages.length === 0 ? /* @__PURE__ */ React114.createElement(UitkFigure4, {
        className: className,
        ratio: imageRatio
    }, /* @__PURE__ */ React114.createElement(UitkImage4, {
        placeholderImage: true
    })) : /* @__PURE__ */ React114.createElement(UitkGalleryCarousel2, {
        allyHeadingText: ((_unitGallery1 = unitGallery) === null || _unitGallery1 === void 0 ? void 0 : _unitGallery1.accessibilityLabel) || "",
        triggerA11yText: ((_unitGallery2 = unitGallery) === null || _unitGallery2 === void 0 ? void 0 : _unitGallery2.accessibilityLabel) || "",
        analytics: controlAnalytics,
        carouselName: "PhotoGallery",
        carouselId: carouselId,
        listingName: listingName,
        className: className,
        images: srcImages,
        onImageClick: handleClick,
        onMediaButtonClick: handleCarouselImageClick,
        ratio: imageRatio,
        showGalleryButton: true
    }));
};
MediaSection.displayName = "MediaSection";
// src/components/property-offers/__private/__fragments/listings/control-property-unit.tsx
var fragment60 = gql98(_templateObject98(), PropertyOffersHeader.fragment, PropertyFeatures.fragment, LodgingHighlightedMessages.fragment, PropertyOffersRateViewScarcity.fragment, PropertyReserveButton.fragment, PropertyRatePlanBadge.fragment, UnitPropertyOffersDetailsDialog.fragment, RatePlanWithAmenities.fragment, LinkTrigger.fragment, AvailabilityCta.fragment, RatePlansExpando.fragment, SleepingArrangements.fragment, RoomAmenitiesDescription.fragment, SpaceDetails.fragment);
var ControlPropertyUnit = function(param) {
    var data = param.data, listingIndex = param.listingIndex, shouldRenderAsTwoRows = param.shouldRenderAsTwoRows, shouldRenderLargeImage = param.shouldRenderLargeImage, className = param.className, forceVerticalPropertyUnitLayout = param.forceVerticalPropertyUnitLayout;
    var getcontent = function getcontent(amenityTextSize) {
        var _trigger_clientSideAnalytics, _trigger_clientSideAnalytics1, _toolbar_clientSideAnalytics, _toolbar, _toolbar_clientSideAnalytics1, _toolbar1;
        return [
            /* @__PURE__ */ React115.createElement(MediaSection, {
                key: "media-section-".concat(id),
                unitGallery: unitGallery,
                handleCarouselImageClick: dialogActions.openDialog
            }),
            /* @__PURE__ */ React115.createElement(InfoSection, {
                key: "info-section-".concat(id),
                headerData: header,
                roomId: id,
                features: features
            }, /* @__PURE__ */ React115.createElement(LinkTrigger, {
                data: trigger,
                openDialog: openMoreDetailsDialog("".concat((_trigger_clientSideAnalytics = trigger.clientSideAnalytics) === null || _trigger_clientSideAnalytics === void 0 ? void 0 : _trigger_clientSideAnalytics.referrerId), "".concat((_trigger_clientSideAnalytics1 = trigger.clientSideAnalytics) === null || _trigger_clientSideAnalytics1 === void 0 ? void 0 : _trigger_clientSideAnalytics1.linkName), "".concat((_toolbar = toolbar) === null || _toolbar === void 0 ? void 0 : (_toolbar_clientSideAnalytics = _toolbar.clientSideAnalytics) === null || _toolbar_clientSideAnalytics === void 0 ? void 0 : _toolbar_clientSideAnalytics.referrerId), "".concat((_toolbar1 = toolbar) === null || _toolbar1 === void 0 ? void 0 : (_toolbar_clientSideAnalytics1 = _toolbar1.clientSideAnalytics) === null || _toolbar_clientSideAnalytics1 === void 0 ? void 0 : _toolbar_clientSideAnalytics1.linkName))
            }))
        ].concat(_to_consumable_array(ratePlans.map(function(ratePlan, index) {
            return /* @__PURE__ */ React115.createElement(RatePlanWithAmenities, {
                key: "rate-plan-section-".concat(id, "-").concat(index),
                data: ratePlan,
                listingIndex: listingIndex,
                roomId: id,
                amenityTextSize: amenityTextSize
            });
        })), [
            availabilityCallToAction && /* @__PURE__ */ React115.createElement(AvailabilityCta, {
                key: "availability-cta-".concat(id),
                data: data,
                listingIndex: listingIndex
            }),
            /* @__PURE__ */ React115.createElement(RatePlansExpando, {
                data: ratePlansExpando,
                key: "rate-plans-expando-".concat(id)
            })
        ]);
    };
    var unitGallery = data.unitGallery, detailsDialog = data.detailsDialog, id = data.id, features = data.features, ratePlans = data.ratePlans, availabilityCallToAction = data.availabilityCallToAction, ratePlansExpando = data.ratePlansExpando, header = data.header;
    var trackClick = useClickTracker32();
    var _React115_useState = _sliced_to_array(React115.useState(""), 2), dialogCloseReferrerId = _React115_useState[0], setDialogCloseReferrerId = _React115_useState[1];
    var _React115_useState1 = _sliced_to_array(React115.useState(""), 2), dialogCloseLinkName = _React115_useState1[0], setDialogCloseLinkName = _React115_useState1[1];
    var _useDialog16 = _sliced_to_array(useDialog16("room-info-dialog-".concat(id, "-").concat(listingIndex), "propertyUnitRoomInfoDialog"), 3), isDialogOpen = _useDialog16[0], dialogActions = _useDialog16[1], DialogComponent = _useDialog16[2];
    var closeMoreDetailsDialog = React115.useCallback(function() {
        if (isDialogOpen) {
            dialogActions.closeDialog();
        }
        trackClick(dialogCloseReferrerId, dialogCloseLinkName);
    }, [
        dialogActions,
        trackClick,
        dialogCloseReferrerId,
        dialogCloseLinkName,
        isDialogOpen
    ]);
    if (!id || !detailsDialog) {
        return null;
    }
    var trigger = detailsDialog.trigger, toolbar = detailsDialog.toolbar, content = detailsDialog.content;
    var HorizontalLayout = shouldRenderAsTwoRows ? HorizontalTwoRowsPropertyUnitLayout : HorizontalOneRowPropertyUnitLayout;
    var openMoreDetailsDialog = function(referrerId, linkName, detailsDialogCloseReferrerId, detailsDialogCloseLinkName) {
        return function() {
            dialogActions.openDialog();
            trackClick(referrerId, linkName);
            setDialogCloseReferrerId(detailsDialogCloseReferrerId);
            setDialogCloseLinkName(detailsDialogCloseLinkName);
        };
    };
    return /* @__PURE__ */ React115.createElement("div", {
        className: className,
        key: "property-offer-".concat(listingIndex),
        "data-stid": "property-offer-".concat(listingIndex)
    }, /* @__PURE__ */ React115.createElement(Viewport18, null, /* @__PURE__ */ React115.createElement(ViewSmall17, null, /* @__PURE__ */ React115.createElement(VerticalPropertyUnitLayout, {
        imageRatio: UitkFigureAspectRatioType4.R21_9
    }, getcontent())), /* @__PURE__ */ React115.createElement(ViewLarge4, null, forceVerticalPropertyUnitLayout ? /* @__PURE__ */ React115.createElement(VerticalPropertyUnitLayout, {
        imageRatio: UitkFigureAspectRatioType4.R21_9
    }, getcontent()) : /* @__PURE__ */ React115.createElement(HorizontalLayout, {
        shouldRenderLargeImage: shouldRenderLargeImage
    }, getcontent(shouldRenderAsTwoRows ? 200 : 300)))), /* @__PURE__ */ React115.createElement(DialogComponent, null, /* @__PURE__ */ React115.createElement(UnitPropertyOffersDetailsDialog, {
        closeDialog: closeMoreDetailsDialog,
        isDialogOpen: isDialogOpen,
        listing: data,
        data: detailsDialog,
        ratePlans: /* @__PURE__ */ React115.createElement(DialogRatePlanSection, {
            ratePlanTitle: content.ratePlanTitle,
            listing: data,
            closeDialog: closeMoreDetailsDialog,
            listingIndex: listingIndex
        })
    })));
};
ControlPropertyUnit.fragment = fragment60;
ControlPropertyUnit.displayName = "ControlPropertyUnit";
// src/components/property-offers/__private/__fragments/listings/layouts/listings-layouts.tsx
import React135, { useCallback as useCallback2, useMemo, useRef as useRef2 } from "react";
import { IntersectionTracker as IntersectionTracker9, useClickTracker as useClickTracker35 } from "@shared-ui/clickstream-analytics-context";
import { UitkBadgeTheme as UitkBadgeTheme5 } from "uitk-react-badge";
import { UitkCarousel } from "uitk-react-carousel";
import { UitkLayoutGrid as UitkLayoutGrid20, UitkLayoutGridItem as UitkLayoutGridItem17 } from "uitk-react-layout-grid";
import { UitkSpacing as UitkSpacing70 } from "uitk-react-spacing";
// src/components/property-offers/__private/__fragments/vertical-messaging-card/index.tsx
import React118 from "react";
// src/components/property-offers/__private/__fragments/vertical-messaging-card/message-types/default-to-fully-refundable.ts
import React117 from "react";
import { Level, liveAnnounce as liveAnnounce2 } from "uitk-react-utils";
// src/components/property-offers/__private/__fragments/listings/offers-level-provider/offers-level-provider.tsx
import React116, { useState as useState2 } from "react";
var OffersLevelContext = React116.createContext({});
var OffersLevelProvider = function(param) {
    var children = param.children;
    var _useState2 = _sliced_to_array(useState2(false), 2), isFullyRefundable = _useState2[0], setDefaultToFullyRefundable = _useState2[1];
    var _useState21 = _sliced_to_array(useState2(false), 2), isMessagingCardDismissed = _useState21[0], setDismissMessagingCard = _useState21[1];
    return /* @__PURE__ */ React116.createElement(OffersLevelContext.Provider, {
        value: {
            isFullyRefundable: isFullyRefundable,
            setDefaultToFullyRefundable: setDefaultToFullyRefundable,
            isMessagingCardDismissed: isMessagingCardDismissed,
            setDismissMessagingCard: setDismissMessagingCard
        }
    }, children);
};
// src/components/property-offers/__private/__fragments/vertical-messaging-card/message-types/default-to-fully-refundable.ts
function UseDefaultToFullyRefundable() {
    var _React117_useContext = React117.useContext(OffersLevelContext), setDefaultToFullyRefundable = _React117_useContext.setDefaultToFullyRefundable, setDismissMessagingCard = _React117_useContext.setDismissMessagingCard;
    var primaryClickHandler = function(primaryAction, primaryActionLiveAnnounce) {
        return function() {
            if (primaryAction === "DEFAULT_TO_RECOMMENDED" && setDefaultToFullyRefundable) {
                setDefaultToFullyRefundable(true);
                liveAnnounce2(primaryActionLiveAnnounce, Level.ASSERTIVE);
            }
        };
    };
    var secondaryClickHandler = function(secondaryAction, secondaryActionLiveAnnounce) {
        return function() {
            if (secondaryAction === "DISMISS_RECOMMENDATIONS_CARD" && setDismissMessagingCard) {
                setDismissMessagingCard(true);
                liveAnnounce2(secondaryActionLiveAnnounce, Level.ASSERTIVE);
            }
        };
    };
    return {
        primaryClickHandler: primaryClickHandler,
        secondaryClickHandler: secondaryClickHandler
    };
}
// src/components/property-offers/__private/__fragments/vertical-messaging-card/index.tsx
function withMessagingCardActions(MessagingCard2) {
    var WithMessagingCardActions = function(props) {
        var _data_action_primary_actionDetails, _data_action_primary, _data_action, _data_action_primary_actionDetails1, _data_action_primary1, _data_action1, _data_action_secondary_actionDetails, _data_action_secondary, _data_action2, _data_action_secondary_actionDetails1, _data_action_secondary1, _data_action3;
        var className = props.className, data = props.data;
        var primaryAction = (_data_action = data.action) === null || _data_action === void 0 ? void 0 : (_data_action_primary = _data_action.primary) === null || _data_action_primary === void 0 ? void 0 : (_data_action_primary_actionDetails = _data_action_primary.actionDetails) === null || _data_action_primary_actionDetails === void 0 ? void 0 : _data_action_primary_actionDetails.action;
        var primaryActionLiveAnnounce = ((_data_action1 = data.action) === null || _data_action1 === void 0 ? void 0 : (_data_action_primary1 = _data_action1.primary) === null || _data_action_primary1 === void 0 ? void 0 : (_data_action_primary_actionDetails1 = _data_action_primary1.actionDetails) === null || _data_action_primary_actionDetails1 === void 0 ? void 0 : _data_action_primary_actionDetails1.accessibilityLabel) || "";
        var secondaryAction = (_data_action2 = data.action) === null || _data_action2 === void 0 ? void 0 : (_data_action_secondary = _data_action2.secondary) === null || _data_action_secondary === void 0 ? void 0 : (_data_action_secondary_actionDetails = _data_action_secondary.actionDetails) === null || _data_action_secondary_actionDetails === void 0 ? void 0 : _data_action_secondary_actionDetails.action;
        var secondaryActionLiveAnnounce = ((_data_action3 = data.action) === null || _data_action3 === void 0 ? void 0 : (_data_action_secondary1 = _data_action3.secondary) === null || _data_action_secondary1 === void 0 ? void 0 : (_data_action_secondary_actionDetails1 = _data_action_secondary1.actionDetails) === null || _data_action_secondary_actionDetails1 === void 0 ? void 0 : _data_action_secondary_actionDetails1.accessibilityLabel) || "";
        var _UseDefaultToFullyRefundable = UseDefaultToFullyRefundable(), primaryClickHandler = _UseDefaultToFullyRefundable.primaryClickHandler, secondaryClickHandler = _UseDefaultToFullyRefundable.secondaryClickHandler;
        var primaryActionClickHandler = primaryClickHandler(primaryAction, primaryActionLiveAnnounce);
        var secondaryActionClickHandler = secondaryClickHandler(secondaryAction, secondaryActionLiveAnnounce);
        var messagingCardProps = _object_spread_props(_object_spread({}, props), {
            primaryActionClickHandler: primaryActionClickHandler,
            secondaryActionClickHandler: secondaryActionClickHandler,
            className: className
        });
        return /* @__PURE__ */ React118.createElement(MessagingCard2, _object_spread({}, messagingCardProps));
    };
    WithMessagingCardActions.displayName = "WithMessagingCardActions(".concat(MessagingCard2.displayName || MessagingCard2.name, ")");
    return WithMessagingCardActions;
}
var vertical_messaging_card_default = withMessagingCardActions;
// src/components/property-offers/__private/__fragments/listings/property-unit-categorization/property-unit-categorization.tsx
import React134 from "react";
import { gql as gql107 } from "@apollo/client";
// src/components/property-offers/__private/__fragments/listings/sections/unit-categorization.tsx
import React130 from "react";
import { gql as gql105 } from "@apollo/client";
import { UitkCardContentSection as UitkCardContentSection13 } from "uitk-react-cards";
import { UitkRadioButton } from "uitk-react-radio-button";
import { UitkSpacing as UitkSpacing66 } from "uitk-react-spacing";
import { Level as Level2, liveAnnounce as liveAnnounce3 } from "uitk-react-utils";
// src/components/property-offers/__private/__fragments/rate-plan/unit-categorization-rate-plan.tsx
import React125 from "react";
import { gql as gql101 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex27, UitkLayoutFlexItem as UitkLayoutFlexItem18 } from "uitk-react-layout-flex";
import { UitkMarkSize as UitkMarkSize10 } from "uitk-react-mark";
import { UitkSpacing as UitkSpacing63 } from "uitk-react-spacing";
// src/components/property-offers/__private/__fragments/listings/property-unit-categorization/micro-room-card/micro-room-card-provider.tsx
import React119 from "react";
var initialValue = {
    listingIndex: void 0,
    isMicroRoomCardRatesDialog: false,
    isMicroRoomCardCarousel: false,
    hasSelections: false
};
var MicroRoomCardContext = React119.createContext(initialValue);
var useMicroRoomCard = function() {
    return React119.useContext(MicroRoomCardContext);
};
var MicroRoomCardProvider = function(param) {
    var children = param.children, _param_value = param.value, isMicroRoomCardRatesDialog = _param_value.isMicroRoomCardRatesDialog, isMicroRoomCardCarousel = _param_value.isMicroRoomCardCarousel, hasSelections = _param_value.hasSelections, listingIndex = _param_value.listingIndex;
    var value = React119.useMemo(function() {
        return {
            listingIndex: listingIndex,
            isMicroRoomCardRatesDialog: isMicroRoomCardRatesDialog,
            isMicroRoomCardCarousel: isMicroRoomCardCarousel,
            hasSelections: hasSelections
        };
    }, []);
    return /* @__PURE__ */ React119.createElement(MicroRoomCardContext.Provider, {
        value: value
    }, children);
};
// src/components/property-offers/__private/__fragments/listings/sections/offer-notifications.tsx
import React121 from "react";
import { UitkSpacing as UitkSpacing59 } from "uitk-react-spacing";
// src/components/property-offers/__private/__fragments/notifications-card/index.tsx
import React120 from "react";
import { gql as gql99 } from "@apollo/client";
import { UitkCard as UitkCard20 } from "uitk-react-cards";
import { UitkList as UitkList7, UitkListItem as UitkListItem8 } from "uitk-react-list";
import { UitkSpacing as UitkSpacing58 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading25 } from "uitk-react-text";
var fragment61 = gql99(_templateObject99(), LodgingEnrichedMessage.fragment);
var LodgingNotificationsCard = function(param) {
    var data = param.data, _param_border = param.border, border = _param_border === void 0 ? true : _param_border;
    if (!data) {
        return null;
    }
    var header = data.header, messages = data.messages;
    return /* @__PURE__ */ React120.createElement(UitkCard20, {
        padded: true,
        border: border
    }, header && /* @__PURE__ */ React120.createElement(UitkHeading25, {
        size: 7,
        tag: "h2"
    }, header.text), /* @__PURE__ */ React120.createElement(UitkSpacing58, {
        padding: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React120.createElement(UitkList7, {
        bullet: "no-bullet"
    }, messages.map(function(message, index) {
        switch(message.__typename){
            case "LodgingEnrichedMessage":
                return /* @__PURE__ */ React120.createElement(UitkListItem8, {
                    key: "room-level-notification-".concat(index)
                }, /* @__PURE__ */ React120.createElement(LodgingEnrichedMessage, {
                    data: message
                }));
            default:
                return null;
        }
    }))));
};
LodgingNotificationsCard.displayName = "LodgingNotificationsCard";
LodgingNotificationsCard.fragment = fragment61;
// src/components/property-offers/__private/__fragments/listings/sections/offer-notifications.tsx
var OfferNotifications = function() {
    var _ratePlan;
    var ratePlan = React121.useContext(UnitRateContext).ratePlan;
    if (!ratePlan || !((_ratePlan = ratePlan) === null || _ratePlan === void 0 ? void 0 : _ratePlan.offerNotifications)) {
        return null;
    }
    var offerNotifications = ratePlan.offerNotifications;
    return /* @__PURE__ */ React121.createElement(UitkSpacing59, {
        margin: {
            block: "six"
        }
    }, /* @__PURE__ */ React121.createElement("div", null, /* @__PURE__ */ React121.createElement(LodgingNotificationsCard, {
        data: offerNotifications
    })));
};
var offer_notifications_default = OfferNotifications;
// src/components/property-offers/__private/__fragments/listings/sections/unit-categorization-highlighted-messages.tsx
import React122 from "react";
import { UitkLayoutGrid as UitkLayoutGrid19 } from "uitk-react-layout-grid";
import { UitkSpacing as UitkSpacing60 } from "uitk-react-spacing";
var UnitCategorizationHighlightedMessages = function(param) {
    var _param_highlightedMessages = param.highlightedMessages, highlightedMessages = _param_highlightedMessages === void 0 ? [] : _param_highlightedMessages, _param_id = param.id, id = _param_id === void 0 ? "" : _param_id;
    return /* @__PURE__ */ React122.createElement(React122.Fragment, null, highlightedMessages.length > 0 && /* @__PURE__ */ React122.createElement(UitkSpacing60, {
        margin: {
            block: "two"
        }
    }, /* @__PURE__ */ React122.createElement(UitkLayoutGrid19, {
        "data-stid": "highlightedMessages-".concat(id)
    }, highlightedMessages.map(function(highlightedMessage, index) {
        return /* @__PURE__ */ React122.createElement(RatePlanMessage, {
            key: "highlightedMessages-".concat(id, "-").concat(index),
            data: highlightedMessage
        });
    }))));
};
UnitCategorizationHighlightedMessages.displayName = "UnitCategorizationHighlightedMessages";
// src/components/property-offers/__private/__fragments/property-rate-plan-standard-badge.tsx
import React123 from "react";
import { gql as gql100 } from "@apollo/client";
import { IntersectionTracker as IntersectionTracker8 } from "@shared-ui/clickstream-analytics-context";
import { UitkBadge as UitkBadge2, UitkBadgeLoyalty as UitkBadgeLoyalty3 } from "uitk-react-badge";
import { UitkIcon as UitkIcon27, UitkIconSize as UitkIconSize21 } from "uitk-react-icons";
import { UitkSpacing as UitkSpacing61 } from "uitk-react-spacing";
var fragment62 = gql100(_templateObject100());
var PropertyRatePlanStandardBadge = function(param) {
    var data = param.data;
    var _data;
    var _data_standardBadge;
    var _ref = (_data_standardBadge = (_data = data) === null || _data === void 0 ? void 0 : _data.standardBadge) !== null && _data_standardBadge !== void 0 ? _data_standardBadge : {}, standardBadge = _ref.standardBadge, impressionEventAnalytics = _ref.impressionEventAnalytics;
    if (!standardBadge || !standardBadge.text) {
        return null;
    }
    var text = standardBadge.text, theme = standardBadge.theme, graphic = standardBadge.graphic;
    var loyaltyBadge = theme ? UitkBadgeLoyaltyThemeMapper[theme] : void 0;
    var _ref1 = impressionEventAnalytics !== null && impressionEventAnalytics !== void 0 ? impressionEventAnalytics : {}, referrerId = _ref1.referrerId, linkName = _ref1.linkName;
    var graphics = function() {
        var _graphic;
        switch((_graphic = graphic) === null || _graphic === void 0 ? void 0 : _graphic.__typename){
            case "Icon":
                return graphic.id && /* @__PURE__ */ React123.createElement(UitkIcon27, {
                    name: graphic.id,
                    id: graphic.id,
                    description: graphic.description,
                    size: UitkIconSize21.SMALL
                });
            default:
                return null;
        }
    };
    var UitkLoyaltyBadge = /* @__PURE__ */ React123.createElement(UitkBadgeLoyalty3, {
        theme: loyaltyBadge,
        text: text
    }, graphics());
    var impressionTrackingTieredMod = referrerId && linkName ? /* @__PURE__ */ React123.createElement(IntersectionTracker8, {
        referrerId: referrerId,
        linkName: linkName,
        trackOnce: true
    }, UitkLoyaltyBadge) : UitkLoyaltyBadge;
    return /* @__PURE__ */ React123.createElement(UitkSpacing61, {
        margin: {
            blockend: "one"
        }
    }, loyaltyBadge ? impressionTrackingTieredMod : /* @__PURE__ */ React123.createElement(UitkBadge2, {
        theme: theme ? UitkBadgeThemeMapper[theme] : void 0,
        text: text
    }, graphics()));
};
PropertyRatePlanStandardBadge.fragment = fragment62;
PropertyRatePlanStandardBadge.displayName = "PropertyRatePlanStandardBadge";
// src/components/property-offers/__private/__fragments/rate-plan/price-details.tsx
import React124 from "react";
import { PriceSummary as PriceSummary3 } from "@shared-ui/pricing-price-summary";
import { PositionType as PositionType2 } from "uitk-react-menu";
import { UitkPriceLockupAlign as UitkPriceLockupAlign5 } from "uitk-react-price-lockup";
import { UitkSpacing as UitkSpacing62 } from "uitk-react-spacing";
import { UitkText as UitkText38 } from "uitk-react-text";
var ETP_DIALOG_QUERY_PARAM = "infosite-room-ratePlans";
var PointsApplied = function(param) {
    var pointsApplied = param.pointsApplied;
    if (!pointsApplied) {
        return null;
    }
    return /* @__PURE__ */ React124.createElement(UitkSpacing62, {
        margin: {
            blockend: "one"
        }
    }, /* @__PURE__ */ React124.createElement(UitkText38, {
        size: 100,
        theme: "default",
        "data-stid": "price-points"
    }, pointsApplied));
};
var PriceDetails = function(param) {
    var listingIndex = param.listingIndex, paymentPolicy = param.paymentPolicy, priceDetail = param.priceDetail, ratePlan = param.ratePlan, _param_enableInlineLink = param.enableInlineLink, enableInlineLink = _param_enableInlineLink === void 0 ? false : _param_enableInlineLink, roomTypeId = param.roomTypeId;
    var _priceDetail_price_displayMessages, _priceDetail_price;
    var isWithinDetailsDialog = React124.useContext(dialog_context_default);
    return /* @__PURE__ */ React124.createElement("div", null, ((_priceDetail_price = priceDetail.price) === null || _priceDetail_price === void 0 ? void 0 : (_priceDetail_price_displayMessages = _priceDetail_price.displayMessages) === null || _priceDetail_price_displayMessages === void 0 ? void 0 : _priceDetail_price_displayMessages.length) ? /* @__PURE__ */ React124.createElement("div", {
        "data-stid": "price-summary"
    }, /* @__PURE__ */ React124.createElement(PriceSummary3, {
        data: priceDetail.price,
        flexAlignment: "start",
        enableInlineLink: enableInlineLink
    })) : /* @__PURE__ */ React124.createElement(LodgingPriceSummary, {
        align: UitkPriceLockupAlign5.LEFT,
        data: priceDetail
    }), !isWithinDetailsDialog && /* @__PURE__ */ React124.createElement(PointsApplied, {
        pointsApplied: priceDetail.pointsApplied
    }), priceDetail.priceBreakDownSummary ? /* @__PURE__ */ React124.createElement(PriceBreakdownSummary, {
        data: priceDetail,
        menuContainerPosition: PositionType2.LEFT,
        actionButton: /* @__PURE__ */ React124.createElement(PropertyReserveButton, {
            dialogSuffix: ETP_DIALOG_QUERY_PARAM,
            data: ratePlan,
            listingIndex: listingIndex,
            paymentPolicy: paymentPolicy,
            rfrrSuffix: "RoomsAndRates" /* Standard */ 
        }),
        roomTypeId: roomTypeId,
        ratePlanId: ratePlan.id
    }) : /* @__PURE__ */ React124.createElement(PricePresentationDialog, {
        data: priceDetail,
        actionButton: /* @__PURE__ */ React124.createElement(PropertyReserveButton, {
            dialogSuffix: ETP_DIALOG_QUERY_PARAM,
            data: ratePlan,
            listingIndex: listingIndex,
            paymentPolicy: paymentPolicy,
            rfrrSuffix: "RoomsAndRates" /* Standard */ ,
            isFullWidth: true
        }),
        roomTypeId: roomTypeId,
        ratePlanId: ratePlan.id
    }), isWithinDetailsDialog && /* @__PURE__ */ React124.createElement(PointsApplied, {
        pointsApplied: priceDetail.pointsApplied
    }));
};
// src/components/property-offers/__private/__fragments/rate-plan/unit-categorization-rate-plan.tsx
var UnitCategorizationRatePlanFragment = gql101(_templateObject101(), LodgingEnrichedMessage.fragment, PropertyOffersRateViewScarcity.fragment, LodgingPriceSummary.fragment, PriceBreakdownSummary.fragment, PropertyRatePlanBadge.fragment, PropertyRatePlanStandardBadge.fragment, PropertyOffersPriceChangeMessage.fragment, PropertyReserveButton.fragment, PriceSummaryFragment, LodgingNotificationsCard.fragment, PricePresentationDialog.fragment, RatePlanAnalyticsTracker.fragment);
var UnitCategorizationRatePlan = function(param) {
    var listingIndex = param.listingIndex, roomId = param.roomId, highlightedMessages = param.highlightedMessages;
    var ETP_DIALOG_QUERY_PARAM3 = "infosite-room-ratePlans";
    var ratePlan = React125.useContext(UnitRateContext).ratePlan;
    var isWithinDetailsDialog = React125.useContext(dialog_context_default);
    var _useMicroRoomCard = useMicroRoomCard(), isMicroRoomCardRatesDialog = _useMicroRoomCard.isMicroRoomCardRatesDialog, hasSelections = _useMicroRoomCard.hasSelections, isMicroRoomCardCarousel = _useMicroRoomCard.isMicroRoomCardCarousel;
    if (!ratePlan) {
        return null;
    }
    var id = ratePlan.id, loyaltyMessage = ratePlan.loyaltyMessage, marketingSection = ratePlan.marketingSection, headerMessage = ratePlan.headerMessage, paymentPolicy = ratePlan.paymentPolicy, _ratePlan_priceDetails = _sliced_to_array(ratePlan.priceDetails, 1), priceDetail = _ratePlan_priceDetails[0];
    var roomAnalytics = roomSchema(roomId, [
        {
            ratePlanCode: id
        }
    ]);
    var reserveButtonBase = /* @__PURE__ */ React125.createElement(PropertyReserveButton, {
        dialogSuffix: ETP_DIALOG_QUERY_PARAM3,
        data: ratePlan,
        listingIndex: listingIndex,
        paymentPolicy: paymentPolicy,
        rfrrSuffix: "RoomsAndRates" /* Standard */ ,
        isFullWidth: isMicroRoomCardCarousel && !isWithinDetailsDialog
    });
    var reserveButton = null;
    switch(isWithinDetailsDialog){
        case false:
            if (isMicroRoomCardCarousel) {
                reserveButton = /* @__PURE__ */ React125.createElement(UitkSpacing63, {
                    margin: {
                        block: "three"
                    }
                }, /* @__PURE__ */ React125.createElement("div", null, reserveButtonBase));
            } else if (isMicroRoomCardRatesDialog) {
                reserveButton = null;
            } else {
                reserveButton = reserveButtonBase;
            }
            break;
        default:
            reserveButton = reserveButtonBase;
    }
    var priceBadge = /* @__PURE__ */ React125.createElement("div", null, ratePlan.standardBadge ? /* @__PURE__ */ React125.createElement(PropertyRatePlanStandardBadge, {
        data: ratePlan
    }) : /* @__PURE__ */ React125.createElement(PropertyRatePlanBadge, {
        data: ratePlan
    }));
    return /* @__PURE__ */ React125.createElement(RatePlanAnalyticsTracker, {
        data: ratePlan,
        ratePlanId: id
    }, /* @__PURE__ */ React125.createElement(UnitCategorizationHighlightedMessages, {
        highlightedMessages: highlightedMessages,
        id: id
    }), (!isMicroRoomCardCarousel || isWithinDetailsDialog) && /* @__PURE__ */ React125.createElement(offer_notifications_default, null), marketingSection && /* @__PURE__ */ React125.createElement(UitkSpacing63, {
        margin: {
            block: "six"
        }
    }, /* @__PURE__ */ React125.createElement("div", null, /* @__PURE__ */ React125.createElement(MarketingSection, {
        data: marketingSection
    }))), headerMessage && /* @__PURE__ */ React125.createElement(PropertyOffersPriceChangeMessage, {
        data: ratePlan
    }), loyaltyMessage && /* @__PURE__ */ React125.createElement(UitkSpacing63, {
        margin: {
            block: "three"
        }
    }, /* @__PURE__ */ React125.createElement("div", null, /* @__PURE__ */ React125.createElement(LodgingEnrichedMessage, {
        data: loyaltyMessage,
        markSize: UitkMarkSize10.SMALL,
        textSize: 300
    }))), priceBadge, /* @__PURE__ */ React125.createElement(UitkLayoutFlex27, {
        alignItems: isWithinDetailsDialog ? "start" : "end",
        justifyContent: "space-between"
    }, /* @__PURE__ */ React125.createElement(UitkLayoutFlexItem18, null, /* @__PURE__ */ React125.createElement("div", null, /* @__PURE__ */ React125.createElement(PriceDetails, {
        listingIndex: listingIndex,
        paymentPolicy: paymentPolicy,
        priceDetail: priceDetail,
        ratePlan: ratePlan,
        roomTypeId: roomId,
        enableInlineLink: true
    }))), /* @__PURE__ */ React125.createElement(UitkLayoutFlexItem18, {
        alignSelf: "end"
    }, /* @__PURE__ */ React125.createElement(UitkLayoutFlex27, {
        direction: "column",
        alignItems: "end",
        space: "two"
    }, /* @__PURE__ */ React125.createElement(PropertyOffersRateViewScarcity, {
        data: priceDetail
    }), (!isMicroRoomCardCarousel || isWithinDetailsDialog) && reserveButton))), isMicroRoomCardCarousel && !hasSelections && !isWithinDetailsDialog && reserveButton);
};
UnitCategorizationRatePlan.displayName = "UnitCategorizationRatePlan";
// src/components/property-offers/__private/__fragments/listings/sections/radio-group.tsx
import React129 from "react";
import { UitkRadioButtonGroup } from "uitk-react-radio-button";
// src/components/property-offers/__private/__fragments/listings/sections/selection-header.tsx
import React128 from "react";
import { gql as gql104 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex28, UitkLayoutFlexItem as UitkLayoutFlexItem19 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing65 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading27, UitkText as UitkText40 } from "uitk-react-text";
// src/components/property-offers/__private/__fragments/unit-categorization-complex-dialog.tsx
import React126 from "react";
import { gql as gql102 } from "@apollo/client";
import { useClickTracker as useClickTracker33 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog17 } from "@shared-ui/dialog-context";
import { ViewMedium as ViewMedium15, Viewport as Viewport19, ViewSmall as ViewSmall18 } from "@shared-ui/viewport-context";
import { UitkTertiaryButton as UitkTertiaryButton4 } from "uitk-react-button";
import { UitkIcon as UitkIcon28, UitkIconSize as UitkIconSize22 } from "uitk-react-icons";
import { UitkLink as UitkLink15 } from "uitk-react-link";
import { UitkSheet as UitkSheet11, UitkSheetContent as UitkSheetContent5 } from "uitk-react-sheet";
import { UitkSpacing as UitkSpacing64 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading26, UitkText as UitkText39 } from "uitk-react-text";
import { UitkToolbar as UitkToolbar11 } from "uitk-react-toolbar";
var fragment63 = gql102(_templateObject102(), __UIPrimaryButtonFragment);
var UnitCategorizationComplexDialog = function(param) {
    var data = param.data;
    var _toolbar, _toolbar_icon, _toolbar1, _content;
    var dialogPostfix = useDialogId();
    var _useDialog17 = _sliced_to_array(useDialog17("unit-categorization-complex-".concat(dialogPostfix), "pwaDialogNested"), 3), isOpen = _useDialog17[0], dialogActions = _useDialog17[1], DialogComponent = _useDialog17[2];
    var trackClick = useClickTracker33();
    var triggerRef = React126.useRef(null);
    if (!data) {
        return null;
    }
    var content = data.content, primaryUIButton = data.primaryUIButton, toolbar = data.toolbar, trigger = data.trigger;
    var openDialog = function() {
        var _trigger;
        dialogActions.openDialog();
        if ((_trigger = trigger) === null || _trigger === void 0 ? void 0 : _trigger.clientSideAnalytics) {
            trackClick("HOT.HIS" /* Infosite */ .concat(trigger.clientSideAnalytics.referrerId), trigger.clientSideAnalytics.linkName);
        }
    };
    var closeDialog = function() {
        var _toolbar;
        dialogActions.closeDialog();
        if ((_toolbar = toolbar) === null || _toolbar === void 0 ? void 0 : _toolbar.clientSideAnalytics) {
            trackClick("HOT.HIS" /* Infosite */ .concat(toolbar.clientSideAnalytics.referrerId), toolbar.clientSideAnalytics.linkName);
        }
    };
    var renderDialogEntries = function(entry, entryIndex) {
        return /* @__PURE__ */ React126.createElement(UitkText39, {
            key: entryIndex,
            size: 300,
            spacing: entryIndex ? "three" : void 0
        }, entry);
    };
    var renderDialogContent = function(param, sectionIndex) {
        var entries = param.content, title = param.title;
        var _title, _entries;
        return /* @__PURE__ */ React126.createElement(React126.Fragment, {
            key: sectionIndex
        }, /* @__PURE__ */ React126.createElement(UitkSpacing64, {
            margin: {
                blockstart: sectionIndex ? "three" : void 0
            }
        }, /* @__PURE__ */ React126.createElement(UitkHeading26, {
            tag: "h3",
            size: 7,
            "data-stid": "property-offers-secondary-dialog-heading"
        }, (_title = title) === null || _title === void 0 ? void 0 : _title.text)), (_entries = entries) === null || _entries === void 0 ? void 0 : _entries.map(renderDialogEntries));
    };
    var _toolbar_title;
    var dialogContent = /* @__PURE__ */ React126.createElement(React126.Fragment, null, /* @__PURE__ */ React126.createElement(UitkToolbar11, {
        toolbarTitle: (_toolbar_title = (_toolbar = toolbar) === null || _toolbar === void 0 ? void 0 : _toolbar.title) !== null && _toolbar_title !== void 0 ? _toolbar_title : void 0,
        navigationContent: {
            navType: "close",
            navIconLabel: (_toolbar1 = toolbar) === null || _toolbar1 === void 0 ? void 0 : (_toolbar_icon = _toolbar1.icon) === null || _toolbar_icon === void 0 ? void 0 : _toolbar_icon.description,
            onClick: closeDialog
        }
    }), /* @__PURE__ */ React126.createElement(UitkSheetContent5, null, (_content = content) === null || _content === void 0 ? void 0 : _content.map(renderDialogContent), primaryUIButton && /* @__PURE__ */ React126.createElement(UitkSpacing64, {
        padding: {
            blockstart: "four"
        }
    }, /* @__PURE__ */ React126.createElement("div", null, /* @__PURE__ */ React126.createElement(UitkTertiaryButton4, _object_spread_props(_object_spread({}, getUiButtonProps(primaryUIButton.action, trackClick, closeDialog)), {
        isFullWidth: true
    }), primaryUIButton.primary || "")))));
    var sheetProps = {
        isVisible: isOpen,
        returnFocusOnClose: true,
        triggerRef: triggerRef
    };
    return /* @__PURE__ */ React126.createElement(UitkSpacing64, {
        padding: {
            blockstart: "half",
            blockend: "one"
        }
    }, /* @__PURE__ */ React126.createElement("div", null, /* @__PURE__ */ React126.createElement(UitkSpacing64, {
        padding: {
            block: "two"
        }
    }, /* @__PURE__ */ React126.createElement(UitkLink15, {
        onClick: openDialog,
        "data-stid": "property-offers-secondary-dialog-link"
    }, /* @__PURE__ */ React126.createElement("button", {
        type: "button",
        ref: triggerRef
    }, /* @__PURE__ */ React126.createElement(UitkText39, {
        size: 200,
        theme: "default",
        "data-stid": "property-offers-secondary-dialog-trigger"
    }, trigger.value, trigger.icon && /* @__PURE__ */ React126.createElement(UitkIcon28, {
        name: trigger.icon.id,
        size: UitkIconSize22.SMALL
    }))))), content && /* @__PURE__ */ React126.createElement(DialogComponent, null, /* @__PURE__ */ React126.createElement(Viewport19, null, /* @__PURE__ */ React126.createElement(ViewSmall18, null, /* @__PURE__ */ React126.createElement(UitkSheet11, _object_spread_props(_object_spread({}, sheetProps), {
        type: "full"
    }), dialogContent)), /* @__PURE__ */ React126.createElement(ViewMedium15, null, /* @__PURE__ */ React126.createElement(UitkSheet11, _object_spread_props(_object_spread({}, sheetProps), {
        type: "centered"
    }), dialogContent))))));
};
UnitCategorizationComplexDialog.fragment = fragment63;
UnitCategorizationComplexDialog.displayName = "UnitCategorizationComplexDialog";
// src/components/property-offers/__private/__fragments/listings/sections/selection-header-dialog.tsx
import React127 from "react";
import { gql as gql103 } from "@apollo/client";
var fragment64 = gql103(_templateObject103(), UnitCategorizationComplexDialog.fragment, LodgingPolicyDialog.fragment);
var SelectionHeaderDialog = function(param) {
    var data = param.data;
    switch(data.__typename){
        case "LodgingComplexDialog":
            return /* @__PURE__ */ React127.createElement(UnitCategorizationComplexDialog, {
                data: data
            });
        case "LodgingPolicyDialog":
            return /* @__PURE__ */ React127.createElement(LodgingPolicyDialog, {
                data: data,
                uniqueDialogId: "lodging-cancellation-policy-dialog",
                policyType: "MULTIPLE" /* MULTIPLE */ 
            });
        default:
            return null;
    }
};
SelectionHeaderDialog.fragment = fragment64;
SelectionHeaderDialog.displayName = "SelectionHeader";
// src/components/property-offers/__private/__fragments/listings/sections/selection-header.tsx
var fragment65 = gql104(_templateObject104(), UnitCategorizationComplexDialog.fragment, SelectionHeaderDialog.fragment);
var SelectionHeader = function(param) {
    var data = param.data;
    var title = data.title;
    if (!title) {
        return null;
    }
    return /* @__PURE__ */ React128.createElement(UitkSpacing65, null, /* @__PURE__ */ React128.createElement("div", null, /* @__PURE__ */ React128.createElement(UitkLayoutFlex28, {
        space: "one",
        justifyContent: "space-between"
    }, /* @__PURE__ */ React128.createElement(UitkLayoutFlexItem19, null, /* @__PURE__ */ React128.createElement(UitkHeading27, {
        tag: "h4",
        size: 7
    }, title.text)), title.subText && /* @__PURE__ */ React128.createElement(UitkLayoutFlexItem19, null, /* @__PURE__ */ React128.createElement(UitkText40, {
        size: 200
    }, title.subText))), data.dialog && /* @__PURE__ */ React128.createElement(UnitCategorizationComplexDialog, {
        data: data.dialog
    }), !data.dialog && data.complexDialog && /* @__PURE__ */ React128.createElement(SelectionHeaderDialog, {
        data: data.complexDialog
    })));
};
SelectionHeader.fragment = fragment65;
SelectionHeader.displayName = "SelectionHeader";
// src/components/property-offers/__private/__fragments/listings/sections/radio-group.tsx
var RadioGroup = function(param) {
    var selectionHeader = param.selectionHeader, radioGroup = param.radioGroup, children = param.children, unitCategorizationKey = param.unitCategorizationKey, handleChange = param.handleChange, selectedIndex = param.selectedIndex, listingIndex = param.listingIndex;
    var _selectionHeader;
    var groupName = "".concat(unitCategorizationKey, "-").concat(radioGroup, "-").concat(listingIndex);
    return /* @__PURE__ */ React129.createElement(React129.Fragment, null, selectionHeader && /* @__PURE__ */ React129.createElement(SelectionHeader, {
        data: selectionHeader
    }), /* @__PURE__ */ React129.createElement(UitkRadioButtonGroup, {
        legendLabel: ((_selectionHeader = selectionHeader) === null || _selectionHeader === void 0 ? void 0 : _selectionHeader.title.accessibilityLabel) || "",
        group: groupName,
        onChange: handleChange,
        selected: "".concat(unitCategorizationKey, "-").concat(radioGroup, "-").concat(selectedIndex),
        key: "".concat(unitCategorizationKey, "-").concat(radioGroup, "RadioGroup")
    }, children));
};
RadioGroup.displayName = "RadioGroup";
// src/components/property-offers/__private/__fragments/listings/sections/unit-categorization.tsx
var UnitCategorizationPropertyUnitFragment = gql105(_templateObject105(), AvailabilityCta.fragment, LinkTrigger.fragment, UnitPropertyOffersDetailsDialog.fragment, RatePlanWithAmenities.fragment, RoomAmenitiesDescription.fragment, UnitCategorizationRatePlanFragment, SpaceDetails.fragment);
var UnitCategorizationSelectionFragment = gql105(_templateObject106());
var fragment66 = gql105(_templateObject107(), LodgingPlainFullscreenDialog.fragment, SelectionHeader.fragment, UnitCategorizationPropertyUnitFragment, UnitCategorizationSelectionFragment);
var UnitCategorization = function(param) {
    var data = param.data, listingIndex = param.listingIndex;
    var _secondarySelections, _secondaryTarget_tertiarySelections, _secondaryTarget;
    var primarySelections = data.primarySelections, primaryHeader = data.primaryHeader, secondaryHeader = data.secondaryHeader, tertiaryHeader = data.tertiaryHeader;
    var _React130_useContext = React130.useContext(UnitRateContext), primaryIndex = _React130_useContext.primaryIndex, secondaryIndex = _React130_useContext.secondaryIndex, tertiaryIndex = _React130_useContext.tertiaryIndex, handleRadio = _React130_useContext.handleRadio, radioSelections = _React130_useContext.radioSelections;
    var indexes = {
        primaryIndex: primaryIndex || 0,
        secondaryIndex: secondaryIndex || 0,
        tertiaryIndex: tertiaryIndex || 0
    };
    var _getSelections = getSelections(primarySelections, indexes), secondaryTarget = _getSelections.secondaryTarget, secondarySelections = _getSelections.secondarySelections;
    var isWithinDetailsDialog = React130.useContext(dialog_context_default);
    var unitCategorizationKey = "".concat(isWithinDetailsDialog ? "dialog" : "LodgingCategorizedUnit", "-").concat(listingIndex);
    var _ref = radioSelections || {}, hasPrimary = _ref.hasPrimary, hasSecondary = _ref.hasSecondary, hasTertiary = _ref.hasTertiary;
    React130.useEffect(function() {
        if (primarySelections && primaryIndex !== void 0) {
            var _primarySelections_primaryIndex_primarySelection;
            var liveAnnounceMessage = (_primarySelections_primaryIndex_primarySelection = primarySelections[primaryIndex].primarySelection) === null || _primarySelections_primaryIndex_primarySelection === void 0 ? void 0 : _primarySelections_primaryIndex_primarySelection.liveAnnounceMessage;
            if (!liveAnnounceMessage) {
                return;
            }
            liveAnnounce3(liveAnnounceMessage, Level2.POLITE);
            setTimeout(function() {
                liveAnnounce3("", Level2.ASSERTIVE);
            }, 500);
        }
    }, [
        primarySelections,
        primaryIndex
    ]);
    if (!primarySelections || !radioSelections) {
        return null;
    }
    return /* @__PURE__ */ React130.createElement(UitkSpacing66, {
        margin: !isWithinDetailsDialog ? {
            inline: "three",
            blockstart: "three"
        } : void 0
    }, /* @__PURE__ */ React130.createElement("div", null, hasPrimary && /* @__PURE__ */ React130.createElement(UitkSpacing66, {
        padding: {
            inline: "half"
        }
    }, /* @__PURE__ */ React130.createElement(UitkCardContentSection13, {
        padded: false
    }, /* @__PURE__ */ React130.createElement(RadioGroup, {
        selectionHeader: primaryHeader,
        selectedIndex: primaryIndex,
        handleChange: handleRadio,
        unitCategorizationKey: unitCategorizationKey,
        radioGroup: "roomFeatures",
        listingIndex: listingIndex
    }, primarySelections.map(function(option, index) {
        var _option_primarySelection, _option, _option_primarySelection1, _option1, _option_primarySelection2, _option2;
        var key = "".concat(unitCategorizationKey, "-roomFeatures-").concat(index);
        return /* @__PURE__ */ React130.createElement(UitkRadioButton, {
            description: ((_option = option) === null || _option === void 0 ? void 0 : (_option_primarySelection = _option.primarySelection) === null || _option_primarySelection === void 0 ? void 0 : _option_primarySelection.subText) || "",
            id: key,
            key: key,
            labelSuffix: ((_option1 = option) === null || _option1 === void 0 ? void 0 : (_option_primarySelection1 = _option1.primarySelection) === null || _option_primarySelection1 === void 0 ? void 0 : _option_primarySelection1.price) || "",
            value: key
        }, (_option2 = option) === null || _option2 === void 0 ? void 0 : (_option_primarySelection2 = _option2.primarySelection) === null || _option_primarySelection2 === void 0 ? void 0 : _option_primarySelection2.description);
    })))), hasSecondary && /* @__PURE__ */ React130.createElement(UitkSpacing66, {
        padding: {
            inline: "half"
        },
        margin: hasPrimary ? {
            blockstart: "two"
        } : void 0
    }, /* @__PURE__ */ React130.createElement(UitkCardContentSection13, {
        padded: hasPrimary ? [
            "blockstart"
        ] : false,
        border: hasPrimary ? "top" : void 0
    }, /* @__PURE__ */ React130.createElement(RadioGroup, {
        selectionHeader: secondaryHeader,
        selectedIndex: secondaryIndex,
        handleChange: handleRadio,
        unitCategorizationKey: unitCategorizationKey,
        radioGroup: "cancellationPolicy",
        listingIndex: listingIndex
    }, (_secondarySelections = secondarySelections) === null || _secondarySelections === void 0 ? void 0 : _secondarySelections.map(function(option, index) {
        var _option_secondarySelection, _option, _option_secondarySelection1, _option1, _option_secondarySelection2, _option2, _option_secondarySelection3, _option3, _option_secondarySelection4, _option4;
        var key = "".concat(unitCategorizationKey, "-cancellationPolicy-").concat(index);
        return /* @__PURE__ */ React130.createElement(UitkRadioButton, {
            description: ((_option = option) === null || _option === void 0 ? void 0 : (_option_secondarySelection = _option.secondarySelection) === null || _option_secondarySelection === void 0 ? void 0 : _option_secondarySelection.subText) || "",
            disabled: !((_option1 = option) === null || _option1 === void 0 ? void 0 : (_option_secondarySelection1 = _option1.secondarySelection) === null || _option_secondarySelection1 === void 0 ? void 0 : _option_secondarySelection1.enabled) || false,
            id: key,
            key: key,
            labelSuffix: ((_option2 = option) === null || _option2 === void 0 ? void 0 : (_option_secondarySelection2 = _option2.secondarySelection) === null || _option_secondarySelection2 === void 0 ? void 0 : _option_secondarySelection2.price) || "",
            value: key
        }, (_option3 = option) === null || _option3 === void 0 ? void 0 : (_option_secondarySelection3 = _option3.secondarySelection) === null || _option_secondarySelection3 === void 0 ? void 0 : _option_secondarySelection3.description, ((_option4 = option) === null || _option4 === void 0 ? void 0 : (_option_secondarySelection4 = _option4.secondarySelection) === null || _option_secondarySelection4 === void 0 ? void 0 : _option_secondarySelection4.dialog) && /* @__PURE__ */ React130.createElement("div", null, /* @__PURE__ */ React130.createElement(LodgingPlainFullscreenDialog, {
            key: "".concat(key, "-dialog"),
            isHtmlContent: true,
            uniqueDialogId: "".concat(key, "-dialog"),
            spacing: {
                padding: {
                    block: "two"
                }
            },
            data: option.secondarySelection.dialog
        })));
    })))), hasTertiary && /* @__PURE__ */ React130.createElement(UitkSpacing66, {
        padding: {
            inline: "half"
        },
        margin: hasPrimary || hasSecondary ? {
            blockstart: "two"
        } : void 0
    }, /* @__PURE__ */ React130.createElement(UitkCardContentSection13, {
        padded: hasPrimary || hasSecondary ? [
            "blockstart"
        ] : false,
        border: hasPrimary || hasSecondary ? "top" : void 0
    }, /* @__PURE__ */ React130.createElement(RadioGroup, {
        handleChange: handleRadio,
        radioGroup: "extras",
        selectionHeader: tertiaryHeader,
        unitCategorizationKey: unitCategorizationKey,
        selectedIndex: tertiaryIndex,
        listingIndex: listingIndex
    }, (_secondaryTarget = secondaryTarget) === null || _secondaryTarget === void 0 ? void 0 : (_secondaryTarget_tertiarySelections = _secondaryTarget.tertiarySelections) === null || _secondaryTarget_tertiarySelections === void 0 ? void 0 : _secondaryTarget_tertiarySelections.map(function(option, index) {
        var _option, _option1, _option2, _option3, _option4;
        var key = "".concat(unitCategorizationKey, "-extras-").concat(index);
        var _option_accessibilityLabel, _option_price;
        return /* @__PURE__ */ React130.createElement(UitkRadioButton, {
            a11yLabel: (_option_accessibilityLabel = (_option = option) === null || _option === void 0 ? void 0 : _option.accessibilityLabel) !== null && _option_accessibilityLabel !== void 0 ? _option_accessibilityLabel : "",
            description: ((_option1 = option) === null || _option1 === void 0 ? void 0 : _option1.subText) || "",
            disabled: !option.enabled,
            id: key,
            key: key,
            labelSuffix: (_option_price = (_option2 = option) === null || _option2 === void 0 ? void 0 : _option2.price) !== null && _option_price !== void 0 ? _option_price : "",
            value: key
        }, /* @__PURE__ */ React130.createElement(React130.Fragment, null, ((_option3 = option) === null || _option3 === void 0 ? void 0 : _option3.description) || "", ((_option4 = option) === null || _option4 === void 0 ? void 0 : _option4.dialog) && /* @__PURE__ */ React130.createElement("div", null, /* @__PURE__ */ React130.createElement(LodgingPlainFullscreenDialog, {
            key: "".concat(key, "-dialog"),
            isHtmlContent: true,
            uniqueDialogId: "".concat(key, "-dialog"),
            spacing: {
                padding: {
                    block: "two"
                }
            },
            data: option.dialog
        }))));
    }))))));
};
UnitCategorization.fragment = fragment66;
UnitCategorization.displayName = "UnitCategorization";
// src/components/property-offers/__private/__fragments/listings/property-unit-categorization/property-unit-card.tsx
import React133 from "react";
import { gql as gql106 } from "@apollo/client";
import { useBexApi as useBexApi4 } from "@shared-ui/bex-api-context";
import { useClickTracker as useClickTracker34 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog18 } from "@shared-ui/dialog-context";
import { UitkCard as UitkCard22, UitkCardContentSection as UitkCardContentSection15, UitkCardFeaturedHeader } from "uitk-react-cards";
import { UitkFigureAspectRatioType as UitkFigureAspectRatioType5 } from "uitk-react-images";
import { UitkLayoutFlex as UitkLayoutFlex30, UitkLayoutFlexItem as UitkLayoutFlexItem21 } from "uitk-react-layout-flex";
import { UitkLayoutPosition as UitkLayoutPosition4 } from "uitk-react-layout-position";
import { UitkList as UitkList8 } from "uitk-react-list";
import { UitkSpacing as UitkSpacing69 } from "uitk-react-spacing";
// src/components/property-offers/__private/__fragments/details-dialog-trigger/dialog/sections/dialog-unit-categorization.tsx
import React131 from "react";
import { UitkCard as UitkCard21, UitkCardContentSection as UitkCardContentSection14 } from "uitk-react-cards";
import { UitkLayoutFlex as UitkLayoutFlex29, UitkLayoutFlexItem as UitkLayoutFlexItem20 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing67 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading28 } from "uitk-react-text";
var DialogUnitCategorization = function(param) {
    var data = param.data, listingIndex = param.listingIndex, roomId = param.roomId, closeDialog = param.closeDialog;
    var _data_primarySelections_find, _data_primarySelections, _data, _propertyUnit, _propertyUnit_ratePlans, _propertyUnit1, _detailsDialog_content_ratePlanTitle, _detailsDialog_content, _detailsDialog;
    var propertyUnit = (_data = data) === null || _data === void 0 ? void 0 : (_data_primarySelections = _data.primarySelections) === null || _data_primarySelections === void 0 ? void 0 : (_data_primarySelections_find = _data_primarySelections.find(function() {
        return true;
    })) === null || _data_primarySelections_find === void 0 ? void 0 : _data_primarySelections_find.propertyUnit;
    var detailsDialog = (_propertyUnit = propertyUnit) === null || _propertyUnit === void 0 ? void 0 : _propertyUnit.detailsDialog;
    var hasRatePlans = Boolean((_propertyUnit1 = propertyUnit) === null || _propertyUnit1 === void 0 ? void 0 : (_propertyUnit_ratePlans = _propertyUnit1.ratePlans) === null || _propertyUnit_ratePlans === void 0 ? void 0 : _propertyUnit_ratePlans.length);
    var highlightedMessages = data.highlightedMessages;
    var alignAvailabilityCta = "end";
    if (!hasRatePlans) {
        return /* @__PURE__ */ React131.createElement(UitkSpacing67, {
            margin: {
                blockend: "unset"
            }
        }, /* @__PURE__ */ React131.createElement("div", null, /* @__PURE__ */ React131.createElement(UitkLayoutFlex29, {
            direction: "column"
        }, /* @__PURE__ */ React131.createElement(UitkLayoutFlexItem20, {
            alignSelf: alignAvailabilityCta,
            grow: 0
        }, /* @__PURE__ */ React131.createElement("div", null, /* @__PURE__ */ React131.createElement(AvailabilityCta, {
            data: propertyUnit,
            listingIndex: listingIndex,
            closeDialog: closeDialog
        }))))));
    }
    return /* @__PURE__ */ React131.createElement(UitkCard21, {
        border: true,
        padded: true,
        overflow: true
    }, /* @__PURE__ */ React131.createElement(UitkCardContentSection14, null, /* @__PURE__ */ React131.createElement(UitkSpacing67, {
        margin: {
            blockend: "three"
        }
    }, /* @__PURE__ */ React131.createElement(UitkHeading28, {
        tag: "h3",
        size: 5
    }, (_detailsDialog = detailsDialog) === null || _detailsDialog === void 0 ? void 0 : (_detailsDialog_content = _detailsDialog.content) === null || _detailsDialog_content === void 0 ? void 0 : (_detailsDialog_content_ratePlanTitle = _detailsDialog_content.ratePlanTitle) === null || _detailsDialog_content_ratePlanTitle === void 0 ? void 0 : _detailsDialog_content_ratePlanTitle.text)), /* @__PURE__ */ React131.createElement(UnitCategorization, {
        data: data,
        listingIndex: listingIndex
    }), /* @__PURE__ */ React131.createElement(UitkSpacing67, {
        margin: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React131.createElement("div", null, /* @__PURE__ */ React131.createElement(UnitCategorizationRatePlan, {
        listingIndex: listingIndex,
        roomId: roomId,
        highlightedMessages: highlightedMessages
    }))), /* @__PURE__ */ React131.createElement(AvailabilityCta, {
        data: propertyUnit,
        listingIndex: listingIndex
    })));
};
DialogUnitCategorization.displayName = "DialogUnitCategorization";
// src/components/property-offers/__private/__fragments/listings/property-unit-categorization/micro-room-card/micro-room-card-footer-button.tsx
import React132 from "react";
import { UitkPrimaryButton as UitkPrimaryButton9 } from "uitk-react-button";
import { UitkSpacing as UitkSpacing68 } from "uitk-react-spacing";
var MicroRoomCardFooterButton = function(param) {
    var footerButton = param.footerButton, onClick = param.onClick;
    if (!footerButton) {
        return null;
    }
    return /* @__PURE__ */ React132.createElement(UitkSpacing68, {
        margin: "three"
    }, /* @__PURE__ */ React132.createElement("div", null, /* @__PURE__ */ React132.createElement(UitkPrimaryButton9, {
        "data-stid": "see-options-dialog",
        onClick: onClick,
        isFullWidth: true
    }, footerButton.primary)));
};
// src/components/property-offers/__private/__fragments/listings/property-unit-categorization/property-unit-card.tsx
var __PropertyUnitCardFragment = gql106(_templateObject108(), PropertyOffersHeader.fragment, PropertyFeatures.fragment, RatePlanMessage.fragment, ExpandoItemsCard.fragment, UnitCategorization.fragment);
var PropertyUnitCard = function(param) {
    var data = param.data, listingIndex = param.listingIndex, _param_isMicroRoomCardCarouselVariant = param.isMicroRoomCardCarouselVariant, isMicroRoomCardCarouselVariant = _param_isMicroRoomCardCarouselVariant === void 0 ? false : _param_isMicroRoomCardCarouselVariant;
    var _data_primarySelections, _context_device, _context, _ratePlan, _header, _ratePlan1, _detailsDialog, _detailsDialog1;
    var features = data.features, header = data.header, highlightedMessages = data.highlightedMessages, featureHeader = data.featureHeader, expandoItemsCard = data.expandoItemsCard;
    var _React133_useState = _sliced_to_array(React133.useState(""), 2), dialogCloseReferrerId = _React133_useState[0], setDialogCloseReferrerId = _React133_useState[1];
    var _React133_useState1 = _sliced_to_array(React133.useState(""), 2), dialogCloseLinkName = _React133_useState1[0], setDialogCloseLinkName = _React133_useState1[1];
    var trackClick = useClickTracker34();
    var primaryIndex = React133.useContext(UnitRateContext).primaryIndex;
    var propertyUnit = (_data_primarySelections = data.primarySelections) === null || _data_primarySelections === void 0 ? void 0 : _data_primarySelections[primaryIndex].propertyUnit;
    var id = propertyUnit.id, detailsDialog = propertyUnit.detailsDialog, ratePlans = propertyUnit.ratePlans, unitGallery = propertyUnit.unitGallery;
    var _React133_useContext = React133.useContext(UnitRateContext), ratePlan = _React133_useContext.ratePlan, radioSelections = _React133_useContext.radioSelections;
    var context = useBexApi4().context;
    var isMobile = ((_context = context) === null || _context === void 0 ? void 0 : (_context_device = _context.device) === null || _context_device === void 0 ? void 0 : _context_device.type) === "MOBILE_PHONE" /* MOBILE_PHONE */ ;
    var shareUrl = (_ratePlan = ratePlan) === null || _ratePlan === void 0 ? void 0 : _ratePlan.shareUrl;
    var footerButton = data.footerButton;
    var hasSelections = Boolean(radioSelections);
    var isSoldOut = !!propertyUnit.availabilityCallToAction;
    var isMicroRoomCard = isMobile && !isSoldOut;
    var isMicroRoomCardRatesDialog = isMicroRoomCard && hasSelections;
    var isMicroRoomCardCarousel = isMicroRoomCard && isMicroRoomCardCarouselVariant;
    var _useDialog18 = _sliced_to_array(useDialog18("room-info-".concat(id, "-").concat(listingIndex), "propertyUnitRoomInfoDialog"), 3), isDialogOpen = _useDialog18[0], dialogActions = _useDialog18[1], DialogComponent = _useDialog18[2];
    var _React133_useState2 = _sliced_to_array(React133.useState(false), 2), swapDialogLayout = _React133_useState2[0], setSwapDialogLayout = _React133_useState2[1];
    var closeMoreDetailsDialog = React133.useCallback(function() {
        if (isDialogOpen) {
            dialogActions.closeDialog();
        }
        trackClick(dialogCloseReferrerId, dialogCloseLinkName);
    }, [
        dialogActions,
        trackClick,
        dialogCloseReferrerId,
        dialogCloseLinkName,
        isDialogOpen
    ]);
    var openMoreDetailsDialog = function(propertyUnitDetailsDialog) {
        var isSeeOptionsDialog = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        return function() {
            var _footerButton_analytics, _footerButton, _propertyUnitDetailsDialog_trigger_clientSideAnalytics, _propertyUnitDetailsDialog_trigger, _propertyUnitDetailsDialog, _ratePlan, _footerButton_analytics1, _footerButton1, _propertyUnitDetailsDialog_trigger_clientSideAnalytics1, _propertyUnitDetailsDialog_trigger1, _propertyUnitDetailsDialog1, _propertyUnitDetailsDialog_toolbar_clientSideAnalytics, _propertyUnitDetailsDialog_toolbar, _propertyUnitDetailsDialog2, _propertyUnitDetailsDialog_toolbar_clientSideAnalytics1, _propertyUnitDetailsDialog_toolbar1, _propertyUnitDetailsDialog3;
            setSwapDialogLayout(isSeeOptionsDialog);
            var referrerId = isSeeOptionsDialog ? ((_footerButton = footerButton) === null || _footerButton === void 0 ? void 0 : (_footerButton_analytics = _footerButton.analytics) === null || _footerButton_analytics === void 0 ? void 0 : _footerButton_analytics.referrerId) || "" : "".concat((_propertyUnitDetailsDialog = propertyUnitDetailsDialog) === null || _propertyUnitDetailsDialog === void 0 ? void 0 : (_propertyUnitDetailsDialog_trigger = _propertyUnitDetailsDialog.trigger) === null || _propertyUnitDetailsDialog_trigger === void 0 ? void 0 : (_propertyUnitDetailsDialog_trigger_clientSideAnalytics = _propertyUnitDetailsDialog_trigger.clientSideAnalytics) === null || _propertyUnitDetailsDialog_trigger_clientSideAnalytics === void 0 ? void 0 : _propertyUnitDetailsDialog_trigger_clientSideAnalytics.referrerId, ".").concat(id, ".").concat((_ratePlan = ratePlan) === null || _ratePlan === void 0 ? void 0 : _ratePlan.id);
            var linkName = isSeeOptionsDialog ? ((_footerButton1 = footerButton) === null || _footerButton1 === void 0 ? void 0 : (_footerButton_analytics1 = _footerButton1.analytics) === null || _footerButton_analytics1 === void 0 ? void 0 : _footerButton_analytics1.linkName) || "" : ((_propertyUnitDetailsDialog1 = propertyUnitDetailsDialog) === null || _propertyUnitDetailsDialog1 === void 0 ? void 0 : (_propertyUnitDetailsDialog_trigger1 = _propertyUnitDetailsDialog1.trigger) === null || _propertyUnitDetailsDialog_trigger1 === void 0 ? void 0 : (_propertyUnitDetailsDialog_trigger_clientSideAnalytics1 = _propertyUnitDetailsDialog_trigger1.clientSideAnalytics) === null || _propertyUnitDetailsDialog_trigger_clientSideAnalytics1 === void 0 ? void 0 : _propertyUnitDetailsDialog_trigger_clientSideAnalytics1.linkName) || "Open Room Gallery dialog";
            var detailsDialogCloseReferrerId = ((_propertyUnitDetailsDialog2 = propertyUnitDetailsDialog) === null || _propertyUnitDetailsDialog2 === void 0 ? void 0 : (_propertyUnitDetailsDialog_toolbar = _propertyUnitDetailsDialog2.toolbar) === null || _propertyUnitDetailsDialog_toolbar === void 0 ? void 0 : (_propertyUnitDetailsDialog_toolbar_clientSideAnalytics = _propertyUnitDetailsDialog_toolbar.clientSideAnalytics) === null || _propertyUnitDetailsDialog_toolbar_clientSideAnalytics === void 0 ? void 0 : _propertyUnitDetailsDialog_toolbar_clientSideAnalytics.referrerId) || "Room.InfoDialog.PhotoGallery".concat(listingIndex, ".Close");
            var detailsDialogCloseLinkName = ((_propertyUnitDetailsDialog3 = propertyUnitDetailsDialog) === null || _propertyUnitDetailsDialog3 === void 0 ? void 0 : (_propertyUnitDetailsDialog_toolbar1 = _propertyUnitDetailsDialog3.toolbar) === null || _propertyUnitDetailsDialog_toolbar1 === void 0 ? void 0 : (_propertyUnitDetailsDialog_toolbar_clientSideAnalytics1 = _propertyUnitDetailsDialog_toolbar1.clientSideAnalytics) === null || _propertyUnitDetailsDialog_toolbar_clientSideAnalytics1 === void 0 ? void 0 : _propertyUnitDetailsDialog_toolbar_clientSideAnalytics1.linkName) || "Close Room Info dialog";
            dialogActions.openDialog();
            trackClick(referrerId, linkName);
            setDialogCloseReferrerId(detailsDialogCloseReferrerId);
            setDialogCloseLinkName(detailsDialogCloseLinkName);
        };
    };
    var _header_text;
    return /* @__PURE__ */ React133.createElement(MicroRoomCardProvider, {
        value: {
            isMicroRoomCardRatesDialog: isMicroRoomCardRatesDialog,
            isMicroRoomCardCarousel: isMicroRoomCardCarousel,
            listingIndex: listingIndex,
            hasSelections: hasSelections
        }
    }, /* @__PURE__ */ React133.createElement(UitkCard22, {
        border: true,
        overflow: true
    }, /* @__PURE__ */ React133.createElement(UitkLayoutFlex30, {
        direction: "column",
        justifyContent: "space-between",
        key: "property-offer-".concat(listingIndex),
        "data-stid": "property-offer-".concat(listingIndex),
        blockSize: "full_size"
    }, /* @__PURE__ */ React133.createElement(UitkLayoutFlexItem21, null, featureHeader && /* @__PURE__ */ React133.createElement(UitkLayoutPosition4, {
        type: "absolute",
        position: {
            left: "zero",
            top: "zero",
            right: "zero",
            zindex: "layer3"
        }
    }, /* @__PURE__ */ React133.createElement(UitkCardFeaturedHeader, {
        title: {
            tag: "h3",
            text: featureHeader.text
        }
    }))), /* @__PURE__ */ React133.createElement(UitkLayoutFlexItem21, null, /* @__PURE__ */ React133.createElement("div", null, unitGallery && /* @__PURE__ */ React133.createElement(MediaSection, {
        listingIndex: listingIndex,
        listingName: (_header_text = (_header = header) === null || _header === void 0 ? void 0 : _header.text) !== null && _header_text !== void 0 ? _header_text : void 0,
        unitGallery: unitGallery,
        className: "uitk-rounded-border-top",
        imageRatio: isMicroRoomCardCarouselVariant ? UitkFigureAspectRatioType5.R3_2 : UitkFigureAspectRatioType5.R16_9,
        handleCarouselImageClick: dialogActions.openDialog,
        roomTypeId: id,
        ratePlanId: (_ratePlan1 = ratePlan) === null || _ratePlan1 === void 0 ? void 0 : _ratePlan1.id
    }), /* @__PURE__ */ React133.createElement(UitkSpacing69, {
        padding: {
            blockstart: "three",
            blockend: "two",
            inline: "three"
        }
    }, /* @__PURE__ */ React133.createElement("div", null, header && /* @__PURE__ */ React133.createElement(PropertyOffersHeader, {
        data: header,
        textSize: 6,
        roomId: id
    }), features && features.length > 0 && /* @__PURE__ */ React133.createElement(UitkSpacing69, {
        margin: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React133.createElement(UitkList8, {
        bullet: "icon-standard"
    }, features.map(function(feature, index) {
        return /* @__PURE__ */ React133.createElement(PropertyFeatures, {
            data: feature,
            uniqueDialogId: "propertyunit-feature",
            key: "feature-".concat(index)
        });
    }))), /* @__PURE__ */ React133.createElement(UnitCategorizationHighlightedMessages, {
        highlightedMessages: highlightedMessages,
        id: id
    }), ((_detailsDialog = detailsDialog) === null || _detailsDialog === void 0 ? void 0 : _detailsDialog.trigger) && /* @__PURE__ */ React133.createElement(UitkSpacing69, {
        margin: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React133.createElement(UitkCardContentSection15, {
        "data-stid": "section-roomtype",
        padded: false
    }, /* @__PURE__ */ React133.createElement(LinkTrigger, {
        data: (_detailsDialog1 = detailsDialog) === null || _detailsDialog1 === void 0 ? void 0 : _detailsDialog1.trigger,
        openDialog: openMoreDetailsDialog(detailsDialog)
    }), /* @__PURE__ */ React133.createElement(DialogComponent, null, /* @__PURE__ */ React133.createElement(UnitPropertyOffersDetailsDialog, {
        closeDialog: closeMoreDetailsDialog,
        data: propertyUnit.detailsDialog,
        isDialogOpen: isDialogOpen,
        listing: propertyUnit,
        featureHeader: featureHeader,
        expandoItemsCard: expandoItemsCard,
        swapDialogLayout: swapDialogLayout,
        ratePlans: /* @__PURE__ */ React133.createElement(DialogUnitCategorization, {
            data: data,
            listingIndex: listingIndex,
            roomId: id,
            closeDialog: closeMoreDetailsDialog
        })
    })))))), expandoItemsCard && /* @__PURE__ */ React133.createElement(ExpandoItemsCard, {
        isWithinDetailsDialog: false,
        data: expandoItemsCard
    }), !isMicroRoomCardRatesDialog && !isMicroRoomCardCarousel && hasSelections && /* @__PURE__ */ React133.createElement(UitkCardContentSection15, {
        padded: false,
        border: "top"
    }, /* @__PURE__ */ React133.createElement(UnitCategorization, {
        data: data,
        listingIndex: listingIndex
    })))), /* @__PURE__ */ React133.createElement(UitkLayoutFlexItem21, {
        alignSelf: !ratePlans.length ? "end" : "stretch"
    }, /* @__PURE__ */ React133.createElement(UitkCardContentSection15, {
        padded: false,
        border: isMicroRoomCardRatesDialog && hasSelections || isMicroRoomCardCarousel ? "top" : void 0
    }, /* @__PURE__ */ React133.createElement(UitkSpacing69, {
        margin: "three"
    }, /* @__PURE__ */ React133.createElement("div", null, /* @__PURE__ */ React133.createElement(UnitCategorizationRatePlan, {
        listingIndex: listingIndex,
        roomId: id
    }), /* @__PURE__ */ React133.createElement(AvailabilityCta, {
        data: propertyUnit,
        listingIndex: listingIndex
    }), shareUrl && /* @__PURE__ */ React133.createElement(UitkSpacing69, {
        padding: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React133.createElement("div", null, /* @__PURE__ */ React133.createElement(MarketingSectionLink, {
        shareUrl: shareUrl
    }))))), (isMicroRoomCardRatesDialog || isMicroRoomCardCarousel && hasSelections) && /* @__PURE__ */ React133.createElement(MicroRoomCardFooterButton, {
        footerButton: footerButton,
        onClick: openMoreDetailsDialog(detailsDialog, true)
    }))))));
};
PropertyUnitCard.displayName = "PropertyUnitCard";
PropertyUnitCard.fragment = __PropertyUnitCardFragment;
// src/components/property-offers/__private/__fragments/listings/property-unit-categorization/property-unit-categorization.tsx
var __PropertyUnitCategorizationFragment = gql107(_templateObject109(), PropertyOffersHeader.fragment, PropertyFeatures.fragment, RatePlanMessage.fragment, ExpandoItemsCard.fragment, UnitCategorization.fragment);
var PropertyUnitCategorization = function(param) {
    var data = param.data, listingIndex = param.listingIndex, _param_isMicroRoomCardCarouselVariant = param.isMicroRoomCardCarouselVariant, isMicroRoomCardCarouselVariant = _param_isMicroRoomCardCarouselVariant === void 0 ? false : _param_isMicroRoomCardCarouselVariant;
    var primarySelections = data.primarySelections;
    var _React134_useContext = React134.useContext(OffersLevelContext), isFullyRefundable = _React134_useContext.isFullyRefundable, setDismissMessagingCard = _React134_useContext.setDismissMessagingCard, setDefaultToFullyRefundable = _React134_useContext.setDefaultToFullyRefundable;
    if (!primarySelections) {
        return null;
    }
    return /* @__PURE__ */ React134.createElement(UnitRateContextProvider, {
        isFullyRefundable: isFullyRefundable,
        primarySelections: primarySelections,
        setDismissMessagingCard: setDismissMessagingCard,
        setDefaultToFullyRefundable: setDefaultToFullyRefundable
    }, /* @__PURE__ */ React134.createElement(PropertyUnitCard, {
        data: data,
        listingIndex: listingIndex,
        isMicroRoomCardCarouselVariant: isMicroRoomCardCarouselVariant
    }));
};
PropertyUnitCategorization.displayName = "PropertyUnitCategorization";
PropertyUnitCategorization.fragment = __PropertyUnitCategorizationFragment;
// src/components/property-offers/__private/__fragments/listings/layouts/listings-layouts.tsx
var MessagingCard = vertical_messaging_card_default(VerticalMessagingCard);
var LOYALTY_EXTRA_HIGH_TIER2 = "loyalty-extra-high-tier";
var FIRST_MOD_LINKNAME = "Viewed first MOD offer on page";
var getMemberTierInfo = function(firstModMemberTierTheme) {
    switch(firstModMemberTierTheme){
        case UitkBadgeTheme5.DEAL_MEMBER:
            return "MemberTier.DEAL_MEMBER.isMOD.true";
        case UitkBadgeTheme5.LOYALTY_MIDDLE_TIER:
            return "MemberTier.SILVER.isMOD.true";
        case UitkBadgeTheme5.LOYALTY_HIGH_TIER:
            return "MemberTier.GOLD.isMOD.true";
        case LOYALTY_EXTRA_HIGH_TIER2:
            return "MemberTier.PLATINUM.isMOD.true";
        default:
            return "undefined";
    }
};
var OffersGridControl = function(param) {
    var listings = param.listings, _param_forceVerticalPropertyUnitLayout = param.forceVerticalPropertyUnitLayout, forceVerticalPropertyUnitLayout = _param_forceVerticalPropertyUnitLayout === void 0 ? false : _param_forceVerticalPropertyUnitLayout;
    var _listings, _listings1, _listings2;
    var isMessagingCardDismissed = React135.useContext(OffersLevelContext).isMessagingCardDismissed;
    var shouldRenderTwoRows = (((_listings = listings) === null || _listings === void 0 ? void 0 : _listings.filter(function(listing) {
        var _listing_ratePlans, _listing;
        return "ratePlans" in listing && ((_listing = listing) === null || _listing === void 0 ? void 0 : (_listing_ratePlans = _listing.ratePlans) === null || _listing_ratePlans === void 0 ? void 0 : _listing_ratePlans.length) > 1;
    }).length) || 0) > 0;
    var shouldRenderLargeImage = ((_listings1 = listings) === null || _listings1 === void 0 ? void 0 : _listings1.filter(function(listing) {
        var _listing_ratePlans, _listing;
        return "ratePlans" in listing && ((_listing = listing) === null || _listing === void 0 ? void 0 : (_listing_ratePlans = _listing.ratePlans) === null || _listing_ratePlans === void 0 ? void 0 : _listing_ratePlans.length) >= 1;
    }).length) === 0;
    var roomPosition = 0;
    return /* @__PURE__ */ React135.createElement(UitkLayoutGrid20, {
        columns: {
            auto_fill: "seventy_six"
        },
        space: "three",
        justifyContent: "start"
    }, (_listings2 = listings) === null || _listings2 === void 0 ? void 0 : _listings2.map(function(listing, index) {
        var __typename = listing.__typename;
        if (__typename === "MessageResult" && !isMessagingCardDismissed) {
            return /* @__PURE__ */ React135.createElement(UitkLayoutGridItem17, {
                key: "".concat(__typename, "-").concat(index)
            }, /* @__PURE__ */ React135.createElement(MessagingCard, {
                data: listing
            }));
        }
        if (__typename === "PropertyUnit") {
            roomPosition += 1;
            return /* @__PURE__ */ React135.createElement(UitkLayoutGridItem17, {
                colSpan: "all",
                key: "".concat(__typename, "-").concat(index)
            }, /* @__PURE__ */ React135.createElement("div", null, /* @__PURE__ */ React135.createElement(ControlPropertyUnit, {
                listingIndex: roomPosition,
                data: listing,
                shouldRenderAsTwoRows: shouldRenderTwoRows,
                shouldRenderLargeImage: shouldRenderLargeImage,
                forceVerticalPropertyUnitLayout: forceVerticalPropertyUnitLayout
            })));
        }
        return null;
    }));
};
var OffersGridCategorization = function(param) {
    var listings = param.listings;
    var _listings, _listings1;
    var isMessagingCardDismissed = React135.useContext(OffersLevelContext).isMessagingCardDismissed;
    var roomPosition = 0;
    var firstModMemberTierTheme = useRef2("");
    var lodgingCategorizedUnits = (_listings = listings) === null || _listings === void 0 ? void 0 : _listings.filter(function(listing) {
        return listing.__typename === "LodgingCategorizedUnit";
    });
    var checkForModRatePlan = useCallback2(function(lodgingCategorizedUnit) {
        var _lodgingCategorizedUnit_primarySelections;
        return (_lodgingCategorizedUnit_primarySelections = lodgingCategorizedUnit.primarySelections) === null || _lodgingCategorizedUnit_primarySelections === void 0 ? void 0 : _lodgingCategorizedUnit_primarySelections.findIndex(function(primarySelection) {
            return primarySelection.propertyUnit.ratePlans.findIndex(function(ratePlan) {
                var _ratePlan_standardBadge, _ratePlan, _ratePlanBadge_graphic, _ratePlanBadge, _ratePlanBadge_graphic1, _ratePlanBadge1;
                var ratePlanBadge = (_ratePlan = ratePlan) === null || _ratePlan === void 0 ? void 0 : (_ratePlan_standardBadge = _ratePlan.standardBadge) === null || _ratePlan_standardBadge === void 0 ? void 0 : _ratePlan_standardBadge.standardBadge;
                if (((_ratePlanBadge = ratePlanBadge) === null || _ratePlanBadge === void 0 ? void 0 : (_ratePlanBadge_graphic = _ratePlanBadge.graphic) === null || _ratePlanBadge_graphic === void 0 ? void 0 : _ratePlanBadge_graphic.__typename) === "Icon" && ((_ratePlanBadge1 = ratePlanBadge) === null || _ratePlanBadge1 === void 0 ? void 0 : (_ratePlanBadge_graphic1 = _ratePlanBadge1.graphic) === null || _ratePlanBadge_graphic1 === void 0 ? void 0 : _ratePlanBadge_graphic1.id) === "mod") {
                    if (!firstModMemberTierTheme.current && ratePlanBadge.theme) {
                        firstModMemberTierTheme.current = ratePlanBadge.theme;
                    }
                    return true;
                }
                return false;
            });
        });
    }, [
        lodgingCategorizedUnits
    ]);
    var firstModRatePlanIndex = useMemo(function() {
        return lodgingCategorizedUnits ? lodgingCategorizedUnits.findIndex(checkForModRatePlan) + 1 : 0;
    }, [
        lodgingCategorizedUnits,
        checkForModRatePlan
    ]);
    return /* @__PURE__ */ React135.createElement(UitkSpacing70, {
        margin: {
            small: {
                inline: "three"
            },
            medium: {
                inline: "unset"
            }
        }
    }, /* @__PURE__ */ React135.createElement(UitkLayoutGrid20, {
        columns: {
            auto_fill: "seventy_six"
        },
        space: "three",
        justifyContent: "start"
    }, (_listings1 = listings) === null || _listings1 === void 0 ? void 0 : _listings1.map(function(listing, index) {
        var __typename = listing.__typename;
        if (__typename === "MessageResult" && !isMessagingCardDismissed) {
            return /* @__PURE__ */ React135.createElement(UitkLayoutGridItem17, {
                key: "".concat(__typename, "-").concat(index)
            }, /* @__PURE__ */ React135.createElement(MessagingCard, {
                data: listing
            }));
        }
        if (__typename === "LodgingCategorizedUnit") {
            roomPosition += 1;
            return firstModRatePlanIndex === roomPosition && firstModMemberTierTheme ? /* @__PURE__ */ React135.createElement(UitkLayoutGridItem17, {
                key: "".concat(__typename, "-").concat(index)
            }, /* @__PURE__ */ React135.createElement(IntersectionTracker9, {
                referrerId: getMemberTierInfo(firstModMemberTierTheme.current),
                linkName: FIRST_MOD_LINKNAME,
                trackOnce: true
            }, /* @__PURE__ */ React135.createElement("div", null, /* @__PURE__ */ React135.createElement(PropertyUnitCategorization, {
                data: listing,
                listingIndex: roomPosition
            })))) : /* @__PURE__ */ React135.createElement(UitkLayoutGridItem17, {
                key: "".concat(__typename, "-").concat(index)
            }, /* @__PURE__ */ React135.createElement("div", null, /* @__PURE__ */ React135.createElement(PropertyUnitCategorization, {
                data: listing,
                listingIndex: roomPosition
            })));
        }
        if (__typename === "LodgingHeader") {
            return /* @__PURE__ */ React135.createElement(UitkLayoutGridItem17, {
                colStart: 1,
                colEnd: "end",
                key: "".concat(__typename, "-").concat(index)
            }, /* @__PURE__ */ React135.createElement("div", null, /* @__PURE__ */ React135.createElement(LodgingSectionHeader, {
                data: listing
            })));
        }
        return null;
    })));
};
var CAROUSEL_NAME = "OffersCarousel";
var OfferSectionCarousel = function(param) {
    var listingSection = param.listingSection, index = param.index;
    var _items;
    var carouselNamePostfix = index > 0 ? ".FiltersNotMatched" : "";
    var carouselName = "".concat(CAROUSEL_NAME).concat(carouselNamePostfix);
    var firstModMemberTierTheme = useRef2("");
    var track = useClickTracker35();
    var analytics2 = React135.useMemo(function() {
        return {
            id: "HOT.HIS.".concat(carouselName),
            description: "Carousel interaction",
            callback: function(rfrrId, linkName) {
                track(rfrrId, linkName);
            }
        };
    }, []);
    var header = listingSection.header, items = listingSection.items;
    var lodgingCategorizedUnits = (_items = items) === null || _items === void 0 ? void 0 : _items.filter(function(listing) {
        return listing.__typename === "LodgingCategorizedUnit";
    });
    var checkForModRatePlanCarousel = useCallback2(function(lodgingCategorizedUnit) {
        var _lodgingCategorizedUnit_primarySelections;
        return (_lodgingCategorizedUnit_primarySelections = lodgingCategorizedUnit.primarySelections) === null || _lodgingCategorizedUnit_primarySelections === void 0 ? void 0 : _lodgingCategorizedUnit_primarySelections.findIndex(function(primarySelection) {
            return primarySelection.propertyUnit.ratePlans.findIndex(function(ratePlan) {
                var _ratePlan_standardBadge, _ratePlan, _ratePlanBadge_graphic, _ratePlanBadge, _ratePlanBadge_graphic1, _ratePlanBadge1;
                var ratePlanBadge = (_ratePlan = ratePlan) === null || _ratePlan === void 0 ? void 0 : (_ratePlan_standardBadge = _ratePlan.standardBadge) === null || _ratePlan_standardBadge === void 0 ? void 0 : _ratePlan_standardBadge.standardBadge;
                if (((_ratePlanBadge = ratePlanBadge) === null || _ratePlanBadge === void 0 ? void 0 : (_ratePlanBadge_graphic = _ratePlanBadge.graphic) === null || _ratePlanBadge_graphic === void 0 ? void 0 : _ratePlanBadge_graphic.__typename) === "Icon" && ((_ratePlanBadge1 = ratePlanBadge) === null || _ratePlanBadge1 === void 0 ? void 0 : (_ratePlanBadge_graphic1 = _ratePlanBadge1.graphic) === null || _ratePlanBadge_graphic1 === void 0 ? void 0 : _ratePlanBadge_graphic1.id) === "mod") {
                    if (!firstModMemberTierTheme.current && ratePlanBadge.theme) {
                        firstModMemberTierTheme.current = ratePlanBadge.theme;
                    }
                    return true;
                }
                return false;
            });
        });
    }, [
        lodgingCategorizedUnits
    ]);
    var firstModRatePlanIndex = useMemo(function() {
        return lodgingCategorizedUnits ? lodgingCategorizedUnits.findIndex(checkForModRatePlanCarousel) + 1 : 0;
    }, [
        lodgingCategorizedUnits,
        checkForModRatePlanCarousel
    ]);
    var roomPosition = 0;
    var carouselProps = {
        carouselName: carouselName,
        analytics: analytics2,
        buttonText: {
            nextButton: "",
            prevButton: ""
        },
        itemsVisible: {
            sm: 1,
            md: 1,
            lg: 1
        },
        pageBy: 1,
        peek: true,
        itemsMaxHeight: true,
        pagingInset: true,
        hideNav: true,
        shouldSnapOnScroll: false
    };
    var unitsCarousel = /* @__PURE__ */ React135.createElement(UitkCarousel, _object_spread({}, carouselProps), listingSection.items.map(function(listing, idx) {
        var __typename = listing.__typename;
        if (__typename === "LodgingCategorizedUnit") {
            roomPosition += 1;
            return firstModRatePlanIndex === roomPosition && firstModMemberTierTheme ? /* @__PURE__ */ React135.createElement(IntersectionTracker9, {
                referrerId: getMemberTierInfo(firstModMemberTierTheme.current),
                linkName: FIRST_MOD_LINKNAME,
                trackOnce: true
            }, /* @__PURE__ */ React135.createElement(PropertyUnitCategorization, {
                data: listing,
                listingIndex: roomPosition,
                key: "".concat(__typename, "-").concat(idx),
                isMicroRoomCardCarouselVariant: true
            })) : /* @__PURE__ */ React135.createElement(PropertyUnitCategorization, {
                data: listing,
                listingIndex: roomPosition,
                key: "".concat(__typename, "-").concat(idx),
                isMicroRoomCardCarouselVariant: true
            });
        }
        return null;
    }));
    return /* @__PURE__ */ React135.createElement("div", null, header && /* @__PURE__ */ React135.createElement(UitkSpacing70, {
        margin: "three"
    }, /* @__PURE__ */ React135.createElement("div", null, /* @__PURE__ */ React135.createElement(LodgingSectionHeader, {
        data: header
    }))), /* @__PURE__ */ React135.createElement(UitkSpacing70, {
        margin: {
            inlinestart: "three"
        }
    }, unitsCarousel));
};
var splitListings = function(listings) {
    var _listings;
    return (_listings = listings) === null || _listings === void 0 ? void 0 : _listings.reduce(function(acc, listing) {
        var __typename = listing.__typename;
        if (__typename === "MessageResult") {
            return acc;
        }
        if (__typename === "LodgingHeader") {
            acc.push({
                header: listing,
                items: []
            });
        } else if (!acc.length) {
            acc.push({
                header: null,
                items: [
                    listing
                ]
            });
        } else {
            acc[acc.length - 1].items.push(listing);
        }
        return acc;
    }, []);
};
var OffersBySections = function(param) {
    var listings = param.listings;
    var _listings, _listingsBySections;
    var isMessagingCardDismissed = React135.useContext(OffersLevelContext).isMessagingCardDismissed;
    var messageResultBanner = !isMessagingCardDismissed ? (_listings = listings) === null || _listings === void 0 ? void 0 : _listings.find(function(listing) {
        return listing.__typename === "MessageResult";
    }) : null;
    var listingsBySections = React135.useMemo(function() {
        return splitListings(listings);
    }, [
        listings
    ]);
    return /* @__PURE__ */ React135.createElement(React135.Fragment, null, messageResultBanner && /* @__PURE__ */ React135.createElement(UitkSpacing70, {
        margin: "three"
    }, /* @__PURE__ */ React135.createElement("div", null, /* @__PURE__ */ React135.createElement(MessagingCard, {
        data: messageResultBanner
    }))), (_listingsBySections = listingsBySections) === null || _listingsBySections === void 0 ? void 0 : _listingsBySections.map(function(section, idx) {
        return /* @__PURE__ */ React135.createElement(OfferSectionCarousel, {
            listingSection: section,
            index: idx,
            key: idx
        });
    }));
};
// src/components/property-offers/__private/__fragments/listings/listings.tsx
var fragment67 = gql108(_templateObject110(), AdaptExAnalyticsEventFragment, ControlPropertyUnit.fragment, PropertyUnitCategorization.fragment, VerticalMessagingCard.fragment, LodgingSectionHeader.fragment);
var Listings = function(param) {
    var data = param.data, className = param.className, forceVerticalPropertyUnitLayout = param.forceVerticalPropertyUnitLayout;
    var _context_device, _context;
    var isMessagingCardDismissed = React136.useContext(OffersLevelContext).isMessagingCardDismissed;
    var ref = React136.useRef(null);
    var context = useBexApi5().context;
    var isMobile = ((_context = context) === null || _context === void 0 ? void 0 : (_context_device = _context.device) === null || _context_device === void 0 ? void 0 : _context_device.type) === "MOBILE_PHONE" /* MOBILE_PHONE */ ;
    React136.useEffect(function() {
        if (isMessagingCardDismissed) {
            var _ref;
            if ((_ref = ref) === null || _ref === void 0 ? void 0 : _ref.current) {
                var _firstfocusElement;
                var firstfocusElement = ref.current.firstChild;
                firstfocusElement.setAttribute("tabIndex", "-1");
                (_firstfocusElement = firstfocusElement) === null || _firstfocusElement === void 0 ? void 0 : _firstfocusElement.focus();
            }
        }
    }, [
        isMessagingCardDismissed
    ]);
    if (!data.categorizedListings && !data.listings) {
        return null;
    }
    var categorizedListingsUnavailable = !!data.listings;
    var offerAdaptExSuccessEvents = data.offerAdaptExSuccessEvents;
    if (categorizedListingsUnavailable) {
        return /* @__PURE__ */ React136.createElement(AdaptExEventsProvider, {
            value: {
                adaptExSuccessEvents: offerAdaptExSuccessEvents
            }
        }, /* @__PURE__ */ React136.createElement("div", {
            "data-stid": "section-room-list",
            className: className,
            ref: ref
        }, /* @__PURE__ */ React136.createElement(OffersGridControl, {
            listings: data.listings,
            forceVerticalPropertyUnitLayout: forceVerticalPropertyUnitLayout
        })));
    }
    if (isMobile) {
        return /* @__PURE__ */ React136.createElement(AdaptExEventsProvider, {
            value: {
                adaptExSuccessEvents: offerAdaptExSuccessEvents
            }
        }, /* @__PURE__ */ React136.createElement("div", {
            "data-stid": "section-room-list",
            className: className,
            ref: ref
        }, /* @__PURE__ */ React136.createElement(Viewport20, null, /* @__PURE__ */ React136.createElement(ViewSmall19, null, /* @__PURE__ */ React136.createElement(Experiment7, {
            name: "Micro_Room_Card_Side_By_Side_Carousel_mWeb"
        }, /* @__PURE__ */ React136.createElement(ExperimentControl7, null, /* @__PURE__ */ React136.createElement(OffersGridCategorization, {
            listings: data.categorizedListings
        })), /* @__PURE__ */ React136.createElement(ExperimentVariant7, {
            bucket: 1
        }, /* @__PURE__ */ React136.createElement(OffersBySections, {
            listings: data.categorizedListings
        })))), /* @__PURE__ */ React136.createElement(ViewMedium16, null, /* @__PURE__ */ React136.createElement(OffersGridCategorization, {
            listings: data.categorizedListings
        })))));
    }
    return /* @__PURE__ */ React136.createElement(AdaptExEventsProvider, {
        value: {
            adaptExSuccessEvents: offerAdaptExSuccessEvents
        }
    }, /* @__PURE__ */ React136.createElement("div", {
        "data-stid": "section-room-list",
        className: className,
        ref: ref
    }, /* @__PURE__ */ React136.createElement(OffersGridCategorization, {
        listings: data.categorizedListings
    })));
};
Listings.fragment = fragment67;
Listings.displayName = "Listings";
// src/components/property-offers/__private/__fragments/listings-error-message.tsx
import React138 from "react";
import { gql as gql110 } from "@apollo/client";
import { UitkCard as UitkCard23, UitkCardContentSection as UitkCardContentSection16 } from "uitk-react-cards";
// src/components/__private/__fragments/error-message.tsx
import React137 from "react";
import { gql as gql109 } from "@apollo/client";
import { UitkLink as UitkLink16 } from "uitk-react-link";
import { UitkSpacing as UitkSpacing71 } from "uitk-react-spacing";
import { UitkText as UitkText41 } from "uitk-react-text";
var __ErrorMessageFragment = gql109(_templateObject111());
var ErrorMessage = function(param) {
    var className = param.className, data = param.data;
    var _title, _action_primary, _action;
    var title = data.title, action = data.action;
    var Link = useLinkComponent().Link;
    if (!((_title = title) === null || _title === void 0 ? void 0 : _title.text)) {
        return null;
    }
    return /* @__PURE__ */ React137.createElement("div", {
        "data-stid": "error-messages",
        className: className
    }, /* @__PURE__ */ React137.createElement(UitkSpacing71, {
        padding: {
            inlineend: "one"
        }
    }, /* @__PURE__ */ React137.createElement(UitkText41, {
        theme: "negative",
        inline: true
    }, title.text)), ((_action = action) === null || _action === void 0 ? void 0 : (_action_primary = _action.primary) === null || _action_primary === void 0 ? void 0 : _action_primary.linkUrl) && /* @__PURE__ */ React137.createElement(UitkLink16, {
        inline: true
    }, /* @__PURE__ */ React137.createElement(Link, {
        href: action.primary.linkUrl
    }, action.primary.text)));
};
ErrorMessage.displayName = "ErrorMessage";
ErrorMessage.fragment = __ErrorMessageFragment;
// src/components/property-offers/__private/__fragments/listings-error-message.tsx
var __fragment2 = gql110(_templateObject112(), ErrorMessage.fragment);
var ListingsErrorMessage = function(param) {
    var data = param.data, className = param.className;
    var _data_errorMessage;
    var error = useMultiItemContext().error;
    if (!((_data_errorMessage = data.errorMessage) === null || _data_errorMessage === void 0 ? void 0 : _data_errorMessage.title) && !error) {
        return null;
    }
    var errorMessage = data.errorMessage ? data.errorMessage : {
        __typename: "MessageResult",
        title: {
            text: error || null,
            __typename: "MessagingResultTitle"
        },
        action: null
    };
    return /* @__PURE__ */ React138.createElement(UitkCard23, {
        className: className
    }, /* @__PURE__ */ React138.createElement(UitkCardContentSection16, null, /* @__PURE__ */ React138.createElement(ErrorMessage, {
        data: errorMessage
    })));
};
ListingsErrorMessage.displayName = "ListingsErrorMessage";
ListingsErrorMessage.fragment = __fragment2;
// src/components/property-offers/__private/__fragments/shopping-context.tsx
import { gql as gql111 } from "@apollo/client";
var __ShoppingContextFragment = gql111(_templateObject113());
// src/components/property-offers/__private/__fragments/sticky-bar-disclaimer.tsx
import React139 from "react";
import { gql as gql112 } from "@apollo/client";
import { UitkSpacing as UitkSpacing72 } from "uitk-react-spacing";
import { UitkText as UitkText42 } from "uitk-react-text";
var __fragment3 = gql112(_templateObject114());
var StickyBarDisclaimer = function(param) {
    var data = param.data;
    var _stickyBar_price_disclaimer, _stickyBar_price, _stickyBar, _stickyBar_price_disclaimer1, _stickyBar_price1, _stickyBar1;
    var stickyBar = data.stickyBar;
    if (!((_stickyBar = stickyBar) === null || _stickyBar === void 0 ? void 0 : (_stickyBar_price = _stickyBar.price) === null || _stickyBar_price === void 0 ? void 0 : (_stickyBar_price_disclaimer = _stickyBar_price.disclaimer) === null || _stickyBar_price_disclaimer === void 0 ? void 0 : _stickyBar_price_disclaimer.value)) {
        return null;
    }
    return /* @__PURE__ */ React139.createElement(UitkSpacing72, {
        margin: {
            blockend: "three"
        }
    }, /* @__PURE__ */ React139.createElement(UitkText42, {
        size: 200
    }, (_stickyBar1 = stickyBar) === null || _stickyBar1 === void 0 ? void 0 : (_stickyBar_price1 = _stickyBar1.price) === null || _stickyBar_price1 === void 0 ? void 0 : (_stickyBar_price_disclaimer1 = _stickyBar_price1.disclaimer) === null || _stickyBar_price_disclaimer1 === void 0 ? void 0 : _stickyBar_price_disclaimer1.value));
};
StickyBarDisclaimer.displayName = "StickyBarDisclaimer";
StickyBarDisclaimer.fragment = __fragment3;
// src/components/property-offers/horizontal-messaging-card-wrapper.tsx
import React140 from "react";
import { UitkSpacing as UitkSpacing73 } from "uitk-react-spacing";
var HorizontalMessagingCardWrapper = function(param) {
    var offerLevelMessages = param.offerLevelMessages;
    var isMessagingCardDismissed = React140.useContext(OffersLevelContext).isMessagingCardDismissed;
    if (!offerLevelMessages) {
        return null;
    }
    var MessagingCard2 = vertical_messaging_card_default(MessageResult);
    if (!isMessagingCardDismissed) {
        var _offerLevelMessages;
        var messageCardElements = (_offerLevelMessages = offerLevelMessages) === null || _offerLevelMessages === void 0 ? void 0 : _offerLevelMessages.map(function(message, index) {
            var _action_primary_actionDetails, _action_primary, _action, _action_secondary_actionDetails, _action_secondary, _action1;
            var action = message.action;
            return /* @__PURE__ */ React140.createElement(UitkSpacing73, {
                margin: {
                    blockend: "three",
                    blockstart: "three"
                },
                key: "horizontal-message-".concat(index)
            }, /* @__PURE__ */ React140.createElement("div", {
                "data-stid": "horizontal-messaging-card"
            }, /* @__PURE__ */ React140.createElement(MessagingCard2, {
                data: message,
                primaryAction: (_action = action) === null || _action === void 0 ? void 0 : (_action_primary = _action.primary) === null || _action_primary === void 0 ? void 0 : (_action_primary_actionDetails = _action_primary.actionDetails) === null || _action_primary_actionDetails === void 0 ? void 0 : _action_primary_actionDetails.action,
                secondaryAction: (_action1 = action) === null || _action1 === void 0 ? void 0 : (_action_secondary = _action1.secondary) === null || _action_secondary === void 0 ? void 0 : (_action_secondary_actionDetails = _action_secondary.actionDetails) === null || _action_secondary_actionDetails === void 0 ? void 0 : _action_secondary_actionDetails.action
            })));
        });
        return /* @__PURE__ */ React140.createElement(React140.Fragment, null, messageCardElements);
    }
    return null;
};
var horizontal_messaging_card_wrapper_default = HorizontalMessagingCardWrapper;
// src/components/property-offers/property-offers.tsx
var __PropertyOffersFragment = gql113(_templateObject115(), ListingsHeader.fragment, AlternateDates.fragment, ListingsErrorMessage.fragment, Listings.fragment, StickyBarDisclaimer.fragment, __ShoppingContextFragment, MessageResult.fragment, PropertyFilterPills.fragment, FilterPills.fragment, PropertyOffersIncludedPerks.fragment);
var Form = function(param) {
    var children = param.children;
    return /* @__PURE__ */ React141.createElement(React141.Fragment, null, children);
};
var HeaderRight = function(param) {
    var children = param.children;
    return /* @__PURE__ */ React141.createElement(React141.Fragment, null, children);
};
var PropertyOffers = function(param) {
    var children = param.children, data = param.data, defaultErrorMessage = param.defaultErrorMessage, LinkWrapper = param.LinkWrapper, handleMultiItemCallback = param.handleMultiItemCallback, updateSearchAndFilters = param.updateSearchAndFilters, refetch = param.refetch, variables = param.variables;
    var _data_shoppingContext_multiItem, _data_shoppingContext, _data, _data_shoppingContext_multiItem1, _data_shoppingContext1, _data1, _variables_searchCriteria, _variables, _usePropertyActivitiesCrossSellContext2, _usePropertyActivitiesCrossSellContext21, _usePropertyActivitiesCrossSellContext22, _usePropertyActivitiesCrossSellContext23, _usePropertyActivitiesCrossSellContext24, _usePropertyActivitiesCrossSellContext25, _usePropertyActivitiesCrossSellContext26, _variables1, _variables_searchCriteria_secondary;
    var multiItemContext = {
        packageType: (_data = data) === null || _data === void 0 ? void 0 : (_data_shoppingContext = _data.shoppingContext) === null || _data_shoppingContext === void 0 ? void 0 : (_data_shoppingContext_multiItem = _data_shoppingContext.multiItem) === null || _data_shoppingContext_multiItem === void 0 ? void 0 : _data_shoppingContext_multiItem.packageType,
        handleMultiItemCallback: handleMultiItemCallback,
        sessionId: (_data1 = data) === null || _data1 === void 0 ? void 0 : (_data_shoppingContext1 = _data1.shoppingContext) === null || _data_shoppingContext1 === void 0 ? void 0 : (_data_shoppingContext_multiItem1 = _data_shoppingContext1.multiItem) === null || _data_shoppingContext_multiItem1 === void 0 ? void 0 : _data_shoppingContext_multiItem1.id
    };
    var inputDateRange = (_variables = variables) === null || _variables === void 0 ? void 0 : (_variables_searchCriteria = _variables.searchCriteria) === null || _variables_searchCriteria === void 0 ? void 0 : _variables_searchCriteria.primary.dateRange;
    var dateRange = (_usePropertyActivitiesCrossSellContext2 = usePropertyActivitiesCrossSellContext2()) === null || _usePropertyActivitiesCrossSellContext2 === void 0 ? void 0 : _usePropertyActivitiesCrossSellContext2.dateRange;
    var setDateRange = (_usePropertyActivitiesCrossSellContext21 = usePropertyActivitiesCrossSellContext2()) === null || _usePropertyActivitiesCrossSellContext21 === void 0 ? void 0 : _usePropertyActivitiesCrossSellContext21.setDateRange;
    var triggerRefetch = (_usePropertyActivitiesCrossSellContext22 = usePropertyActivitiesCrossSellContext2()) === null || _usePropertyActivitiesCrossSellContext22 === void 0 ? void 0 : _usePropertyActivitiesCrossSellContext22.triggerRefetch;
    var activityNaturalKey = (_usePropertyActivitiesCrossSellContext23 = usePropertyActivitiesCrossSellContext2()) === null || _usePropertyActivitiesCrossSellContext23 === void 0 ? void 0 : _usePropertyActivitiesCrossSellContext23.activityNaturalKey;
    var setActivityNaturalKey = (_usePropertyActivitiesCrossSellContext24 = usePropertyActivitiesCrossSellContext2()) === null || _usePropertyActivitiesCrossSellContext24 === void 0 ? void 0 : _usePropertyActivitiesCrossSellContext24.setActivityNaturalKey;
    var setHasAvailableListings = (_usePropertyActivitiesCrossSellContext25 = usePropertyActivitiesCrossSellContext2()) === null || _usePropertyActivitiesCrossSellContext25 === void 0 ? void 0 : _usePropertyActivitiesCrossSellContext25.setHasAvailableListings;
    var propertyOffersMountRef = (_usePropertyActivitiesCrossSellContext26 = usePropertyActivitiesCrossSellContext2()) === null || _usePropertyActivitiesCrossSellContext26 === void 0 ? void 0 : _usePropertyActivitiesCrossSellContext26.propertyOffersMountRef;
    var searchCriteria = ((_variables1 = variables) === null || _variables1 === void 0 ? void 0 : _variables1.searchCriteria) && {
        primary: variables.searchCriteria.primary,
        secondary: _object_spread_props(_object_spread({}, variables.searchCriteria.secondary), {
            booleans: _to_consumable_array(((_variables_searchCriteria_secondary = variables.searchCriteria.secondary) === null || _variables_searchCriteria_secondary === void 0 ? void 0 : _variables_searchCriteria_secondary.booleans) || []).concat([
                {
                    id: "activitySelected",
                    value: true
                }
            ])
        })
    };
    React141.useEffect(function() {
        if (propertyOffersMountRef) {
            var _propertyOffersMountRef;
            if (!((_propertyOffersMountRef = propertyOffersMountRef) === null || _propertyOffersMountRef === void 0 ? void 0 : _propertyOffersMountRef.current) && setDateRange) {
                setDateRange(JSON.stringify(inputDateRange));
            }
            propertyOffersMountRef.current = true;
        }
    }, []);
    React141.useEffect(function() {
        if (JSON.stringify(inputDateRange) !== dateRange && setActivityNaturalKey && setDateRange) {
            setActivityNaturalKey({
                offerToken: "",
                productToken: ""
            });
            setDateRange(JSON.stringify(inputDateRange));
        }
    }, [
        inputDateRange
    ]);
    React141.useEffect(function() {
        if (setHasAvailableListings) {
            var _data_categorizedListings;
            setHasAvailableListings(!!((_data_categorizedListings = data.categorizedListings) === null || _data_categorizedListings === void 0 ? void 0 : _data_categorizedListings.length));
        }
    }, [
        data
    ]);
    React141.useEffect(function() {
        if (triggerRefetch && refetch) {
            var _activityNaturalKey;
            refetch(_object_spread({}, variables, ((_activityNaturalKey = activityNaturalKey) === null || _activityNaturalKey === void 0 ? void 0 : _activityNaturalKey.offerToken) && {
                searchCriteria: searchCriteria
            }));
        }
    }, [
        triggerRefetch
    ]);
    return /* @__PURE__ */ React141.createElement(LinkComponentProvider, {
        Link: LinkWrapper
    }, /* @__PURE__ */ React141.createElement(MultiItemProvider, {
        defaultError: defaultErrorMessage,
        multiItemContext: multiItemContext
    }, /* @__PURE__ */ React141.createElement(OffersLevelProvider, null, /* @__PURE__ */ React141.createElement(UitkSpacing74, {
        margin: {
            small: {
                inline: "three"
            },
            medium: {
                inline: "unset"
            }
        }
    }, /* @__PURE__ */ React141.createElement("div", null, /* @__PURE__ */ React141.createElement(UitkSpacing74, {
        margin: {
            blockend: "three"
        }
    }, /* @__PURE__ */ React141.createElement(UitkLayoutFlex31, {
        justifyContent: "space-between"
    }, /* @__PURE__ */ React141.createElement(ListingsHeader, {
        data: data
    }), findReactChildByType(children, HeaderRight))), /* @__PURE__ */ React141.createElement(UitkSpacing74, {
        margin: {
            blockend: "three"
        }
    }, /* @__PURE__ */ React141.createElement(ListingsErrorMessage, {
        data: data
    })), /* @__PURE__ */ React141.createElement(UitkSpacing74, {
        margin: {
            blockend: "three"
        }
    }, /* @__PURE__ */ React141.createElement(AlternateDates, {
        data: data
    })), findReactChildByType(children, Form), /* @__PURE__ */ React141.createElement(horizontal_messaging_card_wrapper_default, {
        offerLevelMessages: data.offerLevelMessages
    }), /* @__PURE__ */ React141.createElement(PropertyOffersIncludedPerks, {
        data: data
    }), /* @__PURE__ */ React141.createElement(PropertyFilterPills, {
        data: data,
        updateSearchAndFilters: updateSearchAndFilters
    }), /* @__PURE__ */ React141.createElement(FilterPills, {
        data: data
    }))), /* @__PURE__ */ React141.createElement(UitkSpacing74, {
        margin: {
            block: "three"
        }
    }, /* @__PURE__ */ React141.createElement(Listings, {
        data: data
    })), /* @__PURE__ */ React141.createElement(StickyBarDisclaimer, {
        data: data
    }))));
};
PropertyOffers.displayName = "PropertyOffers";
PropertyOffers.fragment = __PropertyOffersFragment;
// src/components/property-offers/listings-placeholder.tsx
var OfferCarouselPlaceholder = function() {
    var carouselProps = {
        carouselName: "OffersCarouselPlaceholder",
        buttonText: {
            nextButton: "",
            prevButton: ""
        },
        itemsVisible: {
            sm: 1,
            md: 1,
            lg: 1
        },
        pageBy: 1,
        peek: true,
        itemsMaxHeight: true,
        pagingInset: true,
        hideNav: true,
        shouldSnapOnScroll: false
    };
    var numberOfCards = 2;
    return /* @__PURE__ */ React142.createElement(UitkCarousel2, _object_spread({}, carouselProps), _to_consumable_array(Array(numberOfCards)).map(function(_, index) {
        return /* @__PURE__ */ React142.createElement("div", {
            key: "similar-properties-placeholder-".concat(index)
        }, /* @__PURE__ */ React142.createElement(UitkCard24, {
            padded: true
        }, /* @__PURE__ */ React142.createElement("div", null, /* @__PURE__ */ React142.createElement(UitkSpacing75, {
            padding: {
                blockend: "sixteen"
            },
            margin: {
                blockend: "six"
            }
        }, /* @__PURE__ */ React142.createElement("div", null, /* @__PURE__ */ React142.createElement(UitkFigure5, {
            ratio: UitkFigureAspectRatioType6.R16_9,
            className: "uitk-card-roundcorner-all"
        }, /* @__PURE__ */ React142.createElement(UitkBlockSkeleton, null)), /* @__PURE__ */ React142.createElement(UitkCardContentSection17, {
            padded: false
        }, /* @__PURE__ */ React142.createElement(UitkSpacing75, {
            margin: {
                block: "four"
            }
        }, /* @__PURE__ */ React142.createElement(UitkLineSkeleton2, {
            animation: true
        })), /* @__PURE__ */ React142.createElement(UitkSpacing75, {
            margin: {
                block: "four"
            }
        }, /* @__PURE__ */ React142.createElement(UitkLineSkeleton2, {
            animation: true
        })), /* @__PURE__ */ React142.createElement(UitkSpacing75, {
            margin: {
                block: "four"
            }
        }, /* @__PURE__ */ React142.createElement(UitkLineSkeleton2, {
            animation: true,
            type: "secondary"
        })), /* @__PURE__ */ React142.createElement(UitkSpacing75, {
            margin: {
                block: "four"
            }
        }, /* @__PURE__ */ React142.createElement(UitkLineSkeleton2, {
            animation: true,
            type: "secondary"
        }))))))));
    }));
};
var CheckInCheckOutInputPlaceholder = function() {
    return /* @__PURE__ */ React142.createElement(Viewport21, null, /* @__PURE__ */ React142.createElement(ViewSmall20, null, /* @__PURE__ */ React142.createElement(UitkSpacing75, {
        margin: {
            block: "four"
        }
    }, /* @__PURE__ */ React142.createElement(UitkCard24, {
        padded: true
    }, /* @__PURE__ */ React142.createElement(UitkCardContentSection17, {
        padded: false
    }, /* @__PURE__ */ React142.createElement(UitkLayoutFlex32, {
        justifyContent: "space-between"
    }, /* @__PURE__ */ React142.createElement(UitkSpacing75, {
        margin: {
            block: "four"
        }
    }, /* @__PURE__ */ React142.createElement(UitkLineSkeleton2, {
        animation: true
    })), /* @__PURE__ */ React142.createElement(UitkSpacing75, {
        margin: {
            block: "four"
        }
    }, /* @__PURE__ */ React142.createElement(UitkLineSkeleton2, {
        animation: true
    }))))))), /* @__PURE__ */ React142.createElement(ViewLarge5, null, /* @__PURE__ */ React142.createElement(UitkLayoutGrid21, {
        columns: 6,
        space: "two"
    }, [
        1,
        2,
        3
    ].map(function(value, index) {
        return /* @__PURE__ */ React142.createElement(UitkLayoutGridItem18, {
            colSpan: value === 3 ? 3 : 1,
            key: "date-placeholder-".concat(index)
        }, /* @__PURE__ */ React142.createElement(UitkSpacing75, {
            margin: {
                block: "four"
            }
        }, /* @__PURE__ */ React142.createElement(UitkCard24, {
            padded: true
        }, /* @__PURE__ */ React142.createElement(UitkCardContentSection17, {
            padded: false
        }, /* @__PURE__ */ React142.createElement(UitkSpacing75, {
            margin: {
                block: "four"
            }
        }, /* @__PURE__ */ React142.createElement(UitkLineSkeleton2, {
            animation: true
        }))))));
    }), /* @__PURE__ */ React142.createElement(UitkLayoutGridItem18, null, /* @__PURE__ */ React142.createElement(UitkSpacing75, {
        margin: {
            block: "twelve"
        }
    }, /* @__PURE__ */ React142.createElement(UitkLineSkeleton2, {
        animation: true
    }))))));
};
var OffersHeadingPlaceholder = function() {
    return /* @__PURE__ */ React142.createElement(UitkSpacing75, {
        margin: {
            block: "four"
        }
    }, /* @__PURE__ */ React142.createElement(UitkLayoutFlex32, {
        justifyContent: "space-between"
    }, /* @__PURE__ */ React142.createElement(UitkLineSkeleton2, {
        animation: true
    }), /* @__PURE__ */ React142.createElement(Viewport21, null, /* @__PURE__ */ React142.createElement(ViewSmall20, null, /* @__PURE__ */ React142.createElement(UitkLineSkeleton2, {
        animation: true,
        type: "secondary"
    })), /* @__PURE__ */ React142.createElement(ViewLarge5, null))));
};
var VerticalListingPlaceholderCard = function() {
    return /* @__PURE__ */ React142.createElement(UitkCard24, {
        padded: true
    }, /* @__PURE__ */ React142.createElement(UitkFigure5, {
        ratio: UitkFigureAspectRatioType6.R16_9,
        className: "uitk-card-roundcorner-all"
    }, /* @__PURE__ */ React142.createElement(UitkBlockSkeleton, null)), /* @__PURE__ */ React142.createElement(UitkCardContentSection17, {
        padded: false
    }, /* @__PURE__ */ React142.createElement(UitkSpacing75, {
        margin: {
            block: "four"
        }
    }, /* @__PURE__ */ React142.createElement(UitkLineSkeleton2, {
        animation: true
    })), /* @__PURE__ */ React142.createElement(UitkSpacing75, {
        margin: {
            block: "four"
        }
    }, /* @__PURE__ */ React142.createElement(UitkLineSkeleton2, {
        animation: true,
        type: "secondary"
    }))));
};
var LoadingPlaceholderCards = function() {
    var _context_device, _context;
    var context = useBexApi6().context;
    var isMobile = ((_context = context) === null || _context === void 0 ? void 0 : (_context_device = _context.device) === null || _context_device === void 0 ? void 0 : _context_device.type) === "MOBILE_PHONE" /* MOBILE_PHONE */ ;
    var _useExperiment3 = useExperiment3("Micro_Room_Card_Side_By_Side_Carousel_mWeb"), microRoomCardCarouselExposure = _useExperiment3.exposure;
    var isMicroRoomCardCarousel = isMobile && microRoomCardCarouselExposure.bucket === 1;
    var carouselPlaceholders = /* @__PURE__ */ React142.createElement(UitkSpacing75, {
        margin: {
            inlinestart: "three"
        }
    }, /* @__PURE__ */ React142.createElement("div", null, /* @__PURE__ */ React142.createElement(OfferCarouselPlaceholder, null)));
    var verticalPlaceholders = /* @__PURE__ */ React142.createElement(UitkSpacing75, {
        margin: {
            small: {
                inline: "three"
            },
            medium: {
                inline: "unset"
            }
        }
    }, /* @__PURE__ */ React142.createElement(UitkLayoutGrid21, {
        columns: {
            auto_fill: "seventy_six"
        },
        space: "three",
        justifyContent: "start"
    }, [
        0,
        1,
        2
    ].map(function(_, index) {
        return /* @__PURE__ */ React142.createElement(VerticalListingPlaceholderCard, {
            key: "listing-placeholder-".concat(index)
        });
    })));
    var offersSkeleton = isMicroRoomCardCarousel ? /* @__PURE__ */ React142.createElement(Viewport21, null, /* @__PURE__ */ React142.createElement(ViewSmall20, null, carouselPlaceholders), /* @__PURE__ */ React142.createElement(ViewMedium17, null, verticalPlaceholders)) : verticalPlaceholders;
    return /* @__PURE__ */ React142.createElement(UitkSpacing75, {
        margin: {
            blockstart: "four"
        }
    }, offersSkeleton);
};
var ListingsInitialPlaceholder = function() {
    return /* @__PURE__ */ React142.createElement(React142.Fragment, null, /* @__PURE__ */ React142.createElement(UitkSpacing75, {
        margin: {
            small: {
                inline: "three"
            },
            medium: {
                inline: "unset"
            }
        }
    }, /* @__PURE__ */ React142.createElement("div", null, /* @__PURE__ */ React142.createElement(OffersHeadingPlaceholder, null), /* @__PURE__ */ React142.createElement(CheckInCheckOutInputPlaceholder, null))), /* @__PURE__ */ React142.createElement(LoadingPlaceholderCards, null));
};
var ListingsPlaceholder = function(param) {
    var data = param.data, children = param.children;
    if (!data) {
        return /* @__PURE__ */ React142.createElement("div", null, /* @__PURE__ */ React142.createElement(ListingsInitialPlaceholder, null));
    }
    return /* @__PURE__ */ React142.createElement("div", null, /* @__PURE__ */ React142.createElement(UitkSpacing75, {
        margin: {
            small: {
                inline: "three"
            },
            medium: {
                inline: "unset"
            }
        }
    }, /* @__PURE__ */ React142.createElement("div", null, /* @__PURE__ */ React142.createElement(UitkSpacing75, {
        margin: {
            blockend: "three"
        }
    }, /* @__PURE__ */ React142.createElement(UitkLayoutFlex32, {
        justifyContent: "space-between"
    }, data && /* @__PURE__ */ React142.createElement(ListingsHeader, {
        data: data
    }), findReactChildByType(children, HeaderRight))), findReactChildByType(children, Form), data && /* @__PURE__ */ React142.createElement(PropertyFilterPills, {
        data: data,
        disabled: true
    }))), /* @__PURE__ */ React142.createElement(LoadingPlaceholderCards, null));
};
LoadingPlaceholderCards.displayName = "LoadingPlaceholderCards";
VerticalListingPlaceholderCard.displayName = "VerticalListingPlaceholderCard";
OffersHeadingPlaceholder.displayName = "OffersHeadingPlaceholder";
CheckInCheckOutInputPlaceholder.displayName = "CheckInCheckOutInputPlaceholder";
ListingsInitialPlaceholder.displayName = "ListingsInitialPlaceholder";
OfferCarouselPlaceholder.displayName = "OfferCarouselPlaceholder";
// src/components/property-search-link/property-search-link.tsx
import React144 from "react";
import { gql as gql115 } from "@apollo/client";
// src/components/property-search-link/__private/__fragments/lodging-link-message.tsx
import React143 from "react";
import { useHistory } from "react-router-dom";
import { gql as gql114 } from "@apollo/client";
import { useClickTracker as useClickTracker36 } from "@shared-ui/clickstream-analytics-context";
import { UitkIcon as UitkIcon29, UitkIconSize as UitkIconSize23 } from "uitk-react-icons";
import { UitkLink as UitkLink17 } from "uitk-react-link";
import { UitkSpacing as UitkSpacing76 } from "uitk-react-spacing";
var __LodgingLinkMessageFragment = gql114(_templateObject116());
var IconWrapper = function(param) {
    var iconId = param.iconId;
    return /* @__PURE__ */ React143.createElement(UitkSpacing76, {
        margin: {
            inlineend: "one"
        }
    }, /* @__PURE__ */ React143.createElement(UitkIcon29, {
        "data-stid": "lodging-link-message-icon",
        name: iconId,
        size: UitkIconSize23.SMALL
    }));
};
var LodgingLinkMessage = function(param) {
    var data = param.data, onClick = param.onClick, _param_isNavigationFromSRP = param.isNavigationFromSRP, isNavigationFromSRP = _param_isNavigationFromSRP === void 0 ? false : _param_isNavigationFromSRP, useAbsolutePath = param.useAbsolutePath;
    var _icon, _icon1;
    var link = data.link, value = data.value, icon = data.icon;
    var track = useClickTracker36();
    var history = useHistory();
    var Link = useLinkComponent().Link;
    var href = useAbsolutePath ? link.uri.value : link.uri.relativePath;
    var handleClick = function() {
        var _onClick, _link;
        (_onClick = onClick) === null || _onClick === void 0 ? void 0 : _onClick();
        if (!useAbsolutePath) {
            if (history.length > 1 && isNavigationFromSRP) {
                history.goBack();
            } else {
                history.push(href);
            }
        }
        if ((_link = link) === null || _link === void 0 ? void 0 : _link.clientSideAnalytics) {
            track("HOT.HIS.".concat(link.clientSideAnalytics.referrerId), link.clientSideAnalytics.linkName, false);
        }
    };
    if (!value) {
        return null;
    }
    return /* @__PURE__ */ React143.createElement(UitkLink17, {
        onClick: handleClick
    }, useAbsolutePath ? /* @__PURE__ */ React143.createElement(Link, {
        href: href
    }, ((_icon = icon) === null || _icon === void 0 ? void 0 : _icon.id) && /* @__PURE__ */ React143.createElement(IconWrapper, {
        iconId: icon.id
    }), value) : /* @__PURE__ */ React143.createElement("button", {
        type: "button",
        role: "link"
    }, ((_icon1 = icon) === null || _icon1 === void 0 ? void 0 : _icon1.id) && /* @__PURE__ */ React143.createElement(IconWrapper, {
        iconId: icon.id
    }), value));
};
LodgingLinkMessage.displayName = "LodgingLinkMessage";
LodgingLinkMessage.fragment = __LodgingLinkMessageFragment;
// src/components/property-search-link/property-search-link.tsx
var __PropertySearchLinkFragment = gql115(_templateObject117(), LodgingLinkMessage.fragment);
var PropertySearchLink = function(param) {
    var data = param.data, onClick = param.onClick, isNavigationFromSRP = param.isNavigationFromSRP, _param_useExternalLink = param.useExternalLink, useExternalLink = _param_useExternalLink === void 0 ? false : _param_useExternalLink;
    var _propertySearchLink, _partnerPropertySearchLink;
    var propertySearchLink = data.propertySearchLink, partnerPropertySearchLink = data.partnerPropertySearchLink;
    var _useMultiItemContext = useMultiItemContext(), sessionId = _useMultiItemContext.sessionId, packageType = _useMultiItemContext.packageType;
    var forceRefresh = sessionId && packageType;
    var onBackLinkClick = React144.useCallback(function() {
        if (forceRefresh) {
            var _propertySearchLink, _partnerPropertySearchLink;
            window.location.href = ((_propertySearchLink = propertySearchLink) === null || _propertySearchLink === void 0 ? void 0 : _propertySearchLink.link.uri.relativePath) || ((_partnerPropertySearchLink = partnerPropertySearchLink) === null || _partnerPropertySearchLink === void 0 ? void 0 : _partnerPropertySearchLink.link.uri.relativePath) || "";
        }
    }, [
        ((_propertySearchLink = propertySearchLink) === null || _propertySearchLink === void 0 ? void 0 : _propertySearchLink.link.uri.relativePath) || ((_partnerPropertySearchLink = partnerPropertySearchLink) === null || _partnerPropertySearchLink === void 0 ? void 0 : _partnerPropertySearchLink.link.uri.relativePath),
        forceRefresh
    ]);
    var handleClick = function() {
        var _onClick;
        onBackLinkClick();
        (_onClick = onClick) === null || _onClick === void 0 ? void 0 : _onClick();
    };
    if (propertySearchLink) {
        return /* @__PURE__ */ React144.createElement(LodgingLinkMessage, {
            data: propertySearchLink,
            onClick: handleClick,
            isNavigationFromSRP: isNavigationFromSRP,
            useAbsolutePath: useExternalLink
        });
    }
    if (partnerPropertySearchLink) {
        return /* @__PURE__ */ React144.createElement(LodgingLinkMessage, {
            onClick: handleClick,
            data: partnerPropertySearchLink,
            isNavigationFromSRP: isNavigationFromSRP,
            useAbsolutePath: true
        });
    }
    return null;
};
PropertySearchLink.displayName = "PropertySearchLink";
PropertySearchLink.fragment = __PropertySearchLinkFragment;
// src/components/property-single-offer/property-single-offer.tsx
import React156 from "react";
import { gql as gql125 } from "@apollo/client";
// src/components/property-single-offer/__private/__fragments/property-single-rate-plan.tsx
import React155 from "react";
import { gql as gql124 } from "@apollo/client";
import { ViewLarge as ViewLarge6, Viewport as Viewport23, ViewSmall as ViewSmall22 } from "@shared-ui/viewport-context";
import { UitkSpacing as UitkSpacing80 } from "uitk-react-spacing";
// src/components/property-single-offer/__private/__fragments/alternate-availability-msg.tsx
import React145 from "react";
import { gql as gql116 } from "@apollo/client";
import { UitkCard as UitkCard25, UitkCardContentSection as UitkCardContentSection18 } from "uitk-react-cards";
import { UitkLink as UitkLink18 } from "uitk-react-link";
import { UitkText as UitkText43 } from "uitk-react-text";
var fragment68 = gql116(_templateObject118());
var AlternateAvailabilityMsg = function(param) {
    var data = param.data;
    var _actionLink_link, _actionLink, _actionLink1;
    if (!data || !data.text || !data.actionLink) {
        return null;
    }
    var text = data.text, actionLink = data.actionLink;
    return /* @__PURE__ */ React145.createElement(UitkCard25, {
        key: "alternate-availability",
        "data-stid": "alternate-availability"
    }, /* @__PURE__ */ React145.createElement(UitkCardContentSection18, null, /* @__PURE__ */ React145.createElement(UitkText43, {
        size: 300
    }, text.value), /* @__PURE__ */ React145.createElement(UitkLink18, null, /* @__PURE__ */ React145.createElement("a", {
        href: (_actionLink = actionLink) === null || _actionLink === void 0 ? void 0 : (_actionLink_link = _actionLink.link) === null || _actionLink_link === void 0 ? void 0 : _actionLink_link.uri.relativePath
    }, (_actionLink1 = actionLink) === null || _actionLink1 === void 0 ? void 0 : _actionLink1.value))));
};
AlternateAvailabilityMsg.displayName = "AlternateAvailabilityMsg";
AlternateAvailabilityMsg.fragment = fragment68;
// src/components/property-single-offer/__private/__fragments/price-breakdown-expanded.tsx
import React146 from "react";
var PriceBreakdownExpanded = function(param) {
    var data = param.data;
    var _sections;
    var _ref = data.priceBreakDownSummary || {}, sections = _ref.sections, priceSummaryHeading = _ref.priceSummaryHeading;
    var _ref1 = priceSummaryHeading || {}, accessibilityLabel = _ref1.accessibilityLabel, value = _ref1.value;
    var a11yLabel = accessibilityLabel || value;
    return /* @__PURE__ */ React146.createElement(React146.Fragment, null, a11yLabel && /* @__PURE__ */ React146.createElement("h3", {
        className: "is-visually-hidden"
    }, a11yLabel), (_sections = sections) === null || _sections === void 0 ? void 0 : _sections.map(function(section, index) {
        var _sections;
        return /* @__PURE__ */ React146.createElement(PriceSummarySection, {
            data: section,
            key: "price-summary-section-".concat(index),
            lastSection: index === ((_sections = sections) === null || _sections === void 0 ? void 0 : _sections.length) - 1
        });
    }));
};
PriceBreakdownExpanded.fragment = fragment33;
PriceBreakdownExpanded.displayName = "PriceBreakdownDialog";
// src/components/property-single-offer/__private/__fragments/price-presentation-expanded.tsx
import React147 from "react";
import { PricePresentation as PricePresentation2 } from "@shared-ui/pricing-price-details";
import { UitkSpacing as UitkSpacing77 } from "uitk-react-spacing";
var PricePresentationExpanded = function(param) {
    var data = param.data;
    var pricePresentation = data.pricePresentation, pricePresentationDialog = data.pricePresentationDialog;
    if (!pricePresentation || !pricePresentationDialog) {
        return null;
    }
    var trigger = pricePresentationDialog.trigger;
    return /* @__PURE__ */ React147.createElement(UitkSpacing77, {
        padding: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React147.createElement("div", null, /* @__PURE__ */ React147.createElement("h3", {
        className: "is-visually-hidden"
    }, trigger.value), /* @__PURE__ */ React147.createElement(PricePresentation2, {
        data: pricePresentation
    })));
};
PricePresentationExpanded.fragment = PricePresentationDialogComponentFragment;
PricePresentationExpanded.displayName = "PricePresentationExpanded";
// src/components/property-single-offer/__private/__fragments/property-single-offer-details.tsx
import React151 from "react";
import { gql as gql120 } from "@apollo/client";
import { UitkCard as UitkCard26, UitkCardContentSection as UitkCardContentSection19 } from "uitk-react-cards";
import { UitkSpacing as UitkSpacing78 } from "uitk-react-spacing";
// src/components/property-single-offer/__private/__fragments/availability-cta.tsx
import React148 from "react";
import { gql as gql117 } from "@apollo/client";
var fragment69 = gql117(_templateObject119());
var AvailabilityCta2 = function(param) {
    var closeDialog = param.closeDialog, listingIndex = param.listingIndex, data = param.data;
    var availabilityCallToAction = data.availabilityCallToAction;
    if (!availabilityCallToAction) {
        return null;
    }
    return /* @__PURE__ */ React148.createElement(AvailabilityCallToAction, {
        closeDialog: closeDialog,
        listingIndex: listingIndex,
        data: availabilityCallToAction
    });
};
AvailabilityCta2.displayName = "AvailabilityCta";
AvailabilityCta2.fragment = fragment69;
// src/components/property-single-offer/__private/__fragments/price-messages.tsx
import React149 from "react";
import { gql as gql118 } from "@apollo/client";
import { UitkText as UitkText44 } from "uitk-react-text";
var fragment70 = gql118(_templateObject120(), LodgingEnrichedMessage.fragment);
var PriceMessages = function(param) {
    var data = param.data;
    var _data_displayPrice, _data, _data_displayPrice1, _data1;
    return /* @__PURE__ */ React149.createElement(React149.Fragment, null, Array.isArray((_data = data) === null || _data === void 0 ? void 0 : (_data_displayPrice = _data.displayPrice) === null || _data_displayPrice === void 0 ? void 0 : _data_displayPrice.priceMessages) && ((_data1 = data) === null || _data1 === void 0 ? void 0 : (_data_displayPrice1 = _data1.displayPrice) === null || _data_displayPrice1 === void 0 ? void 0 : _data_displayPrice1.priceMessages.map(function(message, messageIndex) {
        return /* @__PURE__ */ React149.createElement(UitkText44, {
            size: 200,
            key: "message-".concat(messageIndex)
        }, /* @__PURE__ */ React149.createElement(LodgingEnrichedMessage, {
            data: message
        }));
    })));
};
PriceMessages.fragment = fragment70;
PriceMessages.displayName = "SingleUnitPriceMessages";
// src/components/property-single-offer/__private/__fragments/single-unit-rate-plan-summary.tsx
import React150 from "react";
import { gql as gql119 } from "@apollo/client";
import { PriceSummary as PriceSummary4 } from "@shared-ui/pricing-price-summary";
import { UitkLayoutFlex as UitkLayoutFlex33, UitkLayoutFlexItem as UitkLayoutFlexItem22 } from "uitk-react-layout-flex";
import { UitkText as UitkText45 } from "uitk-react-text";
var fragment71 = gql119(_templateObject121(), LodgingPriceSummary.fragment, PropertyRatePlanBadge.fragment, PropertyOffersPriceChangeMessage.fragment, PriceSummaryFragment);
var SingleUnitRatePlanSummary = function(param) {
    var data = param.data;
    var _priceDetail_price, _priceDetail, _priceDetail_price_displayMessages, _priceDetail_price1;
    var _data_priceDetails = _sliced_to_array(data.priceDetails, 1), priceDetail = _data_priceDetails[0];
    var priceSubtext = ((_priceDetail = priceDetail) === null || _priceDetail === void 0 ? void 0 : (_priceDetail_price = _priceDetail.price) === null || _priceDetail_price === void 0 ? void 0 : _priceDetail_price.priceMessaging) && priceDetail.price.priceMessaging.length > 0 && priceDetail.price.priceMessaging[0].value;
    return /* @__PURE__ */ React150.createElement(React150.Fragment, null, /* @__PURE__ */ React150.createElement(PropertyOffersPriceChangeMessage, {
        data: data
    }), /* @__PURE__ */ React150.createElement(UitkLayoutFlex33, {
        justifyContent: "space-between",
        alignItems: "center"
    }, /* @__PURE__ */ React150.createElement(UitkLayoutFlexItem22, null, /* @__PURE__ */ React150.createElement(UitkLayoutFlex33, {
        alignItems: "end",
        space: "two"
    }, ((_priceDetail_price1 = priceDetail.price) === null || _priceDetail_price1 === void 0 ? void 0 : (_priceDetail_price_displayMessages = _priceDetail_price1.displayMessages) === null || _priceDetail_price_displayMessages === void 0 ? void 0 : _priceDetail_price_displayMessages.length) ? /* @__PURE__ */ React150.createElement(PriceSummary4, {
        data: priceDetail.price,
        flexAlignment: "start"
    }) : /* @__PURE__ */ React150.createElement(React150.Fragment, null, /* @__PURE__ */ React150.createElement(LodgingPriceSummary, {
        data: priceDetail,
        showPriceDetails: false
    }), /* @__PURE__ */ React150.createElement(UitkText45, {
        theme: "default"
    }, priceSubtext)))), /* @__PURE__ */ React150.createElement(UitkLayoutFlexItem22, null, /* @__PURE__ */ React150.createElement(PropertyRatePlanBadge, {
        data: data
    }))));
};
SingleUnitRatePlanSummary.fragment = fragment71;
SingleUnitRatePlanSummary.displayName = "SingleUnitRatePlan";
// src/components/property-single-offer/__private/__fragments/property-single-offer-details.tsx
var fragment72 = gql120(_templateObject122(), PriceMessages.fragment, SingleUnitRatePlanSummary.fragment, LodgingHighlightedMessages.fragment, AvailabilityCta2.fragment);
var PropertySingleOfferDetails = function(param) {
    var data = param.data;
    var _singleUnitOffer, _singleUnitOffer1, _singleUnitOffer2;
    var singleUnitOffer = data;
    var id = singleUnitOffer.id;
    if (!id) {
        return null;
    }
    var singleRatePlan = Array.isArray((_singleUnitOffer = singleUnitOffer) === null || _singleUnitOffer === void 0 ? void 0 : _singleUnitOffer.ratePlans) && ((_singleUnitOffer1 = singleUnitOffer) === null || _singleUnitOffer1 === void 0 ? void 0 : _singleUnitOffer1.ratePlans.length) === 1 && ((_singleUnitOffer2 = singleUnitOffer) === null || _singleUnitOffer2 === void 0 ? void 0 : _singleUnitOffer2.ratePlans[0]);
    if (!singleRatePlan) {
        return null;
    }
    return /* @__PURE__ */ React151.createElement(UitkCard26, {
        overflow: true
    }, /* @__PURE__ */ React151.createElement(UitkCardContentSection19, {
        "data-stid": "property-offer"
    }, /* @__PURE__ */ React151.createElement(AvailabilityCta2, {
        data: data,
        listingIndex: 1
    }), /* @__PURE__ */ React151.createElement(SingleUnitRatePlanSummary, {
        data: singleRatePlan
    }), /* @__PURE__ */ React151.createElement(PriceMessages, {
        data: singleUnitOffer
    }), singleRatePlan.highlightedMessages && /* @__PURE__ */ React151.createElement(UitkSpacing78, {
        margin: {
            blockstart: "three"
        },
        padding: {
            blockstart: "three"
        },
        border: [
            "blockstart"
        ]
    }, /* @__PURE__ */ React151.createElement("div", null, /* @__PURE__ */ React151.createElement(LodgingHighlightedMessages, {
        data: singleRatePlan
    })))));
};
PropertySingleOfferDetails.fragment = fragment72;
PropertySingleOfferDetails.displayName = "PropertySingleOfferDetails";
// src/components/property-single-offer/__private/__fragments/property-single-offer-dialog-link.tsx
import React153 from "react";
import { gql as gql122 } from "@apollo/client";
import { useClickTracker as useClickTracker37 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog19 } from "@shared-ui/dialog-context";
import { ViewMedium as ViewMedium18, Viewport as Viewport22, ViewSmall as ViewSmall21 } from "@shared-ui/viewport-context";
import { UitkDialogContent as UitkDialogContent11 } from "uitk-react-dialog";
import { UitkIcon as UitkIcon30, UitkIconSize as UitkIconSize24 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex34, UitkLayoutFlexItem as UitkLayoutFlexItem23 } from "uitk-react-layout-flex";
import { UitkLink as UitkLink19 } from "uitk-react-link";
import { UitkSheet as UitkSheet12 } from "uitk-react-sheet";
import { UitkSpacing as UitkSpacing79 } from "uitk-react-spacing";
import { UitkText as UitkText46 } from "uitk-react-text";
import { UitkToolbar as UitkToolbar12 } from "uitk-react-toolbar";
// src/components/property-single-offer/__private/__fragments/reserve-property.tsx
import React152 from "react";
import { gql as gql121 } from "@apollo/client";
var fragment73 = gql121(_templateObject123(), PropertyReserveButton.fragment, PropertyInfoMessage.fragment);
var ETP_DIALOG_QUERY_PARAM2 = "infosite-room-ratePlans";
var ReserveProperty = function(param) {
    var data = param.data, _param_isFullWidth = param.isFullWidth, isFullWidth = _param_isFullWidth === void 0 ? true : _param_isFullWidth;
    var paymentPolicy = data.paymentPolicy;
    return /* @__PURE__ */ React152.createElement(React152.Fragment, null, /* @__PURE__ */ React152.createElement(PropertyReserveButton, {
        paymentPolicy: paymentPolicy,
        dialogSuffix: ETP_DIALOG_QUERY_PARAM2,
        data: data,
        listingIndex: 1,
        isFullWidth: isFullWidth,
        showLargeBtn: true
    }));
};
ReserveProperty.fragment = fragment73;
ReserveProperty.displayName = "SingleUnitRatePlan";
// src/components/property-single-offer/__private/__fragments/property-single-offer-dialog-link.tsx
var fragment74 = gql122(_templateObject124(), PropertySingleOfferDetails.fragment, MarketingSection.fragment, ReserveProperty.fragment, PricePresentationExpanded.fragment);
var Dialog2 = function(param) {
    var singleUnitOfferDialog = param.singleUnitOfferDialog, onClose = param.onClose, triggerRef = param.triggerRef, viewport = param.viewport;
    var _content, _content1, _content_ratePlans, _content2, _toolbar_icon, _toolbar;
    var content = singleUnitOfferDialog.content, toolbar = singleUnitOfferDialog.toolbar;
    var singleRatePlan = Array.isArray((_content = content) === null || _content === void 0 ? void 0 : _content.ratePlans) && ((_content1 = content) === null || _content1 === void 0 ? void 0 : _content1.ratePlans.length) === 1 && ((_content2 = content) === null || _content2 === void 0 ? void 0 : (_content_ratePlans = _content2.ratePlans) === null || _content_ratePlans === void 0 ? void 0 : _content_ratePlans[0]);
    var _ref = singleRatePlan || {}, tmp = _ref.priceDetails, _ref1 = _sliced_to_array(tmp === void 0 ? [] : tmp, 1), priceDetail = _ref1[0];
    var priceBreakDownSummary = (priceDetail || {}).priceBreakDownSummary;
    var _toolbar_title;
    return /* @__PURE__ */ React153.createElement(UitkSheet12, {
        type: viewport === "SMALL" ? "full" : "centered",
        isVisible: true,
        triggerRef: triggerRef,
        returnFocusOnClose: true
    }, /* @__PURE__ */ React153.createElement(UitkToolbar12, {
        toolbarTitle: (_toolbar_title = toolbar.title) !== null && _toolbar_title !== void 0 ? _toolbar_title : void 0,
        navigationContent: {
            onClick: onClose,
            navIconLabel: (_toolbar = toolbar) === null || _toolbar === void 0 ? void 0 : (_toolbar_icon = _toolbar.icon) === null || _toolbar_icon === void 0 ? void 0 : _toolbar_icon.description
        }
    }), /* @__PURE__ */ React153.createElement(UitkDialogContent11, {
        zeroPadding: true
    }, /* @__PURE__ */ React153.createElement(React153.Fragment, null, /* @__PURE__ */ React153.createElement(PropertySingleOfferDetails, {
        data: content
    }), /* @__PURE__ */ React153.createElement(UitkSpacing79, {
        padding: {
            inline: "three"
        }
    }, /* @__PURE__ */ React153.createElement("div", null, priceBreakDownSummary ? /* @__PURE__ */ React153.createElement(PriceBreakdownExpanded, {
        data: priceDetail
    }) : /* @__PURE__ */ React153.createElement(PricePresentationExpanded, {
        data: priceDetail
    }), /* @__PURE__ */ React153.createElement(MarketingSection, {
        data: singleRatePlan.marketingSection
    }))))), /* @__PURE__ */ React153.createElement(UitkSpacing79, {
        padding: {
            small: "four"
        }
    }, /* @__PURE__ */ React153.createElement(UitkLayoutFlex34, {
        wrap: "wrap"
    }, /* @__PURE__ */ React153.createElement(UitkLayoutFlexItem23, {
        minWidth: "full_width"
    }, /* @__PURE__ */ React153.createElement("div", null, /* @__PURE__ */ React153.createElement(ReserveProperty, {
        data: singleRatePlan
    }))))));
};
var PropertySingleOfferDialogLink = function(param) {
    var data = param.data, view = param.view;
    var _trigger, _singleUnitOfferDialog, _singleUnitOfferDialog_content_ratePlans, _singleUnitOfferDialog_content, _singleUnitOfferDialog1;
    var singleUnitOfferDialog = data.singleUnitOfferDialog;
    var trigger = (singleUnitOfferDialog || {}).trigger;
    var _useDialog19 = _sliced_to_array(useDialog19("price-details", "pwaDialogNested"), 3), priceDetailsDialogActions = _useDialog19[1], PriceDetailsDialogComponent = _useDialog19[2];
    var trackClick = useClickTracker37();
    var triggerRef = React153.useRef(null);
    if (!((_trigger = trigger) === null || _trigger === void 0 ? void 0 : _trigger.value) || !((_singleUnitOfferDialog = singleUnitOfferDialog) === null || _singleUnitOfferDialog === void 0 ? void 0 : _singleUnitOfferDialog.content) || !((_singleUnitOfferDialog1 = singleUnitOfferDialog) === null || _singleUnitOfferDialog1 === void 0 ? void 0 : (_singleUnitOfferDialog_content = _singleUnitOfferDialog1.content) === null || _singleUnitOfferDialog_content === void 0 ? void 0 : (_singleUnitOfferDialog_content_ratePlans = _singleUnitOfferDialog_content.ratePlans) === null || _singleUnitOfferDialog_content_ratePlans === void 0 ? void 0 : _singleUnitOfferDialog_content_ratePlans.length)) {
        return null;
    }
    var openPriceDetailsDialog = function() {
        priceDetailsDialogActions.openDialog();
        trackClick("HOT.HIS.PriceDetails.Open", "open price details dialog");
    };
    var closePriceDetailsDialog = function() {
        priceDetailsDialogActions.closeDialog();
        trackClick("HOT.HIS.PriceDetails.Close", "close price details dialog");
    };
    return /* @__PURE__ */ React153.createElement(React153.Fragment, null, /* @__PURE__ */ React153.createElement(UitkLayoutFlex34, {
        justifyContent: "space-between"
    }, view === "COMPACT" /* COMPACT */  && /* @__PURE__ */ React153.createElement(UitkLayoutFlexItem23, null, /* @__PURE__ */ React153.createElement(UitkText46, null, trigger.secondaryValue)), /* @__PURE__ */ React153.createElement(UitkLayoutFlexItem23, null, /* @__PURE__ */ React153.createElement(UitkLink19, {
        onClick: openPriceDetailsDialog,
        inline: true
    }, /* @__PURE__ */ React153.createElement("button", {
        type: "button",
        ref: triggerRef
    }, trigger.value, view !== "COMPACT" /* COMPACT */  && /* @__PURE__ */ React153.createElement(UitkIcon30, {
        name: "chevron_right",
        size: UitkIconSize24.SMALL
    }))))), /* @__PURE__ */ React153.createElement(PriceDetailsDialogComponent, null, /* @__PURE__ */ React153.createElement(Viewport22, null, /* @__PURE__ */ React153.createElement(ViewSmall21, null, /* @__PURE__ */ React153.createElement(Dialog2, {
        singleUnitOfferDialog: singleUnitOfferDialog,
        onClose: closePriceDetailsDialog,
        triggerRef: triggerRef,
        viewport: "SMALL"
    })), /* @__PURE__ */ React153.createElement(ViewMedium18, null, /* @__PURE__ */ React153.createElement(Dialog2, {
        singleUnitOfferDialog: singleUnitOfferDialog,
        onClose: closePriceDetailsDialog,
        triggerRef: triggerRef,
        viewport: "MEDIUM"
    })))));
};
PropertySingleOfferDialogLink.fragment = fragment74;
PropertySingleOfferDialogLink.displayName = "PropertySingleOfferDialogLink";
// src/components/property-single-offer/__private/__fragments/total-price.tsx
import React154 from "react";
import { gql as gql123 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex35, UitkLayoutFlexItem as UitkLayoutFlexItem24 } from "uitk-react-layout-flex";
import { UitkHeading as UitkHeading29 } from "uitk-react-text";
var fragment75 = gql123(_templateObject125(), LodgingEnrichedMessage.fragment);
var TotalPrice = function(param) {
    var data = param.data;
    var _data_totalPrice, _data, _data_totalPrice1, _data1;
    if (!((_data = data) === null || _data === void 0 ? void 0 : (_data_totalPrice = _data.totalPrice) === null || _data_totalPrice === void 0 ? void 0 : _data_totalPrice.label) || !((_data1 = data) === null || _data1 === void 0 ? void 0 : (_data_totalPrice1 = _data1.totalPrice) === null || _data_totalPrice1 === void 0 ? void 0 : _data_totalPrice1.amount)) {
        return null;
    }
    return /* @__PURE__ */ React154.createElement(React154.Fragment, null, /* @__PURE__ */ React154.createElement(UitkLayoutFlex35, {
        justifyContent: "space-between"
    }, /* @__PURE__ */ React154.createElement(UitkLayoutFlexItem24, null, /* @__PURE__ */ React154.createElement("div", null, /* @__PURE__ */ React154.createElement(UitkHeading29, {
        size: 6,
        tag: "h4"
    }, /* @__PURE__ */ React154.createElement(LodgingEnrichedMessage, {
        data: data.totalPrice.label
    })))), /* @__PURE__ */ React154.createElement(UitkLayoutFlexItem24, null, /* @__PURE__ */ React154.createElement("div", null, /* @__PURE__ */ React154.createElement(UitkHeading29, {
        size: 6,
        tag: "h4"
    }, /* @__PURE__ */ React154.createElement(LodgingEnrichedMessage, {
        data: data.totalPrice.amount
    }))))));
};
TotalPrice.fragment = fragment75;
TotalPrice.displayName = "TotalPrice";
// src/components/property-single-offer/__private/__fragments/property-single-rate-plan.tsx
var fragment76 = gql124(_templateObject126(), ErrorMessage.fragment, AlternateAvailabilityMsg.fragment, AlternateDates.fragment, TotalPrice.fragment, PropertySingleOfferDetails.fragment, MarketingSection.fragment, ReserveProperty.fragment, PropertySingleOfferDialogLink.fragment, PricePresentationExpanded.fragment);
var PropertySingleRatePlan = function(param) {
    var data = param.data, children = param.children;
    var _singleUnitOffer, _singleUnitOffer_ratePlans, _singleUnitOffer1, _singleRatePlan, _singleRatePlan1, _singleUnitOffer2;
    var offersData = data;
    if (!offersData) {
        return null;
    }
    var singleUnitOffer = offersData.singleUnitOffer;
    var accessibilityLabel = (singleUnitOffer || {}).accessibilityLabel;
    var SingleOfferSearchForm = reactChildrenToDisplayNameMap(children).SingleOfferSearchForm;
    var singleRatePlan = Array.isArray((_singleUnitOffer = singleUnitOffer) === null || _singleUnitOffer === void 0 ? void 0 : _singleUnitOffer.ratePlans) && ((_singleUnitOffer1 = singleUnitOffer) === null || _singleUnitOffer1 === void 0 ? void 0 : (_singleUnitOffer_ratePlans = _singleUnitOffer1.ratePlans) === null || _singleUnitOffer_ratePlans === void 0 ? void 0 : _singleUnitOffer_ratePlans[0]) || null;
    var _ref = singleRatePlan || {}, tmp = _ref.priceDetails, _ref1 = _sliced_to_array(tmp === void 0 ? [] : tmp, 1), priceDetail = _ref1[0];
    var priceBreakDownSummary = (priceDetail || {}).priceBreakDownSummary;
    var marketingSection = (_singleRatePlan = singleRatePlan) === null || _singleRatePlan === void 0 ? void 0 : _singleRatePlan.marketingSection;
    var shareUrl = (_singleRatePlan1 = singleRatePlan) === null || _singleRatePlan1 === void 0 ? void 0 : _singleRatePlan1.shareUrl;
    var compactOfferView = /* @__PURE__ */ React155.createElement(React155.Fragment, null, singleUnitOffer && /* @__PURE__ */ React155.createElement(React155.Fragment, null, /* @__PURE__ */ React155.createElement(UitkSpacing80, {
        padding: {
            inline: "three"
        }
    }, /* @__PURE__ */ React155.createElement("div", {
        "data-stid": "total-price"
    }, /* @__PURE__ */ React155.createElement(TotalPrice, {
        data: singleUnitOffer
    }))), /* @__PURE__ */ React155.createElement(UitkSpacing80, {
        padding: {
            inline: "three",
            block: "one"
        }
    }, /* @__PURE__ */ React155.createElement("div", null, /* @__PURE__ */ React155.createElement(PropertySingleOfferDialogLink, {
        data: offersData,
        view: singleUnitOffer.view
    })))));
    return /* @__PURE__ */ React155.createElement("div", {
        "data-stid": "property-offers"
    }, accessibilityLabel && /* @__PURE__ */ React155.createElement("h2", {
        className: "is-visually-hidden"
    }, accessibilityLabel), offersData.errorMessage && /* @__PURE__ */ React155.createElement(UitkSpacing80, {
        padding: {
            blockstart: "three",
            inline: "three"
        }
    }, /* @__PURE__ */ React155.createElement(ErrorMessage, {
        data: offersData.errorMessage
    })), offersData.alternateAvailabilityMsg && /* @__PURE__ */ React155.createElement(UitkSpacing80, {
        padding: {
            blockend: "three"
        }
    }, /* @__PURE__ */ React155.createElement(AlternateAvailabilityMsg, {
        data: offersData.alternateAvailabilityMsg
    })), offersData.alternateDates && /* @__PURE__ */ React155.createElement(UitkSpacing80, {
        padding: {
            blockend: "three"
        }
    }, /* @__PURE__ */ React155.createElement(AlternateDates, {
        data: offersData,
        columns: 1,
        justifyContent: "space-between"
    })), /* @__PURE__ */ React155.createElement("div", {
        key: "single-unit-offer"
    }, singleUnitOffer && /* @__PURE__ */ React155.createElement(PropertySingleOfferDetails, {
        data: singleUnitOffer
    }), SingleOfferSearchForm, ((_singleUnitOffer2 = singleUnitOffer) === null || _singleUnitOffer2 === void 0 ? void 0 : _singleUnitOffer2.view) === "COMPACT" /* COMPACT */  ? /* @__PURE__ */ React155.createElement(React155.Fragment, null, compactOfferView) : /* @__PURE__ */ React155.createElement(Viewport23, null, /* @__PURE__ */ React155.createElement(ViewSmall22, null, compactOfferView), /* @__PURE__ */ React155.createElement(ViewLarge6, null, /* @__PURE__ */ React155.createElement(React155.Fragment, null, singleRatePlan && /* @__PURE__ */ React155.createElement(UitkSpacing80, {
        padding: {
            inline: "three"
        }
    }, /* @__PURE__ */ React155.createElement("div", null, priceBreakDownSummary ? /* @__PURE__ */ React155.createElement(PriceBreakdownExpanded, {
        data: priceDetail
    }) : /* @__PURE__ */ React155.createElement(PricePresentationExpanded, {
        data: priceDetail
    })))))), marketingSection && /* @__PURE__ */ React155.createElement(UitkSpacing80, {
        margin: {
            block: "two"
        }
    }, /* @__PURE__ */ React155.createElement("div", null, /* @__PURE__ */ React155.createElement(MarketingSection, {
        data: marketingSection
    }))), singleRatePlan && /* @__PURE__ */ React155.createElement(UitkSpacing80, {
        padding: {
            blockstart: "three",
            inline: "three"
        }
    }, /* @__PURE__ */ React155.createElement("div", null, /* @__PURE__ */ React155.createElement(ReserveProperty, {
        data: singleRatePlan
    }))), shareUrl && /* @__PURE__ */ React155.createElement(UitkSpacing80, {
        padding: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React155.createElement("div", null, /* @__PURE__ */ React155.createElement(MarketingSectionLink, {
        shareUrl: shareUrl,
        linkAlignment: "center"
    })))));
};
PropertySingleRatePlan.fragment = fragment76;
PropertySingleRatePlan.displayName = "PropertySingleRatePlan";
// src/components/property-single-offer/property-single-offer.tsx
var __SingleOfferFragment = gql125(_templateObject127(), PropertySingleRatePlan.fragment);
var PropertySingleOffer = function(param) {
    var data = param.data, children = param.children;
    return /* @__PURE__ */ React156.createElement(PropertySingleRatePlan, {
        data: data
    }, children);
};
PropertySingleOffer.displayName = "PropertySingleOffer";
PropertySingleOffer.fragment = __SingleOfferFragment;
// src/components/property-space-details/property-space-details.tsx
import React157 from "react";
import { gql as gql126 } from "@apollo/client";
import { UitkSpacing as UitkSpacing81 } from "uitk-react-spacing";
var __PropertySpaceDetailsFragment = gql126(_templateObject128(), SpaceDetailsHeader.fragment, SpaceDetailsSpaces.fragment, SpaceDetailsFloorPlan.fragment, VirtualTourPrompt.fragment);
var PropertySpaceDetails = function(param) {
    var data = param.data, className = param.className;
    var spaceDetails = data.spaceDetails;
    if (!spaceDetails) {
        return null;
    }
    return /* @__PURE__ */ React157.createElement(UitkSpacing81, {
        padding: "six"
    }, /* @__PURE__ */ React157.createElement(SpaceDetails, {
        className: className,
        data: spaceDetails
    }));
};
PropertySpaceDetails.displayName = "PropertySpaceDetails";
PropertySpaceDetails.fragment = __PropertySpaceDetailsFragment;
// src/components/property-sticky-book-bar/property-sticky-book-bar.tsx
import React162 from "react";
import { gql as gql130 } from "@apollo/client";
import { useDialog as useDialog22 } from "@shared-ui/dialog-context";
import { Experiment as Experiment8, ExperimentControl as ExperimentControl8, ExperimentVariant as ExperimentVariant8 } from "@shared-ui/experiment-context";
import { useRefContext as useRefContext4, useVisibility, VisibilityEventType } from "@shared-ui/ref-context";
import { ViewLarge as ViewLarge7, ViewMedium as ViewMedium20, Viewport as Viewport25, ViewSmall as ViewSmall24 } from "@shared-ui/viewport-context";
import { UitkDialog as UitkDialog5, UitkDialogContent as UitkDialogContent12, UitkDialogFooter as UitkDialogFooter6 } from "uitk-react-dialog";
import { UitkLayoutFlex as UitkLayoutFlex37, UitkLayoutFlexItem as UitkLayoutFlexItem26 } from "uitk-react-layout-flex";
import { UitkSheet as UitkSheet14 } from "uitk-react-sheet";
import { UitkSpacing as UitkSpacing83 } from "uitk-react-spacing";
// src/components/__private/__fragments/sticky-cta.tsx
import React158 from "react";
import { gql as gql127 } from "@apollo/client";
import { useClickTracker as useClickTracker38 } from "@shared-ui/clickstream-analytics-context";
import { useRefContext as useRefContext3, useRefTargetScroll } from "@shared-ui/ref-context";
import { UitkPrimaryButton as UitkPrimaryButton10 } from "uitk-react-button";
var SCROLL_OFFSETS = [
    {
        sectionName: "navigation"
    }
];
var SCROLL_TO_TARGET_SECTION = "Offers";
var SCROLL_TIMEOUT = 1e3;
var __StickyCtaFragment = gql127(_templateObject129(), PropertySingleOfferDialogLink.fragment);
var StickyCta = function(param) {
    var data = param.data, isFullWidth = param.isFullWidth, clickTargetRef = param.clickTargetRef, focusTargetRef = param.focusTargetRef, scrollSectionRef = param.scrollSectionRef;
    var _shoppingContext_multiItem, _shoppingContext, _singleUnitOfferDialog, _singleUnitOffer, _singleUnitOffer_ratePlans, _singleUnitOffer1, _stickyBar, _stickyButton, _stickyButton1;
    var stickyBar = data.stickyBar, singleUnitOfferDialog = data.singleUnitOfferDialog, shoppingContext = data.shoppingContext;
    var packageType = (_shoppingContext = shoppingContext) === null || _shoppingContext === void 0 ? void 0 : (_shoppingContext_multiItem = _shoppingContext.multiItem) === null || _shoppingContext_multiItem === void 0 ? void 0 : _shoppingContext_multiItem.packageType;
    var singleUnitOffer = (_singleUnitOfferDialog = singleUnitOfferDialog) === null || _singleUnitOfferDialog === void 0 ? void 0 : _singleUnitOfferDialog.content;
    var singleUnitRatePlan = Array.isArray((_singleUnitOffer = singleUnitOffer) === null || _singleUnitOffer === void 0 ? void 0 : _singleUnitOffer.ratePlans) && ((_singleUnitOffer1 = singleUnitOffer) === null || _singleUnitOffer1 === void 0 ? void 0 : (_singleUnitOffer_ratePlans = _singleUnitOffer1.ratePlans) === null || _singleUnitOffer_ratePlans === void 0 ? void 0 : _singleUnitOffer_ratePlans[0]);
    var stickyButton = (_stickyBar = stickyBar) === null || _stickyBar === void 0 ? void 0 : _stickyBar.stickyButton;
    var withAvailabilityCalendarStartDateRef = ((_stickyButton = stickyButton) === null || _stickyButton === void 0 ? void 0 : _stickyButton.targetRef) === "AVAILABILITY_CALENDAR_START_DATE";
    var scrollTo = useRefTargetScroll().scrollTo;
    var getTargets = useRefContext3().getTargets;
    var trackClick = useClickTracker38();
    var handleClick = function(ref) {
        var _getTargets = getTargets([
            ref
        ]), clickRef = _getTargets[ref];
        setTimeout(function() {
            var _clickRef_current, _clickRef;
            (_clickRef = clickRef) === null || _clickRef === void 0 ? void 0 : (_clickRef_current = _clickRef.current) === null || _clickRef_current === void 0 ? void 0 : _clickRef_current.click();
        }, SCROLL_TIMEOUT);
    };
    var onClick = function() {
        trackClick("HOT.HIS.StickyBookButton", "Sticky Book Button");
        if (scrollSectionRef) {
            scrollTo(scrollSectionRef, SCROLL_OFFSETS);
        } else {
            scrollTo(SCROLL_TO_TARGET_SECTION, SCROLL_OFFSETS);
        }
        if (focusTargetRef) {
            var _getTargets = getTargets([
                focusTargetRef
            ]), focusRef = _getTargets[focusTargetRef];
            setTimeout(function() {
                var _focusRef_current, _focusRef;
                (_focusRef = focusRef) === null || _focusRef === void 0 ? void 0 : (_focusRef_current = _focusRef.current) === null || _focusRef_current === void 0 ? void 0 : _focusRef_current.focus();
            }, SCROLL_TIMEOUT);
        }
        if (clickTargetRef) {
            handleClick(clickTargetRef);
        } else if (withAvailabilityCalendarStartDateRef) {
            handleClick("startDate");
        }
    };
    return /* @__PURE__ */ React158.createElement(React158.Fragment, null, packageType || !singleUnitRatePlan || withAvailabilityCalendarStartDateRef ? /* @__PURE__ */ React158.createElement(UitkPrimaryButton10, {
        "data-stid": "sticky-button",
        onClick: onClick,
        isFullWidth: isFullWidth
    }, (_stickyButton1 = stickyButton) === null || _stickyButton1 === void 0 ? void 0 : _stickyButton1.text) : /* @__PURE__ */ React158.createElement(ReserveProperty, {
        data: singleUnitRatePlan,
        isFullWidth: isFullWidth
    }));
};
StickyCta.fragment = __StickyCtaFragment;
StickyCta.displayName = "StickyCta";
// src/components/__private/__fragments/sticky-price-summary.tsx
import React159 from "react";
import { gql as gql128 } from "@apollo/client";
import { useDialog as useDialog20 } from "@shared-ui/dialog-context";
import { PriceSummary as PriceSummary5 } from "@shared-ui/pricing-price-summary";
import { UitkIcon as UitkIcon31, UitkIconSize as UitkIconSize25 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex36, UitkLayoutFlexItem as UitkLayoutFlexItem25 } from "uitk-react-layout-flex";
import { UitkLink as UitkLink20 } from "uitk-react-link";
import { UitkText as UitkText47 } from "uitk-react-text";
var __StickyPriceSummaryFragment = gql128(_templateObject130(), PriceSummaryFragment);
var createCorrectFormat = function(propertyPrice) {
    var _propertyPrice, _propertyPrice1;
    if (!propertyPrice || !((_propertyPrice = propertyPrice) === null || _propertyPrice === void 0 ? void 0 : _propertyPrice.displayMessages) || ((_propertyPrice1 = propertyPrice) === null || _propertyPrice1 === void 0 ? void 0 : _propertyPrice1.displayMessages.length) !== 1) {
        return null;
    }
    var allLineItems = propertyPrice.displayMessages.map(function(x) {
        return x.lineItems;
    }).reduce(function(a, b) {
        return a.concat(b);
    });
    if (allLineItems.length === 0) {
        return null;
    }
    var leadPrice = {
        __typename: "PriceDisplayMessage",
        lineItems: allLineItems.filter(function(x, index) {
            return index === 0;
        })
    };
    var qualifiers = {
        __typename: "PriceDisplayMessage",
        lineItems: allLineItems.length > 1 ? allLineItems.slice(1) : []
    };
    var newPropertyPrice = {
        __typename: propertyPrice.__typename,
        options: propertyPrice.options,
        priceMessaging: propertyPrice.priceMessaging,
        displayMessages: [
            leadPrice,
            qualifiers
        ]
    };
    return newPropertyPrice;
};
var StickyPriceSummary = function(param) {
    var data = param.data, wrapLeadPriceQualifier = param.wrapLeadPriceQualifier, align = param.align, dialogId = param.dialogId, _param_justifyContent = param.justifyContent, justifyContent = _param_justifyContent === void 0 ? "start" : _param_justifyContent, children = param.children;
    var _priceDisclaimer_trigger_icon, _priceDisclaimer_trigger, _priceDisclaimer, _formattedPropertyPrice_displayMessages, _formattedPropertyPrice;
    var _useDialog20 = _sliced_to_array(useDialog20(dialogId), 2), dialogActions = _useDialog20[1];
    var handleDialogOpen = React159.useCallback(function() {
        dialogActions.openDialog();
    }, [
        dialogActions
    ]);
    var price = data.price, propertyPrice = data.propertyPrice, qualifier = data.qualifier, subText = data.subText;
    var _ref = price || {}, formattedDisplayPrice = _ref.formattedDisplayPrice, accessibilityLabel = _ref.accessibilityLabel, priceDisclaimer = _ref.priceDisclaimer;
    var priceAvailable = formattedDisplayPrice || subText || propertyPrice;
    var disclaimerIcon = /* @__PURE__ */ React159.createElement(React159.Fragment, null, ((_priceDisclaimer = priceDisclaimer) === null || _priceDisclaimer === void 0 ? void 0 : (_priceDisclaimer_trigger = _priceDisclaimer.trigger) === null || _priceDisclaimer_trigger === void 0 ? void 0 : (_priceDisclaimer_trigger_icon = _priceDisclaimer_trigger.icon) === null || _priceDisclaimer_trigger_icon === void 0 ? void 0 : _priceDisclaimer_trigger_icon.id) && /* @__PURE__ */ React159.createElement(UitkLayoutFlexItem25, null, /* @__PURE__ */ React159.createElement(UitkLink20, {
        inline: true,
        onClick: handleDialogOpen,
        className: "uitk-more-info-trigger",
        "data-stid": "disclaimer-dialog-link"
    }, /* @__PURE__ */ React159.createElement("button", {
        type: "button"
    }, /* @__PURE__ */ React159.createElement(UitkIcon31, {
        name: priceDisclaimer.trigger.icon.id,
        size: UitkIconSize25.SMALL
    })))));
    var priceDisplay = /* @__PURE__ */ React159.createElement(UitkLayoutFlexItem25, null, /* @__PURE__ */ React159.createElement(React159.Fragment, null, /* @__PURE__ */ React159.createElement(UitkText47, {
        className: "is-visually-hidden"
    }, accessibilityLabel || formattedDisplayPrice), /* @__PURE__ */ React159.createElement("span", {
        "aria-hidden": "true"
    }, /* @__PURE__ */ React159.createElement(UitkText47, {
        size: 500,
        weight: "bold"
    }, formattedDisplayPrice, qualifier && /* @__PURE__ */ React159.createElement(UitkText47, {
        size: 200,
        weight: "medium",
        inline: true
    }, qualifier)))));
    var formattedPropertyPrice = wrapLeadPriceQualifier && propertyPrice ? createCorrectFormat(propertyPrice) : propertyPrice;
    return /* @__PURE__ */ React159.createElement(React159.Fragment, null, priceAvailable && /* @__PURE__ */ React159.createElement(React159.Fragment, null, ((_formattedPropertyPrice = formattedPropertyPrice) === null || _formattedPropertyPrice === void 0 ? void 0 : (_formattedPropertyPrice_displayMessages = _formattedPropertyPrice.displayMessages) === null || _formattedPropertyPrice_displayMessages === void 0 ? void 0 : _formattedPropertyPrice_displayMessages.length) ? /* @__PURE__ */ React159.createElement("div", null, /* @__PURE__ */ React159.createElement(PriceSummary5, {
        data: formattedPropertyPrice,
        flexAlignment: justifyContent
    }), children) : /* @__PURE__ */ React159.createElement(UitkLayoutFlexItem25, null, /* @__PURE__ */ React159.createElement(UitkLayoutFlex36, {
        direction: "column",
        alignItems: align
    }, /* @__PURE__ */ React159.createElement(React159.Fragment, null, formattedDisplayPrice && /* @__PURE__ */ React159.createElement(UitkLayoutFlexItem25, null, /* @__PURE__ */ React159.createElement("div", null, /* @__PURE__ */ React159.createElement(UitkLayoutFlex36, null, align === "start" && /* @__PURE__ */ React159.createElement(React159.Fragment, null, priceDisplay, disclaimerIcon), align === "end" && /* @__PURE__ */ React159.createElement(React159.Fragment, null, disclaimerIcon, priceDisplay)), children)), subText && /* @__PURE__ */ React159.createElement(UitkLayoutFlexItem25, null, /* @__PURE__ */ React159.createElement(UitkText47, {
        size: 100,
        weight: "medium"
    }, subText)))))));
};
StickyPriceSummary.fragment = __StickyPriceSummaryFragment;
StickyPriceSummary.displayName = "StickyPriceSummary";
// src/components/property-offers/__private/__fragments/property-sticky-book-bar-price-presentation-dialog/property-sticky-book-bar-price-presentation-dialog.tsx
import React160 from "react";
import { useClickTracker as useClickTracker39 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog21 } from "@shared-ui/dialog-context";
import { PricePresentation as PricePresentation3 } from "@shared-ui/pricing-price-details";
import { ViewMedium as ViewMedium19, Viewport as Viewport24, ViewSmall as ViewSmall23 } from "@shared-ui/viewport-context";
import { UitkIcon as UitkIcon32, UitkIconSize as UitkIconSize26 } from "uitk-react-icons";
import { UitkLink as UitkLink21 } from "uitk-react-link";
import { UitkSheet as UitkSheet13, UitkSheetContent as UitkSheetContent6 } from "uitk-react-sheet";
import { UitkSpacing as UitkSpacing82 } from "uitk-react-spacing";
import { UitkToolbar as UitkToolbar13 } from "uitk-react-toolbar";
// src/components/property-offers/__private/__fragments/property-sticky-book-bar-price-presentation-dialog/property-sticky-book-bar-price-presentation-dialog-fragment.tsx
import { gql as gql129 } from "@apollo/client";
var PropertyStickyBookBarPricePresentationDialogFragment = gql129(_templateObject131(), UiGraphic.fragment);
// src/components/property-offers/__private/__fragments/property-sticky-book-bar-price-presentation-dialog/property-sticky-book-bar-price-presentation-dialog.tsx
var Dialog3 = function(param) {
    var data = param.data, onClose = param.onClose, triggerRef = param.triggerRef, viewport = param.viewport;
    var _toolbar, _toolbar_icon, _toolbar1;
    var pricePresentation = data.pricePresentation, pricePresentationDialog = data.pricePresentationDialog;
    var toolbar = pricePresentationDialog.toolbar;
    var _toolbar_title;
    return /* @__PURE__ */ React160.createElement(UitkSheet13, {
        type: viewport === "SMALL" ? "full" : "centered",
        isVisible: true,
        triggerRef: triggerRef,
        returnFocusOnClose: true
    }, /* @__PURE__ */ React160.createElement(UitkToolbar13, {
        toolbarTitle: (_toolbar_title = (_toolbar = toolbar) === null || _toolbar === void 0 ? void 0 : _toolbar.title) !== null && _toolbar_title !== void 0 ? _toolbar_title : void 0,
        navigationContent: {
            onClick: onClose,
            navType: "close",
            navIconLabel: (_toolbar1 = toolbar) === null || _toolbar1 === void 0 ? void 0 : (_toolbar_icon = _toolbar1.icon) === null || _toolbar_icon === void 0 ? void 0 : _toolbar_icon.description
        }
    }), /* @__PURE__ */ React160.createElement(UitkSheetContent6, {
        padded: false
    }, /* @__PURE__ */ React160.createElement(UitkSpacing82, {
        padding: viewport === "SMALL" ? {
            block: "four",
            inline: "four"
        } : {
            block: "six",
            inline: "six"
        }
    }, /* @__PURE__ */ React160.createElement("div", null, /* @__PURE__ */ React160.createElement(PricePresentation3, {
        data: pricePresentation
    })))));
};
var PropertyStickyBookBarPricePresentationDialog = function(param) {
    var data = param.data;
    var triggerRef = React160.useRef(null);
    var _useDialog21 = _sliced_to_array(useDialog21("price-presentation-book-bar-dialog", "pwaDialogNested"), 3), dialogActions = _useDialog21[1], DialogComponent = _useDialog21[2];
    var track = useClickTracker39();
    var pricePresentation = data.pricePresentation, pricePresentationDialog = data.pricePresentationDialog;
    if (!pricePresentation || !pricePresentationDialog) {
        return null;
    }
    var toolbar = pricePresentationDialog.toolbar, trigger = pricePresentationDialog.trigger;
    var openDialog = function() {
        var clientSideAnalytics = trigger.clientSideAnalytics;
        dialogActions.openDialog();
        if (clientSideAnalytics) {
            track(clientSideAnalytics.referrerId, clientSideAnalytics.linkName);
        }
    };
    var closeDialog = function() {
        var clientSideAnalytics = (toolbar || {}).clientSideAnalytics;
        dialogActions.closeDialog();
        if (clientSideAnalytics) {
            track(clientSideAnalytics.referrerId, clientSideAnalytics.linkName);
        }
    };
    return /* @__PURE__ */ React160.createElement(React160.Fragment, null, /* @__PURE__ */ React160.createElement(UitkSpacing82, null, /* @__PURE__ */ React160.createElement(UitkLink21, {
        onClick: openDialog
    }, /* @__PURE__ */ React160.createElement("button", {
        type: "button"
    }, trigger.value, /* @__PURE__ */ React160.createElement(UitkIcon32, {
        name: "chevron_right",
        size: UitkIconSize26.SMALL
    })))), /* @__PURE__ */ React160.createElement(DialogComponent, null, /* @__PURE__ */ React160.createElement(Viewport24, null, /* @__PURE__ */ React160.createElement(ViewSmall23, null, /* @__PURE__ */ React160.createElement(Dialog3, {
        data: data,
        onClose: closeDialog,
        triggerRef: triggerRef,
        viewport: "SMALL"
    })), /* @__PURE__ */ React160.createElement(ViewMedium19, null, /* @__PURE__ */ React160.createElement(Dialog3, {
        data: data,
        onClose: closeDialog,
        triggerRef: triggerRef,
        viewport: "MEDIUM"
    })))));
};
PropertyStickyBookBarPricePresentationDialog.fragment = PropertyStickyBookBarPricePresentationDialogFragment;
PropertyStickyBookBarPricePresentationDialog.displayName = "PropertyStickyBookBarPricePresentationDialog";
// src/components/property-sticky-book-bar/structured-data.tsx
import React161 from "react";
var generateSchema = function(content) {
    if (!content) {
        return null;
    }
    var schemaJson = {
        "@context": "https://schema.org",
        "@type": "priceRange",
        priceRange: content
    };
    return JSON.stringify(schemaJson);
};
var StickyBarStructuredData = function(param) {
    var content = param.content;
    var data = generateSchema(content);
    if (!data) {
        return null;
    }
    return /* @__PURE__ */ React161.createElement("script", {
        type: "application/ld+json",
        dangerouslySetInnerHTML: {
            __html: data
        }
    });
};
// src/components/property-sticky-book-bar/property-sticky-book-bar.tsx
var fragment77 = gql130(_templateObject132(), PriceSummaryFragment, PropertySingleOfferDialogLink.fragment, StickyCta.fragment, StickyPriceSummary.fragment, PropertyStickyBookBarPricePresentationDialog.fragment);
var HIDE_STICKY_TARGET_SECTION = "Offers";
var PropertyStickyBookBar = function(param) {
    var clickTargetRef = param.clickTargetRef, focusTargetRef = param.focusTargetRef, scrollSectionRef = param.scrollSectionRef, hideSectionRef = param.hideSectionRef, _param_isSticky = param.isSticky, isSticky = _param_isSticky === void 0 ? true : _param_isSticky, _param_align = param.align, align = _param_align === void 0 ? "end" : _param_align, _param_hideCtaButton = param.hideCtaButton, hideCtaButton = _param_hideCtaButton === void 0 ? false : _param_hideCtaButton, _param_hidePrice = param.hidePrice, hidePrice = _param_hidePrice === void 0 ? false : _param_hidePrice, data = param.data, children = param.children;
    var _hideTargetRef, _stickyBar_stickyButton, _stickyBar, _structuredData, _priceDisclaimer, _priceDisclaimer_primaryUIButton;
    var stickyBar = data.stickyBar, soldOut = data.soldOut, singleUnitOfferDialog = data.singleUnitOfferDialog;
    var _React162_useState = _sliced_to_array(React162.useState(false), 2), stickyVisible = _React162_useState[0], setStickyVisible = _React162_useState[1];
    var getTargets = useRefContext4().getTargets;
    var dialogPostix = useDialogId();
    var dialogId = "dateless-price-".concat(dialogPostix);
    var _useDialog22 = _sliced_to_array(useDialog22(dialogId), 3), isDialogOpen = _useDialog22[0], dialogActions = _useDialog22[1], DialogComponent = _useDialog22[2];
    var hideSection = hideSectionRef || HIDE_STICKY_TARGET_SECTION;
    var _getTargets = getTargets([
        hideSection
    ]), hideTargetRef = _getTargets[hideSection];
    var targetList = [
        {
            id: hideSection,
            ref: hideTargetRef
        }
    ];
    var threshold = ((_hideTargetRef = hideTargetRef) === null || _hideTargetRef === void 0 ? void 0 : _hideTargetRef.current) && typeof window !== "undefined" && hideTargetRef.current.clientHeight > window.innerHeight ? window.innerHeight * 0.4 / hideTargetRef.current.clientHeight : 0;
    var onVisibilityChange = React162.useCallback(function(visibilityEvents) {
        var targetVisible = false;
        Object.keys(visibilityEvents).forEach(function(sectionName) {
            targetVisible = sectionName === hideSection && visibilityEvents[sectionName] === VisibilityEventType.PARTIAL_TOP || visibilityEvents[sectionName] === VisibilityEventType.PARTIAL_BOTTOM || visibilityEvents[sectionName] === VisibilityEventType.ENTER_COMPLETE;
        });
        setStickyVisible(!targetVisible);
    }, [
        hideSection
    ]);
    useVisibility(targetList, onVisibilityChange, {
        thresholds: [
            threshold
        ]
    });
    if (!((_stickyBar = stickyBar) === null || _stickyBar === void 0 ? void 0 : (_stickyBar_stickyButton = _stickyBar.stickyButton) === null || _stickyBar_stickyButton === void 0 ? void 0 : _stickyBar_stickyButton.text) || soldOut) {
        return null;
    }
    var subText = stickyBar.subText, price = stickyBar.price, structuredData = stickyBar.structuredData, propertyPrice = stickyBar.propertyPrice, pricePresentation = stickyBar.pricePresentation, pricePresentationDialog = stickyBar.pricePresentationDialog;
    var _ref = price || {}, formattedDisplayPrice = _ref.formattedDisplayPrice, priceDisclaimer = _ref.priceDisclaimer;
    var priceAvailable = formattedDisplayPrice || subText || propertyPrice;
    var priceComponent = /* @__PURE__ */ React162.createElement(React162.Fragment, null, !hidePrice && /* @__PURE__ */ React162.createElement(Experiment8, {
        name: "Vrbex_dateless_stickybar"
    }, /* @__PURE__ */ React162.createElement(ExperimentControl8, null, /* @__PURE__ */ React162.createElement(StickyPriceSummary, {
        data: stickyBar,
        wrapLeadPriceQualifier: false,
        dialogId: dialogId,
        align: align
    }, singleUnitOfferDialog && !pricePresentation && !pricePresentationDialog && /* @__PURE__ */ React162.createElement(PropertySingleOfferDialogLink, {
        data: data
    }, children), pricePresentation && pricePresentationDialog && /* @__PURE__ */ React162.createElement(PropertyStickyBookBarPricePresentationDialog, {
        data: stickyBar
    }))), /* @__PURE__ */ React162.createElement(ExperimentVariant8, {
        bucket: 1
    }, /* @__PURE__ */ React162.createElement(StickyPriceSummary, {
        data: stickyBar,
        wrapLeadPriceQualifier: false,
        dialogId: dialogId,
        align: align
    }))), /* @__PURE__ */ React162.createElement(UitkLayoutFlexItem26, null, (stickyVisible || !isSticky) && !hideCtaButton && /* @__PURE__ */ React162.createElement(StickyCta, {
        data: data,
        isFullWidth: !priceAvailable || hidePrice,
        clickTargetRef: clickTargetRef,
        focusTargetRef: focusTargetRef,
        scrollSectionRef: scrollSectionRef
    })));
    var stickyCard = /* @__PURE__ */ React162.createElement(UitkSpacing83, {
        padding: {
            small: {
                block: "three",
                inline: "three"
            },
            large: {
                block: "two",
                inline: "three"
            }
        },
        className: "elevation-24"
    }, /* @__PURE__ */ React162.createElement("div", null, /* @__PURE__ */ React162.createElement(UitkLayoutFlex37, {
        justifyContent: "space-between",
        wrap: "nowrap",
        alignItems: "center",
        space: "two"
    }, priceComponent)));
    return isSticky ? /* @__PURE__ */ React162.createElement(Viewport25, null, /* @__PURE__ */ React162.createElement(ViewSmall24, null, /* @__PURE__ */ React162.createElement(UitkSheet14, {
        isVisible: stickyVisible,
        triggerRef: null
    }, stickyCard)), /* @__PURE__ */ React162.createElement(ViewMedium20, null, /* @__PURE__ */ React162.createElement(React162.Fragment, null, priceAvailable && /* @__PURE__ */ React162.createElement(UitkSheet14, {
        isVisible: stickyVisible,
        triggerRef: null
    }, stickyCard))), /* @__PURE__ */ React162.createElement(ViewLarge7, null, /* @__PURE__ */ React162.createElement(React162.Fragment, null, stickyVisible && /* @__PURE__ */ React162.createElement(StickyCta, {
        data: data,
        isFullWidth: false,
        clickTargetRef: clickTargetRef,
        focusTargetRef: focusTargetRef,
        scrollSectionRef: scrollSectionRef
    })))) : /* @__PURE__ */ React162.createElement(React162.Fragment, null, ((_structuredData = structuredData) === null || _structuredData === void 0 ? void 0 : _structuredData.content) && /* @__PURE__ */ React162.createElement(React162.Fragment, null, /* @__PURE__ */ React162.createElement("meta", {
        itemProp: structuredData.itemprop,
        content: structuredData.content
    }), /* @__PURE__ */ React162.createElement(StickyBarStructuredData, {
        content: structuredData.content
    })), /* @__PURE__ */ React162.createElement(UitkLayoutFlex37, {
        wrap: "nowrap",
        direction: "column",
        alignItems: align,
        space: "two"
    }, priceComponent), ((_priceDisclaimer = priceDisclaimer) === null || _priceDisclaimer === void 0 ? void 0 : _priceDisclaimer.content) && /* @__PURE__ */ React162.createElement(DialogComponent, null, /* @__PURE__ */ React162.createElement(UitkDialog5, {
        returnFocusOnClose: true,
        dialogShow: isDialogOpen
    }, /* @__PURE__ */ React162.createElement(UitkDialogContent12, null, priceDisclaimer.content, /* @__PURE__ */ React162.createElement(UitkDialogFooter6, {
        buttonOne: {
            onClick: dialogActions.closeDialog,
            text: ((_priceDisclaimer_primaryUIButton = priceDisclaimer.primaryUIButton) === null || _priceDisclaimer_primaryUIButton === void 0 ? void 0 : _priceDisclaimer_primaryUIButton.primary) || "",
            type: "tertiary"
        }
    })))));
};
PropertyStickyBookBar.displayName = "PropertyStickyBookBar";
PropertyStickyBookBar.fragment = fragment77;
// src/components/property-sticky-price-header/property-sticky-price-header.tsx
import React163 from "react";
import { gql as gql131 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex38, UitkLayoutFlexItem as UitkLayoutFlexItem27 } from "uitk-react-layout-flex";
var fragment78 = gql131(_templateObject133(), PriceSummaryFragment, StickyCta.fragment, StickyPriceSummary.fragment);
var PropertyStickyPriceHeader = function(param) {
    var _param_align = param.align, align = _param_align === void 0 ? "end" : _param_align, hideCtaButton = param.hideCtaButton, hidePrice = param.hidePrice, wrapPriceSummary = param.wrapPriceSummary, clickTargetRef = param.clickTargetRef, focusTargetRef = param.focusTargetRef, scrollSectionRef = param.scrollSectionRef, data = param.data;
    var _data_singleUnitOfferDialog;
    var stickyBar = data.stickyBar, soldOut = data.soldOut;
    var dialogPostfix = useDialogId();
    var dialogId = "dateless-price-".concat(dialogPostfix);
    var isSingleUnitOffer = (_data_singleUnitOfferDialog = data.singleUnitOfferDialog) === null || _data_singleUnitOfferDialog === void 0 ? void 0 : _data_singleUnitOfferDialog.content;
    if (soldOut || !stickyBar || isSingleUnitOffer) {
        return null;
    }
    return /* @__PURE__ */ React163.createElement(UitkLayoutFlex38, {
        justifyContent: "space-between",
        space: "three",
        wrap: "nowrap",
        alignItems: "center"
    }, !hidePrice && /* @__PURE__ */ React163.createElement(UitkLayoutFlexItem27, null, /* @__PURE__ */ React163.createElement(StickyPriceSummary, {
        data: stickyBar,
        wrapLeadPriceQualifier: !!wrapPriceSummary,
        dialogId: dialogId,
        align: align,
        justifyContent: "end"
    })), !hideCtaButton && /* @__PURE__ */ React163.createElement(UitkLayoutFlexItem27, null, /* @__PURE__ */ React163.createElement(StickyCta, {
        data: data,
        isFullWidth: false,
        clickTargetRef: clickTargetRef,
        focusTargetRef: focusTargetRef,
        scrollSectionRef: scrollSectionRef
    })));
};
PropertyStickyPriceHeader.displayName = "PropertyStickyPriceHeader";
PropertyStickyPriceHeader.fragment = fragment78;
// src/components/property-trip-summary/property-trip-summary.tsx
import React165 from "react";
import { gql as gql133 } from "@apollo/client";
// src/components/property-trip-summary/__private/__fragments/trip-summary.tsx
import React164 from "react";
import { gql as gql132 } from "@apollo/client";
import { useClickTracker as useClickTracker40 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog23 } from "@shared-ui/dialog-context";
import { InstallmentPlan } from "@shared-ui/retail-multi-item-installment-plan";
import { UitkCard as UitkCard27, UitkCardContentSection as UitkCardContentSection20 } from "uitk-react-cards";
import { UitkDialog as UitkDialog6, UitkDialogContent as UitkDialogContent13, UitkDialogFooter as UitkDialogFooter7 } from "uitk-react-dialog";
import { UitkLayoutFlex as UitkLayoutFlex39 } from "uitk-react-layout-flex";
import { UitkLayoutGrid as UitkLayoutGrid22, UitkLayoutGridItem as UitkLayoutGridItem19 } from "uitk-react-layout-grid";
import { UitkPriceLockup as UitkPriceLockup3, UitkPriceLockupAlign as UitkPriceLockupAlign6 } from "uitk-react-price-lockup";
import { UitkHeading as UitkHeading30, UitkText as UitkText48 } from "uitk-react-text";
var fragment79 = gql132(_templateObject134());
var gridColumns = {
    medium: [
        "2fr",
        "1fr"
    ]
};
var TripSummary = function(param) {
    var className = param.className, data = param.data;
    var _data_price, _options, _priceOption, _priceDisclaimer_trigger, _priceDisclaimer, _priceDisclaimer_tertiaryUIButton_action, _priceDisclaimer_tertiaryUIButton, _priceDisclaimer1, _priceDisclaimer_tertiaryUIButton1, _priceDisclaimer2, _priceMessaging, _priceDisclaimer3, _priceDisclaimer_trigger1, _priceDisclaimer4, _data_installmentPlanOptions, _data_installmentPlanOptions1;
    var _useDialog23 = _sliced_to_array(useDialog23("TripSummaryStrikeThroughDisclaimer"), 3), dialogActions = _useDialog23[1], DialogComponent = _useDialog23[2];
    var clickTracker = useClickTracker40();
    if (!((_data_price = data.price) === null || _data_price === void 0 ? void 0 : _data_price.options) || data.price.options.length === 0) {
        return null;
    }
    var _data_price1 = data.price, priceMessaging = _data_price1.priceMessaging, options = _data_price1.options;
    var priceOption = (_options = options) === null || _options === void 0 ? void 0 : _options[0];
    var priceDisclaimer = (_priceOption = priceOption) === null || _priceOption === void 0 ? void 0 : _priceOption.priceDisclaimer;
    var openAnalytics = (_priceDisclaimer = priceDisclaimer) === null || _priceDisclaimer === void 0 ? void 0 : (_priceDisclaimer_trigger = _priceDisclaimer.trigger) === null || _priceDisclaimer_trigger === void 0 ? void 0 : _priceDisclaimer_trigger.clientSideAnalytics;
    var closeAnalytics = (_priceDisclaimer1 = priceDisclaimer) === null || _priceDisclaimer1 === void 0 ? void 0 : (_priceDisclaimer_tertiaryUIButton = _priceDisclaimer1.tertiaryUIButton) === null || _priceDisclaimer_tertiaryUIButton === void 0 ? void 0 : (_priceDisclaimer_tertiaryUIButton_action = _priceDisclaimer_tertiaryUIButton.action) === null || _priceDisclaimer_tertiaryUIButton_action === void 0 ? void 0 : _priceDisclaimer_tertiaryUIButton_action.analytics;
    var closeButtonText = (_priceDisclaimer2 = priceDisclaimer) === null || _priceDisclaimer2 === void 0 ? void 0 : (_priceDisclaimer_tertiaryUIButton1 = _priceDisclaimer2.tertiaryUIButton) === null || _priceDisclaimer_tertiaryUIButton1 === void 0 ? void 0 : _priceDisclaimer_tertiaryUIButton1.primary;
    var _priceMessaging_map;
    var priceMessages = (_priceMessaging_map = (_priceMessaging = priceMessaging) === null || _priceMessaging === void 0 ? void 0 : _priceMessaging.map(function(message) {
        return message.value;
    })) !== null && _priceMessaging_map !== void 0 ? _priceMessaging_map : [];
    var dialogMessage = (_priceDisclaimer3 = priceDisclaimer) === null || _priceDisclaimer3 === void 0 ? void 0 : _priceDisclaimer3.content;
    var openStrikeThroughPriceDialog = function() {
        dialogActions.openDialog();
        if (openAnalytics) {
            clickTracker(openAnalytics.referrerId, openAnalytics.linkName);
        }
    };
    var closeStrikeThroughPriceDialog = function() {
        dialogActions.closeDialog();
        if (closeAnalytics) {
            clickTracker(closeAnalytics.referrerId, closeAnalytics.linkName);
        }
    };
    var priceProps = buildUitkPriceLockupProps(options);
    return /* @__PURE__ */ React164.createElement(UitkCard27, {
        className: className
    }, /* @__PURE__ */ React164.createElement(UitkCardContentSection20, {
        padded: true
    }, /* @__PURE__ */ React164.createElement(UitkLayoutGrid22, {
        columns: gridColumns
    }, /* @__PURE__ */ React164.createElement(UitkLayoutGridItem19, null, /* @__PURE__ */ React164.createElement("div", null, /* @__PURE__ */ React164.createElement(UitkHeading30, {
        tag: "h3",
        size: 7
    }, data.header.text), data.summary.map(function(param, index) {
        var value = param.value;
        return /* @__PURE__ */ React164.createElement(UitkText48, {
            size: 300,
            theme: "default",
            key: "trip-summary-secondary-".concat(index)
        }, value);
    }))), /* @__PURE__ */ React164.createElement(UitkLayoutGridItem19, null, /* @__PURE__ */ React164.createElement("div", null, /* @__PURE__ */ React164.createElement(UitkPriceLockup3, _object_spread_props(_object_spread({}, priceProps), {
        align: UitkPriceLockupAlign6.RIGHT,
        priceSubtextFirst: priceMessages,
        a11yStrikeThroughDialogTrigger: (_priceDisclaimer4 = priceDisclaimer) === null || _priceDisclaimer4 === void 0 ? void 0 : (_priceDisclaimer_trigger1 = _priceDisclaimer4.trigger) === null || _priceDisclaimer_trigger1 === void 0 ? void 0 : _priceDisclaimer_trigger1.value,
        strikeThroughTrigger: dialogMessage && /* @__PURE__ */ React164.createElement("button", {
            onClick: openStrikeThroughPriceDialog,
            type: "button"
        })
    })), /* @__PURE__ */ React164.createElement(DialogComponent, null, /* @__PURE__ */ React164.createElement(UitkDialog6, {
        dialogShow: true,
        returnFocusOnClose: true,
        closeCallback: dialogActions.closeDialog
    }, dialogMessage && /* @__PURE__ */ React164.createElement(UitkDialogContent13, null, dialogMessage.map(function(msg, index) {
        return /* @__PURE__ */ React164.createElement("div", {
            key: "dialog-message-content-".concat(index)
        }, msg);
    }), closeButtonText && /* @__PURE__ */ React164.createElement(UitkDialogFooter7, {
        buttonOne: {
            onClick: closeStrikeThroughPriceDialog,
            text: closeButtonText,
            type: "tertiary"
        }
    })))), data.installmentPlanOptions && /* @__PURE__ */ React164.createElement(UitkLayoutFlex39, {
        justifyContent: "end",
        "data-stid": "property-offer-installment-plan"
    }, /* @__PURE__ */ React164.createElement(InstallmentPlan, {
        inputs: {
            multiItemSessionId: null,
            amount: (_data_installmentPlanOptions = data.installmentPlanOptions) === null || _data_installmentPlanOptions === void 0 ? void 0 : _data_installmentPlanOptions.totalPrice
        },
        alignment: "end",
        legalText: (_data_installmentPlanOptions1 = data.installmentPlanOptions) === null || _data_installmentPlanOptions1 === void 0 ? void 0 : _data_installmentPlanOptions1.textRequired
    })))))));
};
TripSummary.displayName = "TripSummary";
TripSummary.fragment = fragment79;
// src/components/property-trip-summary/property-trip-summary.tsx
var __PropertyTripSummaryFragment = gql133(_templateObject135(), TripSummary.fragment);
var PropertyTripSummary = function(param) {
    var className = param.className, data = param.data;
    var tripSummary = data.tripSummary;
    if (!tripSummary) {
        return null;
    }
    return /* @__PURE__ */ React165.createElement(TripSummary, {
        className: className,
        data: tripSummary
    });
};
PropertyTripSummary.fragment = __PropertyTripSummaryFragment;
PropertyTripSummary.displayName = "PropertyTripSummary";
// src/components/property-unit-list-view/property-unit-list-view.tsx
import React167 from "react";
import { gql as gql135 } from "@apollo/client";
import { UitkCard as UitkCard28 } from "uitk-react-cards";
// src/components/property-unit-list-view/__private/__fragments/property-unit-list-view-element.tsx
import React166 from "react";
import { gql as gql134 } from "@apollo/client";
import { UitkCardContentSection as UitkCardContentSection21 } from "uitk-react-cards";
import { UitkHeading as UitkHeading31 } from "uitk-react-text";
var __PropertyUnitListViewElementFragment = gql134(_templateObject136());
var PropertyUnitListViewElement = function(param) {
    var data = param.data, listingIndex = param.listingIndex;
    var header = data.header;
    var _React166_useState = _sliced_to_array(React166.useState(false), 2), mounted = _React166_useState[0], setMounted = _React166_useState[1];
    React166.useEffect(function() {
        setMounted(true);
    }, []);
    if (!header) {
        return null;
    }
    return /* @__PURE__ */ React166.createElement(React166.Fragment, null, mounted && /* @__PURE__ */ React166.createElement(UitkCardContentSection21, {
        border: "top",
        "data-stid": "property-offer-list-view-element-".concat(listingIndex)
    }, header && /* @__PURE__ */ React166.createElement("div", null, /* @__PURE__ */ React166.createElement(UitkHeading31, {
        tag: "h2",
        size: 6
    }, header.text))));
};
PropertyUnitListViewElement.fragment = __PropertyUnitListViewElementFragment;
PropertyUnitListViewElement.displayName = "PropertyUnitListViewElement";
// src/components/property-unit-list-view/property-unit-list-view.tsx
var __PropertyUnitListViewFragment = gql135(_templateObject137(), PropertyUnitListViewElement.fragment);
var PropertyUnitListView = function(param) {
    var data = param.data;
    var categorizedListings = data.categorizedListings;
    if (!categorizedListings) {
        return null;
    }
    return /* @__PURE__ */ React167.createElement(UitkCard28, {
        border: true
    }, /* @__PURE__ */ React167.createElement("div", null, categorizedListings.map(function(listing, index) {
        switch(listing.__typename){
            case "LodgingCategorizedUnit":
                return /* @__PURE__ */ React167.createElement(PropertyUnitListViewElement, {
                    key: "property-offer-list-view-element-".concat(index),
                    listingIndex: index + 1,
                    data: listing
                });
            default:
                return null;
        }
    })));
};
PropertyUnitListView.fragment = __PropertyUnitListViewFragment;
PropertyUnitListView.displayName = "PropertyUnitListView";
// src/components/single-offer-search/single-offer-search.tsx
import React168 from "react";
import { gql as gql136 } from "@apollo/client";
import { useLocalization } from "@shared-ui/localization-context";
var __SingleOfferSearchFragment = gql136(_templateObject138());
var SingleOfferSearchDateField = function(param) {
    var data = param.data, doneKey = param.doneKey, submitKey = param.submitKey, DateFieldWrapper = param.DateFieldWrapper;
    var formatText = useLocalization().formatText;
    var l10nKey = shouldShowFormButton(data) ? doneKey : submitKey;
    return /* @__PURE__ */ React168.createElement(DateFieldWrapper, {
        buttonText: formatText(l10nKey),
        closeOnSubmit: false
    });
};
SingleOfferSearchDateField.displayName = "SingleOfferSearchDateField";
SingleOfferSearchDateField.fragment = __SingleOfferSearchFragment;
var SingleOfferSearchButton = function(param) {
    var data = param.data, ButtonWrapper = param.ButtonWrapper;
    var _data_errorMessage_action_primary, _data_errorMessage_action, _data_errorMessage;
    if (!shouldShowFormButton(data)) {
        return null;
    }
    var locText = (_data_errorMessage = data.errorMessage) === null || _data_errorMessage === void 0 ? void 0 : (_data_errorMessage_action = _data_errorMessage.action) === null || _data_errorMessage_action === void 0 ? void 0 : (_data_errorMessage_action_primary = _data_errorMessage_action.primary) === null || _data_errorMessage_action_primary === void 0 ? void 0 : _data_errorMessage_action_primary.text;
    return locText ? /* @__PURE__ */ React168.createElement("div", null, /* @__PURE__ */ React168.createElement(ButtonWrapper, {
        text: locText
    })) : null;
};
SingleOfferSearchButton.displayName = "SingleOfferSearchButton";
SingleOfferSearchButton.fragment = __SingleOfferSearchFragment;
function shouldShowFormButton(data) {
    var _searchCriteria, _errorMessage_title, _errorMessage, _singleUnitOffer;
    var errorMessage = data.errorMessage, searchCriteria = data.searchCriteria, singleUnitOffer = data.singleUnitOffer;
    return Boolean(((_searchCriteria = searchCriteria) === null || _searchCriteria === void 0 ? void 0 : _searchCriteria.primary.dateRange) || ((_errorMessage = errorMessage) === null || _errorMessage === void 0 ? void 0 : (_errorMessage_title = _errorMessage.title) === null || _errorMessage_title === void 0 ? void 0 : _errorMessage_title.text) && !hasActionUrl(errorMessage) && hasActionText(errorMessage) || !((_singleUnitOffer = singleUnitOffer) === null || _singleUnitOffer === void 0 ? void 0 : _singleUnitOffer.ratePlans));
}
function hasActionUrl(errorMessage) {
    var _errorMessage_action_primary, _errorMessage_action, _errorMessage;
    return Boolean((_errorMessage = errorMessage) === null || _errorMessage === void 0 ? void 0 : (_errorMessage_action = _errorMessage.action) === null || _errorMessage_action === void 0 ? void 0 : (_errorMessage_action_primary = _errorMessage_action.primary) === null || _errorMessage_action_primary === void 0 ? void 0 : _errorMessage_action_primary.linkUrl);
}
function hasActionText(errorMessage) {
    var _errorMessage_action_primary, _errorMessage_action, _errorMessage;
    return Boolean((_errorMessage = errorMessage) === null || _errorMessage === void 0 ? void 0 : (_errorMessage_action = _errorMessage.action) === null || _errorMessage_action === void 0 ? void 0 : (_errorMessage_action_primary = _errorMessage_action.primary) === null || _errorMessage_action_primary === void 0 ? void 0 : _errorMessage_action_primary.text);
}
// src/components/traveler-selector/traveler-selector.tsx
import React174, { useState as useState3 } from "react";
import { useDialog as useDialog24 } from "@shared-ui/dialog-context";
import { useLocalization as useLocalization2 } from "@shared-ui/localization-context";
import { ViewLarge as ViewLarge8, ViewMedium as ViewMedium21, Viewport as Viewport26, ViewSmall as ViewSmall25 } from "@shared-ui/viewport-context";
import { UitkFakeInput } from "uitk-react-input";
import { UitkLayoutPosition as UitkLayoutPosition5 } from "uitk-react-layout-position";
import { UitkSheet as UitkSheet15, UitkSheetContent as UitkSheetContent7 } from "uitk-react-sheet";
import { UitkSpacing as UitkSpacing86 } from "uitk-react-spacing";
import { UitkToolbar as UitkToolbar14 } from "uitk-react-toolbar";
// src/components/traveler-selector/__private/traveler-selector-form.tsx
import React173 from "react";
import { gql as gql140 } from "@apollo/client";
import { UitkSpacing as UitkSpacing85 } from "uitk-react-spacing";
// src/components/traveler-selector/__private/hooks/use-update-url.ts
import { useCallback as useCallback3 } from "react";
import { useHistory as useHistory2 } from "react-router-dom";
var useUpdateURL = function() {
    var history = useHistory2();
    return useCallback3(function(event) {
        var params = new URLSearchParams(history.location.search);
        params.set("adults", String(event.adults));
        params.set("children", String(event.children));
        params.delete("rm1");
        if (event.amenities) {
            params.set("amenities", String(event.amenities));
            params.set("house_rules_group", String(event.house_rules_group));
        } else {
            params.delete("amenities");
            params.delete("house_rules_group");
        }
        history.replace("".concat(history.location.pathname, "?").concat(params));
    }, [
        history
    ]);
};
// src/components/traveler-selector/__private/traveler-action-context.tsx
import React169 from "react";
var TravelerContext = React169.createContext(function() {
    return void 0;
});
var useTravelerAction = function() {
    return React169.useContext(TravelerContext);
};
var TravelerActionProvider = TravelerContext.Provider;
// src/components/traveler-selector/__private/unit-group.tsx
import React172 from "react";
import { gql as gql139 } from "@apollo/client";
// src/components/traveler-selector/__private/lodging-guest-group.tsx
import React170 from "react";
import { gql as gql137 } from "@apollo/client";
import { useClickTracker as useClickTracker41 } from "@shared-ui/clickstream-analytics-context";
import { UitkSelect } from "uitk-react-input";
import { UitkLayoutGrid as UitkLayoutGrid23 } from "uitk-react-layout-grid";
import { UitkStepInput } from "uitk-react-step-input";
var __LodgingGuestGroupFragment = gql137(_templateObject139());
var MAX_CHILDREN_PER_ROOM = 6;
var MAX_TRAVELERS = 14;
var LodgingGuestGroup = function(param) {
    var data = param.data, state = param.state, groupIndex = param.groupIndex;
    var _state_children, _state_children1, _state_children2, _children, _state_children3, _state_children4, _state_children5;
    var track = useClickTracker41();
    var dispatch = useTravelerAction();
    var guestCountAnalytics = React170.useMemo(function() {
        return {
            id: "HOT.HIS:Guest",
            description: "Adjust guest count in change search",
            callback: function(id, desc) {
                return track(id, desc);
            }
        };
    }, [
        track
    ]);
    var adults = data.adults, children = data.children, maxChildren = data.maxChildren, maxGuest = data.maxGuest;
    var childrenCount = !maxChildren ? 0 : (_state_children = state.children) === null || _state_children === void 0 ? void 0 : _state_children.length;
    var totalTravelers = state.adults + (((_state_children1 = state.children) === null || _state_children1 === void 0 ? void 0 : _state_children1.length) || 0);
    var defaultMaxChild = Math.min(MAX_CHILDREN_PER_ROOM, (((_state_children2 = state.children) === null || _state_children2 === void 0 ? void 0 : _state_children2.length) || 0) + MAX_TRAVELERS - totalTravelers);
    var buildOnChange = function(type) {
        var actionType = type === "adults" /* ADULTS */  ? "UPDATE_ADULTS_COUNT" : "UPDATE_CHILDREN_COUNT";
        return function(event) {
            var count = parseInt(event.target.value, 10);
            if (!Number.isNaN(count)) {
                dispatch({
                    type: actionType,
                    groupIndex: groupIndex,
                    count: count
                });
            }
        };
    };
    var onSelectChange = function(childIndex) {
        return function(event) {
            var age = parseInt(event.target.value, 10);
            if (!Number.isNaN(age)) {
                dispatch({
                    type: "UPDATE_CHILD_AGE",
                    groupIndex: groupIndex,
                    childIndex: childIndex,
                    childAge: age
                });
            }
            track("HOT.HIS:ROOM.".concat(groupIndex, ".Child.").concat(childIndex, ".AGE.").concat(age), "Child age update");
        };
    };
    var _adults_primary_min, _adults_primary_max, _children_primary_min;
    return /* @__PURE__ */ React170.createElement(React170.Fragment, null, adults.primary.__typename === "EGDSBasicStepInput" && /* @__PURE__ */ React170.createElement(UitkStepInput, {
        label: adults.primary.label,
        incrementText: "".concat(adults.primary.label, " +"),
        decrementText: "".concat(adults.primary.label, " -"),
        incrementId: "room-".concat(groupIndex, "-", "adults" /* ADULTS */ , "-increase"),
        decrementId: "room-".concat(groupIndex, "-", "adults" /* ADULTS */ , "-decrease"),
        min: (_adults_primary_min = adults.primary.min) !== null && _adults_primary_min !== void 0 ? _adults_primary_min : 1,
        max: totalTravelers < maxGuest ? (_adults_primary_max = adults.primary.max) !== null && _adults_primary_max !== void 0 ? _adults_primary_max : MAX_TRAVELERS : state.adults,
        value: state.adults,
        onChange: buildOnChange("adults" /* ADULTS */ ),
        analytics: guestCountAnalytics,
        id: "room-".concat(groupIndex, "-", "adults" /* ADULTS */ )
    }), ((_children = children) === null || _children === void 0 ? void 0 : _children.primary.__typename) === "EGDSBasicStepInput" && /* @__PURE__ */ React170.createElement(UitkStepInput, {
        label: children.primary.label,
        incrementText: "".concat(children.primary.label, " +"),
        decrementText: "".concat(children.primary.label, " -"),
        incrementId: "room-".concat(groupIndex, "-", "children" /* CHILDREN */ , "-increase"),
        decrementId: "room-".concat(groupIndex, "-", "children" /* CHILDREN */ , "-decrease"),
        min: (_children_primary_min = children.primary.min) !== null && _children_primary_min !== void 0 ? _children_primary_min : 0,
        max: totalTravelers < maxGuest ? maxChildren !== null && maxChildren !== void 0 ? maxChildren : defaultMaxChild : ((_state_children3 = state.children) === null || _state_children3 === void 0 ? void 0 : _state_children3.length) || 0,
        value: childrenCount,
        onChange: buildOnChange("children" /* CHILDREN */ ),
        analytics: guestCountAnalytics,
        id: "room-".concat(groupIndex, "-", "children" /* CHILDREN */ ),
        description: children.primary.subLabel || void 0
    }), state.children && ((_state_children4 = state.children) === null || _state_children4 === void 0 ? void 0 : _state_children4.length) > 0 && /* @__PURE__ */ React170.createElement(UitkLayoutGrid23, {
        space: "two",
        columns: 2
    }, (_state_children5 = state.children) === null || _state_children5 === void 0 ? void 0 : _state_children5.map(function(param, childIndex) {
        var age = param.age;
        var _children_secondary, _children, _child;
        var child = (_children = children) === null || _children === void 0 ? void 0 : (_children_secondary = _children.secondary) === null || _children_secondary === void 0 ? void 0 : _children_secondary.inputs[childIndex];
        return ((_child = child) === null || _child === void 0 ? void 0 : _child.__typename) === "EGDSBasicSelect" && /* @__PURE__ */ React170.createElement(UitkSelect, {
            label: child.label,
            id: child.egdsElementId || void 0,
            name: "child-".concat(groupIndex, "-").concat(childIndex),
            value: age.toString(),
            onChange: onSelectChange(childIndex)
        }, child.options.map(function(option) {
            return /* @__PURE__ */ React170.createElement("option", {
                key: option.value,
                value: option.value
            }, option.label);
        }));
    })));
};
LodgingGuestGroup.displayName = "LodgingGuestGroup";
LodgingGuestGroup.fragment = __LodgingGuestGroupFragment;
// src/components/traveler-selector/__private/lodging-pet-group.tsx
import React171 from "react";
import { gql as gql138 } from "@apollo/client";
import { useClickTracker as useClickTracker42 } from "@shared-ui/clickstream-analytics-context";
import { UitkCheckbox as UitkCheckbox2 } from "uitk-react-checkbox";
import { UitkSpacing as UitkSpacing84 } from "uitk-react-spacing";
var __LodgingPetGroupFragment = gql138(_templateObject140());
var INCLUDE_PETS = "INCLUDE_PETS";
var EXCLUDE_PETS = "EXCLUDE_PETS";
var LodgingPetGroup = function(param) {
    var data = param.data, groupIndex = param.groupIndex, isChecked = param.isChecked;
    var dispatch = useTravelerAction();
    var track = useClickTracker42();
    var _React171_useState = _sliced_to_array(React171.useState(isChecked), 2), checked = _React171_useState[0], setChecked = _React171_useState[1];
    var handleCheckboxChange = React171.useCallback(function(event) {
        var eventTarget = event.target.checked;
        var petsIncluded = eventTarget ? INCLUDE_PETS : EXCLUDE_PETS;
        setChecked(eventTarget ? "CHECKED" /* CHECKED */  : "UNCHECKED" /* UNCHECKED */ );
        dispatch({
            type: petsIncluded,
            groupIndex: groupIndex
        });
        track("HOT.HIS.TravelersField.".concat(petsIncluded), "Travelers Field ".concat(petsIncluded));
    }, []);
    if (data.input.primary.__typename !== "EGDSBasicCheckBox") {
        return null;
    }
    var _data_input_primary = data.input.primary, label = _data_input_primary.label, enabled = _data_input_primary.enabled;
    return /* @__PURE__ */ React171.createElement(UitkSpacing84, {
        padding: {
            blockstart: "four"
        }
    }, /* @__PURE__ */ React171.createElement("div", null, /* @__PURE__ */ React171.createElement(UitkCheckbox2, {
        id: label.text,
        checked: checked === "CHECKED" /* CHECKED */ ,
        disabled: !enabled,
        onChange: handleCheckboxChange
    }, label.text)));
};
LodgingPetGroup.displayName = "LodgingPetGroup";
LodgingPetGroup.fragment = __LodgingPetGroupFragment;
// src/components/traveler-selector/__private/unit-group.tsx
var __UnitGroupFragment = gql139(_templateObject141(), LodgingGuestGroup.fragment, LodgingPetGroup.fragment);
var UnitGroup = function(param) {
    var data = param.data, state = param.state, groupIndex = param.groupIndex;
    var inputs = data.inputs;
    return /* @__PURE__ */ React172.createElement(React172.Fragment, null, inputs.map(function(it) {
        switch(it.__typename){
            case "LodgingGuestGroup":
                return /* @__PURE__ */ React172.createElement(LodgingGuestGroup, {
                    data: it,
                    state: state,
                    groupIndex: groupIndex
                });
            case "LodgingPetGroup":
                return /* @__PURE__ */ React172.createElement(React172.Fragment, null, it.input.primary.__typename === "EGDSBasicCheckBox" && /* @__PURE__ */ React172.createElement(LodgingPetGroup, {
                    data: it,
                    groupIndex: groupIndex,
                    isChecked: it.input.primary.state
                }));
            default:
                return null;
        }
    }));
};
UnitGroup.displayName = "UnitGroup";
UnitGroup.fragment = __UnitGroupFragment;
// src/components/traveler-selector/__private/traveler-selector-form.tsx
var __TravelerSelectorFormFragment = gql140(_templateObject142(), UnitGroup.fragment, LodgingEnrichedMessage.fragment, LodgingEGDSIcon.fragment, LodgingEGDSButton.fragment, fragment7, clientSideAnalyticsFragment);
var DEFAULT_SA_CHILD_AGE = 0;
var roomPickerReducer = function(state, action) {
    switch(action.type){
        case "UPDATE_ADULTS_COUNT":
            {
                var groupIndex = action.groupIndex, count = action.count;
                return _object_spread_props(_object_spread({}, state), {
                    rooms: state.rooms.map(function(room, index) {
                        return index === groupIndex ? _object_spread_props(_object_spread({}, room), {
                            adults: count
                        }) : room;
                    })
                });
            }
        case "UPDATE_CHILDREN_COUNT":
            {
                var _state_rooms_groupIndex_children;
                var groupIndex1 = action.groupIndex, count1 = action.count;
                var childrenAdded = count1 > (((_state_rooms_groupIndex_children = state.rooms[groupIndex1].children) === null || _state_rooms_groupIndex_children === void 0 ? void 0 : _state_rooms_groupIndex_children.length) || 0);
                return _object_spread_props(_object_spread({}, state), {
                    rooms: state.rooms.map(function(room, index) {
                        if (index === groupIndex1) {
                            var _room_children, _room_children1;
                            return _object_spread_props(_object_spread({}, room), {
                                children: childrenAdded ? ((_room_children = room.children) === null || _room_children === void 0 ? void 0 : _room_children.concat([
                                    {
                                        age: DEFAULT_SA_CHILD_AGE
                                    }
                                ])) || [
                                    {
                                        age: DEFAULT_SA_CHILD_AGE
                                    }
                                ] : (_room_children1 = room.children) === null || _room_children1 === void 0 ? void 0 : _room_children1.slice(0, -1)
                            });
                        }
                        return room;
                    })
                });
            }
        case "UPDATE_CHILD_AGE":
            {
                var groupIndex2 = action.groupIndex, childIndex = action.childIndex, childAge = action.childAge;
                return _object_spread_props(_object_spread({}, state), {
                    rooms: state.rooms.map(function(room, index) {
                        if (groupIndex2 === index) {
                            var _room_children;
                            return _object_spread_props(_object_spread({}, room), {
                                children: (_room_children = room.children) === null || _room_children === void 0 ? void 0 : _room_children.map(function(child, j) {
                                    return childIndex === j ? {
                                        age: childAge
                                    } : child;
                                })
                            });
                        }
                        return room;
                    })
                });
            }
        case "INCLUDE_PETS":
            {
                var groupIndex3 = action.groupIndex;
                return _object_spread_props(_object_spread({}, state), {
                    rooms: state.rooms.map(function(room, index) {
                        if (groupIndex3 === index) {
                            return _object_spread_props(_object_spread({}, room), {
                                petsIncluded: true
                            });
                        }
                        return room;
                    })
                });
            }
        case "EXCLUDE_PETS":
            {
                var groupIndex4 = action.groupIndex;
                return _object_spread_props(_object_spread({}, state), {
                    rooms: state.rooms.map(function(room, index) {
                        if (groupIndex4 === index) {
                            return _object_spread_props(_object_spread({}, room), {
                                petsIncluded: false
                            });
                        }
                        return room;
                    })
                });
            }
        default:
            return state;
    }
};
var TravelerSelectorForm = function(param) {
    var data = param.data, initialTravelerData = param.initialTravelerData, setTravelerSelectorModalOpen = param.setTravelerSelectorModalOpen, updateDisplayedTravelersButtonText = param.updateDisplayedTravelersButtonText, updateStoreWithTravelerUrlData = param.updateStoreWithTravelerUrlData;
    var updateUrl = useUpdateURL();
    var unitGroups = data.unitGroups;
    var adaptForRoom = function(index) {
        var _initialTravelerData_rooms_index = initialTravelerData.rooms[index], children = _initialTravelerData_rooms_index.children, adults = _initialTravelerData_rooms_index.adults;
        return {
            adults: adults,
            children: children,
            petsIncluded: initialTravelerData.petsIncluded
        };
    };
    var newRooms = {
        rooms: unitGroups.map(function(_, index) {
            return adaptForRoom(index);
        })
    };
    var _React173_useReducer = _sliced_to_array(React173.useReducer(roomPickerReducer, newRooms), 2), state = _React173_useReducer[0], dispatch = _React173_useReducer[1];
    var getPetsIncludedUrlParam = React173.useCallback(function() {
        var petsIncludedByRoom = state.rooms.map(function(room) {
            return room.petsIncluded;
        }).filter(Boolean);
        if (petsIncludedByRoom.length > 0) {
            return petsIncludedByRoom.every(Boolean);
        }
        return false;
    }, [
        state
    ]);
    var handleSubmit = React173.useCallback(function() {
        var rooms = state.rooms;
        var adultCount = rooms && rooms.length > 0 ? rooms.reduce(function(count, room) {
            return count + (room.adults || 0);
        }, 0) : 0;
        var childrenCount = rooms && rooms.length > 0 ? rooms.reduce(function(count, room) {
            var _room_children;
            return count + (((_room_children = room.children) === null || _room_children === void 0 ? void 0 : _room_children.length) || 0);
        }, 0) : 0;
        var guestCount = adultCount + childrenCount;
        var isPetsIncluded = getPetsIncludedUrlParam();
        var amenities = isPetsIncluded ? "PETS" : void 0;
        var house_rules_group = isPetsIncluded ? "pets_allowed" : void 0;
        var dataForUrl = {
            adults: adultCount,
            children: state.rooms.flatMap(function(room, roomIndex) {
                var _room_children;
                return ((_room_children = room.children) === null || _room_children === void 0 ? void 0 : _room_children.map(function(param) {
                    var age = param.age;
                    return "".concat(roomIndex + 1, "_").concat(age);
                })) || [];
            }),
            amenities: amenities,
            house_rules_group: house_rules_group
        };
        updateDisplayedTravelersButtonText(guestCount, isPetsIncluded);
        setTravelerSelectorModalOpen();
        setTimeout(function() {
            return updateUrl(dataForUrl);
        }, 50);
        updateStoreWithTravelerUrlData(state, isPetsIncluded);
    }, [
        state,
        updateDisplayedTravelersButtonText,
        setTravelerSelectorModalOpen,
        updateStoreWithTravelerUrlData
    ]);
    return /* @__PURE__ */ React173.createElement(TravelerActionProvider, {
        value: dispatch
    }, /* @__PURE__ */ React173.createElement("section", null, data.title && /* @__PURE__ */ React173.createElement(LodgingEnrichedMessage, {
        data: data.title,
        textSize: 500
    }), /* @__PURE__ */ React173.createElement(UitkSpacing85, {
        padding: {
            blockstart: "four"
        }
    }, /* @__PURE__ */ React173.createElement("div", null, unitGroups.map(function(group, groupIndex) {
        return /* @__PURE__ */ React173.createElement(UnitGroup, {
            key: groupIndex,
            data: group,
            state: state.rooms[groupIndex],
            groupIndex: groupIndex
        });
    }))), /* @__PURE__ */ React173.createElement(UitkSpacing85, {
        padding: {
            blockstart: "four"
        }
    }, /* @__PURE__ */ React173.createElement("div", null, data.submitButton && /* @__PURE__ */ React173.createElement(LodgingEGDSButton, {
        data: data.submitButton,
        isFullWidth: true,
        onClick: handleSubmit
    })))));
};
TravelerSelectorForm.displayName = "TravelerSelectorForm";
TravelerSelectorForm.fragment = __TravelerSelectorFormFragment;
// src/components/traveler-selector/traveler-selector.tsx
var TravelerSelector = function(param) {
    var data = param.data, initalTravelerData = param.initalTravelerData, translations = param.translations, updateStoreWithTravelerUrlData = param.updateStoreWithTravelerUrlData, triggerRef = param.triggerRef;
    var formatText = useLocalization2().formatText;
    var _useDialog24 = _sliced_to_array(useDialog24("full-sheet-traveler-selector"), 3), isDialogOpen = _useDialog24[0], dialogActions = _useDialog24[1], DialogComponent = _useDialog24[2];
    var getButtonDisplayText = function(guestCount, petsIncluded) {
        var key = petsIncluded ? translations.pets : translations.travelers;
        var numberOfRooms = 1;
        return formatText(key, numberOfRooms, guestCount);
    };
    var _useState3 = _sliced_to_array(useState3(getButtonDisplayText(initalTravelerData.totalGuestCount, initalTravelerData.petsIncluded)), 2), buttonDisplayText = _useState3[0], setButtonDisplayText = _useState3[1];
    var updateDisplayedTravelersButtonText = React174.useCallback(function(totalTravelers, petsIncluded) {
        setButtonDisplayText(getButtonDisplayText(totalTravelers, petsIncluded));
    }, []);
    if (!data) {
        return null;
    }
    var labelText = formatText(translations.travelersLabel);
    return /* @__PURE__ */ React174.createElement(UitkLayoutPosition5, {
        type: "relative"
    }, /* @__PURE__ */ React174.createElement(Viewport26, null, /* @__PURE__ */ React174.createElement(ViewLarge8, null, /* @__PURE__ */ React174.createElement(React174.Fragment, null, /* @__PURE__ */ React174.createElement(UitkFakeInput, {
        label: labelText,
        value: buttonDisplayText,
        "data-stid": "open-room-picker",
        onClick: function() {
            return dialogActions.openDialog();
        },
        domRef: triggerRef
    }), /* @__PURE__ */ React174.createElement(UitkSheet15, {
        isVisible: isDialogOpen,
        type: "popover",
        triggerRef: triggerRef,
        onDismiss: dialogActions.closeDialog,
        showOverTrigger: true,
        width: 400
    }, /* @__PURE__ */ React174.createElement(UitkSheetContent7, null, /* @__PURE__ */ React174.createElement(UitkSpacing86, {
        padding: {
            blockstart: "half"
        }
    }, /* @__PURE__ */ React174.createElement("div", null, /* @__PURE__ */ React174.createElement(TravelerSelectorForm, {
        data: data,
        initialTravelerData: initalTravelerData,
        updateDisplayedTravelersButtonText: updateDisplayedTravelersButtonText,
        setTravelerSelectorModalOpen: function() {
            return dialogActions.closeDialog();
        },
        updateStoreWithTravelerUrlData: updateStoreWithTravelerUrlData
    }))))))), /* @__PURE__ */ React174.createElement(ViewMedium21, null, /* @__PURE__ */ React174.createElement(React174.Fragment, null, /* @__PURE__ */ React174.createElement(UitkFakeInput, {
        label: labelText,
        value: buttonDisplayText,
        "data-stid": "open-room-picker",
        onClick: function() {
            return dialogActions.openDialog();
        },
        domRef: triggerRef
    }), /* @__PURE__ */ React174.createElement(DialogComponent, null, /* @__PURE__ */ React174.createElement(UitkSheet15, {
        isVisible: isDialogOpen,
        type: "centered",
        triggerRef: triggerRef
    }, /* @__PURE__ */ React174.createElement(UitkToolbar14, {
        navigationContent: {
            onClick: function() {
                return dialogActions.closeDialog();
            },
            navIconLabel: "Close"
        }
    }), /* @__PURE__ */ React174.createElement(UitkSheetContent7, null, /* @__PURE__ */ React174.createElement(UitkSpacing86, {
        padding: {
            blockstart: "half"
        }
    }, /* @__PURE__ */ React174.createElement("div", null, /* @__PURE__ */ React174.createElement(TravelerSelectorForm, {
        data: data,
        initialTravelerData: initalTravelerData,
        updateDisplayedTravelersButtonText: updateDisplayedTravelersButtonText,
        setTravelerSelectorModalOpen: function() {
            return dialogActions.closeDialog();
        },
        updateStoreWithTravelerUrlData: updateStoreWithTravelerUrlData
    })))))))), /* @__PURE__ */ React174.createElement(ViewSmall25, null, /* @__PURE__ */ React174.createElement(React174.Fragment, null, /* @__PURE__ */ React174.createElement(UitkFakeInput, {
        label: labelText,
        value: buttonDisplayText,
        "data-stid": "open-room-picker",
        onClick: function() {
            return dialogActions.openDialog();
        },
        domRef: triggerRef
    }), /* @__PURE__ */ React174.createElement(DialogComponent, null, /* @__PURE__ */ React174.createElement(UitkSheet15, {
        isVisible: isDialogOpen,
        type: "full",
        triggerRef: triggerRef
    }, /* @__PURE__ */ React174.createElement(UitkToolbar14, {
        navigationContent: {
            onClick: function() {
                return dialogActions.closeDialog();
            },
            navIconLabel: "Close"
        }
    }), /* @__PURE__ */ React174.createElement(UitkSheetContent7, null, /* @__PURE__ */ React174.createElement(UitkSpacing86, {
        padding: {
            blockstart: "half"
        }
    }, /* @__PURE__ */ React174.createElement("div", null, /* @__PURE__ */ React174.createElement(TravelerSelectorForm, {
        data: data,
        initialTravelerData: initalTravelerData,
        updateDisplayedTravelersButtonText: updateDisplayedTravelersButtonText,
        setTravelerSelectorModalOpen: function() {
            return dialogActions.closeDialog();
        },
        updateStoreWithTravelerUrlData: updateStoreWithTravelerUrlData
    }))))))))));
};
TravelerSelector.displayName = "TravelerSelector";
TravelerSelector.fragment = TravelerSelectorForm.fragment;
// src/components/units-carousel/placeholder.tsx
import React175 from "react";
import { UitkCard as UitkCard29, UitkCardContentSection as UitkCardContentSection22 } from "uitk-react-cards";
import { UitkFigure as UitkFigure6, UitkFigureAspectRatioType as UitkFigureAspectRatioType7 } from "uitk-react-images";
import { UitkLayoutGrid as UitkLayoutGrid24, UitkLayoutGridItem as UitkLayoutGridItem20 } from "uitk-react-layout-grid";
import { UitkBlockSkeleton as UitkBlockSkeleton2, UitkLineSkeleton as UitkLineSkeleton3 } from "uitk-react-skeleton";
import { UitkSpacing as UitkSpacing87 } from "uitk-react-spacing";
var UnitsCarouselPlaceholder = function() {
    return /* @__PURE__ */ React175.createElement(UitkSpacing87, {
        padding: {
            blockend: "six"
        }
    }, /* @__PURE__ */ React175.createElement("div", null, /* @__PURE__ */ React175.createElement(UitkLineSkeleton3, {
        type: "primary"
    }), /* @__PURE__ */ React175.createElement(UitkSpacing87, {
        padding: {
            blockstart: "six"
        }
    }, /* @__PURE__ */ React175.createElement(UitkLayoutGrid24, {
        columns: {
            small: 2,
            medium: 2,
            large: 2
        },
        space: "three"
    }, [
        0,
        1
    ].map(function(_, index) {
        return /* @__PURE__ */ React175.createElement(UitkLayoutGridItem20, {
            key: "units-carousel-placeholder-".concat(index)
        }, /* @__PURE__ */ React175.createElement(UitkCard29, null, /* @__PURE__ */ React175.createElement(UitkFigure6, {
            ratio: UitkFigureAspectRatioType7.R16_9
        }, /* @__PURE__ */ React175.createElement(UitkBlockSkeleton2, null)), /* @__PURE__ */ React175.createElement(UitkCardContentSection22, {
            padded: true
        }, /* @__PURE__ */ React175.createElement(UitkSpacing87, {
            margin: {
                blockstart: "one"
            }
        }, /* @__PURE__ */ React175.createElement(UitkLineSkeleton3, {
            animation: true
        })), /* @__PURE__ */ React175.createElement(UitkSpacing87, {
            margin: {
                block: "three"
            }
        }, /* @__PURE__ */ React175.createElement(UitkLineSkeleton3, {
            animation: true,
            type: "secondary"
        })))));
    })))));
};
// src/components/units-carousel/units-carousel.tsx
import React177 from "react";
import { gql as gql142 } from "@apollo/client";
import { IntersectionTracker as IntersectionTracker10 } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/components/lodging-unit-card/lodging-unit-card.tsx
import React176 from "react";
import { gql as gql141 } from "@apollo/client";
import { useClickTracker as useClickTracker43 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog25 } from "@shared-ui/dialog-context";
import { UitkCard as UitkCard30, UitkCardContentSection as UitkCardContentSection23, UitkCardLink as UitkCardLink3 } from "uitk-react-cards";
import { UitkFigure as UitkFigure7, UitkFigureAspectRatioType as UitkFigureAspectRatioType8, UitkImage as UitkImage5 } from "uitk-react-images";
import { UitkLayoutFlex as UitkLayoutFlex40, UitkLayoutFlexItem as UitkLayoutFlexItem28 } from "uitk-react-layout-flex";
import { UitkHeading as UitkHeading32, UitkText as UitkText49 } from "uitk-react-text";
var fragment80 = gql141(_templateObject143());
var LodgingUnitCard = function(param) {
    var data = param.data, _param_aspectRatio = param.aspectRatio, aspectRatio = _param_aspectRatio === void 0 ? UitkFigureAspectRatioType8.R16_9 : _param_aspectRatio, dialogProps = param.dialogProps;
    var _dialogProps, _dialogProps1, _image, _image1, _header, _trigger, _trigger1, _trigger2, _trigger3, _trigger4, _trigger5;
    var trackClick = useClickTracker43();
    var _dialogProps_id;
    var _useDialog25 = _sliced_to_array(useDialog25((_dialogProps_id = (_dialogProps = dialogProps) === null || _dialogProps === void 0 ? void 0 : _dialogProps.id) !== null && _dialogProps_id !== void 0 ? _dialogProps_id : "", (_dialogProps1 = dialogProps) === null || _dialogProps1 === void 0 ? void 0 : _dialogProps1.dialogQueryKey), 2), dialogActions = _useDialog25[1];
    var onClickCaptureCallback = React176.useCallback(function() {
        var _data_trigger, _data;
        if ((_data = data) === null || _data === void 0 ? void 0 : (_data_trigger = _data.trigger) === null || _data_trigger === void 0 ? void 0 : _data_trigger.clientSideAnalytics) {
            trackClick(data.trigger.clientSideAnalytics.referrerId, data.trigger.clientSideAnalytics.linkName);
        }
        dialogActions.openDialog();
    }, [
        data,
        trackClick,
        dialogActions
    ]);
    if (!data) {
        return null;
    }
    var image = data.image, header = data.header, trigger = data.trigger;
    return /* @__PURE__ */ React176.createElement(UitkCard30, {
        border: true
    }, /* @__PURE__ */ React176.createElement(UitkLayoutFlex40, {
        direction: "column"
    }, /* @__PURE__ */ React176.createElement(UitkFigure7, {
        ratio: aspectRatio
    }, /* @__PURE__ */ React176.createElement(UitkImage5, {
        alt: (_image = image) === null || _image === void 0 ? void 0 : _image.description,
        src: (_image1 = image) === null || _image1 === void 0 ? void 0 : _image1.url,
        placeholderImage: true
    })), /* @__PURE__ */ React176.createElement(UitkLayoutFlexItem28, {
        grow: 1
    }, /* @__PURE__ */ React176.createElement(UitkCardContentSection23, {
        padded: true
    }, /* @__PURE__ */ React176.createElement(UitkLayoutFlex40, {
        direction: "column",
        justifyContent: "space-between",
        blockSize: "full_size"
    }, /* @__PURE__ */ React176.createElement(UitkLayoutFlexItem28, null, /* @__PURE__ */ React176.createElement(UitkHeading32, {
        overflow: "truncate-2-lines",
        size: 7
    }, (_header = header) === null || _header === void 0 ? void 0 : _header.text)), /* @__PURE__ */ React176.createElement(UitkLayoutFlexItem28, {
        alignSelf: "stretch"
    }, /* @__PURE__ */ React176.createElement("div", null, ((_trigger = trigger) === null || _trigger === void 0 ? void 0 : _trigger.theme) === "AGGRESSIVE" /* AGGRESSIVE */  ? /* @__PURE__ */ React176.createElement(UitkText49, {
        weight: "bold",
        size: 200,
        theme: highlightedMessagesThemeToUitkTextTheme[(_trigger1 = trigger) === null || _trigger1 === void 0 ? void 0 : _trigger1.theme],
        spacing: "two"
    }, (_trigger2 = trigger) === null || _trigger2 === void 0 ? void 0 : _trigger2.value) : /* @__PURE__ */ React176.createElement(UitkText49, {
        weight: "bold",
        size: 400,
        spacing: "two",
        overflow: "wrap"
    }, (_trigger3 = trigger) === null || _trigger3 === void 0 ? void 0 : _trigger3.value), /* @__PURE__ */ React176.createElement(UitkText49, {
        size: 100,
        overflow: "wrap",
        weight: "regular"
    }, (_trigger4 = trigger) === null || _trigger4 === void 0 ? void 0 : _trigger4.secondaryValue)))))), /* @__PURE__ */ React176.createElement(UitkCardLink3, null, /* @__PURE__ */ React176.createElement("button", {
        type: "button",
        onClick: onClickCaptureCallback
    }, (_trigger5 = trigger) === null || _trigger5 === void 0 ? void 0 : _trigger5.accessibilityLabel))));
};
LodgingUnitCard.displayName = "LodgingUnitCard";
LodgingUnitCard.fragment = fragment80;
// src/components/units-carousel/units-carousel.tsx
import { UitkCarousel as UitkCarousel3 } from "uitk-react-carousel";
import { UitkSpacing as UitkSpacing88 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading33 } from "uitk-react-text";
var fragment81 = gql142(_templateObject144(), LodgingUnitCard.fragment);
var UnitsCarousel = function(param) {
    var data = param.data;
    var _impressionAnalytics, _impressionAnalytics1, _items, _carousel_nextButton_icon, _carousel_nextButton, _carousel, _carousel_previousButton_icon, _carousel_previousButton, _carousel1;
    if (!data || !data.unitsCarousel || data.unitsCarousel.items.length === 0) {
        return null;
    }
    var _data_unitsCarousel = data.unitsCarousel, carousel = _data_unitsCarousel.carousel, heading = _data_unitsCarousel.heading, impressionAnalytics = _data_unitsCarousel.impressionAnalytics, items = _data_unitsCarousel.items;
    var _impressionAnalytics_referrerId, _impressionAnalytics_linkName;
    return /* @__PURE__ */ React177.createElement(IntersectionTracker10, {
        referrerId: (_impressionAnalytics_referrerId = (_impressionAnalytics = impressionAnalytics) === null || _impressionAnalytics === void 0 ? void 0 : _impressionAnalytics.referrerId) !== null && _impressionAnalytics_referrerId !== void 0 ? _impressionAnalytics_referrerId : "",
        linkName: (_impressionAnalytics_linkName = (_impressionAnalytics1 = impressionAnalytics) === null || _impressionAnalytics1 === void 0 ? void 0 : _impressionAnalytics1.linkName) !== null && _impressionAnalytics_linkName !== void 0 ? _impressionAnalytics_linkName : "",
        trackOnce: true
    }, /* @__PURE__ */ React177.createElement(UitkSpacing88, {
        padding: {
            blockend: "six"
        }
    }, /* @__PURE__ */ React177.createElement("div", null, heading.__typename === "EGDSStylizedText" && /* @__PURE__ */ React177.createElement(UitkHeading33, {
        size: 5,
        tag: "h2"
    }, heading.text), ((_items = items) === null || _items === void 0 ? void 0 : _items.length) > 0 && /* @__PURE__ */ React177.createElement(UitkSpacing88, {
        margin: {
            blockstart: "four"
        }
    }, /* @__PURE__ */ React177.createElement(UitkCarousel3, {
        buttonText: {
            nextButton: ((_carousel = carousel) === null || _carousel === void 0 ? void 0 : (_carousel_nextButton = _carousel.nextButton) === null || _carousel_nextButton === void 0 ? void 0 : (_carousel_nextButton_icon = _carousel_nextButton.icon) === null || _carousel_nextButton_icon === void 0 ? void 0 : _carousel_nextButton_icon.description) || "",
            prevButton: ((_carousel1 = carousel) === null || _carousel1 === void 0 ? void 0 : (_carousel_previousButton = _carousel1.previousButton) === null || _carousel_previousButton === void 0 ? void 0 : (_carousel_previousButton_icon = _carousel_previousButton.icon) === null || _carousel_previousButton_icon === void 0 ? void 0 : _carousel_previousButton_icon.description) || ""
        },
        itemsVisible: {
            sm: 2,
            md: 2,
            lg: 2
        },
        pageBy: 1,
        peek: true,
        itemsMaxHeight: true
    }, items.map(function(item, index) {
        return item.__typename === "LodgingUnitCard" && /* @__PURE__ */ React177.createElement(LodgingUnitCard, {
            data: item,
            key: "units-carousel-item-".concat(index),
            dialogProps: {
                id: "room-info-".concat(item.unitId, "-").concat(index + 1),
                dialogQueryKey: "propertyUnitRoomInfoDialog"
            }
        });
    }))))));
};
UnitsCarousel.fragment = fragment81;
UnitsCarousel.displayName = "UnitsCarousel";
// src/components/vip-messaging-card/vip-messaging-card.tsx
import React182 from "react";
import { gql as gql147 } from "@apollo/client";
// src/components/vip-access-module/__private/__fragments/vip-access-module-detail.tsx
import React180 from "react";
import { gql as gql145 } from "@apollo/client";
import { UitkBadgeSize as UitkBadgeSize2 } from "uitk-react-badge";
import { UitkCard as UitkCard31, UitkCardContentSection as UitkCardContentSection24 } from "uitk-react-cards";
import { UitkLayoutFlex as UitkLayoutFlex42, UitkLayoutFlexItem as UitkLayoutFlexItem29 } from "uitk-react-layout-flex";
import { FitContent as FitContent3, UitkLayoutGrid as UitkLayoutGrid25, UitkLayoutGridItem as UitkLayoutGridItem22 } from "uitk-react-layout-grid";
import { UitkList as UitkList9, UitkListItem as UitkListItem9 } from "uitk-react-list";
import { UitkSpacing as UitkSpacing90 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading34, UitkText as UitkText51 } from "uitk-react-text";
// src/components/vip-access-module/__private/__fragments/property-content-item-lodging-link-message.tsx
import React178 from "react";
import { gql as gql143 } from "@apollo/client";
import { useClickTracker as useClickTracker44 } from "@shared-ui/clickstream-analytics-context";
import { UitkIcon as UitkIcon33 } from "uitk-react-icons";
import { UitkLink as UitkLink22 } from "uitk-react-link";
var __PropertyContentItemLodgingLinkMessageFragment = gql143(_templateObject145());
var PropertyContentItemLodgingLinkMessage = function(param) {
    var data = param.data;
    var _link, _link1, _icon;
    var icon = data.icon, link = data.link, value = data.value, accessibilityLabel = data.accessibilityLabel;
    var track = useClickTracker44();
    var onClickLearnMoreLink = function() {
        var _link_clientSideAnalytics, _link_clientSideAnalytics1;
        if (!((_link_clientSideAnalytics = link.clientSideAnalytics) === null || _link_clientSideAnalytics === void 0 ? void 0 : _link_clientSideAnalytics.referrerId) || !((_link_clientSideAnalytics1 = link.clientSideAnalytics) === null || _link_clientSideAnalytics1 === void 0 ? void 0 : _link_clientSideAnalytics1.linkName)) {
            return;
        }
        track(link.clientSideAnalytics.referrerId, link.clientSideAnalytics.linkName);
    };
    return /* @__PURE__ */ React178.createElement("div", null, /* @__PURE__ */ React178.createElement(UitkLink22, {
        onClick: onClickLearnMoreLink
    }, /* @__PURE__ */ React178.createElement("a", {
        href: (_link = link) === null || _link === void 0 ? void 0 : _link.uri.value,
        target: ((_link1 = link) === null || _link1 === void 0 ? void 0 : _link1.target) || "",
        "aria-hidden": "false"
    }, value, /* @__PURE__ */ React178.createElement("span", {
        className: "is-visually-hidden"
    }, accessibilityLabel), /* @__PURE__ */ React178.createElement(UitkIcon33, {
        name: ((_icon = icon) === null || _icon === void 0 ? void 0 : _icon.id) || ""
    }))));
};
PropertyContentItemLodgingLinkMessage.fragment = __PropertyContentItemLodgingLinkMessageFragment;
PropertyContentItemLodgingLinkMessage.displayName = "PropertyContentItemLodgingLinkMessage";
// src/components/vip-access-module/__private/__fragments/property-content-item-text.tsx
import React179 from "react";
import { gql as gql144 } from "@apollo/client";
import { UitkBadgeLoyalty as UitkBadgeLoyalty4 } from "uitk-react-badge";
import { UitkLayoutFlex as UitkLayoutFlex41 } from "uitk-react-layout-flex";
import { UitkLayoutGridItem as UitkLayoutGridItem21 } from "uitk-react-layout-grid";
import { UitkSpacing as UitkSpacing89 } from "uitk-react-spacing";
import { UitkText as UitkText50 } from "uitk-react-text";
var __PropertyContentItemTextFragment = gql144(_templateObject146());
var PropertyContentItemText = function(param) {
    var data = param.data, badgeSize = param.badgeSize;
    if (!data.content) {
        return null;
    }
    var primary = data.content.primary;
    var _primary_badge_text;
    return /* @__PURE__ */ React179.createElement(React179.Fragment, null, primary.badge && /* @__PURE__ */ React179.createElement(UitkLayoutGridItem21, null, /* @__PURE__ */ React179.createElement(UitkSpacing89, {
        margin: {
            inlineend: "two"
        }
    }, /* @__PURE__ */ React179.createElement(UitkText50, {
        "aria-hidden": primary.badge.text === "VIP Access" ? "true" : "false"
    }, /* @__PURE__ */ React179.createElement(UitkBadgeLoyalty4, {
        text: (_primary_badge_text = primary.badge.text) !== null && _primary_badge_text !== void 0 ? _primary_badge_text : void 0,
        theme: primary.badge.theme_temp ? UitkBadgeLoyaltyThemePerksMessageMapper[primary.badge.theme_temp] : void 0,
        size: badgeSize,
        a11yText: primary.badge.text === "VIP Access" ? void 0 : "".concat(primary.badge.text, " tier member")
    })))), primary.value && /* @__PURE__ */ React179.createElement(UitkLayoutFlex41, {
        alignItems: "center"
    }, /* @__PURE__ */ React179.createElement(UitkLayoutGridItem21, null, /* @__PURE__ */ React179.createElement(UitkSpacing89, {
        padding: {
            small: {
                inlineend: "unset"
            },
            medium: {
                inlineend: "four"
            }
        }
    }, /* @__PURE__ */ React179.createElement(UitkText50, {
        theme: "default",
        size: 300
    }, primary.value)))));
};
PropertyContentItemText.displayName = "PropertyContentItemText";
PropertyContentItemText.fragment = __PropertyContentItemTextFragment;
// src/components/vip-access-module/__private/__fragments/vip-access-module-detail.tsx
var __VipAccessModuleDetailFragment = gql145(_templateObject147(), PropertyContentItemText.fragment, PropertyContentItemLodgingLinkMessage.fragment);
var VipAccessModuleDetail = function(param) {
    var data = param.data;
    var _sections, _modItem, _modItem_content_primary_badge;
    var sections = data.sections;
    if (!sections || !((_sections = sections) === null || _sections === void 0 ? void 0 : _sections.length) || sections.some(function(sec) {
        var _sec_bodySubSections, _sec;
        return sec.bodySubSections === null || !((_sec = sec) === null || _sec === void 0 ? void 0 : (_sec_bodySubSections = _sec.bodySubSections) === null || _sec_bodySubSections === void 0 ? void 0 : _sec_bodySubSections.length);
    })) {
        return null;
    }
    var modElement = sections[0].bodySubSections[0].elementsV2[0].elements[0];
    var modItem = modElement.__typename === "PropertyContent" ? modElement.items[1] : null;
    var mod = ((_modItem = modItem) === null || _modItem === void 0 ? void 0 : _modItem.__typename) === "PropertyContentItemText" ? (_modItem_content_primary_badge = modItem.content.primary.badge) === null || _modItem_content_primary_badge === void 0 ? void 0 : _modItem_content_primary_badge.text : null;
    var upperMod = mod === "Silver" || mod === "Gold" || mod === "Platinum";
    var content = sections.map(function(section, i) {
        var _section_bodySubSections, _sectionContent;
        if (!section.bodySubSections || !((_section_bodySubSections = section.bodySubSections) === null || _section_bodySubSections === void 0 ? void 0 : _section_bodySubSections.length)) {
            return null;
        }
        var elements = section.bodySubSections[0].elementsV2[0].elements[0];
        var sectionContent = elements.__typename === "PropertyContent" ? elements.items : null;
        if (!((_sectionContent = sectionContent) === null || _sectionContent === void 0 ? void 0 : _sectionContent.length)) {
            return null;
        }
        var sectionItems = sectionContent.map(function(item, index) {
            return item.__typename === "PropertyContentItemText" ? /* @__PURE__ */ React180.createElement(PropertyContentItemText, {
                key: "content-item-text-".concat(index),
                data: item
            }) : null;
        });
        switch(section.sectionName){
            case "headerSection":
                {
                    return /* @__PURE__ */ React180.createElement(UitkLayoutGridItem22, {
                        colSpan: {
                            small: 1,
                            medium: 3
                        }
                    }, /* @__PURE__ */ React180.createElement(UitkCardContentSection24, {
                        border: "bottom",
                        padded: false
                    }, /* @__PURE__ */ React180.createElement(UitkSpacing90, {
                        padding: {
                            blockend: "three"
                        }
                    }, /* @__PURE__ */ React180.createElement(UitkLayoutFlex42, null, sectionItems))));
                }
            case "leftSection":
                {
                    return /* @__PURE__ */ React180.createElement(UitkLayoutGridItem22, {
                        colSpan: upperMod ? {
                            small: 1,
                            medium: 3
                        } : void 0
                    }, /* @__PURE__ */ React180.createElement(UitkSpacing90, {
                        padding: {
                            block: "four"
                        }
                    }, /* @__PURE__ */ React180.createElement(UitkLayoutFlex42, {
                        direction: "column",
                        space: "two"
                    }, /* @__PURE__ */ React180.createElement(UitkLayoutFlexItem29, null, section.header && /* @__PURE__ */ React180.createElement(UitkHeading34, {
                        tag: "h3",
                        size: 5
                    }, /* @__PURE__ */ React180.createElement(UitkText51, {
                        weight: "bold"
                    }, section.header.text))), upperMod ? /* @__PURE__ */ React180.createElement(UitkLayoutFlexItem29, null, /* @__PURE__ */ React180.createElement(UitkList9, null, sectionContent.map(function(item, index) {
                        return item.__typename === "PropertyContentItemText" ? /* @__PURE__ */ React180.createElement(UitkListItem9, {
                            key: "property-content-list-item-".concat(index)
                        }, item.content.primary.value) : null;
                    }))) : /* @__PURE__ */ React180.createElement(UitkLayoutFlexItem29, null, sectionItems))));
                }
            case "rightSection":
                {
                    return /* @__PURE__ */ React180.createElement(UitkLayoutGridItem22, {
                        colSpan: {
                            small: 1,
                            medium: 2
                        }
                    }, /* @__PURE__ */ React180.createElement(UitkSpacing90, {
                        padding: {
                            small: {
                                blockend: "four"
                            },
                            medium: {
                                block: "three",
                                inlinestart: "twelve"
                            }
                        }
                    }, /* @__PURE__ */ React180.createElement(UitkLayoutFlex42, {
                        direction: "column",
                        space: "two"
                    }, /* @__PURE__ */ React180.createElement(UitkSpacing90, {
                        margin: mod === "Blue" ? {
                            small: {
                                blockstart: "two",
                                blockend: "two"
                            },
                            medium: {
                                blockstart: "one"
                            }
                        } : void 0
                    }, /* @__PURE__ */ React180.createElement(UitkLayoutFlexItem29, null, /* @__PURE__ */ React180.createElement(UitkLayoutFlex42, {
                        space: "two",
                        alignItems: "center"
                    }, /* @__PURE__ */ React180.createElement(UitkLayoutFlexItem29, null, section.header && /* @__PURE__ */ React180.createElement(UitkHeading34, {
                        tag: "h3",
                        size: 7
                    }, /* @__PURE__ */ React180.createElement(UitkText51, {
                        weight: "bold"
                    }, section.header.text)))))), /* @__PURE__ */ React180.createElement(UitkLayoutFlexItem29, null, /* @__PURE__ */ React180.createElement(UitkLayoutGrid25, {
                        space: "two",
                        rows: {
                            small: [
                                FitContent3("0x"),
                                "1fr"
                            ],
                            medium: [
                                FitContent3("0x"),
                                "1fr"
                            ]
                        }
                    }, sectionContent.map(function(item, index) {
                        return item.__typename === "PropertyContentItemText" ? /* @__PURE__ */ React180.createElement("div", {
                            key: "property-content-list-item-".concat(index)
                        }, /* @__PURE__ */ React180.createElement(UitkLayoutGrid25, {
                            columns: [
                                "15x",
                                "7fr"
                            ],
                            alignItems: "start"
                        }, /* @__PURE__ */ React180.createElement(PropertyContentItemText, {
                            data: item,
                            badgeSize: UitkBadgeSize2.SMALL
                        }))) : null;
                    }))))));
                }
            case "footerSection":
                {
                    return sectionContent[0].__typename === "LodgingLinkMessage" ? /* @__PURE__ */ React180.createElement(UitkLayoutGridItem22, {
                        colSpan: {
                            small: 1,
                            medium: 3
                        }
                    }, /* @__PURE__ */ React180.createElement(UitkSpacing90, null, /* @__PURE__ */ React180.createElement(UitkLayoutFlexItem29, null, /* @__PURE__ */ React180.createElement(UitkSpacing90, {
                        margin: {
                            small: {
                                block: "unset"
                            },
                            medium: {
                                block: "two"
                            }
                        }
                    }, /* @__PURE__ */ React180.createElement("div", null, sectionContent && /* @__PURE__ */ React180.createElement(PropertyContentItemLodgingLinkMessage, {
                        data: sectionContent[0]
                    })))))) : null;
                }
            default:
                return null;
        }
    });
    return /* @__PURE__ */ React180.createElement("div", null, /* @__PURE__ */ React180.createElement(UitkCard31, null, /* @__PURE__ */ React180.createElement(UitkSpacing90, {
        padding: {
            blockstart: "four",
            small: {
                blockend: "six",
                inline: "four"
            },
            medium: {
                blockend: "two",
                inline: "six"
            }
        }
    }, /* @__PURE__ */ React180.createElement(UitkCardContentSection24, null, /* @__PURE__ */ React180.createElement(UitkLayoutGrid25, {
        columns: {
            medium: [
                "1fr",
                "2fr"
            ]
        },
        rows: {
            small: [
                "1fr"
            ],
            medium: [
                "1fr"
            ]
        }
    }, content)))));
};
VipAccessModuleDetail.fragment = __VipAccessModuleDetailFragment;
VipAccessModuleDetail.displayName = "VipAccessModuleDetail";
// src/components/vip-messaging/__private/__fragments/property-highlight-section.tsx
import React181 from "react";
import { gql as gql146 } from "@apollo/client";
import { useClickTracker as useClickTracker45 } from "@shared-ui/clickstream-analytics-context";
import { UitkBadgeSize as UitkBadgeSize3, UitkBadgeTheme as UitkBadgeTheme6, UitkMemberBadge as UitkMemberBadge2 } from "uitk-react-badge";
import { UitkCard as UitkCard32, UitkCardContentSection as UitkCardContentSection25 } from "uitk-react-cards";
import { UitkIcon as UitkIcon34 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex43, UitkLayoutFlexItem as UitkLayoutFlexItem30 } from "uitk-react-layout-flex";
import { UitkLayoutGrid as UitkLayoutGrid26, UitkLayoutGridItem as UitkLayoutGridItem23, withUitkLayoutGrid as withUitkLayoutGrid3 } from "uitk-react-layout-grid";
import { UitkLink as UitkLink23 } from "uitk-react-link";
import { UitkList as UitkList10, UitkListItem as UitkListItem10 } from "uitk-react-list";
import { UitkMark as UitkMark10, UitkMarkSize as UitkMarkSize11 } from "uitk-react-mark";
import { UitkSpacing as UitkSpacing91 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading35, UitkText as UitkText52 } from "uitk-react-text";
var fragment82 = gql146(_templateObject148());
var PropertyHighlightSection = function(param) {
    var data = param.data;
    var _subSections, _contents, _header, _header1, _header2, _footerLink_icon;
    var label = data.label, header = data.header, subSections = data.subSections, footerLink = data.footerLink;
    var track = useClickTracker45();
    if (!((_subSections = subSections) === null || _subSections === void 0 ? void 0 : _subSections.length)) {
        return null;
    }
    var _subSections_ = subSections[0], contents = _subSections_.contents, description = _subSections_.description;
    if (!((_contents = contents) === null || _contents === void 0 ? void 0 : _contents.length)) {
        return null;
    }
    var onClickFooterLink = function() {
        var _footerLink;
        if (!((_footerLink = footerLink) === null || _footerLink === void 0 ? void 0 : _footerLink.link.referrerId)) {
            return;
        }
        track(footerLink.link.referrerId, label || "Clicked footer link of PropertyHighlightSection");
    };
    var list = function(props) {
        return /* @__PURE__ */ React181.createElement(UitkList10, _object_spread_props(_object_spread({}, props), {
            bullet: "icon-alternate",
            spacing: true
        }), contents.map(function(content, index) {
            var _icon;
            var icon = content.icon, value = content.value;
            return /* @__PURE__ */ React181.createElement(UitkListItem10, {
                key: "property-highlight-list-item-".concat(index)
            }, ((_icon = icon) === null || _icon === void 0 ? void 0 : _icon.id) && /* @__PURE__ */ React181.createElement(UitkIcon34, {
                name: icon.id
            }), /* @__PURE__ */ React181.createElement(UitkLayoutFlex43, {
                space: "two"
            }, /* @__PURE__ */ React181.createElement(UitkText52, null, value)));
        }));
    };
    var MessagesListWithGrid = withUitkLayoutGrid3(list);
    var messagesRowsCount = Math.ceil(contents.length / 2);
    return /* @__PURE__ */ React181.createElement("div", null, /* @__PURE__ */ React181.createElement(UitkCard32, null, /* @__PURE__ */ React181.createElement(UitkCardContentSection25, {
        padded: true
    }, /* @__PURE__ */ React181.createElement(UitkLayoutGrid26, {
        columns: {
            small: 1,
            medium: 2,
            large: 3
        }
    }, /* @__PURE__ */ React181.createElement(UitkLayoutGridItem23, {
        colStart: 1,
        colSpan: "all"
    }, /* @__PURE__ */ React181.createElement("div", null, /* @__PURE__ */ React181.createElement(UitkText52, {
        className: "is-visually-hidden"
    }, label), ((_header = header) === null || _header === void 0 ? void 0 : _header.mark) && /* @__PURE__ */ React181.createElement(UitkSpacing91, {
        margin: {
            inlineend: "three"
        }
    }, /* @__PURE__ */ React181.createElement(UitkMark10, {
        name: header.mark.id,
        size: UitkMarkSize11.MEDIUM_LARGE
    })), ((_header1 = header) === null || _header1 === void 0 ? void 0 : _header1.badge) && /* @__PURE__ */ React181.createElement(UitkMemberBadge2, {
        text: header.badge.text || "",
        theme: header.badge.theme_temp && UitkBadgeTheme6[header.badge.theme_temp],
        size: UitkBadgeSize3.LARGE
    }), ((_header2 = header) === null || _header2 === void 0 ? void 0 : _header2.text) && /* @__PURE__ */ React181.createElement(UitkHeading35, {
        tag: "h2",
        size: 5
    }, header.text))), /* @__PURE__ */ React181.createElement(UitkSpacing91, {
        padding: {
            blockstart: "two"
        },
        margin: {
            inlineend: "three"
        }
    }, /* @__PURE__ */ React181.createElement(UitkLayoutGridItem23, {
        colSpan: {
            medium: 2,
            large: 1
        }
    }, /* @__PURE__ */ React181.createElement(UitkText52, null, description))), /* @__PURE__ */ React181.createElement(UitkSpacing91, {
        padding: {
            blockstart: "two",
            inlinestart: "two"
        },
        margin: {
            inlineend: "three"
        }
    }, /* @__PURE__ */ React181.createElement(UitkLayoutGridItem23, {
        colSpan: {
            medium: 2,
            large: 2
        }
    }, /* @__PURE__ */ React181.createElement(MessagesListWithGrid, {
        rows: messagesRowsCount,
        autoFlow: "column"
    })))), footerLink && /* @__PURE__ */ React181.createElement(UitkSpacing91, {
        margin: {
            blockstart: "four"
        }
    }, /* @__PURE__ */ React181.createElement(UitkLayoutFlex43, {
        alignItems: "end",
        direction: "column",
        wrap: "nowrap"
    }, /* @__PURE__ */ React181.createElement(UitkLayoutFlexItem30, null, /* @__PURE__ */ React181.createElement(UitkLink23, {
        inline: true,
        onClick: onClickFooterLink
    }, /* @__PURE__ */ React181.createElement("a", {
        href: footerLink.link.uri.value,
        target: footerLink.link.target || ""
    }, footerLink.value, /* @__PURE__ */ React181.createElement("span", {
        className: "is-visually-hidden"
    }, footerLink.accessibilityLabel), /* @__PURE__ */ React181.createElement(UitkIcon34, {
        name: ((_footerLink_icon = footerLink.icon) === null || _footerLink_icon === void 0 ? void 0 : _footerLink_icon.id) || ""
    })))))))));
};
PropertyHighlightSection.fragment = fragment82;
PropertyHighlightSection.displayName = "PropertyHighlightSection";
// src/components/vip-messaging-card/vip-messaging-card.tsx
var fragment83 = gql147(_templateObject149(), VipAccessModuleDetail.fragment, PropertyHighlightSection.fragment);
var VipMessagingCard = function(param) {
    var data = param.data;
    var propertyHighlightSection = data.propertyHighlightSection, propertyContentSectionGroup = data.propertyContentSectionGroup;
    if (!propertyHighlightSection && !propertyContentSectionGroup) {
        return null;
    }
    if (propertyHighlightSection) {
        return /* @__PURE__ */ React182.createElement(PropertyHighlightSection, {
            data: propertyHighlightSection
        });
    }
    if (propertyContentSectionGroup) {
        return /* @__PURE__ */ React182.createElement(VipAccessModuleDetail, {
            data: propertyContentSectionGroup
        });
    }
    return null;
};
VipMessagingCard.fragment = fragment83;
VipMessagingCard.displayName = "VipMessagingCard";
// src/components/property-offers.tsx
var __Query = gql148(_templateObject150(), PropertyLevelOffersMessage.fragment, PropertyLevelOffersCard.fragment, VipMessagingCard.fragment, NewVipModule.fragment, PropertyTripSummary.fragment, PropertySingleOffer.fragment, PropertyStickyBookBar.fragment, PropertyStickyPriceHeader.fragment, PropertyOffers.fragment, PropertySpaceDetails.fragment, PropertySearchLink.fragment, PropertyUnitListView.fragment, ListingsHeader.fragment, FilterPills.fragment, LoyaltyDiscountToggle.fragment, LegalDisclaimer.fragment, HighlightedBenefits.fragment, LodgingOneKeyBurnSwitch.fragment, TravelerSelector.fragment, UnitsCarousel.fragment);
function PropertyOffersComponent(WrappedComponent, LoadingPlaceholder) {
    var Component = function(props) {
        var _data, _previousData;
        var inputs = props.inputs, skipSsr = props.skipSsr, children = props.children;
        var context = useBexApi7().context;
        var variables = _object_spread_props(_object_spread({}, inputs), {
            context: context
        });
        var _useQuery = useQuery(__Query, {
            variables: variables,
            ssr: !skipSsr,
            notifyOnNetworkStatusChange: true
        }), data = _useQuery.data, previousData = _useQuery.previousData, loading = _useQuery.loading, refetch = _useQuery.refetch;
        var propertyOffers = (_data = data) === null || _data === void 0 ? void 0 : _data.propertyOffers;
        var previousPropertyOffers = (_previousData = previousData) === null || _previousData === void 0 ? void 0 : _previousData.propertyOffers;
        if (loading) {
            return LoadingPlaceholder ? /* @__PURE__ */ React183.createElement(LoadingPlaceholder, {
                data: previousPropertyOffers
            }, children) : null;
        }
        if (!propertyOffers) {
            return null;
        }
        return /* @__PURE__ */ React183.createElement(InputsProvider, {
            inputs: inputs
        }, /* @__PURE__ */ React183.createElement(WrappedComponent, _object_spread({
            data: propertyOffers,
            refetch: refetch,
            variables: variables
        }, props), children));
    };
    Component.displayName = "PropertyOffers".concat(WrappedComponent.displayName);
    return Component;
}
function TravelerSelectorComponent(WrappedComponent, LoadingPlaceholder) {
    var Component = function(props) {
        var _data, _previousData;
        var inputs = props.inputs, skipSsr = props.skipSsr, children = props.children;
        var context = useBexApi7().context;
        var variables = _object_spread_props(_object_spread({}, inputs), {
            context: context
        });
        var _useQuery = useQuery(__Query, {
            variables: variables,
            ssr: !skipSsr
        }), data = _useQuery.data, previousData = _useQuery.previousData, loading = _useQuery.loading;
        var travelerSelector = (_data = data) === null || _data === void 0 ? void 0 : _data.travelerSelector;
        var previousPropertyOffers = (_previousData = previousData) === null || _previousData === void 0 ? void 0 : _previousData.propertyOffers;
        if (loading) {
            return LoadingPlaceholder ? /* @__PURE__ */ React183.createElement(LoadingPlaceholder, {
                data: previousPropertyOffers
            }, children) : null;
        }
        if (!travelerSelector) {
            return null;
        }
        return /* @__PURE__ */ React183.createElement(InputsProvider, {
            inputs: inputs
        }, /* @__PURE__ */ React183.createElement(WrappedComponent, _object_spread({
            data: travelerSelector
        }, props), children));
    };
    Component.displayName = "PropertyOffers".concat(WrappedComponent.displayName);
    return Component;
}
var ListingsHeader2 = PropertyOffersComponent(ListingsHeader);
var VipMessagingCard2 = PropertyOffersComponent(VipMessagingCard);
var NewVipModule2 = PropertyOffersComponent(NewVipModule);
var PropertyTripSummary2 = PropertyOffersComponent(PropertyTripSummary);
var PropertyLevelOffersMessage2 = PropertyOffersComponent(PropertyLevelOffersMessage);
var PropertyLevelOffersCard2 = PropertyOffersComponent(PropertyLevelOffersCard);
var PropertySingleOffer2 = PropertyOffersComponent(PropertySingleOffer);
var PropertyStickyBookBar2 = PropertyOffersComponent(PropertyStickyBookBar);
var PropertyStickyPriceHeader2 = PropertyOffersComponent(PropertyStickyPriceHeader);
var PropertySpaceDetails2 = PropertyOffersComponent(PropertySpaceDetails);
var PropertySearchLink2 = PropertyOffersComponent(PropertySearchLink);
var PropertyUnitListView2 = PropertyOffersComponent(PropertyUnitListView);
var FilterPills2 = PropertyOffersComponent(FilterPills);
var LoyaltyDiscountToggle2 = PropertyOffersComponent(LoyaltyDiscountToggle);
var SingleOfferSearchDateField2 = PropertyOffersComponent(SingleOfferSearchDateField);
var SingleOfferSearchButton2 = PropertyOffersComponent(SingleOfferSearchButton);
var PropertyLegalDisclaimer = PropertyOffersComponent(LegalDisclaimer);
var PropertyFilterPills2 = PropertyOffersComponent(PropertyFilterPills);
var PropertyOffersIncludedPerks2 = PropertyOffersComponent(PropertyOffersIncludedPerks);
var HighlightedBenefits2 = PropertyOffersComponent(HighlightedBenefits, HighlightedBenefitsPlaceholder);
var LodgingOneKeyBurnSwitch2 = PropertyOffersComponent(LodgingOneKeyBurnSwitch);
var UnitsCarousel2 = PropertyOffersComponent(UnitsCarousel, UnitsCarouselPlaceholder);
var TravelerSelector2 = TravelerSelectorComponent(TravelerSelector);
var PropertyOffers2 = Object.assign(PropertyOffersComponent(PropertyOffers, ListingsPlaceholder), {
    Form: Form,
    HeaderRight: HeaderRight
});
// src/components/basic-property-offers.tsx
import React184 from "react";
import { gql as gql149, useQuery as useQuery2 } from "@apollo/client";
import { useBexApi as useBexApi8 } from "@shared-ui/bex-api-context";
import { UitkSpacing as UitkSpacing92 } from "uitk-react-spacing";
var __Query2 = gql149(_templateObject151(), ListingsHeader.fragment, Listings.fragment, __ShoppingContextFragment);
var BasicPropertyOffers = function(param) {
    var inputs = param.inputs, skipSsr = param.skipSsr, forceVerticalPropertyUnitLayout = param.forceVerticalPropertyUnitLayout;
    var _data;
    var context = useBexApi8().context;
    var _useQuery2 = useQuery2(__Query2, {
        variables: _object_spread_props(_object_spread({}, inputs), {
            context: context
        }),
        ssr: !skipSsr
    }), data = _useQuery2.data, error = _useQuery2.error, loading = _useQuery2.loading;
    if (loading) {
        return /* @__PURE__ */ React184.createElement(LoadingPlaceholderCards, null);
    }
    if (error || !((_data = data) === null || _data === void 0 ? void 0 : _data.propertyOffers)) {
        return null;
    }
    return /* @__PURE__ */ React184.createElement(InputsProvider, {
        inputs: inputs
    }, /* @__PURE__ */ React184.createElement(MultiItemProvider, {
        multiItemContext: setMultiItemContext(data.propertyOffers.shoppingContext)
    }, /* @__PURE__ */ React184.createElement(UitkSpacing92, {
        margin: {
            small: {
                inline: "three"
            },
            medium: {
                inline: "unset"
            },
            blockend: "one"
        }
    }, /* @__PURE__ */ React184.createElement(ListingsHeader, {
        data: data.propertyOffers
    })), /* @__PURE__ */ React184.createElement(Listings, {
        data: data.propertyOffers,
        forceVerticalPropertyUnitLayout: forceVerticalPropertyUnitLayout
    })));
};
BasicPropertyOffers.displayName = "BasicPropertyOffers";
// src/components/room-details.tsx
import React185 from "react";
import { gql as gql150, useQuery as useQuery3 } from "@apollo/client";
import { useBexApi as useBexApi9 } from "@shared-ui/bex-api-context";
var __RoomDetailsQuery = gql150(_templateObject152(), ControlPropertyUnit.fragment);
var RoomDetails = function(param) {
    var inputs = param.inputs, skipSsr = param.skipSsr;
    var _data_propertyOffers, _data, _unitGallery_images, _unitGallery;
    var context = useBexApi9().context;
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context
    });
    var _useQuery3 = useQuery3(__RoomDetailsQuery, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery3.data, loading = _useQuery3.loading, error = _useQuery3.error;
    var selectedPropertyUnit = (_data = data) === null || _data === void 0 ? void 0 : (_data_propertyOffers = _data.propertyOffers) === null || _data_propertyOffers === void 0 ? void 0 : _data_propertyOffers.units.find(function(unit) {
        var _inputs_searchOffer;
        return unit.id === ((_inputs_searchOffer = inputs.searchOffer) === null || _inputs_searchOffer === void 0 ? void 0 : _inputs_searchOffer.roomTypeId);
    });
    if (loading || error || !selectedPropertyUnit) {
        return null;
    }
    var unitGallery = selectedPropertyUnit.unitGallery, features = selectedPropertyUnit.features, roomAmenities = selectedPropertyUnit.roomAmenities;
    if (!((_unitGallery = unitGallery) === null || _unitGallery === void 0 ? void 0 : (_unitGallery_images = _unitGallery.images) === null || _unitGallery_images === void 0 ? void 0 : _unitGallery_images.length) && !features.length && !roomAmenities) {
        return null;
    }
    return /* @__PURE__ */ React185.createElement(DetailsDialogContent, {
        listing: selectedPropertyUnit
    });
};
RoomDetails.displayName = "RoomDetails";
export { BasicPropertyOffers, FilterPills2 as FilterPills, HighlightedBenefits2 as HighlightedBenefits, ListingsHeader2 as ListingsHeader, LodgingOneKeyBurnSwitch2 as LodgingOneKeyBurnSwitch, LoyaltyDiscountToggle2 as LoyaltyDiscountToggle, NewVipModule2 as NewVipModule, PropertyFilterPills2 as PropertyFilterPills, PropertyLegalDisclaimer, PropertyLevelOffersCard2 as PropertyLevelOffersCard, PropertyLevelOffersMessage2 as PropertyLevelOffersMessage, PropertyOffers2 as PropertyOffers, PropertyOffersIncludedPerks2 as PropertyOffersIncludedPerks, PropertyOffersSignalNames, PropertySearchLink2 as PropertySearchLink, PropertySingleOffer2 as PropertySingleOffer, PropertySpaceDetails2 as PropertySpaceDetails, PropertyStickyBookBar2 as PropertyStickyBookBar, PropertyStickyPriceHeader2 as PropertyStickyPriceHeader, PropertyTripSummary2 as PropertyTripSummary, PropertyUnitListView2 as PropertyUnitListView, RoomDetails, SingleOfferSearchButton2 as SingleOfferSearchButton, SingleOfferSearchDateField2 as SingleOfferSearchDateField, TravelerSelector2 as TravelerSelector, UnitsCarousel2 as UnitsCarousel, VipMessagingCard2 as VipMessagingCard }; /* istanbul ignore next -- @preserve */  /* istanbul ignore file -- @preserve */  // istanbul ignore next -- @preserve
//# sourceMappingURL=index.js.map